// @ts-nocheck
// This file is auto-generated by @hey-api/openapi-ts

export type SeriesDataDto = {
    seriesId: string;
    label?: string;
    /**
     * Every available data type for a timeseries.
     */
    dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
    unit: string;
    /**
     * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
     */
    energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    firstDataDate?: string;
    lastDataDate?: string;
    dataPoints: Array<{
        timestamp: string;
        value: number | null;
    }>;
};

/**
 * Every available data type for a timeseries.
 */
export enum dataType {
    ENERGY = 'energy',
    POWER = 'power',
    TEMPERATURE = 'temperature',
    COSTS = 'costs',
    PRICES = 'prices',
    CUSTOM = 'custom'
}

/**
 * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
 */
export enum energyType {
    ELECTRICITY = 'electricity',
    GAS = 'gas',
    WATER = 'water',
    PRESSURIZED_AIR = 'pressurizedAir',
    HEATING = 'heating',
    FUELS = 'fuels',
    FLUID_GAS = 'fluidGas'
}

/**
 * Available options for the intervals between two values in a timeseries.
 */
export enum granularity {
    _15MIN = '15min',
    HOURLY = 'hourly',
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    YEARLY = 'yearly'
}

export type SeriesDataPointDto = {
    timestamp: string;
    value: number | null;
};

export type LoginDto = {
    email: string;
    password: string;
};

export type OrganizationMappingDto = {
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Organization ID
     */
    organizationId?: string | null;
};

export type UserInfoDto = {
    userId: string;
    userName: string;
    email: string;
    companyId: string;
    organizationId?: string | null;
    /**
     * List of company firebase ids
     */
    companyIds: Array<(string)>;
    /**
     * List of company ids
     */
    companyPgIds: Array<(number)>;
    /**
     * List of organization mappings per company
     */
    organizationIds: Array<OrganizationMappingDto>;
    /**
     * Has only readonly access
     */
    readonly: boolean;
};

export type AuthDto = {
    token: string;
    userInfo: UserInfoDto;
};

export type SsoLoginRequestDto = {
    email: string;
    companySlug: string;
    accessToken: string;
};

export type SendResetPasswordEmailDto = {
    email: string;
};

export type ResetPasswordRequestDto = {
    password: string;
    uid: string;
    token: string;
};

export type SelfResetPasswordRequestDto = {
    currentPassword: string;
    newPassword: string;
};

export type UpdateEmailDto = {
    /**
     * The new email address to assign to the user.
     */
    newEmail: string;
};

export type UserDto_Stats = {
    logouts: number;
    emailOpeningRates: number;
    mostVisitedPage: number;
    emailToAppJumps: number;
    sessionDuration: number;
    logins: number;
};

export type UserDto_EnabledNotifications = {
    dailyElectricityReport: boolean;
    updatesAboutRegulations: boolean;
    realTimeAlerts: boolean;
};

export type UserDto_Location = {
    id: number;
    firebaseId: string;
    title: string;
};

export type UserDto_Role = {
    id: number;
    title: string;
    companyId: {
        [key: string]: unknown;
    };
};

export type UserDto_Company = {
    id: number;
    industryId: number;
    firebaseId: string;
    title: string;
    isDeleted: boolean;
    apiKey: string;
    isCostless: boolean;
    accountTypeId: number;
    logoId?: number | null;
    whiteLabelLogoId?: number | null;
};

export type UserDto_Region = {
    id: number;
    companyId: number;
    title: string;
};

export type UserDto = {
    id: number;
    firebaseId: string;
    firstName: string;
    lastName: string;
    companyRole: string;
    email: string;
    phoneNumber: string;
    stats: (UserDto_Stats) | null;
    isDeleted: boolean;
    enabledNotifications: (UserDto_EnabledNotifications) | null;
    appReloadRequired: boolean;
    isEnergyTeam: boolean;
    customDashboardLayout: {
        [key: string]: unknown;
    } | null;
    companyId: {
        [key: string]: unknown;
    } | null;
    title: string | null;
    locations: Array<UserDto_Location>;
    roles: Array<UserDto_Role>;
    company: (UserDto_Company) | null;
    companies: Array<UserDto_Company>;
    regions: Array<UserDto_Region>;
    readonly: boolean;
};

export type UserFrontendDto_LocationsPermissions_AllowedLocation = {
    /**
     * Location id. (firebase_id)
     */
    id: string;
};

export type UserFrontendDto_LocationsPermissions = {
    /**
     * Whether the user can see all locations.
     */
    canSeeAllLocations: boolean;
    /**
     * List of locations the user has access to.
     */
    allowedLocations: Array<UserFrontendDto_LocationsPermissions_AllowedLocation>;
};

export type UserFrontendDto_Stats = {
    /**
     * Total number of logouts.
     */
    logouts: number;
    /**
     * Rate of opening emails.
     */
    emailOpeningRates: number;
    /**
     * Most visited page.
     */
    mostVisitedPage: number;
    /**
     * Number of times jumping from emails to app.
     */
    emailToAppJumps: number;
    /**
     * Average session duration in minutes.
     */
    sessionDuration: number;
    /**
     * Total number of logins.
     */
    logins: number;
};

export type UserFrontendDto_EnabledNotifications = {
    /**
     * Whether the user receives daily electricity reports.
     */
    dailyElectricityReport: boolean;
    /**
     * Whether the user receives updates about regulations.
     */
    updatesAboutRegulations: boolean;
    /**
     * Whether the user receives real-time alerts.
     */
    realTimeAlerts: boolean;
};

export type UserFrontendDto_Company = {
    id: number;
    title: string;
    firebaseId: string;
    logoId?: number | null;
    whiteLabelLogoId?: number | null;
};

export type UserFrontendDto = {
    /**
     * The unique pg ID of the user.
     */
    pgId: number;
    /**
     * Permissions related to locations.
     */
    locationsPermissions: UserFrontendDto_LocationsPermissions;
    /**
     * Last name of the user.
     */
    lastName: string;
    /**
     * Position of the user within the company.
     */
    companyRole: string;
    /**
     * Whether the app reload is required for the user.
     */
    appReloadRequired: boolean;
    /**
     * Roles assigned to the user.
     */
    roles: Array<('admin' | 'user' | 'consultant')>;
    /**
     * Title of the user.
     */
    title: string;
    /**
     * First name of the user.
     */
    firstName: string;
    /**
     * Firebase id of the main location of the user.
     */
    companyId: string;
    /**
     * Phone number of the user.
     */
    phoneNumber: string;
    /**
     * Whether the user is marked as deleted.
     */
    isDeleted: boolean;
    /**
     * Statistical data related to the user's activity.
     */
    stats: UserFrontendDto_Stats;
    /**
     * Notifications enabled for the user.
     */
    enabledNotifications: UserFrontendDto_EnabledNotifications;
    /**
     * Email address of the user.
     */
    email: string;
    /**
     * Region permissions IDs.
     */
    regionsPermissions: Array<(string)>;
    /**
     * Firebase id of the user.
     */
    id: string;
    /**
     * Indicates whether the user is part of the energy team
     */
    isEnergyTeam?: boolean;
    /**
     * Whether the user may release insights to customers.
     */
    isInsightsAdmin: boolean;
    /**
     * Custom dashboard layout for the user.
     */
    customDashboardLayout: {
        [key: string]: unknown;
    } | null;
    company: UserFrontendDto_Company;
    companies: Array<UserFrontendDto_Company>;
    /**
     * Whether the user has only read-only access.
     */
    readonly: boolean;
    /**
     * The consultancy ID of the user.
     */
    consultancyId?: number | null;
};

export type StatsDto = {
    /**
     * Total number of logouts.
     */
    logouts: number;
    /**
     * Rate of opening emails.
     */
    emailOpeningRates: number;
    /**
     * Most visited page.
     */
    mostVisitedPage: number;
    /**
     * Number of times jumping from emails to app.
     */
    emailToAppJumps: number;
    /**
     * Average session duration in minutes.
     */
    sessionDuration: number;
    /**
     * Total number of logins.
     */
    logins: number;
};

export type EnabledNotificationsDto = {
    /**
     * Whether the user receives daily electricity reports.
     */
    dailyElectricityReport: boolean;
    /**
     * Whether the user receives updates about regulations.
     */
    updatesAboutRegulations: boolean;
    /**
     * Whether the user receives real-time alerts.
     */
    realTimeAlerts: boolean;
};

export type LocationPermissionIdDto = {
    /**
     * Location id. (firebase_id)
     */
    id: string;
};

export type LocationsPermissionsDto = {
    /**
     * Whether the user can see all locations.
     */
    canSeeAllLocations: boolean;
    /**
     * List of locations the user has access to.
     */
    allowedLocations: Array<LocationPermissionIdDto>;
};

export type CreateUserDto = {
    /**
     * The unique ID of the user.
     */
    id?: number;
    /**
     * Last name of the user.
     */
    lastName?: string;
    /**
     * Position of the user within the company.
     */
    companyRole?: string | null;
    /**
     * Whether the app reload is required for the user.
     */
    appReloadRequired?: boolean;
    /**
     * Roles assigned to the user.
     */
    roles?: Array<('admin' | 'user' | 'consultant')>;
    /**
     * Title of the user.
     */
    title?: string;
    /**
     * First name of the user.
     */
    firstName?: string;
    /**
     * Path to the user's profile picture.
     */
    profilePicPath?: string;
    /**
     * Phone number of the user. Multiple spaces will be collapsed into a single space. Only digits, spaces, and optional leading + are allowed.
     */
    phoneNumber?: string;
    /**
     * Whether the user is marked as deleted.
     */
    isDeleted?: boolean;
    /**
     * Statistical data related to the user's activity.
     */
    stats?: StatsDto;
    /**
     * Notifications enabled for the user.
     */
    enabledNotifications?: EnabledNotificationsDto;
    /**
     * Email address of the user.
     */
    email?: string;
    /**
     * Indicates whether the user is part of the energy team
     */
    isEnergyTeam?: boolean;
    /**
     * Password of the user.
     */
    password?: string;
    /**
     * Password confirmation of the user.
     */
    passwordConfirmation?: string;
    /**
     * Permissions related to locations.
     */
    locationsPermissions: LocationsPermissionsDto;
    /**
     * Custom dashboard layout for the user.
     */
    customDashboardLayout?: {
        [key: string]: unknown;
    };
    /**
     * Whether the user has only read-only access.
     */
    readonly?: boolean;
    /**
     * The consultancy ID of the user.
     */
    consultancyId?: number | null;
    /**
     * Company where the user will initially be created
     */
    companyId: number;
};

export type UpsertUserResponseDto = {
    id: number;
    firebaseId: string;
};

export type UpdateUserDto = {
    /**
     * The unique ID of the user.
     */
    id?: number;
    /**
     * Last name of the user.
     */
    lastName?: string;
    /**
     * Position of the user within the company.
     */
    companyRole?: string | null;
    /**
     * Whether the app reload is required for the user.
     */
    appReloadRequired?: boolean;
    /**
     * Roles assigned to the user.
     */
    roles?: Array<('admin' | 'user' | 'consultant')>;
    /**
     * Title of the user.
     */
    title?: string;
    /**
     * First name of the user.
     */
    firstName?: string;
    /**
     * Path to the user's profile picture.
     */
    profilePicPath?: string;
    /**
     * Phone number of the user. Multiple spaces will be collapsed into a single space. Only digits, spaces, and optional leading + are allowed.
     */
    phoneNumber?: string;
    /**
     * Whether the user is marked as deleted.
     */
    isDeleted?: boolean;
    /**
     * Statistical data related to the user's activity.
     */
    stats?: StatsDto;
    /**
     * Notifications enabled for the user.
     */
    enabledNotifications?: EnabledNotificationsDto;
    /**
     * Indicates whether the user is part of the energy team
     */
    isEnergyTeam?: boolean;
    /**
     * Password of the user.
     */
    password?: string;
    /**
     * Password confirmation of the user.
     */
    passwordConfirmation?: string;
    /**
     * Permissions related to locations.
     */
    locationsPermissions: LocationsPermissionsDto;
    /**
     * Custom dashboard layout for the user.
     */
    customDashboardLayout?: {
        [key: string]: unknown;
    };
    /**
     * Whether the user has only read-only access.
     */
    readonly?: boolean;
    /**
     * The consultancy ID of the user.
     */
    consultancyId?: number | null;
    /**
     * Company where the update will happen
     */
    companyId: number;
};

export type UpsertUserLocationsDto = {
    locations: Array<(number)>;
    regions: Array<(number)>;
    companyId: number;
};

export type UpsertUserDto = {
    /**
     * The unique ID of the user.
     */
    id?: number;
    /**
     * Last name of the user.
     */
    lastName?: string;
    /**
     * Position of the user within the company.
     */
    companyRole?: string | null;
    /**
     * Whether the app reload is required for the user.
     */
    appReloadRequired?: boolean;
    /**
     * Roles assigned to the user.
     */
    roles?: Array<('admin' | 'user' | 'consultant')>;
    /**
     * Title of the user.
     */
    title?: string;
    /**
     * First name of the user.
     */
    firstName?: string;
    /**
     * Path to the user's profile picture.
     */
    profilePicPath?: string;
    /**
     * Phone number of the user. Multiple spaces will be collapsed into a single space. Only digits, spaces, and optional leading + are allowed.
     */
    phoneNumber?: string;
    /**
     * Whether the user is marked as deleted.
     */
    isDeleted?: boolean;
    /**
     * Statistical data related to the user's activity.
     */
    stats?: StatsDto;
    /**
     * Notifications enabled for the user.
     */
    enabledNotifications?: EnabledNotificationsDto;
    /**
     * Email address of the user.
     */
    email?: string;
    /**
     * Indicates whether the user is part of the energy team
     */
    isEnergyTeam?: boolean;
    /**
     * Password of the user.
     */
    password?: string;
    /**
     * Password confirmation of the user.
     */
    passwordConfirmation?: string;
    /**
     * Permissions related to locations.
     */
    locationsPermissions: LocationsPermissionsDto;
    /**
     * Custom dashboard layout for the user.
     */
    customDashboardLayout?: {
        [key: string]: unknown;
    };
    /**
     * Whether the user has only read-only access.
     */
    readonly?: boolean;
    /**
     * The consultancy ID of the user.
     */
    consultancyId?: number | null;
};

export type UserCompanyItemDto = {
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Business role of the user in this company
     */
    companyRole: string;
    /**
     * Custom dashboard layout configuration
     */
    customDashboardLayout?: {
        [key: string]: unknown;
    } | null;
    /**
     * Whether the user is part of the energy team
     */
    isEnergyTeam: boolean;
    /**
     * Access roles for the user
     */
    roles?: Array<(string)>;
};

export type UserCompanyResponseDto = {
    id: number;
    userId: number;
    companyId: number;
    isSelected: boolean;
    companyRole: string | null;
    customDashboardLayout: {
        [key: string]: unknown;
    } | null;
    isEnergyTeam: boolean | null;
};

export type SyncUserCompaniesDto = {
    /**
     * The full desired set of companies the user should belong to. Companies already assigned are kept (metadata updated if changed), missing ones are added, and any current company not in this list is removed.
     */
    companies: Array<UserCompanyItemDto>;
};

export type DeleteUserRequestDto = {
    userId: number;
    firebaseId: string;
};

export type UpdateAppReloadRequiredRequestBodyDto = {
    appReloadRequired: boolean;
};

export type UploadProfilePictureDto = {
    /**
     * Profile picture (jpeg, png, gif, webp — max 20 MB)
     */
    file: (Blob | File);
};

export type TraceErrorDto = {
    environment: string;
    timestamp: number;
    humanDate: string;
    url: string;
    user: {
        companyName?: string;
        email?: string;
    };
    error?: string;
    errorInfo: {
        componentStack?: string;
    };
};

export type EntraResponseDto = {
    clientId: string;
    authority: string;
};

export type StrategyResponseDto = {
    id: number;
    name: string;
    company: string;
    payload: EntraResponseDto;
};

export type ConsultancyDto = {
    id: number;
    name: string;
    logoId: number | null;
};

export type CreateConsultancyDto = {
    name: string;
    logoId?: number | null;
};

export type UpdateConsultancyDto = {
    name?: string;
    logoId?: number | null;
};

export type AddCompaniesDto = {
    companiesIds: Array<(number)>;
};

export type User = unknown;

export type RequestMeterCreationDto = {
    /**
     * Name of the device
     */
    deviceName: string;
    /**
     * Device ID
     */
    deviceId: string;
    /**
     * Energy type
     */
    energyType: string;
};

export type UpsertRegionDto = {
    /**
     * Region ID
     */
    id?: number;
    /**
     * Region title
     */
    title: string;
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Location IDs
     */
    locationIds?: Array<(number)>;
};

export type Role = unknown;

export type MetaData = {
    filename: string;
    mimeType: string;
    size: number;
};

export type ObjectStorageDto = {
    id: number;
    uid: string;
    companyId?: number | null;
    storageUrl: string;
    metaData: MetaData;
};

export type ObjectStoragePostResponseDto = {
    /**
     * The id of the uploaded file
     */
    id: number;
    /**
     * The filename of uploaded file
     */
    fileName: string;
};

export type ObjectStorageV2PostResponseDto = {
    /**
     * The UUID of the uploaded file
     */
    uid: string;
    /**
     * The filename of uploaded file
     */
    fileName: string;
};

export type ObjectStorageV2MetadataDto = {
    uid: string;
    companyId: number;
    storageUrl: string;
    metaData: MetaData;
};

export type EmissionsComparisonDto = {
    emissionsYtd: number;
    emissionsPastMonth: number;
    emissionsCurrentMonth: number;
    monthlyData: Array<{
        [key: string]: unknown;
    }>;
};

export type AvailableMeterYearsDto = {
    availableYears: Array<(number)>;
    availableEfficiencyYears?: Array<(number)>;
    minDate: string;
    maxDate: string;
};

export type MeterInfrastructureSettingsDto = {
    deviceId: string;
    buildingId: number;
    locationId: number;
    name: string | null;
    isSignificantEnergyConsumer: boolean;
    aggregationLevel: 'aggregation_area' | 'aggregation' | 'end_consumer' | 'component' | 'not_applicable' | 'unknown' | null;
    assetPurpose: 'production' | 'operating_equipment' | 'building' | 'supply_grid' | 'unknown' | null;
    assetTypes: Array<('compressor' | 'vacuum_pump' | 'compressed_air_treatment' | 'chiller' | 'cold_storage' | 'cooling_tower' | 'froster' | 'deep_freeze' | 'steam_boiler' | 'hot_water_boiler' | 'electrode_boiler' | 'heat_pump' | 'air_handling_unit' | 'extraction_dedusting' | 'air_conditioner' | 'conveyor' | 'crane' | 'elevator_lift' | 'cnc_machine' | 'press' | 'punching_machine' | 'injection_molding_machine' | 'extruder' | 'mill_crusher' | 'centrifuge' | 'mixer' | 'robotics' | 'welding_soldering_laser' | 'rolling_mill' | 'forge' | 'saw' | 'assembly' | 'hardening_shop' | 'melting_induction_furnace' | 'dryer' | 'painting_line' | 'electroplating' | 'electrolyzer' | 'pasteurizer' | 'oven' | 'filling_line' | 'packaging_line' | 'cleaning_cip' | 'washing_plant' | 'sterilization' | 'pv_system' | 'wind_turbine' | 'chp' | 'biogas_plant' | 'battery_storage' | 'emergency_generator' | 'transformer_station' | 'sub_distribution' | 'ups' | 'grid_connection' | 'water_supply' | 'charging_infrastructure' | 'industrial_trucks' | 'lighting' | 'it_server_room' | 'kitchen_canteen' | 'workshop_auxiliary' | 'warehouse_logistics' | 'other' | 'unknown')>;
    machineCategoryId: number | null;
    parentMeterId: string | null;
};

export enum aggregationLevel {
    AGGREGATION_AREA = 'aggregation_area',
    AGGREGATION = 'aggregation',
    END_CONSUMER = 'end_consumer',
    COMPONENT = 'component',
    NOT_APPLICABLE = 'not_applicable',
    UNKNOWN = 'unknown'
}

export enum assetPurpose {
    PRODUCTION = 'production',
    OPERATING_EQUIPMENT = 'operating_equipment',
    BUILDING = 'building',
    SUPPLY_GRID = 'supply_grid',
    UNKNOWN = 'unknown'
}

export type MeterInfrastructureSettingsListDto = {
    settings: Array<MeterInfrastructureSettingsDto>;
};

export type MeterClassificationUpdateDto = {
    deviceId: string;
    buildingId: number;
    aggregationLevel?: 'aggregation_area' | 'aggregation' | 'end_consumer' | 'component' | 'not_applicable' | 'unknown' | null;
    assetPurpose?: 'production' | 'operating_equipment' | 'building' | 'supply_grid' | 'unknown' | null;
    assetTypes?: Array<('compressor' | 'vacuum_pump' | 'compressed_air_treatment' | 'chiller' | 'cold_storage' | 'cooling_tower' | 'froster' | 'deep_freeze' | 'steam_boiler' | 'hot_water_boiler' | 'electrode_boiler' | 'heat_pump' | 'air_handling_unit' | 'extraction_dedusting' | 'air_conditioner' | 'conveyor' | 'crane' | 'elevator_lift' | 'cnc_machine' | 'press' | 'punching_machine' | 'injection_molding_machine' | 'extruder' | 'mill_crusher' | 'centrifuge' | 'mixer' | 'robotics' | 'welding_soldering_laser' | 'rolling_mill' | 'forge' | 'saw' | 'assembly' | 'hardening_shop' | 'melting_induction_furnace' | 'dryer' | 'painting_line' | 'electroplating' | 'electrolyzer' | 'pasteurizer' | 'oven' | 'filling_line' | 'packaging_line' | 'cleaning_cip' | 'washing_plant' | 'sterilization' | 'pv_system' | 'wind_turbine' | 'chp' | 'biogas_plant' | 'battery_storage' | 'emergency_generator' | 'transformer_station' | 'sub_distribution' | 'ups' | 'grid_connection' | 'water_supply' | 'charging_infrastructure' | 'industrial_trucks' | 'lighting' | 'it_server_room' | 'kitchen_canteen' | 'workshop_auxiliary' | 'warehouse_logistics' | 'other' | 'unknown')>;
    isSignificantEnergyConsumer?: boolean | null;
};

export type BulkUpdateMeterClassificationDto = {
    settings: Array<MeterClassificationUpdateDto>;
};

export type InfrastructureSettingsSelectOneResponseDto = {
    name?: string;
    parentMeterId?: string;
    parentMeterBuildingId?: number;
    ratedCapacity?: number;
    brand?: string;
    model?: string;
    installationDate?: string;
    notes?: string;
    meterNumber?: string | null;
    maLoId?: string | null;
    meLoId?: string | null;
    isSignificantEnergyConsumer: boolean;
    energyConsumptionInfluence?: number | null;
    machineCategoryId?: number | null;
    aggregationLevel?: 'aggregation_area' | 'aggregation' | 'end_consumer' | 'component' | 'not_applicable' | 'unknown' | null;
    assetPurpose?: 'production' | 'operating_equipment' | 'building' | 'supply_grid' | 'unknown' | null;
    assetTypes: Array<('compressor' | 'vacuum_pump' | 'compressed_air_treatment' | 'chiller' | 'cold_storage' | 'cooling_tower' | 'froster' | 'deep_freeze' | 'steam_boiler' | 'hot_water_boiler' | 'electrode_boiler' | 'heat_pump' | 'air_handling_unit' | 'extraction_dedusting' | 'air_conditioner' | 'conveyor' | 'crane' | 'elevator_lift' | 'cnc_machine' | 'press' | 'punching_machine' | 'injection_molding_machine' | 'extruder' | 'mill_crusher' | 'centrifuge' | 'mixer' | 'robotics' | 'welding_soldering_laser' | 'rolling_mill' | 'forge' | 'saw' | 'assembly' | 'hardening_shop' | 'melting_induction_furnace' | 'dryer' | 'painting_line' | 'electroplating' | 'electrolyzer' | 'pasteurizer' | 'oven' | 'filling_line' | 'packaging_line' | 'cleaning_cip' | 'washing_plant' | 'sterilization' | 'pv_system' | 'wind_turbine' | 'chp' | 'biogas_plant' | 'battery_storage' | 'emergency_generator' | 'transformer_station' | 'sub_distribution' | 'ups' | 'grid_connection' | 'water_supply' | 'charging_infrastructure' | 'industrial_trucks' | 'lighting' | 'it_server_room' | 'kitchen_canteen' | 'workshop_auxiliary' | 'warehouse_logistics' | 'other' | 'unknown')>;
};

export type InfrastructureSettingsUpdateOneRequestBody = {
    name?: string;
    parentMeterId?: string | null;
    parentMeterBuildingId?: number;
    ratedCapacity?: number;
    brand?: string;
    model?: string;
    installationDate?: string;
    notes?: string;
    /**
     * Meter number (Zählernummer)
     */
    meterNumber?: string | null;
    /**
     * Market location ID (MaLo)
     */
    maLoId?: string | null;
    /**
     * Metering location ID (MeLo)
     */
    meLoId?: string | null;
    isSignificantEnergyConsumer: boolean;
    machineCategoryId?: number | null;
    energyConsumptionInfluence?: number;
    aggregationLevel?: 'aggregation_area' | 'aggregation' | 'end_consumer' | 'component' | 'not_applicable' | 'unknown' | null;
    assetPurpose?: 'production' | 'operating_equipment' | 'building' | 'supply_grid' | 'unknown' | null;
    assetTypes?: Array<('compressor' | 'vacuum_pump' | 'compressed_air_treatment' | 'chiller' | 'cold_storage' | 'cooling_tower' | 'froster' | 'deep_freeze' | 'steam_boiler' | 'hot_water_boiler' | 'electrode_boiler' | 'heat_pump' | 'air_handling_unit' | 'extraction_dedusting' | 'air_conditioner' | 'conveyor' | 'crane' | 'elevator_lift' | 'cnc_machine' | 'press' | 'punching_machine' | 'injection_molding_machine' | 'extruder' | 'mill_crusher' | 'centrifuge' | 'mixer' | 'robotics' | 'welding_soldering_laser' | 'rolling_mill' | 'forge' | 'saw' | 'assembly' | 'hardening_shop' | 'melting_induction_furnace' | 'dryer' | 'painting_line' | 'electroplating' | 'electrolyzer' | 'pasteurizer' | 'oven' | 'filling_line' | 'packaging_line' | 'cleaning_cip' | 'washing_plant' | 'sterilization' | 'pv_system' | 'wind_turbine' | 'chp' | 'biogas_plant' | 'battery_storage' | 'emergency_generator' | 'transformer_station' | 'sub_distribution' | 'ups' | 'grid_connection' | 'water_supply' | 'charging_infrastructure' | 'industrial_trucks' | 'lighting' | 'it_server_room' | 'kitchen_canteen' | 'workshop_auxiliary' | 'warehouse_logistics' | 'other' | 'unknown')>;
};

export type InfrastructureSettingsUpdateOneResponseDto = {
    name?: string;
    parentMeterId?: string;
    parentMeterBuildingId?: number;
    ratedCapacity?: number;
    brand?: string;
    model?: string;
    installationDate?: string;
    notes?: string;
    meterNumber?: string | null;
    maLoId?: string | null;
    meLoId?: string | null;
    isSignificantEnergyConsumer: boolean;
    energyConsumptionInfluence?: number | null;
    machineCategoryId?: number | null;
    aggregationLevel?: 'aggregation_area' | 'aggregation' | 'end_consumer' | 'component' | 'not_applicable' | 'unknown' | null;
    assetPurpose?: 'production' | 'operating_equipment' | 'building' | 'supply_grid' | 'unknown' | null;
    assetTypes: Array<('compressor' | 'vacuum_pump' | 'compressed_air_treatment' | 'chiller' | 'cold_storage' | 'cooling_tower' | 'froster' | 'deep_freeze' | 'steam_boiler' | 'hot_water_boiler' | 'electrode_boiler' | 'heat_pump' | 'air_handling_unit' | 'extraction_dedusting' | 'air_conditioner' | 'conveyor' | 'crane' | 'elevator_lift' | 'cnc_machine' | 'press' | 'punching_machine' | 'injection_molding_machine' | 'extruder' | 'mill_crusher' | 'centrifuge' | 'mixer' | 'robotics' | 'welding_soldering_laser' | 'rolling_mill' | 'forge' | 'saw' | 'assembly' | 'hardening_shop' | 'melting_induction_furnace' | 'dryer' | 'painting_line' | 'electroplating' | 'electrolyzer' | 'pasteurizer' | 'oven' | 'filling_line' | 'packaging_line' | 'cleaning_cip' | 'washing_plant' | 'sterilization' | 'pv_system' | 'wind_turbine' | 'chp' | 'biogas_plant' | 'battery_storage' | 'emergency_generator' | 'transformer_station' | 'sub_distribution' | 'ups' | 'grid_connection' | 'water_supply' | 'charging_infrastructure' | 'industrial_trucks' | 'lighting' | 'it_server_room' | 'kitchen_canteen' | 'workshop_auxiliary' | 'warehouse_logistics' | 'other' | 'unknown')>;
};

export type MeterIdentifierDto = {
    /**
     * The display name of the meter
     */
    name: string;
    /**
     * The unique device ID of the meter
     */
    deviceId: string;
};

export type MeterCyclicErrorDto = {
    /**
     * Error type identifier for cyclic meter reference
     */
    error: string;
    /**
     * Stack trace showing the cyclic path of meters
     */
    stack: Array<MeterIdentifierDto>;
};

export type PossibleParentMetersResponseDto = {
    meters: Array<{
        [key: string]: unknown;
    }>;
};

export enum SlpDataSource {
    MONTHLY_CONSUMPTION = 'MONTHLY_CONSUMPTION',
    METER_READING = 'METER_READING'
}

export type CreateSlpMeterRequestDto = {
    title: string;
    buildingId: number;
    energyType: string;
    dataSource: SlpDataSource;
    converterFactor?: number;
    /**
     * Measurement unit. m3 only valid for gas energy type.
     */
    unit?: 'kWh' | 'm3';
};

/**
 * Measurement unit. m3 only valid for gas energy type.
 */
export enum unit {
    K_WH = 'kWh',
    M3 = 'm3'
}

export type SlpMeterDto = {
    deviceId: string;
    title: string;
    energyType: string;
    buildingId: number;
    dataSource?: SlpDataSource;
    converterFactor: number;
    unit?: 'kWh' | 'm3';
};

export type VirtualMeterDefinitionDto = {
    /**
     * Formula for the virtual meter
     */
    formula: string;
    /**
     * Mapping of variables in the formula to device IDs
     */
    mapping: {
        [key: string]: (string);
    };
};

export type VirtualDto = {
    /**
     * Virtual object with definition and formula
     */
    type: string;
    /**
     * Definition of the virtual meter
     */
    definition: VirtualMeterDefinitionDto;
};

export type KwhDataSeriesEntryDto = {
    /**
     * Device ID
     */
    deviceId: string;
    /**
     * Timestamp
     */
    timestamp: string;
    /**
     * ⭐ **DISCRIMINATOR**  ⭐
     * Union type for consumption data points with discriminated types
     *
     * ⚠️ IMPORTANT: Use the 'type' property to discriminate between series point variants:
     * - 'kwh': KwH meter data (has value_kwh (consumption) and value_kw (load) properties)
     * - 'm3': M3 meter data (has value_m3 (consumption) and value_m3h (load) properties)
     *
     * For SLP meters, `value_kw` and `value_m3h` will be `undefined`.
     *
     * **Example usage:**
     * ```ts
     * + if (dataPoint.type === 'kwh') {
     * +   dataPoint.value_kwh
     * +   dataPoint.value_kw // undefined for SLP
     * + }
     * ```
     *
     * --
     * ```ts
     * + if (dataPoint.type === 'm3') {
     * +   dataPoint.value_m3
     * +   dataPoint.value_m3h // undefined for SLP
     * + }
     * ```
     *
     */
    type: 'kwh';
    /**
     * Value in kWh (for kWh meters)
     */
    value_kwh: number | null;
    /**
     * Value in kW (for kWh meters). This value is `undefined` for SLP meters.
     */
    value_kw?: number | null;
};

/**
 * ⭐ **DISCRIMINATOR**  ⭐
 * Union type for consumption data points with discriminated types
 *
 * ⚠️ IMPORTANT: Use the 'type' property to discriminate between series point variants:
 * - 'kwh': KwH meter data (has value_kwh (consumption) and value_kw (load) properties)
 * - 'm3': M3 meter data (has value_m3 (consumption) and value_m3h (load) properties)
 *
 * For SLP meters, `value_kw` and `value_m3h` will be `undefined`.
 *
 * **Example usage:**
 * ```ts
 * + if (dataPoint.type === 'kwh') {
 * +   dataPoint.value_kwh
 * +   dataPoint.value_kw // undefined for SLP
 * + }
 * ```
 *
 * --
 * ```ts
 * + if (dataPoint.type === 'm3') {
 * +   dataPoint.value_m3
 * +   dataPoint.value_m3h // undefined for SLP
 * + }
 * ```
 *
 */
export enum type {
    KWH = 'kwh'
}

export type M3DataSeriesEntryDto = {
    /**
     * Device ID
     */
    deviceId: string;
    /**
     * Timestamp
     */
    timestamp: string;
    /**
     * ⭐ **DISCRIMINATOR**  ⭐
     * Union type for consumption data points with discriminated types
     *
     * ⚠️ IMPORTANT: Use the 'type' property to discriminate between series point variants:
     * - 'kwh': KwH meter data (has value_kwh (consumption) and value_kw (load) properties)
     * - 'm3': M3 meter data (has value_m3 (consumption) and value_m3h (load) properties)
     *
     * For SLP meters, `value_kw` and `value_m3h` will be `undefined`.
     *
     * **Example usage:**
     * ```ts
     * + if (dataPoint.type === 'kwh') {
     * +   dataPoint.value_kwh
     * +   dataPoint.value_kw // undefined for SLP
     * + }
     * ```
     *
     * --
     * ```ts
     * + if (dataPoint.type === 'm3') {
     * +   dataPoint.value_m3
     * +   dataPoint.value_m3h // undefined for SLP
     * + }
     * ```
     *
     */
    type: 'm3';
    /**
     * Value in m3 (for m3 meters)
     */
    value_m3: number | null;
    /**
     * Value in m3/h (for m3 meters). This value is `undefined` for SLP meters.
     */
    value_m3h?: number | null;
};

/**
 * ⭐ **DISCRIMINATOR**  ⭐
 * Union type for consumption data points with discriminated types
 *
 * ⚠️ IMPORTANT: Use the 'type' property to discriminate between series point variants:
 * - 'kwh': KwH meter data (has value_kwh (consumption) and value_kw (load) properties)
 * - 'm3': M3 meter data (has value_m3 (consumption) and value_m3h (load) properties)
 *
 * For SLP meters, `value_kw` and `value_m3h` will be `undefined`.
 *
 * **Example usage:**
 * ```ts
 * + if (dataPoint.type === 'kwh') {
 * +   dataPoint.value_kwh
 * +   dataPoint.value_kw // undefined for SLP
 * + }
 * ```
 *
 * --
 * ```ts
 * + if (dataPoint.type === 'm3') {
 * +   dataPoint.value_m3
 * +   dataPoint.value_m3h // undefined for SLP
 * + }
 * ```
 *
 */
export enum type2 {
    M3 = 'm3'
}

export type ConsumptionDataDto = {
    /**
     * Consumption year-to-date value in kWh
     */
    consumptionYtd?: number | null;
    /**
     * Consumption in specified timeframe in kWh
     */
    consumptionInTimeframe?: number | null;
    /**
     * Peakload in specified timeframe in kW
     */
    peakloadInTimeframe?: number | null;
    /**
     * Baseload in specified timeframe in kW
     */
    baseloadInTimeframe?: number | null;
    /**
     * Peakload year-to-date value in kW
     */
    peakloadYtd?: number | null;
    /**
     * Baseload year-to-date value in kW
     */
    baseloadYtd?: number | null;
    /**
     * Data series for consumption data
     */
    dataSeries?: Array<(KwhDataSeriesEntryDto | M3DataSeriesEntryDto)>;
};

export type MeterResponseDto = {
    /**
     * Internal meter ID
     */
    id: number;
    /**
     * Scale factor for the meter
     */
    scaleFactor: number;
    /**
     * Granularity
     */
    granularity: string;
    /**
     * Granularity unit
     */
    granularityUnit: string;
    /**
     * Device ID
     */
    deviceId: string;
    /**
     * Meter title
     */
    meterTitle: string;
    /**
     * Is default meter
     */
    isDefault: boolean;
    /**
     * Virtual meter data as JSON
     */
    virtual?: VirtualDto;
    /**
     * Device type ID
     */
    deviceTypeId: number;
    /**
     * First data available date
     */
    firstDataDate?: string | null;
    /**
     * Last data available date
     */
    lastDataDate?: string | null;
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Location title
     */
    locationTitle: string;
    /**
     * Location Firebase ID
     */
    locationFirebaseId: string;
    /**
     * Building ID
     */
    buildingId: number;
    /**
     * Building title
     */
    buildingTitle?: string | null;
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Company title
     */
    companyTitle: string;
    /**
     * Energy type. Will be null for virtual meters.
     */
    energyType?: string | null;
    /**
     * Value type
     */
    valueType?: string | null;
    /**
     * API Provider ID
     */
    apiProviderId?: number | null;
    /**
     * Source
     */
    source?: string | null;
    /**
     * Is virtual meter
     */
    isVirtual: boolean;
    /**
     * Device type
     */
    deviceType: 'consumption' | 'generation';
    /**
     * Firebase ID (alias for locationFirebaseId)
     */
    firebaseId: string;
    /**
     * Consumption data
     */
    consumptionData?: ConsumptionDataDto;
    /**
     * Measurement unit (kWh or m3)
     */
    measurementUnit: 'kWh' | 'm3';
    /**
     * Is significant energy consumer
     */
    isSignificantEnergyConsumer: boolean;
    /**
     * Meter number (Zählernummer)
     */
    meterNumber: string | null;
    /**
     * Market location ID (MaLo)
     */
    maLoId: string | null;
    /**
     * Metering location ID (MeLo)
     */
    meLoId: string | null;
};

/**
 * Device type
 */
export enum deviceType {
    CONSUMPTION = 'consumption',
    GENERATION = 'generation'
}

/**
 * Measurement unit (kWh or m3)
 */
export enum measurementUnit {
    K_WH = 'kWh',
    M3 = 'm3'
}

export type SlpMeterResponseDto = {
    /**
     * Internal meter ID
     */
    id: number;
    /**
     * Scale factor for the meter
     */
    scaleFactor: number;
    /**
     * Granularity
     */
    granularity: string;
    /**
     * Granularity unit
     */
    granularityUnit: string;
    /**
     * Device ID
     */
    deviceId: string;
    /**
     * Meter title
     */
    meterTitle: string;
    /**
     * Is default meter
     */
    isDefault: boolean;
    /**
     * Device type ID
     */
    deviceTypeId: number;
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Location title
     */
    locationTitle: string;
    /**
     * Location Firebase ID
     */
    locationFirebaseId: string;
    /**
     * Building ID
     */
    buildingId: number;
    /**
     * Building title
     */
    buildingTitle?: string | null;
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Company title
     */
    companyTitle: string;
    /**
     * Energy type
     */
    energyType: string | null;
    /**
     * Value type
     */
    valueType?: string | null;
    /**
     * API Provider ID
     */
    apiProviderId?: number | null;
    /**
     * Source
     */
    source?: string | null;
    /**
     * Device type
     */
    deviceType: 'consumption' | 'generation';
    /**
     * Firebase ID (alias for locationFirebaseId)
     */
    firebaseId: string;
    /**
     * Measurement unit (kWh or m3)
     */
    measurementUnit: 'kWh' | 'm3';
    /**
     * Data source of the SLP meter
     */
    slpDataSource: 'MONTHLY_CONSUMPTION' | 'METER_READING';
};

/**
 * Data source of the SLP meter
 */
export enum slpDataSource {
    MONTHLY_CONSUMPTION = 'MONTHLY_CONSUMPTION',
    METER_READING = 'METER_READING'
}

export type MeterInfoResponseDto = {
    /**
     * API Provider ID
     */
    apiProviderId: number | null;
    /**
     * Building ID
     */
    buildingId: number;
    /**
     * Building title
     */
    buildingTitle: string | null;
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Company title
     */
    companyTitle: string;
    /**
     * Device ID
     */
    deviceId: string;
    /**
     * Device type ID
     */
    deviceTypeId: number;
    /**
     * Energy type
     */
    energyType: string | null;
    /**
     * First data date
     */
    firstDataDate: string | null;
    /**
     * Granularity
     */
    granularity: string;
    /**
     * Meter ID
     */
    id: number;
    /**
     * Is default meter
     */
    isDefault: boolean;
    /**
     * Last data date
     */
    lastDataDate: string | null;
    /**
     * Location Firebase ID (deprecated: use locationId instead)
     * @deprecated
     */
    locationFirebaseId: string;
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Location title
     */
    locationTitle: string;
    /**
     * Meter title
     */
    meterTitle: string;
    /**
     * Scale factor
     */
    scaleFactor: number;
    /**
     * Source
     */
    source: string | null;
    /**
     * Value type
     */
    valueType: string | null;
    /**
     * Virtual meter configuration
     */
    virtual: {
        [key: string]: unknown;
    };
};

export type MeterEvaluationResponseDto = {
    /**
     * Evaluation record ID
     */
    id: number;
    /**
     * Meter ID
     */
    meterId: number;
    /**
     * When evaluation was created
     */
    createdAt: string;
};

export type MeterEvaluationCreateRequestDto = {
    /**
     * Meter ID to create evaluation for
     */
    meterId: number;
};

export type MeterEvaluationDto = {
    /**
     * Meter ID
     */
    id: string;
    /**
     * Device ID
     */
    deviceId: string;
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Meter name
     */
    name: string;
    /**
     * Is virtual meter
     */
    isVirtual: boolean;
    /**
     * Is significant energy consumer
     */
    isSignificantEnergyConsumer?: boolean;
    /**
     * Consumption in selected timeframe
     */
    consumption?: number;
    /**
     * Energy consumption influence factor
     */
    energyConsumptionInfluence?: number;
    /**
     * Is default/main meter
     */
    isDefault: boolean;
    /**
     * Source of the meter
     */
    source?: string;
    /**
     * Energy type
     */
    energyType: string;
    /**
     * Device type
     */
    deviceType: 'consumption' | 'generation';
    /**
     * Consumption percentage of total
     */
    consumptionPercentage: number;
    /**
     * Cumulative percentage (sorted)
     */
    cumulativePercentage: number;
    /**
     * Energy impact score (1-5)
     */
    energyImpactScore?: number | null;
    /**
     * Final score (energyImpactScore * influence)
     */
    finalScore?: number | null;
    /**
     * Category based on final score
     */
    category?: {
        [key: string]: unknown;
    };
};

export type CreateDocumentTemplateDto = {
    /**
     * The title of the document template
     */
    title: string;
    /**
     * The language of the document template
     */
    language: 'GERMAN';
    /**
     * The type of the document template
     */
    type: 'STATIC' | 'MEASURE' | 'ENPI' | 'GOAL';
    isSuggested?: boolean;
    /**
     * The content of the document template
     */
    content: string;
};

/**
 * The language of the document template
 */
export enum language {
    GERMAN = 'GERMAN'
}

/**
 * The type of the document template
 */
export enum type3 {
    STATIC = 'STATIC',
    MEASURE = 'MEASURE',
    ENPI = 'ENPI',
    GOAL = 'GOAL'
}

export type DocumentTemplateDto = {
    /**
     * The ID of the document template
     */
    id: number;
    /**
     * The title of the document template
     */
    title: string;
    /**
     * The language of the document template
     */
    language: 'GERMAN';
    /**
     * The type of the document template
     */
    type: 'STATIC' | 'MEASURE' | 'ENPI' | 'GOAL';
    isSuggested?: boolean;
    /**
     * The content of the document template
     */
    content: string;
};

export type DocumentTemplateDtoList = {
    /**
     * List of templates
     */
    templates: Array<DocumentTemplateDto>;
};

export type UpdateDocumentTemplateDto = {
    /**
     * The title of the document template
     */
    title?: string;
    /**
     * The language of the document template
     */
    language?: 'GERMAN';
    /**
     * The type of the document template
     */
    type: 'STATIC' | 'MEASURE' | 'ENPI' | 'GOAL';
    isSuggested?: boolean;
    /**
     * The content of the document template
     */
    content?: string;
};

export type EventUserDto = {
    id: string;
    email: string;
    companyId: string;
};

export type TrackEventDto = {
    user: EventUserDto;
    event: string;
};

export type HedgingCsvDto = {
    /**
     * Date
     */
    timestamp: string;
    /**
     * Hedged cost
     */
    hedgedCost: number;
    /**
     * Price
     */
    price: string;
};

export type Visualization = unknown;

export type GridUsagePriceResponseDto = {
    locationId: number;
    validFromYear: number;
    validFromMonth: number;
    unit: string;
    value: number;
};

export type ApiGridUsagePriceResponseDto = {
    success: boolean;
    data: Array<GridUsagePriceResponseDto>;
};

export type UpsertGridUsagePriceDto = {
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Year
     */
    year: number;
    /**
     * Month
     */
    month: number;
    /**
     * Unit
     */
    unit: string;
    /**
     * Value
     */
    value: number;
};

export type GenericResponseDto = {
    success: boolean;
    message: string;
};

export type PeakLoadPriceResponseDto = {
    locationId: number;
    validFromYear: number;
    validFromMonth: number;
    unit: string;
    value: number;
};

export type ApiPeakLoadPriceResponseDto = {
    success: boolean;
    data: Array<PeakLoadPriceResponseDto>;
};

export type UpsertPeakLoadPriceDto = {
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Year
     */
    year: number;
    /**
     * Month
     */
    month: number;
    /**
     * Unit
     */
    unit: string;
    /**
     * Value
     */
    value: number;
};

export type IsoChapterResponseDto = {
    /**
     * The ID of the ISO chapter
     */
    id: number;
    /**
     * The title of the ISO chapter
     */
    title: string;
    /**
     * The order of the ISO chapter
     */
    order: number;
    exampleDocuments: Array<(string)>;
};

export type IsoChapterListResponseDto = {
    /**
     * List of ISO chapters
     */
    chapters: Array<IsoChapterResponseDto>;
};

export type CreateIsoChapterDto = {
    /**
     * The title of the ISO chapter
     */
    title: string;
    /**
     * The order of the ISO chapter
     */
    order: number;
    exampleDocuments: Array<(string)>;
};

export type UpdateIsoChapterDto = {
    /**
     * The title of the ISO chapter
     */
    title: string;
    /**
     * The order of the ISO chapter
     */
    order: number;
    exampleDocuments: Array<(string)>;
};

export type ResponsibleUser = {
    /**
     * First name of the user
     */
    firstName: string;
    /**
     * Last name of the user
     */
    lastName: string;
    /**
     * Email address of the user
     */
    email: string;
};

export type IsoDocumentResponseDto = {
    id: number;
    title: string;
    file?: (ObjectStorageV2MetadataDto) | null;
    chapterId: number;
    locationId: number;
    measureId?: number;
    link?: string;
    updatedAt: string;
    createdAt: string;
    createdBy: string;
    /**
     * Details about the responsible user
     */
    responsibleUser: (ResponsibleUser) | null;
};

export type IsoDocumentResponseListDto = {
    documents: Array<IsoDocumentResponseDto>;
};

export type IsoDocumentChangeHistoryDto = {
    changeUser: string;
    updatedAt: string;
};

export type IsoDocumentFetchOneResponseDto = {
    id: number;
    title: string;
    file?: (ObjectStorageV2MetadataDto) | null;
    chapterId: number;
    locationId: number;
    measureId?: number;
    templateId?: number;
    updatedAt: string;
    createdAt: string;
    createdBy: string;
    content?: string;
    link?: string;
    responsibleUser: string;
    changeHistory: Array<IsoDocumentChangeHistoryDto>;
};

export type CreateIsoDocumentDto = {
    title: string;
    chapterId: number;
    locationId: number;
    content?: string;
    link?: string;
    responsibleUser: string;
    measureId?: number;
    enpiId?: number;
    isoGoalId?: number;
    templateId?: number;
    /**
     * Object storage file UID (V2)
     */
    fileUid?: string;
};

export type IsoDocumentUpdateContentDto = {
    content: string;
};

export type UpdateIsoDocumentMetaDataDto = {
    title: string;
    chapterId: number;
    locationId: number;
    responsibleUser: string;
    measureId?: number;
    link?: string;
    content?: string;
};

export type FieldChangeDto = {
    /**
     * The name of the changed field
     */
    field: string;
    /**
     * The original value
     */
    existing: string;
    /**
     * The updated value
     */
    updated: string;
};

export type ObjectChangeHistoryDto = {
    /**
     * The change user email
     */
    changeUser: string;
    /**
     * The changed fields
     */
    changeFields: Array<FieldChangeDto>;
    /**
     * The change date
     */
    updatedAt: string;
};

export type IsoRiskFetchResponseDto = {
    id: number;
    title: string;
    description?: string;
    riskTypeId: 1 | 2;
    riskImpactId: 1 | 2 | 3;
    companyId: number;
    changeHistory: Array<ObjectChangeHistoryDto>;
};

export enum riskTypeId {
    '_1' = 1,
    '_2' = 2
}

export enum riskImpactId {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3
}

export type IsoRiskFetchResponseListDto = {
    risks: Array<IsoRiskFetchResponseDto>;
};

export type IsoRiskFetchOneResponseDto = {
    id: number;
    title: string;
    description?: string;
    riskTypeId: 1 | 2;
    riskImpactId: 1 | 2 | 3;
    companyId: number;
    changeHistory: Array<ObjectChangeHistoryDto>;
};

export type CreateIsoRiskDto = {
    title: string;
    description?: string;
    riskTypeId: 1 | 2;
    riskImpactId: 1 | 2 | 3;
    companyId: number;
};

export type IsoGoalMeasuresDto = {
    id: number;
};

export type IsoGoalFetchResponseDto = {
    id: number;
    title: string;
    riskId?: number;
    deadline: string;
    locationId: number;
    responsibleUser: string;
    notes?: string;
    description?: string;
    parentGoalId?: number;
    category: 'ENERGY_GOAL' | 'SYSTEM_RELEVANT';
    changeHistory: Array<ObjectChangeHistoryDto>;
    measures: Array<IsoGoalMeasuresDto>;
    measuresProgress: number;
};

export enum category {
    ENERGY_GOAL = 'ENERGY_GOAL',
    SYSTEM_RELEVANT = 'SYSTEM_RELEVANT'
}

export type IsoGoalFetchResponseListDto = {
    goals: Array<IsoGoalFetchResponseDto>;
    averagePercentageOfGoalsReached: number;
};

export type CreateIsoGoalDto = {
    title: string;
    riskId?: number;
    deadline: string;
    locationId: number;
    responsibleUser: string;
    notes?: string;
    description?: string;
    parentGoalId?: number;
    category: 'ENERGY_GOAL' | 'SYSTEM_RELEVANT';
};

export type EnpiSeuResolutionDto = {
    minutes: number;
    enum: string;
    label: string;
};

export type AdjustmentFactorDto = {
    /**
     * Unique identifier for the adjustment factor
     */
    id: string;
    /**
     * Type of adjustment factor (e.g., temperature, humidity)
     */
    type: string;
};

export type EnpiSeuOptionDto = {
    label: string;
    energyType: string;
    unit: string;
    resolution: EnpiSeuResolutionDto;
    minDate: string | null;
    maxDate: string | null;
    dataQualityTimeSeriesIds: Array<(string)>;
    formulaVersion?: string;
    reference: AdjustmentFactorDto;
    locationId: number;
    group: 'overall_consumption' | 'grid_import' | 'onsite_generation' | 'grid_export' | 'submeter';
    selectable: boolean;
    disabledReason?: string;
};

export enum group {
    OVERALL_CONSUMPTION = 'overall_consumption',
    GRID_IMPORT = 'grid_import',
    ONSITE_GENERATION = 'onsite_generation',
    GRID_EXPORT = 'grid_export',
    SUBMETER = 'submeter'
}

export type FetchEnpiSeuOptionsDto = {
    options: Array<EnpiSeuOptionDto>;
};

export type FetchEnpiSeuOptionsForLocationsDto = {
    locationIds: Array<(number)>;
};

export type InfluencingFactorResolutionDto = {
    minutes: number;
    enum: string;
    label: string;
};

export type InfluencingFactorWithMetadata = {
    /**
     * Unique identifier for the adjustment factor
     */
    id: string;
    /**
     * Type of adjustment factor (e.g., temperature, humidity)
     */
    type: string;
    unit: string;
    resolution?: InfluencingFactorResolutionDto;
};

export type EnpiSeuMetadataDto = {
    label: string;
    energyType: string;
    unit: string;
    resolution: EnpiSeuResolutionDto;
    minDate: string | null;
    maxDate: string | null;
    dataQualityTimeSeriesIds: Array<(string)>;
    formulaVersion?: string;
};

export type CommentDto = {
    content: string;
    createUser: string;
    createdAt: string;
    mentionedUsers?: Array<(string)>;
};

export type CommentsDto = {
    comments: Array<CommentDto>;
};

export type EnPISeriesResultsDto = {
    cusum: number;
    baseline: number;
    deviation: number;
    timestamp: string;
    prediction: number;
    deviationKWh: number;
    measuredValue: number;
    targetDeviation: number;
};

export type EnPISummaryResultsDto = {
    /**
     * Also known as cusum
     */
    deviationSum: number;
    deviationAverage: number;
    measuredValueAverage: number;
    targetDeviationAverage: number;
    baselineAverage: number;
};

export type EnPIResultsDto = {
    series: Array<EnPISeriesResultsDto>;
    summary: EnPISummaryResultsDto;
};

export type FetchOneEnpiDto = {
    id: number;
    efficiencyTrendVsLastPeriod?: number;
    locationId: number;
    targetValue?: number;
    influencingFactorId?: {
        [key: string]: unknown;
    };
    influencingFactor?: InfluencingFactorWithMetadata;
    adjustmentFactorIds?: Array<(string)>;
    adjustmentFactors?: Array<AdjustmentFactorDto>;
    referenceDateTo: string;
    referenceDateFrom: string;
    targetValueType: 'absolute' | 'relative';
    interval: 'yearly' | 'monthly' | 'weekly' | 'daily';
    title: string;
    description?: string;
    currentValue: number;
    isMainEnpi: boolean;
    /**
     * main consumer
     */
    seu: {
        [key: string]: unknown;
    };
    /**
     * main consumer
     */
    seuId: AdjustmentFactorDto;
    seuMetadata?: EnpiSeuMetadataDto;
    responsibleUser?: string;
    changeHistory: Array<ObjectChangeHistoryDto>;
    fallback: {
        lastIntervalValue?: number | null;
        lastEfficiencyTrendValue?: number | null;
    };
    comments: CommentsDto;
    /**
     * Calculated historic values of the EnPI
     */
    results: (EnPIResultsDto) | null;
    /**
     * Whether the last update on enpi results failed
     */
    lastUpdateFailed: boolean;
    /**
     * When the EnPI was last recalculated
     */
    lastCalculatedAt?: string;
};

export enum targetValueType {
    ABSOLUTE = 'absolute',
    RELATIVE = 'relative'
}

export enum interval {
    YEARLY = 'yearly',
    MONTHLY = 'monthly',
    WEEKLY = 'weekly',
    DAILY = 'daily'
}

export type FetchEnpiListDto = {
    enpis: Array<FetchOneEnpiDto>;
};

export type CreateEnpiDto = {
    /**
     * main consumer
     */
    seuId: AdjustmentFactorDto;
    influencingFactorId?: {
        [key: string]: unknown;
    };
    adjustmentFactorIds?: Array<(string)>;
    adjustmentFactors?: Array<AdjustmentFactorDto>;
    referenceDateTo: string;
    referenceDateFrom: string;
    locationId: number;
    targetValue?: number;
    targetValueType: 'absolute' | 'relative';
    interval: 'yearly' | 'monthly' | 'weekly' | 'daily';
    title: string;
    description: string;
    isMainEnpi: boolean;
    responsibleUser?: string;
};

export type UpdateEnpiDto = {
    title: string;
    /**
     * main consumer
     */
    seuId: AdjustmentFactorDto;
    influencingFactorId?: {
        [key: string]: unknown;
    };
    adjustmentFactorIds?: Array<(string)>;
    adjustmentFactors?: Array<AdjustmentFactorDto>;
    referenceDateTo: string;
    referenceDateFrom: string;
    locationId: number;
    targetValue?: number;
    targetValueType?: 'absolute' | 'relative';
    interval?: 'yearly' | 'monthly' | 'weekly' | 'daily';
    description: string;
    isMainEnpi: boolean;
    responsibleUser?: string;
};

export type CreateCommentDto = {
    content: string;
    createUser: string;
    /**
     * Emails of users tagged via @mention in the comment content
     */
    mentionedUsers?: Array<(string)>;
};

export enum IsoMeasureSavingsSourceDto {
    SIMULATION = 'SIMULATION',
    MANUAL = 'MANUAL'
}

export type MeasureSavingsDto = {
    source?: IsoMeasureSavingsSourceDto | null;
    kwhPerYear?: number | null;
    euroPerYear?: number | null;
    notes?: string | null;
};

export enum IsoMeasureSourceDto {
    INTERNAL_ANALYSIS = 'INTERNAL_ANALYSIS',
    ENERGY_AUDIT = 'ENERGY_AUDIT',
    AI_RECOMMENDATION = 'AI_RECOMMENDATION',
    EXTERNAL_CONSULTING = 'EXTERNAL_CONSULTING',
    EMPLOYEE_SUGGESTION = 'EMPLOYEE_SUGGESTION',
    ENERGY_EFFICIENCY_NETWORK = 'ENERGY_EFFICIENCY_NETWORK',
    OTHER = 'OTHER'
}

export enum IsoMeasureStatusEnum {
    BACKLOG = 'BACKLOG',
    PLANNED = 'PLANNED',
    ACTIVE = 'ACTIVE',
    REVIEW = 'REVIEW',
    DONE = 'DONE'
}

export enum IsoMilestoneStatusEnum {
    OPEN = 'OPEN',
    DONE = 'DONE'
}

export type IsoMilestoneFetchOneDto = {
    id: number;
    title: string;
    description: string;
    responsiblePerson: string;
    deadline: string;
    state: IsoMilestoneStatusEnum;
    position: number;
    changeHistory: Array<ObjectChangeHistoryDto>;
    measureId: number;
};

export type MeasureFinalSavingsDto = {
    /**
     * Realized energy savings in kWh from baseline regression (cumulative over the reporting period)
     */
    kwhSaved: number;
    /**
     * Realized cost savings in € from baseline regression (cumulative over the reporting period)
     */
    euroSaved: number;
    /**
     * Annualized realized energy savings (kWh/year), normalized over the full calendar months of the reporting period
     */
    kwhSavedPerYear: number;
    /**
     * Annualized realized cost savings (€/year), normalized over the full calendar months of the reporting period
     */
    euroSavedPerYear: number;
};

export type FetchOneIsoMeasureDto = {
    measureSource?: IsoMeasureSourceDto | null;
    measureType?: string | null;
    seuId?: string | null;
    id: number;
    title: string;
    problem?: string;
    cause?: string;
    description: string;
    determinationDate?: string;
    effectivenessDate?: string;
    locationId: number;
    responsiblePerson?: string;
    deadline?: string;
    isoGoalId?: number;
    status: IsoMeasureStatusEnum;
    priority: 'LOW' | 'MEDIUM' | 'HIGH';
    category?: 'INVESTMENT' | 'EFFICIENCY' | 'OTHER';
    enpiId?: number | null;
    savings: number;
    measureSavings?: MeasureSavingsDto;
    emberThreadId: number;
    createdByEmber: boolean;
    milestones: Array<IsoMilestoneFetchOneDto>;
    changeHistory: Array<(string)>;
    savingsType?: 'MANUAL' | 'VALERI' | 'EMBER';
    baselineId?: number | null;
    realizedSavings?: (MeasureFinalSavingsDto) | null;
};

export enum priority {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH'
}

export enum category2 {
    INVESTMENT = 'INVESTMENT',
    EFFICIENCY = 'EFFICIENCY',
    OTHER = 'OTHER'
}

export enum savingsType {
    MANUAL = 'MANUAL',
    VALERI = 'VALERI',
    EMBER = 'EMBER'
}

export type IsoMeasureSavingsByStatusDto = {
    status: IsoMeasureStatusEnum;
    totalSavings: number;
};

export type IsoMeasureFetchResponseListDto = {
    measures: Array<FetchOneIsoMeasureDto>;
    savingsByStatus: Array<IsoMeasureSavingsByStatusDto>;
    totalSavings: number;
    /**
     * Sum of realized euro savings (€/year) across all measures with a calculated baseline
     */
    totalRealizedSavings: number;
    /**
     * Sum of realized kWh savings (kWh/year) across all measures with a calculated baseline
     */
    totalRealizedKwh: number;
};

export type FetchOneDetailIsoMeasureDto = {
    measureSource?: IsoMeasureSourceDto | null;
    measureType?: string | null;
    seuId?: string | null;
    id: number;
    title: string;
    problem?: string;
    cause?: string;
    description: string;
    determinationDate?: string;
    effectivenessDate?: string;
    locationId: number;
    responsiblePerson?: string;
    deadline?: string;
    isoGoalId?: number;
    status: IsoMeasureStatusEnum;
    priority: 'LOW' | 'MEDIUM' | 'HIGH';
    category?: 'INVESTMENT' | 'EFFICIENCY' | 'OTHER';
    enpiId?: number | null;
    savings: number;
    measureSavings?: MeasureSavingsDto;
    emberThreadId: number;
    createdByEmber: boolean;
    milestones: Array<IsoMilestoneFetchOneDto>;
    comments: CommentsDto;
    changeHistory: Array<(string)>;
    savingsType?: 'MANUAL' | 'VALERI' | 'EMBER';
    baselineId?: number | null;
    baselineError?: {
        [key: string]: unknown;
    } | null;
    autoCreationActivated: boolean;
    /**
     * ID of the load simulation tied to this measure, if any.
     */
    simulationId?: number | null;
};

export type CreateIsoMeasureDto = {
    measureSource?: IsoMeasureSourceDto | null;
    measureType?: string | null;
    seuId?: string | null;
    title: string;
    problem?: string;
    cause?: string;
    description: string;
    determinationDate?: string;
    locationId: number;
    responsiblePerson?: string;
    deadline?: string;
    isoGoalId?: number;
    priority: 'LOW' | 'MEDIUM' | 'HIGH';
    category?: 'INVESTMENT' | 'EFFICIENCY' | 'OTHER';
    enpiId?: number | null;
    savings?: number;
    measureSavings?: MeasureSavingsDto;
    emberThreadId?: number;
    createdByEmber?: boolean;
    status?: IsoMeasureStatusEnum;
};

export type UpdateIsoMeasureDto = {
    measureSource?: IsoMeasureSourceDto | null;
    measureType?: string | null;
    seuId?: string | null;
    title: string;
    problem?: string;
    cause?: string;
    description: string;
    determinationDate?: string;
    effectivenessDate?: string;
    locationId: number;
    responsiblePerson?: string;
    deadline?: string;
    isoGoalId?: number;
    status: IsoMeasureStatusEnum;
    priority: 'LOW' | 'MEDIUM' | 'HIGH';
    category?: 'INVESTMENT' | 'EFFICIENCY' | 'OTHER';
    enpiId?: number | null;
    /**
     * Deprecated: use measureSavings
     */
    savings?: number;
    /**
     * Deprecated: use measureSavings
     */
    savingsType?: 'MANUAL' | 'VALERI' | 'EMBER';
    measureSavings?: (MeasureSavingsDto) | null;
    valeriId?: number;
};

export type LinkSuccessMeasurementAnalyticsBaselineDto = {
    /**
     * ID of an existing analytics.baseline row to use as the measure’s Erfolgsmessung
     */
    analyticsBaselineId: number;
};

export type PatchMeasureStatusDto = {
    status: IsoMeasureStatusEnum;
};

export type IsoMeasureStatusValidationResultDto = {
    validationWarnings: Array<('DOCUMENT_MISSING' | 'MISSING_RESPONSIBLE_PERSON' | 'MISSING_MILESTONE' | 'MISSING_ENPI' | 'DOCUMENTS_MISSING' | 'MILESTONES_NOT_FINISHED')>;
};

export type CreateIsoMilestoneDto = {
    title: string;
    description: string;
    responsiblePerson: string;
    deadline: string;
    state: IsoMilestoneStatusEnum;
};

export type UpdateIsoMilestoneDto = {
    title: string;
    description: string;
    responsiblePerson: string;
    deadline: string;
    state: IsoMilestoneStatusEnum;
};

export type PatchMilestoneStatusDto = {
    status: IsoMilestoneStatusEnum;
};

export type UpdateMilestoneOrderDto = {
    /**
     * Milestone ids in desired order
     */
    order: Array<(number)>;
};

export type IsoOverviewGoalsDto = {
    goals: number;
    goalsWithoutSubGoals: number;
};

export type IsoOverviewEnpiDto = {
    enpis: number;
    seusNotCovered: number;
};

export type IsoOverviewMeasuresDto = {
    assignedMeasures: Array<FetchOneIsoMeasureDto>;
    measuresWithoutMilestones: number;
    measures: Array<FetchOneIsoMeasureDto>;
};

export type IsoOverviewModelDto = {
    nextAuditDate?: string;
    nextEnergyTeamMeeting?: string;
    goals: IsoOverviewGoalsDto;
    enpis: IsoOverviewEnpiDto;
    measures: IsoOverviewMeasuresDto;
    assignedMilestones: Array<IsoMilestoneFetchOneDto>;
};

export type IsoChecklistTaskConfigurationFetchDto = {
    id: number;
    title: string;
    description: string;
    standardRequirements: Array<(string)>;
    requiredDocuments: Array<(string)>;
    aiContext: string;
};

export type IsoChecklistSubChaptersConfigurationFetchDto = {
    id: number;
    chapterId: number;
    title: string;
    description: string;
    tasks: Array<IsoChecklistTaskConfigurationFetchDto>;
};

export type IsoChecklistChaptersConfigurationFetchDto = {
    id: number;
    chapterId: number;
    title: string;
    description: string;
    /**
     * List of chapter configurations
     */
    subChapters: Array<IsoChecklistSubChaptersConfigurationFetchDto>;
};

export type IsoChecklistConfigurationFetchDto = {
    id: number;
    /**
     * indicates whether the given configuration is the most recent and valid one
     */
    isLatest: boolean;
    /**
     * after a checklist has been set to final, its steps can not be deleted anymore
     */
    isFinalized: boolean;
    /**
     * List of chapter configurations
     */
    chapters: Array<IsoChecklistChaptersConfigurationFetchDto>;
};

export type IsoChecklistConfigurationFetchListDto = {
    checklists: Array<IsoChecklistConfigurationFetchDto>;
};

export type IsoChecklistChaptersConfigurationCreateDto = {
    chapterId: number;
    description: string;
};

export type IsoChecklistChaptersConfigurationUpdateDto = {
    chapterId: number;
    description: string;
};

export type IsoChecklistSubChaptersConfigurationCreateDto = {
    chapterId: number;
    description: string;
};

export type IsoChecklistSubChaptersConfigurationUpdateDto = {
    chapterId: number;
    description: string;
};

export type IsoChecklistCompletionInfoDto = {
    completedBy: string;
    completionDate: string;
};

/**
 * The current status of the task
 */
export enum IsoChecklistTaskStatusEnum {
    OPEN = 'open',
    COMPLETED = 'completed',
    IN_PROGRESS = 'inProgress'
}

export type IsoChecklistTaskDto = {
    id: number;
    title: string;
    description: string;
    standardRequirements: Array<(string)>;
    requiredDocuments: Array<(string)>;
    aiContext: string;
    completeInfo?: IsoChecklistCompletionInfoDto;
    status: IsoChecklistTaskStatusEnum;
};

export type IsoChecklistSubChapterDto = {
    id: number;
    chapterId: number;
    title: string;
    description: string;
    tasks: Array<IsoChecklistTaskDto>;
};

export type IsoChecklistChapterDto = {
    id: number;
    chapterId: number;
    title: string;
    description: string;
    subChapters: Array<IsoChecklistSubChapterDto>;
};

export type IsoChecklistDto = {
    chapters: Array<IsoChecklistChapterDto>;
};

export type IsoChecklistLinkedDocumentDto = {
    documentId: number;
    taskId: number;
};

export type IsoChecklistFetchDto = {
    id: number;
    companyId: number;
    configurationId: number;
    checklist: IsoChecklistDto;
    linkedDocuments: Array<IsoChecklistLinkedDocumentDto>;
};

export type IsoChecklistDocumentLinkCreateDto = {
    documentId: number;
};

export type CreateValeriDto = {
    equityShare: number;
    planningHorizon: number;
    internalInterestRate: number;
    debtInterestRate: number;
    riskRate: number;
    /**
     * Description of the investment
     */
    description?: string;
    /**
     * ID of User that is responsible for this VALERI
     */
    responsibleUserId?: number;
    /**
     * Title of the VALERI
     */
    title?: string;
    locationId?: number;
    taxesIncluded: boolean;
    degradationRate: number;
    /**
     * Measure ID that this VALERI is linked to
     */
    measureId?: number | null;
};

export type ValeriCalculationPositionResultDto = {
    positionId: number;
    title: string;
    value: number;
    isQuantifiable: boolean;
};

export type ValeriCalculationAggregatedResultDto = {
    movingSums: Array<(number)>;
    totalSum: number;
    costsSums: number;
    benefitsSum: number;
};

export type ValeriCalculationResultDto = {
    costs: Array<ValeriCalculationPositionResultDto>;
    benefits: Array<ValeriCalculationPositionResultDto>;
    aggregatedResults: ValeriCalculationAggregatedResultDto;
    paybackPeriod: number;
    yearlySavingsSum?: number;
};

export type ValeriCalculationResultSummaryDto = {
    normalCase: ValeriCalculationResultDto;
    bestCase: ValeriCalculationResultDto;
    worstCase: ValeriCalculationResultDto;
    calculationDate: string;
};

export type FetchOneValeriDto = {
    equityShare: number;
    planningHorizon: number;
    internalInterestRate: number;
    debtInterestRate: number;
    riskRate: number;
    /**
     * Description of the investment
     */
    description?: string;
    /**
     * ID of User that is responsible for this VALERI
     */
    responsibleUserId?: number;
    /**
     * Title of the VALERI
     */
    title?: string;
    locationId?: number;
    taxesIncluded: boolean;
    degradationRate: number;
    id: number;
    valeriCalculationResult?: (ValeriCalculationResultSummaryDto) | null;
    /**
     * ID of the measure
     */
    measureId?: number | null;
    /**
     * Name of the measure
     */
    measureName?: string;
    /**
     * Whether this valeri resource is archived or not
     */
    isArchived: boolean;
};

export type UpdateValeriDto = {
    equityShare: number;
    planningHorizon: number;
    internalInterestRate: number;
    debtInterestRate: number;
    riskRate: number;
    /**
     * Description of the investment
     */
    description?: string;
    /**
     * ID of User that is responsible for this VALERI
     */
    responsibleUserId?: number;
    /**
     * Title of the VALERI
     */
    title?: string;
    locationId?: number;
    taxesIncluded: boolean;
    degradationRate: number;
    valeriCalculationResult?: (ValeriCalculationResultSummaryDto) | null;
    /**
     * ID of the measure
     */
    measureId?: number | null;
    /**
     * Whether this valeri resource is archived or not
     */
    isArchived: boolean;
};

export enum ValeriPositionFrequencyEnum {
    YEARLY = 'YEARLY',
    ONE_TIME = 'ONE_TIME'
}

export enum ValeriPositionCategoryEnum {
    ADDITIONAL_FINANCIAL_EFFECTS = 'ADDITIONAL_FINANCIAL_EFFECTS',
    OTHER_EFFECTS = 'OTHER_EFFECTS',
    ENERGY_IMPACT_EFFECTS = 'ENERGY_IMPACT_EFFECTS',
    INVESTMENT_PAYMENTS = 'INVESTMENT_PAYMENTS'
}

export enum ValeriPositionTypeEnum {
    COST = 'COST',
    BENEFIT = 'BENEFIT'
}

export type ValeriPositionDto = {
    id: number;
    valeriId: number;
    title: string;
    unit: string;
    amount: number;
    frequency: ValeriPositionFrequencyEnum;
    category: ValeriPositionCategoryEnum;
    isQuantifiable: boolean;
    valuePerUnit: number;
    priceFluctuationRate?: number | null;
    description?: string | null;
    document?: (ObjectStorageV2MetadataDto) | null;
    type: ValeriPositionTypeEnum;
};

export type ValeriPositionsListDto = {
    costs: Array<ValeriPositionDto>;
    benefits: Array<ValeriPositionDto>;
};

export type CreateValeriPositionDto = {
    title: string;
    unit: string;
    amount: number;
    frequency: ValeriPositionFrequencyEnum;
    category: ValeriPositionCategoryEnum;
    isQuantifiable: boolean;
    valuePerUnit: number;
    priceFluctuationRate?: number | null;
    description?: string | null;
    type: ValeriPositionTypeEnum;
    /**
     * Object storage file UID (V2)
     */
    documentUid?: string;
};

export type UpdateValeriPositionDto = {
    title: string;
    unit: string;
    amount: number;
    frequency: ValeriPositionFrequencyEnum;
    category: ValeriPositionCategoryEnum;
    isQuantifiable: boolean;
    valuePerUnit: number;
    priceFluctuationRate?: number | null;
    description?: string | null;
    /**
     * Object storage file UID (V2)
     */
    documentUid?: string;
};

export type FetchCalculationsOneValeriDto = {
    equityShare: number;
    planningHorizon: number;
    internalInterestRate: number;
    debtInterestRate: number;
    riskRate: number;
    /**
     * Description of the investment
     */
    description?: string;
    /**
     * ID of User that is responsible for this VALERI
     */
    responsibleUserId?: number;
    /**
     * Title of the VALERI
     */
    title?: string;
    locationId?: number;
    taxesIncluded: boolean;
    degradationRate: number;
    id: number;
    valeriCalculationResult?: (ValeriCalculationResultSummaryDto) | null;
    /**
     * ID of the measure
     */
    measureId?: number | null;
    /**
     * Name of the measure
     */
    measureName?: string;
    /**
     * Whether this valeri resource is archived or not
     */
    isArchived: boolean;
    /**
     * Indicate if the VALERI has at least one energy impact effects position
     */
    hasEnergyImpactEffects: boolean;
};

export type GetValeriCalculationResultsDto = {
    valeris: Array<FetchCalculationsOneValeriDto>;
    /**
     * The count of VALERI with a positive valeriCalculationResult.normalCase.aggregatedResults.totalSum
     */
    positiveCalculationResults: number;
    /**
     * The sum of valeriCalculationResult.normalCase.aggregatedResults.yearlySavingsSum
     */
    totalYearlySavings: number;
    /**
     * Total amount of VALERIs that has valeriCalculationResult
     */
    totalCalculatedResults: number;
    averagePaybackPeriod: number;
};

export type LinkValeriToMeasureDto = {
    /**
     * ID of the measure
     */
    measureId: number;
};

export type ResponseCompanyValeriDefaultsDto = {
    id: number;
    companyId: number;
    /**
     * Equity share in percentage
     */
    equityShare: number;
    /**
     * Planning horizon in years
     */
    planningHorizon: number;
    /**
     * Internal interest rate in percentage
     */
    internalInterestRate: number;
    /**
     * Debt interest rate in percentage
     */
    debtInterestRate: number;
    /**
     * Degradation rate in percentage
     */
    degradationRate: number;
    /**
     * Risk rate in percentage
     */
    riskRate: number;
};

export type UpsertCompanyValeriDefaultsDto = {
    /**
     * Equity share in percentage
     */
    equityShare: number;
    /**
     * Planning horizon in years
     */
    planningHorizon: number;
    /**
     * Internal interest rate in percentage
     */
    internalInterestRate: number;
    /**
     * Debt interest rate in percentage
     */
    debtInterestRate: number;
    /**
     * Degradation rate in percentage
     */
    degradationRate: number;
    /**
     * Risk rate in percentage
     */
    riskRate: number;
};

export type ResponseCompanyEnergyBaselineConfigDto = {
    companyId: number;
    startDate: string;
    endDate: string;
    energyManagementOfficerId?: number | null;
    updatedBy: number;
    updatedAt: string;
};

export type UpsertCompanyEnergyBaselineConfigDto = {
    /**
     * Baseline period start date
     */
    startDate: string;
    /**
     * Baseline period end date
     */
    endDate: string;
    /**
     * User ID of the energy management officer
     */
    energyManagementOfficerId?: number | null;
};

export type UpsertBuildingDto = {
    /**
     * Building ID
     */
    id?: number;
    /**
     * Building name
     */
    title: string;
    /**
     * Location ID
     */
    locationId: number;
};

export type ConsumptionResponseDto = {
    consumption_kwh: number;
};

export type LoadDataEntryDto = {
    timestamp: string;
    value_kw: number;
};

export type DailyDataKWhDto = {
    timestamp: string;
    day_total_kwh: number;
};

export type LoadProfileResponseDto = {
    quarterlyDataKW: Array<LoadDataEntryDto>;
    dailyDataKWh: Array<DailyDataKWhDto>;
    maxPeakloadSoFar: number;
};

export type ConsumptionSeriesRequestDto = {
    /**
     * Device IDs or Series UUIDs
     */
    deviceIds: Array<(string)>;
    /**
     * Start date for data
     */
    from: string;
    /**
     * End date for data
     */
    to: string;
    /**
     * Desired granularity (defaults to original)
     */
    granularity?: '15min' | 'hourly' | 'daily' | 'monthly' | 'original';
};

/**
 * Desired granularity (defaults to original)
 */
export enum granularity2 {
    _15MIN = '15min',
    HOURLY = 'hourly',
    DAILY = 'daily',
    MONTHLY = 'monthly',
    ORIGINAL = 'original'
}

export type ConsumptionSeriesDto = {
    /**
     * Consumption unit
     */
    type: string;
    /**
     * Device ID
     */
    deviceId: string;
    /**
     * Consumption timestamp
     */
    timestamp: string;
    /**
     * Consumption value in KW for kwh type
     */
    value_kw?: number | null;
    /**
     * Normalized value in KWh for kwh type
     */
    value_kwh?: number | null;
    /**
     * Consumption value in m3 for m3 type
     */
    value_m3?: number | null;
    /**
     * Normalized value in m3h for m3 type
     */
    value_m3h?: number | null;
    /**
     * Location ID the meter belongs to. Only present when groupByLocation=true is requested.
     */
    locationId?: number;
};

export type LocationTotalSeriesReferenceDto = {
    id: string;
    type: 'location_total';
};

export enum type4 {
    LOCATION_TOTAL = 'location_total'
}

export type LocationTotalSeriesRequestDto = {
    reference: LocationTotalSeriesReferenceDto;
    from?: string;
    to?: string;
    granularity?: string;
};

export type UpsertCompanyDto = {
    /**
     * Company ID
     */
    id: number;
    /**
     * Company title
     */
    title: string;
    /**
     * Industry ID
     */
    industryId: number;
    /**
     * Firebase ID
     */
    firebaseId: string;
    /**
     * Information
     */
    information: string;
    /**
     * Interaction Context
     */
    interactionContext: string;
    /**
     * Soft delete flag
     */
    isDeleted: boolean;
    /**
     * API key
     */
    apiKey: string | null;
    /**
     * Costless flag
     */
    isCostless: boolean;
    /**
     * Trial flag
     */
    isTrial: boolean;
    /**
     * Demo flag
     */
    isDemo: boolean;
    /**
     * Locations reports included
     */
    includeLocationsReports: boolean;
    /**
     * Account type ID
     */
    accountTypeId: number;
    /**
     * Organization ID
     */
    organizationId: string;
};

/**
 * Premium features enabled for the company
 */
export enum CompanyPremiumFeature {
    REPORTING = 'reporting'
}

export type CompanyDto = {
    id: number;
    industryId: number | null;
    industryNaceCodeId: number | null;
    divisionNaceCodeId: number | null;
    firebaseId: string;
    information?: string | null;
    interactionContext?: string | null;
    title: string;
    isDeleted: boolean;
    apiKey: string | null;
    isCostless: boolean;
    isTrial: boolean;
    isDemo: boolean;
    includeLocationsReports: boolean;
    accountTypeId: number | null;
    organizationId: string | null;
    logoId: number | null;
    whiteLabelLogoId: number | null;
    premiumFeatures: Array<CompanyPremiumFeature>;
};

export type CompanyPremiumFeaturesResponseDto = {
    premiumFeatures: Array<CompanyPremiumFeature>;
};

export type UpdateCompanyPremiumFeaturesDto = {
    premiumFeatures: Array<CompanyPremiumFeature>;
};

export type WeekendSpanDto = {
    startDay?: string | null;
    startTime?: string | null;
    endDay?: string | null;
    endTime?: string | null;
};

export type ReportDto = {
    isEnabled: boolean;
    /**
     * Could be Date[] if actual dates
     */
    missingDays: Array<(string)>;
    schedule: string;
    sentAt?: string | null;
};

export type ReportsDto = {
    dailyElectricityReport: ReportDto;
    monthlyEnergyReport: ReportDto;
    budgetStatusReport: ReportDto;
    performanceVsMarketReport: ReportDto;
    regulatoryDeadlinesReport: ReportDto;
};

export type CustomSectionDto = {
    /**
     * Display name for the custom section
     */
    name?: string | null;
    /**
     * URL to open when the section is selected
     */
    url: string;
};

export type DeviceTreeDto = {
    id: number;
    name?: string | null;
    brand?: string | null;
    model?: string | null;
    ratedCapacity?: number | null;
    installationDate?: string | null;
    /**
     * Main source flag (same meaning as isDefault on MeterEntity)
     */
    isMainSource: boolean;
    factor: number;
    buildingId: number;
    deviceId: string;
    granularity: string;
    granularityUnit: 'MINUTES' | 'MONTHS';
    energyType?: string | null;
    /**
     * API provider / source (SLP, MAKO, DEMO, ...)
     */
    source?: string | null;
    energyTypeId?: number | null;
    measurementUnit?: string | null;
    isVirtual: boolean;
    firstDataDate: string | null;
    lastDataDate: string | null;
    linemetricsInputId: string | null;
    deviceTypeId: number;
    deviceType?: string | null;
    measurementUnitId?: number | null;
    valueTypeId: number;
    obisCodeId: number | null;
};

export enum granularityUnit {
    MINUTES = 'MINUTES',
    MONTHS = 'MONTHS'
}

export type BuildingTreeDto = {
    id: number;
    locationId: number;
    name?: string | null;
    devices: Array<DeviceTreeDto>;
};

export type LocationTreeDto = {
    id: number;
    companyId: number;
    cityId?: number | null;
    name: string;
    meterOperatorId?: number | null;
    postalCode?: string | null;
    streetName?: string | null;
    streetNumber?: string | null;
    employeesCount: number;
    co2Factor: number;
    costFactorGas?: number | null;
    usageMwh: number;
    electricityCostYtd: number;
    electricityPrice: number;
    targetPeakLoad: number;
    ecoPoints: number;
    roofSpace: number;
    delRenewablesShare: number;
    workingDays?: Array<(string)> | null;
    weekendSpan?: (WeekendSpanDto) | null;
    csvFilePath?: string | null;
    shiftBegin?: string | null;
    shiftEnd?: string | null;
    meterInstalledAt?: string | null;
    contractEndsAt?: string | null;
    delIsOtherRenewables: boolean;
    isProcurementRequestSent: boolean;
    isDeleted: boolean;
    isMain: boolean;
    shiftsCount?: number | null;
    firebaseId: string;
    productionDays?: Array<(string)> | null;
    targetEnergyEfficiency?: number | null;
    targetBaseLoad?: number | null;
    procurementModelId?: number | null;
    delEnergyIntensiveShare?: number | null;
    lastYearEfficiencyFactor?: number | null;
    aiContext?: string | null;
    isEnergyPriceTopActive?: boolean | null;
    enabledFrontendRoutes: Array<(string)>;
    reports: ReportsDto;
    efficiencyVariable?: {
        [key: string]: unknown;
    } | null;
    highTariffTimes: {
        [key: string]: unknown;
    };
    costInformation: {
        [key: string]: unknown;
    };
    electricityBudget: {
        [key: string]: unknown;
    };
    provider?: string | null;
    electricityPurchaseKnowHow?: number | null;
    preciseNextYearEnergyPlan?: number | null;
    targets: {
        [key: string]: unknown;
    };
    yearlyConsumption?: number | null;
    isCostless: boolean;
    potentials: {
        [key: string]: unknown;
    };
    lastBudgetState?: string | null;
    currentPeakloadYtd?: {
        [key: string]: unknown;
    } | null;
    energyManagerSettings?: {
        [key: string]: unknown;
    } | null;
    customSection?: (CustomSectionDto) | null;
    enabledModules: Array<('procurement' | 'measures' | 'iso50001' | 'messstellen' | 'ai-invoice-checking' | 'invoice-checking' | 'procurement-freemium' | 'reports' | 'analyses' | 'data-management' | 'flex' | 'energy-cost' | 'custom-section' | 'insight-inbox')>;
    lifecycleStatusId?: number | null;
    buildings: Array<BuildingTreeDto>;
};

export type UpsertLocationDto = {
    id?: number;
    title: string;
    companyId: number;
    cityId?: number | null;
    postalCode?: string | null;
    streetName?: string | null;
    streetNumber?: string | null;
    employeesCount: number;
    co2Factor: number;
    usageMwh?: number;
    electricityCostYtd?: number;
    electricityPrice?: number;
    targetPeakLoad: number;
    ecoPoints?: number;
    roofSpace?: number;
    delRenewablesShare?: number;
    workingDays?: Array<(string)> | null;
    weekendSpan?: (WeekendSpanDto) | null;
    csvFilePath?: string | null;
    shiftBegin?: string | null;
    shiftEnd?: string | null;
    lifecycleStatusId?: number | null;
    meterInstalledAt?: string | null;
    contractEndsAt?: string | null;
    delIsOtherRenewables?: boolean;
    isProcurementRequestSent?: boolean;
    isDeleted: boolean;
    isMain?: boolean;
    shiftsCount?: number | null;
    firebaseId?: string;
    productionDays?: Array<(string)> | null;
    targetEnergyEfficiency?: number | null;
    targetBaseLoad?: number | null;
    procurementModelId?: number | null;
    delEnergyIntensiveShare?: number | null;
    lastYearEfficiencyFactor?: number | null;
    aiContext?: string | null;
    isEnergyPriceTopActive?: boolean | null;
    enabledFrontendRoutes?: Array<(string)>;
    reports?: ReportsDto;
    efficiencyVariable?: {
        [key: string]: unknown;
    } | null;
    highTariffTimes?: {
        [key: string]: unknown;
    };
    costInformation?: {
        [key: string]: unknown;
    };
    electricityBudget?: {
        [key: string]: unknown;
    };
    provider?: string | null;
    electricityPurchaseKnowHow?: number | null;
    preciseNextYearEnergyPlan?: number | null;
    targets?: {
        [key: string]: unknown;
    };
    yearlyConsumption?: number | null;
    isCostless: boolean;
    potentials?: {
        [key: string]: unknown;
    };
    lastBudgetState?: string | null;
    currentPeakloadYtd?: {
        [key: string]: unknown;
    } | null;
    energyManagerSettings?: {
        [key: string]: unknown;
    } | null;
    enabledModules?: Array<('procurement' | 'measures' | 'iso50001' | 'messstellen' | 'ai-invoice-checking' | 'invoice-checking' | 'procurement-freemium' | 'reports' | 'analyses' | 'data-management' | 'flex' | 'energy-cost' | 'custom-section' | 'insight-inbox')>;
    customSection?: (CustomSectionDto) | null;
    meterOperatorId?: number | null;
    costFactorGas?: number | null;
};

export type TemperatureResponseDto = {
    /**
     * Temperature ID
     */
    id: number;
    /**
     * Name of the temperature location
     */
    name: string;
    /**
     * Longitude coordinate
     */
    longitude: number;
    /**
     * Latitude coordinate
     */
    latitude: number;
    /**
     * ZIP code
     */
    zipCode: string;
    /**
     * Location ID
     */
    locationId: number | null;
};

export type TemperatureDataPointDto = {
    /**
     * Timestamp of the temperature reading in ISO format
     */
    timestamp: string;
    /**
     * Temperature value in Celsius
     */
    value: number;
};

export type WeatherDataResponseDto = {
    /**
     * Temperature location ID
     */
    id: number;
    /**
     * Longitude coordinate
     */
    longitude: number;
    /**
     * Latitude coordinate
     */
    latitude: number;
    /**
     * Array of temperature data points
     */
    temperature: Array<TemperatureDataPointDto>;
};

export type CreateTemperatureDto = {
    /**
     * Name of the temperature location
     */
    name: string;
    /**
     * Longitude coordinate with 4 decimal places
     */
    longitude: number;
    /**
     * Latitude coordinate with 4 decimal places
     */
    latitude: number;
    /**
     * ZIP code
     */
    zipCode: string;
};

export type UpdateTemperatureDto = {
    /**
     * Name of the temperature location
     */
    name?: string;
    /**
     * Longitude coordinate with 4 decimal places
     */
    longitude?: number;
    /**
     * Latitude coordinate with 4 decimal places
     */
    latitude?: number;
    /**
     * ZIP code
     */
    zipCode?: string;
};

export type CityDto = {
    id: number;
    name: string;
    latitude?: number;
    longitude?: number;
};

export type CreateCityGeocodeDto = {
    /**
     * Name sent to the geocoder to resolve coordinates.
     */
    searchName: string;
    /**
     * Name persisted as the city title.
     */
    displayName: string;
    /**
     * State / Bundesland filter (Open-Meteo admin1).
     */
    state?: string;
    /**
     * District / Landkreis filter (Open-Meteo admin3).
     */
    district?: string;
    /**
     * Municipality filter (Open-Meteo admin4).
     */
    municipality?: string;
};

export type CityGeocodePreviewDto = {
    name: string;
    latitude: number;
    longitude: number;
    /**
     * State / Bundesland (Open-Meteo admin1).
     */
    state?: string;
    /**
     * District / Landkreis (Open-Meteo admin3).
     */
    district?: string;
    /**
     * Municipality (Open-Meteo admin4).
     */
    municipality?: string;
    /**
     * The title that would be persisted for the city.
     */
    displayName: string;
    /**
     * True if committing would create a new city, false if it would update an existing one.
     */
    wouldCreate: boolean;
};

export type CustomTimeseriesResolutionDto = {
    minutes: number;
    label: string;
    enum: string;
};

export type CustomTimeseriesListItemDto = {
    id: number;
    title: string;
    name: string;
    details: string | null;
    type: string;
    groupId: number;
    companyName: string;
    locationId: number;
    locationName: string;
    buildingId: number | null;
    buildingName: string | null;
    energyType: string;
    resolution: CustomTimeseriesResolutionDto;
    aggregationType: string;
    unit: string;
    startDate: string | null;
    endDate: string | null;
};

export type PageableMetadataDto = {
    currentPage: number;
    pageSize: number;
    totalItems: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
};

export type CustomTimeseriesListResponseDto = {
    tableData: Array<CustomTimeseriesListItemDto>;
    metadata: PageableMetadataDto;
};

export type MonthlySeriesGroupingDto = {
    /**
     * Month name in lowercase
     */
    month: string;
    /**
     * Year-based values for this month
     */
    yearValues: {
        [key: string]: {
            value: number | null;
        };
    };
};

export type AggregatedMonthlyPeakloadsResponseDto = {
    /**
     * Monthly comparison data grouped by month
     */
    monthlyData: Array<MonthlySeriesGroupingDto>;
};

export type AggregatedMonthlyBaseloadsResponseDto = {
    /**
     * Monthly baseloads aggregated by devices grouped by month over a given year
     */
    monthlyData: Array<MonthlySeriesGroupingDto>;
};

export type AvailableMainMeterDto = {
    /**
     * Unique numeric identifier of the meter record
     */
    id: number;
    /**
     * Identifier of the device to which this meter belongs
     */
    deviceId: string;
    /**
     * Human‑readable title of the meter
     */
    meterTitle: string;
    /**
     * Numeric identifier of the location where the meter is installed
     */
    locationId: number;
    /**
     * Numeric identifier of the company that owns the meter
     */
    companyId: number;
    /**
     * Human‑readable title of the location
     */
    locationTitle: string;
    /**
     * Numeric identifier of the building that contains the location
     */
    buildingId: number;
    /**
     * Human‑readable title of the building
     */
    buildingTitle: string;
};

export type GenerationLoadProfileDto = {
    /**
     * Identifier
     */
    readonly id: number;
    /**
     * Name of the generation load profile.
     */
    name: string;
    /**
     * How much energy this load profile generates on an annual basis
     */
    annualGeneration: number;
};

export type IsoMeasureDto = {
    /**
     * Identifier
     */
    readonly id: number;
    /**
     * Title of the measure.
     */
    title: string;
    /**
     * Deadline of the measure.
     */
    deadline?: string;
    /**
     * Effectiveness date of the measure.
     */
    effectivenessDate?: string;
};

export type LoadSimulationDataDto = {
    /**
     * Unique identifier of the device that generated the measurement
     */
    deviceId: string;
    /**
     * Timestamp of the measurement
     */
    timestamp: string;
    /**
     * Measured energy consumption in kilowatt‑hours
     */
    valueKwh: number | null;
    /**
     * Measured power in kilowatts
     */
    valueKw: number | null;
    /**
     * Simulated power (kW) produced by the simulation algorithm
     */
    simulatedKw: number | null;
    /**
     * Simulated energy consumption (kWh) derived simulation algorithm
     */
    simulatedKwh: number | null;
    /**
     * Delta from actual to simulated value of power (kW) produced by the simulation algorithm
     */
    deltaKw: number | null;
    /**
     * Delta from actual to simulated value of power (kWh) derived simulation algorithm
     */
    deltaKwh: number | null;
    /**
     * Indicates whether the record is expressed in kW or kWh
     */
    type: 'kw' | 'kwh';
};

/**
 * Indicates whether the record is expressed in kW or kWh
 */
export enum type5 {
    KW = 'kw',
    KWH = 'kwh'
}

export type PeakLoadSavingsDto = {
    /**
     * Previous peak‑load (kW)
     */
    peakLoadOldKw: number;
    /**
     * Optimized peak‑load (kW)
     */
    peakLoadNewKw: number;
    /**
     * Savings in euros
     */
    savingsEuro: number;
};

export type QuantityChangeSavingsDto = {
    /**
     * Original quantity (kWh)
     */
    quantityOldKwh: number;
    /**
     * Adjusted quantity (kWh)
     */
    quantityNewKwh: number;
    /**
     * Savings in euros
     */
    savingsEuro: number;
};

export type FlexibilitySavingsDto = {
    /**
     * Spot price before (EUR)
     */
    spotPriceOldEuro: number;
    /**
     * Spot price after (EUR)
     */
    spotPriceNewEuro: number;
    /**
     * Spot price before (c/kwH)
     */
    spotPriceOldCentPerKwh: number;
    /**
     * Spot price after (c/kwH)
     */
    spotPriceNewCentPerKwh: number;
    /**
     * Savings in euros
     */
    savingsEuro: number;
};

export type LoadSimulationSavingsKpis = {
    /**
     * Peak‑load savings
     */
    savingsPeakLoad: PeakLoadSavingsDto;
    /**
     * Quantity‑change savings
     */
    savingsQuantityChange: QuantityChangeSavingsDto;
    /**
     * Flexibility savings
     */
    savingsFlexibility: FlexibilitySavingsDto;
    /**
     * Total savings (EUR)
     */
    totalSavingsEuro: number;
};

export type EfficiencyImprovementSimulationDto = {
    /**
     * Identifier
     */
    readonly id: number;
    /**
     * Name of the simulation.
     */
    name: string;
    /**
     * Identifier of the main meter this simulation applies to.
     */
    mainMeterId: number;
    /**
     * Identifier of the location this simulation applies to.
     */
    locationId: number;
    /**
     * Optional measure attached to the simulation. Null if none.
     */
    measure?: IsoMeasureDto;
    /**
     * Discriminator – tells the API which concrete payload follows.
     */
    simulationType: 'EFFICIENCY_IMPROVEMENT' | 'ONSITE_GENERATION' | 'FLEXIBILITY';
    /**
     * Boolean flag determining, if flex savings should be considered in the overall savings
     */
    includeFlexSavings: boolean;
    /**
     * Boolean flag determining if this simulation can be included in load planning. Can only be true if a measure with a deadline is attached.
     */
    allowLoadPlanningInclusion: boolean;
    /**
     * Timestamp of the earliest consumption data point contained in that simulation
     */
    calculatedFrom: string | null;
    /**
     * Timestamp of the latest consumption data point contained in that simulation
     */
    calculatedTo: string | null;
    /**
     * Timestamp of when the simulation was calculated
     */
    calculatedAt: string | null;
    /**
     * Contains the data points of the simulation graph
     */
    graphData?: Array<LoadSimulationDataDto>;
    /**
     * Combined decision on whether this fulfills the requirements to be included in Load Planning
     */
    canBeIncludedInLoadPlanning: boolean;
    /**
     * Target increase in efficiency (kW).
     */
    efficiencyGainKw: number;
    /**
     * Weekdays on which the efficiency gain is applied.
     */
    applicableWeekdays: Array<('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')>;
    /**
     * Start of the daily time window (HH:mm) when the improvement is active.
     */
    applicableTimeframeFrom: string;
    /**
     * End of the daily time window (HH:mm) when the improvement is active.
     */
    applicableTimeframeTo: string;
    kpis?: LoadSimulationSavingsKpis;
};

/**
 * Discriminator – tells the API which concrete payload follows.
 */
export enum simulationType {
    EFFICIENCY_IMPROVEMENT = 'EFFICIENCY_IMPROVEMENT',
    ONSITE_GENERATION = 'ONSITE_GENERATION',
    FLEXIBILITY = 'FLEXIBILITY'
}

export type OnsiteGenerationSimulationDto = {
    /**
     * Identifier
     */
    readonly id: number;
    /**
     * Name of the simulation.
     */
    name: string;
    /**
     * Identifier of the main meter this simulation applies to.
     */
    mainMeterId: number;
    /**
     * Identifier of the location this simulation applies to.
     */
    locationId: number;
    /**
     * Optional measure attached to the simulation. Null if none.
     */
    measure?: IsoMeasureDto;
    /**
     * Discriminator – tells the API which concrete payload follows.
     */
    simulationType: 'EFFICIENCY_IMPROVEMENT' | 'ONSITE_GENERATION' | 'FLEXIBILITY';
    /**
     * Boolean flag determining, if flex savings should be considered in the overall savings
     */
    includeFlexSavings: boolean;
    /**
     * Boolean flag determining if this simulation can be included in load planning. Can only be true if a measure with a deadline is attached.
     */
    allowLoadPlanningInclusion: boolean;
    /**
     * Timestamp of the earliest consumption data point contained in that simulation
     */
    calculatedFrom: string | null;
    /**
     * Timestamp of the latest consumption data point contained in that simulation
     */
    calculatedTo: string | null;
    /**
     * Timestamp of when the simulation was calculated
     */
    calculatedAt: string | null;
    /**
     * Contains the data points of the simulation graph
     */
    graphData?: Array<LoadSimulationDataDto>;
    /**
     * Combined decision on whether this fulfills the requirements to be included in Load Planning
     */
    canBeIncludedInLoadPlanning: boolean;
    /**
     * Identifier of the generation load profile that drives the simulation.
     */
    generationLoadProfileId: number;
    /**
     * Expected annual generation produced by the on‑site assets.
     */
    annualGeneration: number;
    kpis?: LoadSimulationSavingsKpis;
};

export type FlexibilitySimulationDto = {
    /**
     * Identifier
     */
    readonly id: number;
    /**
     * Name of the simulation.
     */
    name: string;
    /**
     * Identifier of the main meter this simulation applies to.
     */
    mainMeterId: number;
    /**
     * Identifier of the location this simulation applies to.
     */
    locationId: number;
    /**
     * Optional measure attached to the simulation. Null if none.
     */
    measure?: IsoMeasureDto;
    /**
     * Discriminator – tells the API which concrete payload follows.
     */
    simulationType: 'EFFICIENCY_IMPROVEMENT' | 'ONSITE_GENERATION' | 'FLEXIBILITY';
    /**
     * Boolean flag determining, if flex savings should be considered in the overall savings
     */
    includeFlexSavings: boolean;
    /**
     * Boolean flag determining if this simulation can be included in load planning. Can only be true if a measure with a deadline is attached.
     */
    allowLoadPlanningInclusion: boolean;
    /**
     * Timestamp of the earliest consumption data point contained in that simulation
     */
    calculatedFrom: string | null;
    /**
     * Timestamp of the latest consumption data point contained in that simulation
     */
    calculatedTo: string | null;
    /**
     * Timestamp of when the simulation was calculated
     */
    calculatedAt: string | null;
    /**
     * Contains the data points of the simulation graph
     */
    graphData?: Array<LoadSimulationDataDto>;
    /**
     * Combined decision on whether this fulfills the requirements to be included in Load Planning
     */
    canBeIncludedInLoadPlanning: boolean;
    /**
     * Amount of load shift (kW).
     */
    loadShiftAmountKw: number;
    /**
     * Weekdays on which the flexibility action is applied.
     */
    applicableWeekdays: Array<('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')>;
    /**
     * Original start time of the load (HH:mm).
     */
    oldStartTime: string;
    /**
     * New start time after shifting (HH:mm).
     */
    newStartTime: string;
    /**
     * Duration of the shifted period (hours).
     */
    durationHours: number;
    kpis?: LoadSimulationSavingsKpis;
};

export type CreateEfficiencyImprovementSimulationRequestDto = {
    name: string;
    mainMeterId: number;
    measureId?: number;
    simulationType: 'EFFICIENCY_IMPROVEMENT' | 'ONSITE_GENERATION' | 'FLEXIBILITY';
    /**
     * Boolean flag determining, if flex savings should be considered in the overall savings
     */
    includeFlexSavings: boolean;
    companyId: number;
    /**
     * Allow this simulation to be included in load planning. Can only be true if a measure with a deadline is attached.
     */
    allowLoadPlanningInclusion?: boolean;
    efficiencyGainKw: number;
    applicableWeekdays: Array<(string)>;
    applicableTimeframeFrom: string;
    applicableTimeframeTo: string;
};

export type CreateOnsiteGenerationSimulationRequestDto = {
    name: string;
    mainMeterId: number;
    measureId?: number;
    simulationType: 'EFFICIENCY_IMPROVEMENT' | 'ONSITE_GENERATION' | 'FLEXIBILITY';
    /**
     * Boolean flag determining, if flex savings should be considered in the overall savings
     */
    includeFlexSavings: boolean;
    companyId: number;
    /**
     * Allow this simulation to be included in load planning. Can only be true if a measure with a deadline is attached.
     */
    allowLoadPlanningInclusion?: boolean;
    generationLoadProfileId: number;
    annualGeneration: number;
};

export type CreateFlexibilitySimulationRequestDto = {
    name: string;
    mainMeterId: number;
    measureId?: number;
    simulationType: 'EFFICIENCY_IMPROVEMENT' | 'ONSITE_GENERATION' | 'FLEXIBILITY';
    /**
     * Boolean flag determining, if flex savings should be considered in the overall savings
     */
    includeFlexSavings: boolean;
    companyId: number;
    /**
     * Allow this simulation to be included in load planning. Can only be true if a measure with a deadline is attached.
     */
    allowLoadPlanningInclusion?: boolean;
    loadShiftAmountKw: number;
    applicableWeekdays: Array<(string)>;
    oldStartTime: string;
    newStartTime: string;
    durationHours: number;
};

export type CreateSimulationRequestDto = {
    simulation: CreateEfficiencyImprovementSimulationRequestDto | CreateOnsiteGenerationSimulationRequestDto | CreateFlexibilitySimulationRequestDto;
};

export type GenerationLoadProfileWriteDto = {
    /**
     * Name of the generation load profile.
     */
    name: string;
    /**
     * Reference value of the annual generation for that profile
     */
    annualGeneration: number;
};

export type EnpiEntity = {
    id: number;
    title: string;
    efficiencyTrendVsLastPeriod: number;
    seuId: {
        [key: string]: unknown;
    };
    influencingFactorId?: {
        [key: string]: unknown;
    } | null;
    adjustmentFactors: Array<{
        [key: string]: unknown;
    }>;
    referenceDateTo: string;
    referenceDateFrom: string;
    locationId: number;
    targetValue?: number;
    currentValue?: number;
    isMainEnpi: boolean;
    responsibleUser?: string | null;
    description?: string;
    targetValueType: 'absolute' | 'relative';
    interval: 'yearly' | 'monthly' | 'weekly' | 'daily';
    changeHistory: {
        [key: string]: unknown;
    };
    comments?: {
        [key: string]: unknown;
    };
    fallback: {
        lastIntervalValue?: number | null;
        lastEfficiencyTrendValue?: number | null;
    };
    results: {
        [key: string]: unknown;
    } | null;
    lastUpdateFailed: boolean;
    influencingFactor?: {
        [key: string]: unknown;
    };
    seuMetadata?: {
        [key: string]: unknown;
    };
    isArchived: boolean;
    archiveUser?: string;
    lastCalculatedAt?: string;
};

export type DeviceReferencesResponseDto = {
    visualizations: Array<Visualization>;
    enpiReferences: Array<EnpiEntity>;
};

export type SlpConsumptionGetDto = {
    timestamp: string;
    deviceId: string;
    value: number;
};

export type SlpConsumptionResponseDto = {
    consumption: Array<SlpConsumptionGetDto>;
};

export type SlpConsumptionDto = {
    year: number;
    monthId: number;
    value: number;
};

export type SlpConsumptionPutRequestDto = {
    consumption: Array<SlpConsumptionDto>;
};

export type SlpMeterReadingResponseDto = {
    /**
     * The unique identifier of the reading
     */
    id: number;
    /**
     * The device ID
     */
    deviceId: string;
    /**
     * The meter reading value
     */
    value: number;
    /**
     * The UID of the image stored in object storage
     */
    imageId: string;
    /**
     * Timestamp when the reading was taken
     */
    timestamp: string;
};

export type CreateSlpMeterReadingDto = {
    /**
     * The meter reading value
     */
    value: number;
    /**
     * The UID of the image stored in object storage
     */
    imageId?: string;
    /**
     * Timestamp when the reading was taken
     */
    timestamp: string;
};

export type SlpMeterReadingValidationErrorDto = {
    /**
     * The validation error code
     */
    code: 'NEW_READING_HIGHER_THAN_NEXT_READING' | 'NEW_READING_LOWER_THAN_PREV_READING' | 'NEW_READING_TOO_HIGH';
    /**
     * Additional payload data related to the validation error. Can be a reading object, array of unsafe period information tuples [timestamp, value], or null
     */
    payload: SlpMeterReadingResponseDto | Array<(unknown[])> | null | null;
};

/**
 * The validation error code
 */
export enum code {
    NEW_READING_HIGHER_THAN_NEXT_READING = 'NEW_READING_HIGHER_THAN_NEXT_READING',
    NEW_READING_LOWER_THAN_PREV_READING = 'NEW_READING_LOWER_THAN_PREV_READING',
    NEW_READING_TOO_HIGH = 'NEW_READING_TOO_HIGH'
}

export type UploadSlpImageDto = {
    /**
     * The meter reading image file
     */
    file: (Blob | File);
};

export type UploadSlpImageResponseDto = {
    /**
     * Indicates if the upload and reading extraction was successful
     */
    success: boolean;
    /**
     * The extracted meter reading value
     */
    reading: number;
    /**
     * The UID of the uploaded image stored in object storage
     */
    imageId: string;
};

export type GasCostYearInformationDto = {
    spotIndex: 'EGSI' | 'EOD';
};

export enum spotIndex {
    EGSI = 'EGSI',
    EOD = 'EOD'
}

export type GasCostInformationResponseDto = {
    locationId: number;
    gasCostInformation: {
        [key: string]: GasCostYearInformationDto;
    };
};

export type MonthlyData = {
    month: string;
    budget: number;
    cost: number;
    deviation: number;
};

export type BudgetTrackingResponseDto = {
    monthlyData: Array<MonthlyData>;
    availableYears: Array<(number)>;
};

export type ConsumptionMonthlyDataDto = {
    month: string;
    currentYearKWh: number;
    pastYearKWh: number;
    year1: number;
    year2: number;
};

export type ConsumptionTrendsResponseDto = {
    totalConsumptionYtdKWh: number;
    totalConsumptionInTimeframe: number;
    trend: number | null;
    monthlyData?: Array<ConsumptionMonthlyDataDto> | null;
};

export type MonthlyHistoricEntryDto = {
    month: string;
};

export type ConsumptionHistoryResponseDto = {
    monthlyHistoricConsumption: Array<MonthlyHistoricEntryDto>;
    totalConsumptionYtdKwh: number;
    totalConsumptionPastMonthKWh: number;
    yearEndPrognose: number | null;
};

export type CalculateEnetCostsBodyDto = {
    year: string;
    deviceId?: string;
    locationId?: number;
    companyId?: number;
    forceHedgeArbeitpreisCalculation?: boolean;
};

export type CalculateDailyPeakloadForDateRangeBodyDto = unknown;

export type CalculateDailyBaseloadForDateRangeBodyDto = unknown;

export type DeviceEnergyPerformanceMetricsDto = {
    /**
     * Consumption from the beginning of the year to the current date (Year-to-Date).
     */
    consumptionYtd?: number;
    /**
     * Consumption from the beginning of the previous year to the same date as current YTD.
     */
    consumptionYtdLastYear?: number;
    /**
     * Total consumption during the previous calendar month.
     */
    consumptionPreviousMonth?: number;
    /**
     * Estimated total consumption for the full current year.
     */
    consumptionPrognoseYearEnd?: number;
    /**
     * Total consumption for the full selected year.
     */
    consumptionYear?: number;
    /**
     * Total consumption for the full previous year.
     */
    consumptionLastYear?: number;
    /**
     * Percentage change in YTD consumption compared to the same period last year. At aggregated levels, recalculated from aggregated values.
     */
    consumptionYtdYearOverYearChangePercentage?: number;
    /**
     * Percentage change in full year consumption compared to the previous year.
     */
    consumptionYearYearOverYearChangePercentage?: number;
    /**
     * Total cost for the current calendar month.
     */
    costCurrentMonth?: number;
    /**
     * Total cost from the beginning of the year to the current date (YTD).
     */
    costYtd?: number;
    /**
     * Estimated total cost for the full current year.
     */
    costPrognoseYearEnd?: number;
    /**
     * Percentage of the current month's budget spent.
     */
    costToBudgetCurrentMonthPercentage?: number;
    /**
     * Percentage of the prorated YTD budget spent.
     */
    costToBudgetYtdPercentage?: number;
    /**
     * Projected percentage of the annual budget to be spent by year-end.
     */
    costToBudgetPrognoseYearEndPercentage?: number;
    /**
     * Average minimum power consumption (baseload) for the year.
     */
    baseload?: number;
    /**
     * Baseload for the previous calendar month.
     */
    baseloadPreviousMonth?: number;
    /**
     * Percentage change in baseload compared to the previous year. At aggregated levels, weighted by full year consumption.
     */
    baseloadYearOverYearChangePercentage?: number;
    /**
     * Highest peak power consumption for the year.
     */
    peakload?: number;
    /**
     * Peak load for the previous calendar month.
     */
    peakloadPreviousMonth?: number;
    /**
     * Percentage change in peak load compared to the previous year. At aggregated levels, weighted by full year consumption.
     */
    peakloadYearOverYearChangePercentage?: number;
    deviceId: string;
    deviceName: string;
    energyType?: {
        [key: string]: unknown;
    };
    /**
     * The prorated YTD budget for the entire location. This value is repeated here for context.
     */
    locationBudgetYtd?: number;
    /**
     * The budget for the current month for the entire location. This value is repeated here for context.
     */
    locationBudgetCurrentMonth?: number;
    /**
     * The total annual budget for the entire location. This value is repeated here for context.
     */
    locationBudgetYear?: number;
};

export type BuildingEnergyPerformanceMetricsDto = {
    /**
     * Consumption from the beginning of the year to the current date (Year-to-Date).
     */
    consumptionYtd?: number;
    /**
     * Consumption from the beginning of the previous year to the same date as current YTD.
     */
    consumptionYtdLastYear?: number;
    /**
     * Total consumption during the previous calendar month.
     */
    consumptionPreviousMonth?: number;
    /**
     * Estimated total consumption for the full current year.
     */
    consumptionPrognoseYearEnd?: number;
    /**
     * Total consumption for the full selected year.
     */
    consumptionYear?: number;
    /**
     * Total consumption for the full previous year.
     */
    consumptionLastYear?: number;
    /**
     * Percentage change in YTD consumption compared to the same period last year. At aggregated levels, recalculated from aggregated values.
     */
    consumptionYtdYearOverYearChangePercentage?: number;
    /**
     * Percentage change in full year consumption compared to the previous year.
     */
    consumptionYearYearOverYearChangePercentage?: number;
    /**
     * Total cost for the current calendar month.
     */
    costCurrentMonth?: number;
    /**
     * Total cost from the beginning of the year to the current date (YTD).
     */
    costYtd?: number;
    /**
     * Estimated total cost for the full current year.
     */
    costPrognoseYearEnd?: number;
    /**
     * Percentage of the current month's budget spent.
     */
    costToBudgetCurrentMonthPercentage?: number;
    /**
     * Percentage of the prorated YTD budget spent.
     */
    costToBudgetYtdPercentage?: number;
    /**
     * Projected percentage of the annual budget to be spent by year-end.
     */
    costToBudgetPrognoseYearEndPercentage?: number;
    /**
     * Average minimum power consumption (baseload) for the year.
     */
    baseload?: number;
    /**
     * Baseload for the previous calendar month.
     */
    baseloadPreviousMonth?: number;
    /**
     * Percentage change in baseload compared to the previous year. At aggregated levels, weighted by full year consumption.
     */
    baseloadYearOverYearChangePercentage?: number;
    /**
     * Highest peak power consumption for the year.
     */
    peakload?: number;
    /**
     * Peak load for the previous calendar month.
     */
    peakloadPreviousMonth?: number;
    /**
     * Percentage change in peak load compared to the previous year. At aggregated levels, weighted by full year consumption.
     */
    peakloadYearOverYearChangePercentage?: number;
    buildingId: number;
    buildingName: string;
    devices: Array<DeviceEnergyPerformanceMetricsDto>;
    /**
     * The prorated YTD budget for the entire location. This value is repeated here for context.
     */
    locationBudgetYtd?: number;
    /**
     * The budget for the current month for the entire location. This value is repeated here for context.
     */
    locationBudgetCurrentMonth?: number;
    /**
     * The total annual budget for the entire location. This value is repeated here for context.
     */
    locationBudgetYear?: number;
};

export type LocationEnergyPerformanceMetricsDto = {
    /**
     * Consumption from the beginning of the year to the current date (Year-to-Date).
     */
    consumptionYtd?: number;
    /**
     * Consumption from the beginning of the previous year to the same date as current YTD.
     */
    consumptionYtdLastYear?: number;
    /**
     * Total consumption during the previous calendar month.
     */
    consumptionPreviousMonth?: number;
    /**
     * Estimated total consumption for the full current year.
     */
    consumptionPrognoseYearEnd?: number;
    /**
     * Total consumption for the full selected year.
     */
    consumptionYear?: number;
    /**
     * Total consumption for the full previous year.
     */
    consumptionLastYear?: number;
    /**
     * Percentage change in YTD consumption compared to the same period last year. At aggregated levels, recalculated from aggregated values.
     */
    consumptionYtdYearOverYearChangePercentage?: number;
    /**
     * Percentage change in full year consumption compared to the previous year.
     */
    consumptionYearYearOverYearChangePercentage?: number;
    /**
     * Total cost for the current calendar month.
     */
    costCurrentMonth?: number;
    /**
     * Total cost from the beginning of the year to the current date (YTD).
     */
    costYtd?: number;
    /**
     * Estimated total cost for the full current year.
     */
    costPrognoseYearEnd?: number;
    /**
     * Percentage of the current month's budget spent.
     */
    costToBudgetCurrentMonthPercentage?: number;
    /**
     * Percentage of the prorated YTD budget spent.
     */
    costToBudgetYtdPercentage?: number;
    /**
     * Projected percentage of the annual budget to be spent by year-end.
     */
    costToBudgetPrognoseYearEndPercentage?: number;
    /**
     * Average minimum power consumption (baseload) for the year.
     */
    baseload?: number;
    /**
     * Baseload for the previous calendar month.
     */
    baseloadPreviousMonth?: number;
    /**
     * Percentage change in baseload compared to the previous year. At aggregated levels, weighted by full year consumption.
     */
    baseloadYearOverYearChangePercentage?: number;
    /**
     * Highest peak power consumption for the year.
     */
    peakload?: number;
    /**
     * Peak load for the previous calendar month.
     */
    peakloadPreviousMonth?: number;
    /**
     * Percentage change in peak load compared to the previous year. At aggregated levels, weighted by full year consumption.
     */
    peakloadYearOverYearChangePercentage?: number;
    locationId: number;
    locationName: string;
    buildings: Array<BuildingEnergyPerformanceMetricsDto>;
    /**
     * The prorated YTD budget for the location.
     */
    budgetYtd?: number;
    /**
     * The budget for the current month for the location.
     */
    budgetCurrentMonth?: number;
    /**
     * The total annual budget for the location.
     */
    budgetYear?: number;
};

export type GroupEnergyPerformanceMetricsDto = {
    /**
     * Consumption from the beginning of the year to the current date (Year-to-Date).
     */
    consumptionYtd?: number;
    /**
     * Consumption from the beginning of the previous year to the same date as current YTD.
     */
    consumptionYtdLastYear?: number;
    /**
     * Total consumption during the previous calendar month.
     */
    consumptionPreviousMonth?: number;
    /**
     * Estimated total consumption for the full current year.
     */
    consumptionPrognoseYearEnd?: number;
    /**
     * Total consumption for the full selected year.
     */
    consumptionYear?: number;
    /**
     * Total consumption for the full previous year.
     */
    consumptionLastYear?: number;
    /**
     * Percentage change in YTD consumption compared to the same period last year. At aggregated levels, recalculated from aggregated values.
     */
    consumptionYtdYearOverYearChangePercentage?: number;
    /**
     * Percentage change in full year consumption compared to the previous year.
     */
    consumptionYearYearOverYearChangePercentage?: number;
    /**
     * Total cost for the current calendar month.
     */
    costCurrentMonth?: number;
    /**
     * Total cost from the beginning of the year to the current date (YTD).
     */
    costYtd?: number;
    /**
     * Estimated total cost for the full current year.
     */
    costPrognoseYearEnd?: number;
    /**
     * Percentage of the current month's budget spent.
     */
    costToBudgetCurrentMonthPercentage?: number;
    /**
     * Percentage of the prorated YTD budget spent.
     */
    costToBudgetYtdPercentage?: number;
    /**
     * Projected percentage of the annual budget to be spent by year-end.
     */
    costToBudgetPrognoseYearEndPercentage?: number;
    /**
     * Average minimum power consumption (baseload) for the year.
     */
    baseload?: number;
    /**
     * Baseload for the previous calendar month.
     */
    baseloadPreviousMonth?: number;
    /**
     * Percentage change in baseload compared to the previous year. At aggregated levels, weighted by full year consumption.
     */
    baseloadYearOverYearChangePercentage?: number;
    /**
     * Highest peak power consumption for the year.
     */
    peakload?: number;
    /**
     * Peak load for the previous calendar month.
     */
    peakloadPreviousMonth?: number;
    /**
     * Percentage change in peak load compared to the previous year. At aggregated levels, weighted by full year consumption.
     */
    peakloadYearOverYearChangePercentage?: number;
    regionId?: number;
    regionName?: string;
    companyId: number;
    companyName: string;
    locations: Array<LocationEnergyPerformanceMetricsDto>;
    /**
     * The aggregated prorated YTD budget for the group of locations.
     */
    budgetYtd?: number;
    /**
     * The aggregated budget for the current month for the group of locations.
     */
    budgetCurrentMonth?: number;
    /**
     * The aggregated total annual budget for the group of locations.
     */
    budgetYear?: number;
};

export type LocationEnergyPerformanceMetricsResponseDto = {
    metrics: GroupEnergyPerformanceMetricsDto;
    totalDocs: number;
};

export type StoreHedgeCostMonthlySummaryBodyDto = {
    /**
     * Year
     */
    year: number;
    /**
     * Month
     */
    month?: number;
    /**
     * Company ID
     */
    companyId?: number;
};

export type RecalculateDeviceMetricsDto = {
    /**
     * Year to calculate metrics for
     */
    year: number;
    /**
     * Filter by company IDs
     */
    companyIds?: Array<(number)>;
    /**
     * Filter by location IDs
     */
    locationIds?: Array<(number)>;
    /**
     * Filter by device IDs
     */
    deviceIds?: Array<(string)>;
};

export type CostsSummaryValuesDto = {
    /**
     * Total hedged amount
     */
    totalHedgeAmount: number;
    /**
     * Total hedge cost
     */
    totalHedgeCost: number;
    /**
     * Total spot amount
     */
    totalSpotAmount: number;
    /**
     * Total spot cost
     */
    totalSpotCost: number;
    /**
     * Last update timestamp
     */
    updatedAt: string;
};

export type CostsSummaryResponseDto = {
    /**
     * Summerized Values
     */
    values?: CostsSummaryValuesDto;
};

export type LocationModulesResponseDto = {
    /**
     * Array of enabled modules for the location
     */
    enabledModules: Array<('procurement' | 'measures' | 'iso50001' | 'messstellen' | 'ai-invoice-checking' | 'invoice-checking' | 'procurement-freemium' | 'reports' | 'analyses' | 'data-management' | 'flex' | 'energy-cost' | 'custom-section' | 'insight-inbox')>;
    /**
     * Custom section for the location
     */
    customSection?: (CustomSectionDto) | null;
};

export type UpdateEnabledModulesRequestDto = {
    /**
     * List of enabled modules
     */
    enabledModules: Array<('procurement' | 'measures' | 'iso50001' | 'messstellen' | 'ai-invoice-checking' | 'invoice-checking' | 'procurement-freemium' | 'reports' | 'analyses' | 'data-management' | 'flex' | 'energy-cost' | 'custom-section' | 'insight-inbox')>;
    /**
     * Custom section for the location
     */
    customSection?: (CustomSectionDto) | null;
};

export type LocationDto = {
    id: number;
    companyId: number;
    cityId?: number | null;
    title: string;
    postalCode?: string | null;
    streetName?: string | null;
    streetNumber?: string | null;
    employeesCount: number;
    co2Factor: number;
    usageMwh: number;
    electricityCostYtd: number;
    electricityPrice: number;
    targetPeakLoad: number;
    ecoPoints: number;
    roofSpace: number;
    delRenewablesShare: number;
    workingDays?: {
        [key: string]: unknown;
    } | null;
    weekendSpan?: {
        [key: string]: unknown;
    } | null;
    csvFilePath?: string | null;
    shiftBegin?: string | null;
    shiftEnd?: string | null;
    meterInstalledAt?: string | null;
    contractEndsAt?: string | null;
    delIsOtherRenewables: boolean;
    isProcurementRequestSent: boolean;
    isDeleted: boolean;
    isMain: boolean;
    shiftsCount?: number | null;
    firebaseId: string;
    productionDays?: {
        [key: string]: unknown;
    } | null;
    targetEnergyEfficiency?: number | null;
    targetBaseLoad?: number | null;
    procurementModelId?: number | null;
    delEnergyIntensiveShare?: number | null;
    lastYearEfficiencyFactor?: number | null;
    aiContext?: string | null;
    isEnergyPriceTopActive?: boolean | null;
    enabledFrontendRoutes: Array<(string)>;
    reports: {
        [key: string]: unknown;
    };
    efficiencyVariable?: {
        [key: string]: unknown;
    } | null;
    highTariffTimes: {
        [key: string]: unknown;
    };
    costInformation: {
        [key: string]: unknown;
    };
    electricityBudget: {
        [key: string]: unknown;
    };
    provider?: string | null;
    electricityPurchaseKnowHow?: number | null;
    preciseNextYearEnergyPlan?: number | null;
    targets: {
        [key: string]: unknown;
    };
    yearlyConsumption?: number | null;
    isCostless: boolean;
    potentials: {
        [key: string]: unknown;
    };
    invitedUsers?: Array<(string)> | null;
    lastBudgetState?: string | null;
    currentPeakloadYtd?: {
        [key: string]: unknown;
    } | null;
    energyManagerSettings?: {
        [key: string]: unknown;
    } | null;
    customSection?: (CustomSectionDto) | null;
    enabledModules: Array<('procurement' | 'measures' | 'iso50001' | 'messstellen' | 'ai-invoice-checking' | 'invoice-checking' | 'procurement-freemium' | 'reports' | 'analyses' | 'data-management' | 'flex' | 'energy-cost' | 'custom-section' | 'insight-inbox')>;
    lifecycleStatusId?: number | null;
};

export type PatchEnergyManagerRequestDto = {
    locationId: string;
    champion?: {
        [key: string]: unknown;
    };
    nextEnergyTeamMeeting?: string;
    nextAudit?: string;
};

export type ReportSettingsDto = {
    schedule: string;
    isEnabled: boolean;
    sentAt: string | null;
    recipients: Array<(number)>;
};

export type ReportsSettingsDto = {
    budgetStatusReport: ReportSettingsDto;
    dailyElectricityReport: ReportSettingsDto;
    monthlyEnergyReport: ReportSettingsDto;
    performanceVsMarketReport: ReportSettingsDto;
    regulatoryDeadlinesReport: ReportSettingsDto;
    weekendReport: ReportSettingsDto;
};

export type PricesResponseDto = {
    entries: Array<{
        [key: string]: unknown;
    }>;
};

export type CurrentPriceResponseDto = {
    /**
     * Current spot market price
     */
    price: number;
};

export type AveragePriceResponseDto = {
    /**
     * Average year to date spot market price
     */
    averagePrice: number;
};

export type DeviceLocationDto = {
    /**
     * Device ID
     */
    deviceId: string;
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Firebase Location ID
     */
    firebaseLocationId: string;
};

export type ElectricityPricesBodyDto = {
    /**
     * Array of company and device combinations
     */
    companiesWithMainDevices: Array<DeviceLocationDto>;
};

export type SpotMarketPriceResponseDto = {
    /**
     * Timestamp (interval start)
     */
    timestamp: string;
    /**
     * Interval start timestamp
     */
    timestampStart: string;
    /**
     * Interval end timestamp
     */
    timestampEnd: string;
    /**
     * Spot price in ct/kWh
     */
    spotPrice: number;
    /**
     * Value
     */
    value: number;
};

export type EmberStreamingEvent = {
    eventName: 'streaming';
    /**
     * A chunk of a generated message, used for streaming responses from the server to the client
     */
    textDelta: string;
    /**
     * The id of the thread this event is attached to
     */
    threadId: string;
};

export enum eventName {
    STREAMING = 'streaming'
}

export type EmberToolCallCreatedEvent = {
    eventName: 'toolCallCreated';
    toolName: string;
};

export enum eventName2 {
    TOOL_CALL_CREATED = 'toolCallCreated'
}

export type EmberToolCallDeltaEvent = {
    eventName: 'toolCallDelta';
    toolName: string;
    data: string;
};

export enum eventName3 {
    TOOL_CALL_DELTA = 'toolCallDelta'
}

export type EmberToolCallDoneEvent = {
    eventName: 'toolCallDone';
    toolName: string;
};

export enum eventName4 {
    TOOL_CALL_DONE = 'toolCallDone'
}

export type EmberErrorEvent = {
    eventName: 'error';
    errorMessage: string;
    /**
     * The id of the thread this event is attached to
     */
    threadId: string;
};

export enum eventName5 {
    ERROR = 'error'
}

export type EmberDoneEvent = {
    eventName: 'done';
    data: {
        [key: string]: unknown;
    };
    /**
     * The id of the thread this event is attached to
     */
    threadId: string;
};

export enum eventName6 {
    DONE = 'done'
}

export type EmberChecklistAgentRequestBody = {
    userId: string;
    threadId: string;
    question: string;
    instructions?: string;
};

export type EmberChecklistAgentResponse = {
    /**
     * Status of the processed request
     */
    message: string;
};

export type EmberDocumentAgentRequestBody = {
    userId: string;
    threadId: string;
    question: string;
    instructions?: string;
    locationId?: string;
    buildingId?: number;
};

export type EmberDocumentAgentResponse = {
    /**
     * Status of the processed request
     */
    message: string;
};

export type EmbeddedFileDTO = {
    id: number;
    filename: string;
};

export type GetEmbeddedFilesDTO = {
    /**
     * List of already embedded files (with their ids and filenames)
     */
    files: Array<EmbeddedFileDTO>;
};

export type EmbeddingResultDTO = {
    /**
     * Number of successfully embedded files
     */
    newlyEmbedded: number;
    /**
     * Number of files that have already been embedded before and were skipped over this time
     */
    alreadyPresent: number;
    /**
     * Number of files that could not be embedded due to errors
     */
    errors: number;
};

export type EmberChatAgentRequestBody = {
    userId: string;
    threadId: string;
    question: string;
    instructions?: string;
    locationId?: string;
    buildingId?: number;
    insight?: string;
};

export type EmberChatAgentResponse = {
    /**
     * Status of the processed request
     */
    message: string;
};

export type EmberCancelProcessingRequestBody = {
    threadId: string;
};

export type EmberThreadCleanupResultDto = {
    /**
     * Number of threads successfully deleted
     */
    threadsDeleted: number;
    /**
     * List of errors encountered during cleanup
     */
    errors: Array<(string)>;
    /**
     * Total number of threads processed
     */
    totalThreadsProcessed: number;
    /**
     * Number of expired threads found
     */
    expiredThreadsFound: number;
};

export type EmberThreadDeleteResultDto = {
    /**
     * Number of threads successfully deleted
     */
    threadsDeleted: number;
    /**
     * List of errors encountered during cleanup
     */
    errors: Array<(string)>;
};

export type EmberThreadStatsDto = {
    /**
     * Total number of active threads
     */
    totalThreads: number;
    /**
     * Number of threads that are expired and eligible for cleanup
     */
    expiredThreads: number;
    /**
     * Cutoff date for thread expiration
     */
    expirationDate: string;
    /**
     * Thread expiration period in days
     */
    expirationDays: number;
};

export type ProposedQuestionsRequestDto = {
    message: string;
    assistantType: 'ISO_CHECKLIST' | 'LOAD_PROFILE';
};

export enum assistantType {
    ISO_CHECKLIST = 'ISO_CHECKLIST',
    LOAD_PROFILE = 'LOAD_PROFILE'
}

export type ProposedQuestionsResponseDto = {
    questions: Array<(string)>;
};

export type EmberReportAgentRequestBody = {
    userId: string;
    threadId: string;
    question: string;
    instructions?: string;
    moduleId: number;
    reportId: number;
};

export type ResponseReportModuleDto = {
    config: LineChartConfigDto | BarChartConfigDto | PieChartConfigDto | ComboChartConfigDto | HeatmapConfigDto | TableConfigDto | KpiConfigDto | TextConfigDto | ImageConfigDto | MagicModuleConfigDto | EnpiConfigDto | CostOverviewConfigDto;
    id: number;
    reportId: number;
    title: string;
    order: number;
    isHidden: boolean;
    createdFromTemplate: boolean;
    createdAt: string;
    updatedAt: string;
};

export type EmbeddedCallTranscriptDTO = {
    /**
     * Emails of all call participants
     */
    participants: Array<(string)>;
    id: string;
    companyId: number;
    title: string;
};

export type GetEmbeddedCallTranscriptsDTO = {
    /**
     * List of embedded call transcripts (includes the generated summary)
     */
    transcripts: Array<EmbeddedCallTranscriptDTO>;
};

export type SynchronizeCallTranscriptsDTO = {
    /**
     * Date from which to start the synchronization. Only transcripts newer than the given date will be synced
     */
    syncFromDate?: string;
};

export type CreateEmbeddedCallTranscriptDTO = {
    /**
     * Fireflies ID of a call transcript
     */
    firefliesId: string;
    /**
     * User email for which to embed the call transcripts
     */
    emails: Array<(string)>;
    /**
     * Company ID for which to embed all call transcripts
     */
    companyId: number;
    /**
     * Forcefully associates the call transcripts with the given overrideCompanyId (necessary workaround for Gong). Currently only used in conjunction with firefliesId.
     */
    overrideCompanyId: number;
};

export type DeleteEmbeddedCallTranscriptDTO = {
    /**
     * Fireflies ID of a call transcript
     */
    firefliesId: string;
};

export type PresetTimeRangeDto = {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
};

/**
 * Preset timerange options. Used to determine what data to fetch for a report module.
 */
export enum value {
    TODAY = 'today',
    YESTERDAY = 'yesterday',
    LAST_CALENDAR_WEEK = 'last-calendar-week',
    LAST_SEVEN_DAYS = 'last-seven-days',
    LAST_FOURTEEN_DAYS = 'last-fourteen-days',
    LAST_THIRTY_DAYS = 'last-thirty-days',
    LAST_CALENDAR_MONTH = 'last-calendar-month',
    LAST_THREE_CALENDAR_MONTHS = 'last-three-calendar-months',
    LAST_SIX_CALENDAR_MONTHS = 'last-six-calendar-months',
    CURRENT_YEAR_TO_DATE = 'current-year-to-date',
    LAST_CALENDAR_YEAR = 'last-calendar-year',
    PENULTIMATE_CALENDAR_YEAR = 'penultimate-calendar-year'
}

export type RelativeTimeRangeDto = {
    type: "relative";
    start: {
        operation?: 'subtract' | 'add';
        amount?: number;
        unit?: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
};

export enum operation {
    SUBTRACT = 'subtract',
    ADD = 'add'
}

export enum unit2 {
    MINUTES = 'minutes',
    HOURS = 'hours',
    DAYS = 'days',
    WEEKS = 'weeks',
    MONTHS = 'months',
    YEARS = 'years'
}

export type AbsoluteTimeRangeDto = {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};

export type LineChartConfigDto = {
    moduleType: "line-chart";
    showDataPoints?: boolean;
    smoothLine?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
} & BaseSeriesModuleDto & ChartAxisDto & VisualizationOptionsDto;

export type BarChartConfigDto = {
    moduleType: "bar-chart";
    orientation?: 'vertical' | 'horizontal';
    stacked?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
} & BaseSeriesModuleDto & ChartAxisDto & VisualizationOptionsDto;

export enum orientation {
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal'
}

export type PieChartConfigDto = {
    moduleType: "pie-chart";
    aggregation?: 'sum' | 'avg' | 'min' | 'max' | 'last';
    showPercentages?: boolean;
    showValues?: boolean;
} & BaseSeriesModuleDto & VisualizationOptionsDto;

export enum aggregation {
    SUM = 'sum',
    AVG = 'avg',
    MIN = 'min',
    MAX = 'max',
    LAST = 'last'
}

export type ComboChartConfigDto = {
    moduleType: "combo-chart";
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
} & BaseSeriesModuleDto & ChartAxisDto & VisualizationOptionsDto;

export type HeatmapConfigDto = {
    moduleType: "heatmap";
    xAxisLabel?: string;
    yAxisLabel?: string;
    colorScheme?: 'blue-red' | 'green-red' | 'monochrome' | 'viridis' | 'plasma';
    showValues?: boolean;
} & BaseSeriesModuleDto & VisualizationOptionsDto;

export enum colorScheme {
    BLUE_RED = 'blue-red',
    GREEN_RED = 'green-red',
    MONOCHROME = 'monochrome',
    VIRIDIS = 'viridis',
    PLASMA = 'plasma'
}

export type TableConfigDto = {
    moduleType: "table";
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    yAxisType?: 'period' | 'series';
    showTotals?: boolean;
    showAverages?: boolean;
    columns?: Array<{
        field: string;
        label: string;
        format?: 'number' | 'datetime' | 'date' | 'time' | 'percentage' | 'currency' | 'text';
        align?: 'left' | 'center' | 'right';
        width?: string;
    }>;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
} & BaseSeriesModuleDto & VisualizationOptionsDto;

export enum yAxisType {
    PERIOD = 'period',
    SERIES = 'series'
}

export enum sortOrder {
    ASC = 'asc',
    DESC = 'desc'
}

export type KpiConfigDto = {
    moduleType: "kpi";
    /**
     * Selected time series ids. KPI modules support at most one series.
     */
    timeSeriesIds: Array<(string)>;
    /**
     * Scalar calculation applied to the selected series.
     */
    loadType: 'base-load' | 'average-load' | 'peak-load' | 'sum';
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Optional KPI comparison periods. KPI modules support at most one comparison period.
     */
    comparisonPeriods?: Array<{
        /**
         * Number of units to shift the comparison period back.
         */
        count: number;
        unit: 'day' | 'week' | 'month' | 'year';
    }>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
};

/**
 * Scalar calculation applied to the selected series.
 */
export enum loadType {
    BASE_LOAD = 'base-load',
    AVERAGE_LOAD = 'average-load',
    PEAK_LOAD = 'peak-load',
    SUM = 'sum'
}

export type TextConfigDto = {
    moduleType: "text";
    content?: string;
    format?: 'plain' | 'markdown' | 'html';
    alignment?: 'left' | 'center' | 'right';
};

export enum format {
    PLAIN = 'plain',
    MARKDOWN = 'markdown',
    HTML = 'html'
}

export enum alignment {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right'
}

export type ImageConfigDto = {
    moduleType: "image";
    fileId?: string;
    fileName?: string;
    mimeType?: string;
};

export type MagicModuleConfigDto = {
    moduleType: "magic";
    /**
     * Identifiers for every regular module type
     */
    normalModuleType: 'line-chart' | 'bar-chart' | 'pie-chart' | 'combo-chart' | 'heatmap' | 'table' | 'text' | 'image' | 'kpi';
    /**
     * Text generated by an LLM to answer a user prompt. Relevant for normalModuleType==="text", should be null for all other module types.
     */
    generatedText?: string | null;
    /**
     * The dataSources field should only be null if the normalModuleType==='text'. For every other module type it should be an array.
     */
    dataSources?: Array<{
    type: "customSQL";
    /**
     * Generated SQL query
     */
    query: string;
    /**
     * Pay special attention to the distinction between 'energy' and 'power'. If the user asks for things like load, Lastgang or consumption in 15-minute intervals, then the correct dataType is 'power'.Else if the user asks for things like daily, weekly or monthly consumption, then the correct dataType is 'energy'.Other data types like temperature and costs should be identified from the query context.
     */
    dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
    /**
     * 'kWh', 'kW', '°C', '€', 'm3', 'm3/h', etc.
     * Must match the dataType and the context of the query. If dataType is power, then the unit must be 'kW' or 'm3/h'.If dataType is energy, then the unit must be 'kWh' or 'm3'.
     */
    unit: string;
    /**
     * Only present when dataType is energy or power.
     */
    energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas' | null;
    /**
     * Axis label describing the query data. Three words maximum. Must be in the language of the user.
     */
    label: string;
    /**
     * Chart type. Must be set for every combo-chart. Must be null otherwise.
     */
    chartType?: 'line' | 'bar' | 'area' | null;
}> | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    timeRange?: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
} | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    granularity?: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | null;
    /**
     * Flag for telling whether this config has been generated by an LLM.
     */
    isGenerated: boolean;
    /**
     * Extra data to be added to a DTO when sending a response. Should never be generated, only set by a service further downstream.
     */
    dtoExtra?: {
    chartTypes?: Array<('line' | 'bar' | 'area' | null)> | null;
} | null;
} & ChartAxisDto & VisualizationOptionsDto;

/**
 * Identifiers for every regular module type
 */
export enum normalModuleType {
    LINE_CHART = 'line-chart',
    BAR_CHART = 'bar-chart',
    PIE_CHART = 'pie-chart',
    COMBO_CHART = 'combo-chart',
    HEATMAP = 'heatmap',
    TABLE = 'table',
    TEXT = 'text',
    IMAGE = 'image',
    KPI = 'kpi'
}

export type EnpiConfigDto = {
    moduleType: "enpi";
    /**
     * 'overview' renders a multi-EnPI summary table (1..N EnPIs); 'detail' renders one EnPI's full result table + KPI cards.
     */
    mode: 'overview' | 'detail';
    /**
     * Selected EnPI ids. overview: 0..N; detail: at most one.
     */
    enpiIds: Array<(number)>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
};

/**
 * 'overview' renders a multi-EnPI summary table (1..N EnPIs); 'detail' renders one EnPI's full result table + KPI cards.
 */
export enum mode {
    OVERVIEW = 'overview',
    DETAIL = 'detail'
}

export type CostOverviewConfigDto = {
    moduleType: "cost-overview";
    year: number;
    locationId?: number | null;
    description?: string | null;
};

export type AxisConfigDto = {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
};

export type TimeSeriesConfigDto = {
    id: string;
    type?: string;
    locationId?: number;
    /**
     * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
     */
    energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
    label?: string;
    color?: string;
    unit?: string;
    /**
     * Every available data type for a timeseries.
     */
    dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
    yAxisIndex?: number;
    /**
     * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
     */
    chartType?: 'line' | 'bar' | 'area';
    /**
     * How a report time series should be calculated within each displayed bucket.
     */
    calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
};

/**
 * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
 */
export enum chartType {
    LINE = 'line',
    BAR = 'bar',
    AREA = 'area'
}

/**
 * How a report time series should be calculated within each displayed bucket.
 */
export enum calculationMethod {
    VALUE = 'value',
    LOAD_PROFILE = 'loadProfile',
    PEAK = 'peak',
    BASE = 'base',
    AVERAGE = 'average'
}

export type VisualizationOptionsDto = {
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
};

export type BaseSeriesModuleDto = {
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
};

export type ChartAxisDto = {
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
};

export type DailyFrequencyConfigDto = {
    /**
     * Frequency type
     */
    type: 'DAILY' | 'WEEKLY' | 'MONTHLY';
    /**
     * Hour of execution (0-23)
     */
    hour: number;
    /**
     * Minute of execution (0-59)
     */
    minute: number;
    /**
     * Exclude weekends from execution
     */
    excludeWeekends?: boolean;
};

/**
 * Frequency type
 */
export enum type6 {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY'
}

export type WeeklyFrequencyConfigDto = {
    /**
     * Frequency type
     */
    type: 'DAILY' | 'WEEKLY' | 'MONTHLY';
    /**
     * Hour of execution (0-23)
     */
    hour: number;
    /**
     * Minute of execution (0-59)
     */
    minute: number;
    /**
     * Day of the week
     */
    weekday: 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY';
};

/**
 * Day of the week
 */
export enum weekday {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY'
}

export type MonthlyByDayOfWeekConfigDto = {
    /**
     * Frequency type
     */
    type: 'DAILY' | 'WEEKLY' | 'MONTHLY';
    /**
     * Hour of execution (0-23)
     */
    hour: number;
    /**
     * Minute of execution (0-59)
     */
    minute: number;
    /**
     * Day of the week
     */
    weekday: 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY';
    /**
     * Nth occurrence in the month
     */
    occurrence: 1 | 2;
};

/**
 * Nth occurrence in the month
 */
export enum occurrence {
    '_1' = 1,
    '_2' = 2
}

export type MonthlyByDayOfMonthConfigDto = {
    /**
     * Frequency type
     */
    type: 'DAILY' | 'WEEKLY' | 'MONTHLY';
    /**
     * Hour of execution (0-23)
     */
    hour: number;
    /**
     * Minute of execution (0-59)
     */
    minute: number;
    /**
     * Day of the month (1-31)
     */
    dayOfMonth: number;
};

export type ResponseCustomReportDto = {
    /**
     * Unique ID of the custom report
     */
    id: number;
    /**
     * Name of the report
     */
    name: string;
    /**
     * Mode of the report
     */
    mode: 'finalized' | 'draft';
    /**
     * List of recipients
     */
    recipients: Array<(string)>;
    /**
     * ID of the logo
     */
    logoId: number | null;
    /**
     * ID of the company that owns the report
     */
    companyId: number;
    /**
     * Report creation timestamp
     */
    createdAt: string;
    /**
     * Report last updated timestamp
     */
    updatedAt: string;
    /**
     * User ID who created the report
     */
    createdBy: number | null;
    /**
     * User ID who last updated the report
     */
    updatedBy: number | null;
    /**
     * Subject of the custom report
     */
    subject?: string | null;
    /**
     * Frequency configuration for scheduled reports
     */
    frequencyConfig: DailyFrequencyConfigDto | WeeklyFrequencyConfigDto | MonthlyByDayOfWeekConfigDto | MonthlyByDayOfMonthConfigDto;
    /**
     * Date when the schedule starts (first execution date)
     */
    scheduleStartDate?: string | null;
    /**
     * Date of the next scheduled execution
     */
    nextExecution?: string | null;
    /**
     * Date when the report was last executed
     */
    lastExecuted?: string | null;
};

/**
 * Mode of the report
 */
export enum mode2 {
    FINALIZED = 'finalized',
    DRAFT = 'draft'
}

export type CreateCustomReportDto = {
    /**
     * Name of the custom report
     */
    name: string;
    /**
     * Mode of the report
     */
    mode: 'finalized' | 'draft';
    /**
     * ID of the company
     */
    companyId: number;
    /**
     * List of recipients
     */
    recipients?: Array<(string)>;
    /**
     * ID of the logo
     */
    logoId?: number | null;
    /**
     * Subject of the custom report
     */
    subject?: string | null;
    /**
     * Frequency configuration for scheduled reports
     */
    frequencyConfig: DailyFrequencyConfigDto | WeeklyFrequencyConfigDto | MonthlyByDayOfWeekConfigDto | MonthlyByDayOfMonthConfigDto;
};

export type UpdateCustomReportDto = {
    /**
     * Name of the custom report
     */
    name?: string;
    /**
     * Mode of the report
     */
    mode?: 'finalized' | 'draft';
    /**
     * List of recipients
     */
    recipients?: Array<(string)>;
    /**
     * ID of the logo (set null to remove)
     */
    logoId?: number | null;
    /**
     * Subject of the custom report
     */
    subject?: string | null;
    /**
     * Frequency configuration for scheduled reports
     */
    frequencyConfig?: DailyFrequencyConfigDto | WeeklyFrequencyConfigDto | MonthlyByDayOfWeekConfigDto | MonthlyByDayOfMonthConfigDto | null;
};

export type GenerateReportDto = {
    /**
     * Optional email address to send the report to. If not provided, sends to all configured recipients.
     */
    email?: string;
};

export type ResponseReportWithModulesForPdfDto = {
    report: {
        id?: number;
        name?: string;
        logoId?: number | null;
        logoDataUrl?: string | null;
    };
    modules: Array<{
        id: number;
        reportId: number;
        title: string;
        order: number;
        isHidden: boolean;
        config: {
    moduleType: "line-chart";
    showDataPoints?: boolean;
    smoothLine?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "bar-chart";
    orientation?: 'vertical' | 'horizontal';
    stacked?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "pie-chart";
    aggregation?: 'sum' | 'avg' | 'min' | 'max' | 'last';
    showPercentages?: boolean;
    showValues?: boolean;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "combo-chart";
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "heatmap";
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    xAxisLabel?: string;
    yAxisLabel?: string;
    colorScheme?: 'blue-red' | 'green-red' | 'monochrome' | 'viridis' | 'plasma';
    showValues?: boolean;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "table";
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    yAxisType?: 'period' | 'series';
    showTotals?: boolean;
    showAverages?: boolean;
    columns?: Array<{
        field: string;
        label: string;
        format?: 'number' | 'datetime' | 'date' | 'time' | 'percentage' | 'currency' | 'text';
        align?: 'left' | 'center' | 'right';
        width?: string;
    }>;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "kpi";
    /**
     * Selected time series ids. KPI modules support at most one series.
     */
    timeSeriesIds: Array<(string)>;
    /**
     * Scalar calculation applied to the selected series.
     */
    loadType: 'base-load' | 'average-load' | 'peak-load' | 'sum';
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Optional KPI comparison periods. KPI modules support at most one comparison period.
     */
    comparisonPeriods?: Array<{
        /**
         * Number of units to shift the comparison period back.
         */
        count: number;
        unit: 'day' | 'week' | 'month' | 'year';
    }>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "text";
    content?: string;
    format?: 'plain' | 'markdown' | 'html';
    alignment?: 'left' | 'center' | 'right';
} | {
    moduleType: "image";
    fileId?: string;
    fileName?: string;
    mimeType?: string;
} | {
    moduleType: "magic";
    /**
     * Identifiers for every regular module type
     */
    normalModuleType: 'line-chart' | 'bar-chart' | 'pie-chart' | 'combo-chart' | 'heatmap' | 'table' | 'text' | 'image' | 'kpi';
    /**
     * Text generated by an LLM to answer a user prompt. Relevant for normalModuleType==="text", should be null for all other module types.
     */
    generatedText?: string | null;
    /**
     * The dataSources field should only be null if the normalModuleType==='text'. For every other module type it should be an array.
     */
    dataSources?: Array<{
    type: "customSQL";
    /**
     * Generated SQL query
     */
    query: string;
    /**
     * Pay special attention to the distinction between 'energy' and 'power'. If the user asks for things like load, Lastgang or consumption in 15-minute intervals, then the correct dataType is 'power'.Else if the user asks for things like daily, weekly or monthly consumption, then the correct dataType is 'energy'.Other data types like temperature and costs should be identified from the query context.
     */
    dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
    /**
     * 'kWh', 'kW', '°C', '€', 'm3', 'm3/h', etc.
     * Must match the dataType and the context of the query. If dataType is power, then the unit must be 'kW' or 'm3/h'.If dataType is energy, then the unit must be 'kWh' or 'm3'.
     */
    unit: string;
    /**
     * Only present when dataType is energy or power.
     */
    energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas' | null;
    /**
     * Axis label describing the query data. Three words maximum. Must be in the language of the user.
     */
    label: string;
    /**
     * Chart type. Must be set for every combo-chart. Must be null otherwise.
     */
    chartType?: 'line' | 'bar' | 'area' | null;
}> | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    timeRange?: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
} | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    granularity?: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | null;
    /**
     * Flag for telling whether this config has been generated by an LLM.
     */
    isGenerated: boolean;
    /**
     * Extra data to be added to a DTO when sending a response. Should never be generated, only set by a service further downstream.
     */
    dtoExtra?: {
    chartTypes?: Array<('line' | 'bar' | 'area' | null)> | null;
} | null;
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "enpi";
    /**
     * 'overview' renders a multi-EnPI summary table (1..N EnPIs); 'detail' renders one EnPI's full result table + KPI cards.
     */
    mode: 'overview' | 'detail';
    /**
     * Selected EnPI ids. overview: 0..N; detail: at most one.
     */
    enpiIds: Array<(number)>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "cost-overview";
    year: number;
    locationId?: number | null;
    description?: string | null;
};
        createdAt: string;
        updatedAt: string;
        seriesData: Array<{
            seriesId: string;
            label?: string;
            /**
             * Every available data type for a timeseries.
             */
            dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
            unit: string;
            /**
             * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
             */
            energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
            /**
             * Available options for the intervals between two values in a timeseries.
             */
            granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
            firstDataDate?: string;
            lastDataDate?: string;
            dataPoints: Array<{
                timestamp: string;
                value: number | null;
            }>;
        }>;
        comparisonSeriesData?: Array<{
            seriesId: string;
            label?: string;
            /**
             * Every available data type for a timeseries.
             */
            dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
            unit: string;
            /**
             * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
             */
            energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
            /**
             * Available options for the intervals between two values in a timeseries.
             */
            granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
            firstDataDate?: string;
            lastDataDate?: string;
            dataPoints: Array<{
                timestamp: string;
                value: number | null;
            }>;
            /**
             * Index into the config's comparisonTimeRanges array this series was resolved for.
             */
            comparisonIndex: number;
        }> | null;
        enpiData?: {
            /**
             * 'overview' renders a multi-EnPI summary table (1..N EnPIs); 'detail' renders one EnPI's full result table + KPI cards.
             */
            mode: 'overview' | 'detail';
            overview?: Array<{
                enpiId: number;
                name: string;
                efficiencyTrendVsLastPeriod: number | null;
                currentValue: number | null;
                unit: string | null;
                energyType: string | null;
                measuringPoint: string | null;
                locationName: string | null;
                referenceDateFrom: string | null;
                dataQualityTimeSeriesIds: Array<(string)>;
            }> | null;
            detail?: {
                enpiId: number;
                name: string;
                interval: 'yearly' | 'monthly' | 'weekly' | 'daily';
                currentValue: number | null;
                unit: string | null;
                efficiencyTrendVsLastPeriod: number | null;
                targetValue: number | null;
                targetValueType: 'absolute' | 'relative' | null;
                energyType: string | null;
                measuringPoint: string | null;
                locationName: string | null;
                referenceDateFrom: string | null;
                dataQualityTimeSeriesIds: Array<(string)>;
                lastCalculatedAt: string | null;
                results: {
                    series: Array<{
                        timestamp: string;
                        measuredValue: number | null;
                        baseline: number | null;
                        prediction: number | null;
                        deviation: number | null;
                        deviationKWh: number | null;
                        cusum: number | null;
                        targetDeviation: number | null;
                    }>;
                    summary: {
                        measuredValueAverage: number | null;
                        baselineAverage: number | null;
                        deviationAverage: number | null;
                        deviationSum: number | null;
                        targetDeviationAverage: number | null;
                    };
                } | null;
            } | null;
        } | null;
        costOverviewData?: {
            year: number;
            locationId: number | null;
            locationName: string | null;
            monthlyData: Array<{
                month: string;
                budget: number | null;
                cost: number | null;
                deviation: number | null;
            }>;
        } | null;
        kpiData?: {
            seriesId: string | null;
            label: string | null;
            loadType: 'base-load' | 'average-load' | 'peak-load' | 'sum';
            value: number | null;
            unit: string | null;
            comparisonValue: number | null;
            comparisonDelta: number | null;
            comparisonPercent: number | null;
        } | null;
    }>;
};

export type DataCompletenessPeriodDataDto = {
    startTime: string;
    endTime: string;
    /**
     * Percentage of ideal consumption time that is present (actual / ideal × 100)
     */
    completenessPercentage: number;
};

export type DataCompletenessItemDto = {
    /**
     * Display name for the scope item (device, building, location, or company)
     */
    name: string;
    /**
     * Stable source id for matching this item back to the request source.
     */
    sourceId?: string;
    /**
     * Source type for the item represented by sourceId.
     */
    sourceType?: 'customTimeseries' | 'device' | 'building' | 'location' | 'company' | 'meter' | 'series' | 'electricitySpotPrice';
    /**
     * Item-level rollup across all intervals and meters in this item. Null when intervalsCompletenessData is null (no matching meters for this scope item).
     */
    completenessPercentage?: number | null;
    /**
     * Per-interval completeness for this item. Omitted when includeIntervals=false and null when this scope item has no matching meters.
     */
    intervalsCompletenessData?: Array<DataCompletenessPeriodDataDto> | null;
};

/**
 * Source type for the item represented by sourceId.
 */
export enum sourceType {
    CUSTOM_TIMESERIES = 'customTimeseries',
    DEVICE = 'device',
    BUILDING = 'building',
    LOCATION = 'location',
    COMPANY = 'company',
    METER = 'meter',
    SERIES = 'series',
    ELECTRICITY_SPOT_PRICE = 'electricitySpotPrice'
}

export type GetDataCompletenessResponseDto = {
    /**
     * Resolved filter scope, derived from the highest-priority scope parameter in the request. itemLevel controls item granularity independently.
     */
    scope: 'customTimeseries' | 'device' | 'building' | 'location' | 'company';
    items: Array<DataCompletenessItemDto>;
    /**
     * Global rollup across all non-excluded items. Null when no scope item has matching meters (nothing to aggregate).
     */
    completenessPercentage?: number | null;
};

/**
 * Resolved filter scope, derived from the highest-priority scope parameter in the request. itemLevel controls item granularity independently.
 */
export enum scope {
    CUSTOM_TIMESERIES = 'customTimeseries',
    DEVICE = 'device',
    BUILDING = 'building',
    LOCATION = 'location',
    COMPANY = 'company'
}

export type ResponseSentReportDto = {
    /**
     * Unique ID of the sent report
     */
    id: number;
    /**
     * ID of the original custom report
     */
    reportId: number;
    /**
     * ID of the generated PDF
     */
    pdfId?: number | null;
    /**
     * ID of the logo used for the report
     */
    logoId?: number | null;
    /**
     * Display name of the sent report
     */
    name: string;
    /**
     * Timestamp when the report was sent
     */
    createdAt: string;
};

export type ResponseSentReportModuleDto = {
    id: number;
    title: string;
    sort: number;
    config: {
    moduleType: "line-chart";
    showDataPoints?: boolean;
    smoothLine?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "bar-chart";
    orientation?: 'vertical' | 'horizontal';
    stacked?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "pie-chart";
    aggregation?: 'sum' | 'avg' | 'min' | 'max' | 'last';
    showPercentages?: boolean;
    showValues?: boolean;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "combo-chart";
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "heatmap";
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    xAxisLabel?: string;
    yAxisLabel?: string;
    colorScheme?: 'blue-red' | 'green-red' | 'monochrome' | 'viridis' | 'plasma';
    showValues?: boolean;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "table";
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    yAxisType?: 'period' | 'series';
    showTotals?: boolean;
    showAverages?: boolean;
    columns?: Array<{
        field: string;
        label: string;
        format?: 'number' | 'datetime' | 'date' | 'time' | 'percentage' | 'currency' | 'text';
        align?: 'left' | 'center' | 'right';
        width?: string;
    }>;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "kpi";
    /**
     * Selected time series ids. KPI modules support at most one series.
     */
    timeSeriesIds: Array<(string)>;
    /**
     * Scalar calculation applied to the selected series.
     */
    loadType: 'base-load' | 'average-load' | 'peak-load' | 'sum';
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Optional KPI comparison periods. KPI modules support at most one comparison period.
     */
    comparisonPeriods?: Array<{
        /**
         * Number of units to shift the comparison period back.
         */
        count: number;
        unit: 'day' | 'week' | 'month' | 'year';
    }>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "text";
    content?: string;
    format?: 'plain' | 'markdown' | 'html';
    alignment?: 'left' | 'center' | 'right';
} | {
    moduleType: "image";
    fileId?: string;
    fileName?: string;
    mimeType?: string;
} | {
    moduleType: "magic";
    /**
     * Identifiers for every regular module type
     */
    normalModuleType: 'line-chart' | 'bar-chart' | 'pie-chart' | 'combo-chart' | 'heatmap' | 'table' | 'text' | 'image' | 'kpi';
    /**
     * Text generated by an LLM to answer a user prompt. Relevant for normalModuleType==="text", should be null for all other module types.
     */
    generatedText?: string | null;
    /**
     * The dataSources field should only be null if the normalModuleType==='text'. For every other module type it should be an array.
     */
    dataSources?: Array<{
    type: "customSQL";
    /**
     * Generated SQL query
     */
    query: string;
    /**
     * Pay special attention to the distinction between 'energy' and 'power'. If the user asks for things like load, Lastgang or consumption in 15-minute intervals, then the correct dataType is 'power'.Else if the user asks for things like daily, weekly or monthly consumption, then the correct dataType is 'energy'.Other data types like temperature and costs should be identified from the query context.
     */
    dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
    /**
     * 'kWh', 'kW', '°C', '€', 'm3', 'm3/h', etc.
     * Must match the dataType and the context of the query. If dataType is power, then the unit must be 'kW' or 'm3/h'.If dataType is energy, then the unit must be 'kWh' or 'm3'.
     */
    unit: string;
    /**
     * Only present when dataType is energy or power.
     */
    energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas' | null;
    /**
     * Axis label describing the query data. Three words maximum. Must be in the language of the user.
     */
    label: string;
    /**
     * Chart type. Must be set for every combo-chart. Must be null otherwise.
     */
    chartType?: 'line' | 'bar' | 'area' | null;
}> | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    timeRange?: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
} | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    granularity?: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | null;
    /**
     * Flag for telling whether this config has been generated by an LLM.
     */
    isGenerated: boolean;
    /**
     * Extra data to be added to a DTO when sending a response. Should never be generated, only set by a service further downstream.
     */
    dtoExtra?: {
    chartTypes?: Array<('line' | 'bar' | 'area' | null)> | null;
} | null;
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "enpi";
    /**
     * 'overview' renders a multi-EnPI summary table (1..N EnPIs); 'detail' renders one EnPI's full result table + KPI cards.
     */
    mode: 'overview' | 'detail';
    /**
     * Selected EnPI ids. overview: 0..N; detail: at most one.
     */
    enpiIds: Array<(number)>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "cost-overview";
    year: number;
    locationId?: number | null;
    description?: string | null;
};
};

export type ResponseSentReportModuleWithDataDto = {
    id: number;
    sentReportId: number;
    title: string;
    sort: number;
    config: {
    moduleType: "line-chart";
    showDataPoints?: boolean;
    smoothLine?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "bar-chart";
    orientation?: 'vertical' | 'horizontal';
    stacked?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "pie-chart";
    aggregation?: 'sum' | 'avg' | 'min' | 'max' | 'last';
    showPercentages?: boolean;
    showValues?: boolean;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "combo-chart";
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "heatmap";
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    xAxisLabel?: string;
    yAxisLabel?: string;
    colorScheme?: 'blue-red' | 'green-red' | 'monochrome' | 'viridis' | 'plasma';
    showValues?: boolean;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "table";
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    yAxisType?: 'period' | 'series';
    showTotals?: boolean;
    showAverages?: boolean;
    columns?: Array<{
        field: string;
        label: string;
        format?: 'number' | 'datetime' | 'date' | 'time' | 'percentage' | 'currency' | 'text';
        align?: 'left' | 'center' | 'right';
        width?: string;
    }>;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "kpi";
    /**
     * Selected time series ids. KPI modules support at most one series.
     */
    timeSeriesIds: Array<(string)>;
    /**
     * Scalar calculation applied to the selected series.
     */
    loadType: 'base-load' | 'average-load' | 'peak-load' | 'sum';
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Optional KPI comparison periods. KPI modules support at most one comparison period.
     */
    comparisonPeriods?: Array<{
        /**
         * Number of units to shift the comparison period back.
         */
        count: number;
        unit: 'day' | 'week' | 'month' | 'year';
    }>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "text";
    content?: string;
    format?: 'plain' | 'markdown' | 'html';
    alignment?: 'left' | 'center' | 'right';
} | {
    moduleType: "image";
    fileId?: string;
    fileName?: string;
    mimeType?: string;
} | {
    moduleType: "magic";
    /**
     * Identifiers for every regular module type
     */
    normalModuleType: 'line-chart' | 'bar-chart' | 'pie-chart' | 'combo-chart' | 'heatmap' | 'table' | 'text' | 'image' | 'kpi';
    /**
     * Text generated by an LLM to answer a user prompt. Relevant for normalModuleType==="text", should be null for all other module types.
     */
    generatedText?: string | null;
    /**
     * The dataSources field should only be null if the normalModuleType==='text'. For every other module type it should be an array.
     */
    dataSources?: Array<{
    type: "customSQL";
    /**
     * Generated SQL query
     */
    query: string;
    /**
     * Pay special attention to the distinction between 'energy' and 'power'. If the user asks for things like load, Lastgang or consumption in 15-minute intervals, then the correct dataType is 'power'.Else if the user asks for things like daily, weekly or monthly consumption, then the correct dataType is 'energy'.Other data types like temperature and costs should be identified from the query context.
     */
    dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
    /**
     * 'kWh', 'kW', '°C', '€', 'm3', 'm3/h', etc.
     * Must match the dataType and the context of the query. If dataType is power, then the unit must be 'kW' or 'm3/h'.If dataType is energy, then the unit must be 'kWh' or 'm3'.
     */
    unit: string;
    /**
     * Only present when dataType is energy or power.
     */
    energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas' | null;
    /**
     * Axis label describing the query data. Three words maximum. Must be in the language of the user.
     */
    label: string;
    /**
     * Chart type. Must be set for every combo-chart. Must be null otherwise.
     */
    chartType?: 'line' | 'bar' | 'area' | null;
}> | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    timeRange?: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
} | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    granularity?: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | null;
    /**
     * Flag for telling whether this config has been generated by an LLM.
     */
    isGenerated: boolean;
    /**
     * Extra data to be added to a DTO when sending a response. Should never be generated, only set by a service further downstream.
     */
    dtoExtra?: {
    chartTypes?: Array<('line' | 'bar' | 'area' | null)> | null;
} | null;
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "enpi";
    /**
     * 'overview' renders a multi-EnPI summary table (1..N EnPIs); 'detail' renders one EnPI's full result table + KPI cards.
     */
    mode: 'overview' | 'detail';
    /**
     * Selected EnPI ids. overview: 0..N; detail: at most one.
     */
    enpiIds: Array<(number)>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "cost-overview";
    year: number;
    locationId?: number | null;
    description?: string | null;
};
    seriesData: Array<{
        seriesId: string;
        label?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        unit: string;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        /**
         * Available options for the intervals between two values in a timeseries.
         */
        granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
        firstDataDate?: string;
        lastDataDate?: string;
        dataPoints: Array<{
            timestamp: string;
            value: number | null;
        }>;
    }>;
    comparisonSeriesData?: Array<{
        seriesId: string;
        label?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        unit: string;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        /**
         * Available options for the intervals between two values in a timeseries.
         */
        granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
        firstDataDate?: string;
        lastDataDate?: string;
        dataPoints: Array<{
            timestamp: string;
            value: number | null;
        }>;
        /**
         * Index into the config's comparisonTimeRanges array this series was resolved for.
         */
        comparisonIndex: number;
    }> | null;
    enpiData?: {
        /**
         * 'overview' renders a multi-EnPI summary table (1..N EnPIs); 'detail' renders one EnPI's full result table + KPI cards.
         */
        mode: 'overview' | 'detail';
        overview?: Array<{
            enpiId: number;
            name: string;
            efficiencyTrendVsLastPeriod: number | null;
            currentValue: number | null;
            unit: string | null;
            energyType: string | null;
            measuringPoint: string | null;
            locationName: string | null;
            referenceDateFrom: string | null;
            dataQualityTimeSeriesIds: Array<(string)>;
        }> | null;
        detail?: {
            enpiId: number;
            name: string;
            interval: 'yearly' | 'monthly' | 'weekly' | 'daily';
            currentValue: number | null;
            unit: string | null;
            efficiencyTrendVsLastPeriod: number | null;
            targetValue: number | null;
            targetValueType: 'absolute' | 'relative' | null;
            energyType: string | null;
            measuringPoint: string | null;
            locationName: string | null;
            referenceDateFrom: string | null;
            dataQualityTimeSeriesIds: Array<(string)>;
            lastCalculatedAt: string | null;
            results: {
                series: Array<{
                    timestamp: string;
                    measuredValue: number | null;
                    baseline: number | null;
                    prediction: number | null;
                    deviation: number | null;
                    deviationKWh: number | null;
                    cusum: number | null;
                    targetDeviation: number | null;
                }>;
                summary: {
                    measuredValueAverage: number | null;
                    baselineAverage: number | null;
                    deviationAverage: number | null;
                    deviationSum: number | null;
                    targetDeviationAverage: number | null;
                };
            } | null;
        } | null;
    } | null;
    costOverviewData?: {
        year: number;
        locationId: number | null;
        locationName: string | null;
        monthlyData: Array<{
            month: string;
            budget: number | null;
            cost: number | null;
            deviation: number | null;
        }>;
    } | null;
    kpiData?: {
        seriesId: string | null;
        label: string | null;
        loadType: 'base-load' | 'average-load' | 'peak-load' | 'sum';
        value: number | null;
        unit: string | null;
        comparisonValue: number | null;
        comparisonDelta: number | null;
        comparisonPercent: number | null;
    } | null;
};

export type ResponseReportModuleWithDataDto = {
    id: number;
    reportId: number;
    title: string;
    order: number;
    isHidden: boolean;
    config: {
    moduleType: "line-chart";
    showDataPoints?: boolean;
    smoothLine?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "bar-chart";
    orientation?: 'vertical' | 'horizontal';
    stacked?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "pie-chart";
    aggregation?: 'sum' | 'avg' | 'min' | 'max' | 'last';
    showPercentages?: boolean;
    showValues?: boolean;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "combo-chart";
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "heatmap";
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    xAxisLabel?: string;
    yAxisLabel?: string;
    colorScheme?: 'blue-red' | 'green-red' | 'monochrome' | 'viridis' | 'plasma';
    showValues?: boolean;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "table";
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    yAxisType?: 'period' | 'series';
    showTotals?: boolean;
    showAverages?: boolean;
    columns?: Array<{
        field: string;
        label: string;
        format?: 'number' | 'datetime' | 'date' | 'time' | 'percentage' | 'currency' | 'text';
        align?: 'left' | 'center' | 'right';
        width?: string;
    }>;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "kpi";
    /**
     * Selected time series ids. KPI modules support at most one series.
     */
    timeSeriesIds: Array<(string)>;
    /**
     * Scalar calculation applied to the selected series.
     */
    loadType: 'base-load' | 'average-load' | 'peak-load' | 'sum';
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Optional KPI comparison periods. KPI modules support at most one comparison period.
     */
    comparisonPeriods?: Array<{
        /**
         * Number of units to shift the comparison period back.
         */
        count: number;
        unit: 'day' | 'week' | 'month' | 'year';
    }>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "text";
    content?: string;
    format?: 'plain' | 'markdown' | 'html';
    alignment?: 'left' | 'center' | 'right';
} | {
    moduleType: "image";
    fileId?: string;
    fileName?: string;
    mimeType?: string;
} | {
    moduleType: "magic";
    /**
     * Identifiers for every regular module type
     */
    normalModuleType: 'line-chart' | 'bar-chart' | 'pie-chart' | 'combo-chart' | 'heatmap' | 'table' | 'text' | 'image' | 'kpi';
    /**
     * Text generated by an LLM to answer a user prompt. Relevant for normalModuleType==="text", should be null for all other module types.
     */
    generatedText?: string | null;
    /**
     * The dataSources field should only be null if the normalModuleType==='text'. For every other module type it should be an array.
     */
    dataSources?: Array<{
    type: "customSQL";
    /**
     * Generated SQL query
     */
    query: string;
    /**
     * Pay special attention to the distinction between 'energy' and 'power'. If the user asks for things like load, Lastgang or consumption in 15-minute intervals, then the correct dataType is 'power'.Else if the user asks for things like daily, weekly or monthly consumption, then the correct dataType is 'energy'.Other data types like temperature and costs should be identified from the query context.
     */
    dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
    /**
     * 'kWh', 'kW', '°C', '€', 'm3', 'm3/h', etc.
     * Must match the dataType and the context of the query. If dataType is power, then the unit must be 'kW' or 'm3/h'.If dataType is energy, then the unit must be 'kWh' or 'm3'.
     */
    unit: string;
    /**
     * Only present when dataType is energy or power.
     */
    energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas' | null;
    /**
     * Axis label describing the query data. Three words maximum. Must be in the language of the user.
     */
    label: string;
    /**
     * Chart type. Must be set for every combo-chart. Must be null otherwise.
     */
    chartType?: 'line' | 'bar' | 'area' | null;
}> | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    timeRange?: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
} | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    granularity?: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | null;
    /**
     * Flag for telling whether this config has been generated by an LLM.
     */
    isGenerated: boolean;
    /**
     * Extra data to be added to a DTO when sending a response. Should never be generated, only set by a service further downstream.
     */
    dtoExtra?: {
    chartTypes?: Array<('line' | 'bar' | 'area' | null)> | null;
} | null;
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "enpi";
    /**
     * 'overview' renders a multi-EnPI summary table (1..N EnPIs); 'detail' renders one EnPI's full result table + KPI cards.
     */
    mode: 'overview' | 'detail';
    /**
     * Selected EnPI ids. overview: 0..N; detail: at most one.
     */
    enpiIds: Array<(number)>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "cost-overview";
    year: number;
    locationId?: number | null;
    description?: string | null;
};
    createdAt: string;
    updatedAt: string;
    seriesData: Array<{
        seriesId: string;
        label?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        unit: string;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        /**
         * Available options for the intervals between two values in a timeseries.
         */
        granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
        firstDataDate?: string;
        lastDataDate?: string;
        dataPoints: Array<{
            timestamp: string;
            value: number | null;
        }>;
    }>;
    comparisonSeriesData?: Array<{
        seriesId: string;
        label?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        unit: string;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        /**
         * Available options for the intervals between two values in a timeseries.
         */
        granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
        firstDataDate?: string;
        lastDataDate?: string;
        dataPoints: Array<{
            timestamp: string;
            value: number | null;
        }>;
        /**
         * Index into the config's comparisonTimeRanges array this series was resolved for.
         */
        comparisonIndex: number;
    }> | null;
    enpiData?: {
        /**
         * 'overview' renders a multi-EnPI summary table (1..N EnPIs); 'detail' renders one EnPI's full result table + KPI cards.
         */
        mode: 'overview' | 'detail';
        overview?: Array<{
            enpiId: number;
            name: string;
            efficiencyTrendVsLastPeriod: number | null;
            currentValue: number | null;
            unit: string | null;
            energyType: string | null;
            measuringPoint: string | null;
            locationName: string | null;
            referenceDateFrom: string | null;
            dataQualityTimeSeriesIds: Array<(string)>;
        }> | null;
        detail?: {
            enpiId: number;
            name: string;
            interval: 'yearly' | 'monthly' | 'weekly' | 'daily';
            currentValue: number | null;
            unit: string | null;
            efficiencyTrendVsLastPeriod: number | null;
            targetValue: number | null;
            targetValueType: 'absolute' | 'relative' | null;
            energyType: string | null;
            measuringPoint: string | null;
            locationName: string | null;
            referenceDateFrom: string | null;
            dataQualityTimeSeriesIds: Array<(string)>;
            lastCalculatedAt: string | null;
            results: {
                series: Array<{
                    timestamp: string;
                    measuredValue: number | null;
                    baseline: number | null;
                    prediction: number | null;
                    deviation: number | null;
                    deviationKWh: number | null;
                    cusum: number | null;
                    targetDeviation: number | null;
                }>;
                summary: {
                    measuredValueAverage: number | null;
                    baselineAverage: number | null;
                    deviationAverage: number | null;
                    deviationSum: number | null;
                    targetDeviationAverage: number | null;
                };
            } | null;
        } | null;
    } | null;
    costOverviewData?: {
        year: number;
        locationId: number | null;
        locationName: string | null;
        monthlyData: Array<{
            month: string;
            budget: number | null;
            cost: number | null;
            deviation: number | null;
        }>;
    } | null;
    kpiData?: {
        seriesId: string | null;
        label: string | null;
        loadType: 'base-load' | 'average-load' | 'peak-load' | 'sum';
        value: number | null;
        unit: string | null;
        comparisonValue: number | null;
        comparisonDelta: number | null;
        comparisonPercent: number | null;
    } | null;
};

export type CreateReportModuleDto = {
    title: string;
    order?: number;
    isHidden?: boolean;
    config: {
    moduleType: "line-chart";
    showDataPoints?: boolean;
    smoothLine?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "bar-chart";
    orientation?: 'vertical' | 'horizontal';
    stacked?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "pie-chart";
    aggregation?: 'sum' | 'avg' | 'min' | 'max' | 'last';
    showPercentages?: boolean;
    showValues?: boolean;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "combo-chart";
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "heatmap";
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    xAxisLabel?: string;
    yAxisLabel?: string;
    colorScheme?: 'blue-red' | 'green-red' | 'monochrome' | 'viridis' | 'plasma';
    showValues?: boolean;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "table";
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    yAxisType?: 'period' | 'series';
    showTotals?: boolean;
    showAverages?: boolean;
    columns?: Array<{
        field: string;
        label: string;
        format?: 'number' | 'datetime' | 'date' | 'time' | 'percentage' | 'currency' | 'text';
        align?: 'left' | 'center' | 'right';
        width?: string;
    }>;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "kpi";
    /**
     * Selected time series ids. KPI modules support at most one series.
     */
    timeSeriesIds: Array<(string)>;
    /**
     * Scalar calculation applied to the selected series.
     */
    loadType: 'base-load' | 'average-load' | 'peak-load' | 'sum';
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Optional KPI comparison periods. KPI modules support at most one comparison period.
     */
    comparisonPeriods?: Array<{
        /**
         * Number of units to shift the comparison period back.
         */
        count: number;
        unit: 'day' | 'week' | 'month' | 'year';
    }>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "text";
    content?: string;
    format?: 'plain' | 'markdown' | 'html';
    alignment?: 'left' | 'center' | 'right';
} | {
    moduleType: "image";
    fileId?: string;
    fileName?: string;
    mimeType?: string;
} | {
    moduleType: "magic";
    /**
     * Identifiers for every regular module type
     */
    normalModuleType: 'line-chart' | 'bar-chart' | 'pie-chart' | 'combo-chart' | 'heatmap' | 'table' | 'text' | 'image' | 'kpi';
    /**
     * Text generated by an LLM to answer a user prompt. Relevant for normalModuleType==="text", should be null for all other module types.
     */
    generatedText?: string | null;
    /**
     * The dataSources field should only be null if the normalModuleType==='text'. For every other module type it should be an array.
     */
    dataSources?: Array<{
    type: "customSQL";
    /**
     * Generated SQL query
     */
    query: string;
    /**
     * Pay special attention to the distinction between 'energy' and 'power'. If the user asks for things like load, Lastgang or consumption in 15-minute intervals, then the correct dataType is 'power'.Else if the user asks for things like daily, weekly or monthly consumption, then the correct dataType is 'energy'.Other data types like temperature and costs should be identified from the query context.
     */
    dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
    /**
     * 'kWh', 'kW', '°C', '€', 'm3', 'm3/h', etc.
     * Must match the dataType and the context of the query. If dataType is power, then the unit must be 'kW' or 'm3/h'.If dataType is energy, then the unit must be 'kWh' or 'm3'.
     */
    unit: string;
    /**
     * Only present when dataType is energy or power.
     */
    energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas' | null;
    /**
     * Axis label describing the query data. Three words maximum. Must be in the language of the user.
     */
    label: string;
    /**
     * Chart type. Must be set for every combo-chart. Must be null otherwise.
     */
    chartType?: 'line' | 'bar' | 'area' | null;
}> | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    timeRange?: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
} | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    granularity?: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | null;
    /**
     * Flag for telling whether this config has been generated by an LLM.
     */
    isGenerated: boolean;
    /**
     * Extra data to be added to a DTO when sending a response. Should never be generated, only set by a service further downstream.
     */
    dtoExtra?: {
    chartTypes?: Array<('line' | 'bar' | 'area' | null)> | null;
} | null;
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "enpi";
    /**
     * 'overview' renders a multi-EnPI summary table (1..N EnPIs); 'detail' renders one EnPI's full result table + KPI cards.
     */
    mode: 'overview' | 'detail';
    /**
     * Selected EnPI ids. overview: 0..N; detail: at most one.
     */
    enpiIds: Array<(number)>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "cost-overview";
    year: number;
    locationId?: number | null;
    description?: string | null;
};
};

export type ApplyTemplateDto = {
    /**
     * Template to apply.
     */
    templateId: 'monthly-energy-report-rlm' | 'monthly-energy-report-manual';
    /**
     * Time series id preselected for every module of the template.
     */
    timeSeriesId: string;
};

/**
 * Template to apply.
 */
export enum templateId {
    MONTHLY_ENERGY_REPORT_RLM = 'monthly-energy-report-rlm',
    MONTHLY_ENERGY_REPORT_MANUAL = 'monthly-energy-report-manual'
}

export type ReorderModulesDto = {
    moduleIds: Array<(number)>;
};

export type UpdateReportModuleDto = {
    title?: string;
    order?: number;
    isHidden?: boolean;
    config?: {
    moduleType: "line-chart";
    showDataPoints?: boolean;
    smoothLine?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "bar-chart";
    orientation?: 'vertical' | 'horizontal';
    stacked?: boolean;
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "pie-chart";
    aggregation?: 'sum' | 'avg' | 'min' | 'max' | 'last';
    showPercentages?: boolean;
    showValues?: boolean;
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "combo-chart";
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "heatmap";
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    xAxisLabel?: string;
    yAxisLabel?: string;
    colorScheme?: 'blue-red' | 'green-red' | 'monochrome' | 'viridis' | 'plasma';
    showValues?: boolean;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "table";
    /**
     * Optional comparison periods (max 10). When set, the chart also returns comparisonSeriesData for each period, tagged by comparisonIndex.
     */
    comparisonTimeRanges?: Array<({
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
})> | null;
    yAxisType?: 'period' | 'series';
    showTotals?: boolean;
    showAverages?: boolean;
    columns?: Array<{
        field: string;
        label: string;
        format?: 'number' | 'datetime' | 'date' | 'time' | 'percentage' | 'currency' | 'text';
        align?: 'left' | 'center' | 'right';
        width?: string;
    }>;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    series: Array<{
        id: string;
        type?: string;
        locationId?: number;
        /**
         * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
         */
        energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
        label?: string;
        color?: string;
        unit?: string;
        /**
         * Every available data type for a timeseries.
         */
        dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
        yAxisIndex?: number;
        /**
         * Chart type (used in combo-chart). If omitted, defaults to 'bar'.
         */
        chartType?: 'line' | 'bar' | 'area';
        /**
         * How a report time series should be calculated within each displayed bucket.
         */
        calculationMethod?: 'value' | 'loadProfile' | 'peak' | 'base' | 'average';
    }>;
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "kpi";
    /**
     * Selected time series ids. KPI modules support at most one series.
     */
    timeSeriesIds: Array<(string)>;
    /**
     * Scalar calculation applied to the selected series.
     */
    loadType: 'base-load' | 'average-load' | 'peak-load' | 'sum';
    timeRange: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
};
    /**
     * Optional KPI comparison periods. KPI modules support at most one comparison period.
     */
    comparisonPeriods?: Array<{
        /**
         * Number of units to shift the comparison period back.
         */
        count: number;
        unit: 'day' | 'week' | 'month' | 'year';
    }>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "text";
    content?: string;
    format?: 'plain' | 'markdown' | 'html';
    alignment?: 'left' | 'center' | 'right';
} | {
    moduleType: "image";
    fileId?: string;
    fileName?: string;
    mimeType?: string;
} | {
    moduleType: "magic";
    /**
     * Identifiers for every regular module type
     */
    normalModuleType: 'line-chart' | 'bar-chart' | 'pie-chart' | 'combo-chart' | 'heatmap' | 'table' | 'text' | 'image' | 'kpi';
    /**
     * Text generated by an LLM to answer a user prompt. Relevant for normalModuleType==="text", should be null for all other module types.
     */
    generatedText?: string | null;
    /**
     * The dataSources field should only be null if the normalModuleType==='text'. For every other module type it should be an array.
     */
    dataSources?: Array<{
    type: "customSQL";
    /**
     * Generated SQL query
     */
    query: string;
    /**
     * Pay special attention to the distinction between 'energy' and 'power'. If the user asks for things like load, Lastgang or consumption in 15-minute intervals, then the correct dataType is 'power'.Else if the user asks for things like daily, weekly or monthly consumption, then the correct dataType is 'energy'.Other data types like temperature and costs should be identified from the query context.
     */
    dataType: 'energy' | 'power' | 'temperature' | 'costs' | 'prices' | 'custom';
    /**
     * 'kWh', 'kW', '°C', '€', 'm3', 'm3/h', etc.
     * Must match the dataType and the context of the query. If dataType is power, then the unit must be 'kW' or 'm3/h'.If dataType is energy, then the unit must be 'kWh' or 'm3'.
     */
    unit: string;
    /**
     * Only present when dataType is energy or power.
     */
    energyType?: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas' | null;
    /**
     * Axis label describing the query data. Three words maximum. Must be in the language of the user.
     */
    label: string;
    /**
     * Chart type. Must be set for every combo-chart. Must be null otherwise.
     */
    chartType?: 'line' | 'bar' | 'area' | null;
}> | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    timeRange?: {
    type: "preset";
    /**
     * Preset timerange options. Used to determine what data to fetch for a report module.
     */
    value: 'today' | 'yesterday' | 'last-calendar-week' | 'last-seven-days' | 'last-fourteen-days' | 'last-thirty-days' | 'last-calendar-month' | 'last-three-calendar-months' | 'last-six-calendar-months' | 'current-year-to-date' | 'last-calendar-year' | 'penultimate-calendar-year';
} | {
    type: "relative";
    start: {
        operation: 'subtract' | 'add';
        amount: number;
        unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
    };
    /**
     * If omitted or set to null, will be handled as "now"
     */
    end?: {
    operation: 'subtract' | 'add';
    amount: number;
    unit: 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';
} | null;
} | {
    type: "absolute";
    /**
     * ISO 8601 datetime, for example: "2024-01-01T00:00:00Z"
     */
    startDate: string;
    /**
     * ISO 8601 datetime, for example: "2024-12-31T23:59:59Z"
     */
    endDate: string;
} | null;
    /**
     * Should be null only if all dataSources are of type generatedText
     */
    granularity?: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | null;
    /**
     * Flag for telling whether this config has been generated by an LLM.
     */
    isGenerated: boolean;
    /**
     * Extra data to be added to a DTO when sending a response. Should never be generated, only set by a service further downstream.
     */
    dtoExtra?: {
    chartTypes?: Array<('line' | 'bar' | 'area' | null)> | null;
} | null;
    /**
     * X-axis configuration
     */
    xAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Left Y-axis configuration
     */
    yAxis?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Right Y-axis configuration (for dual-axis plots)
     */
    yAxisRight?: {
    /**
     * Axis label
     */
    label?: string | null;
    /**
     * Unit to display (e.g., "kWh", "°C")
     */
    unit?: string | null;
    /**
     * Min value (will be treated as "auto" if omitted or set to null)
     */
    min?: number | null;
    /**
     * Max value (will be treated as "auto" if omitted or set to null)
     */
    max?: number | null;
    /**
     * Scale type
     */
    scale?: 'linear' | 'logarithmic' | null;
} | null;
    /**
     * Display legend
     */
    showLegend?: boolean | null;
    /**
     * Module description/annotation
     */
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "enpi";
    /**
     * 'overview' renders a multi-EnPI summary table (1..N EnPIs); 'detail' renders one EnPI's full result table + KPI cards.
     */
    mode: 'overview' | 'detail';
    /**
     * Selected EnPI ids. overview: 0..N; detail: at most one.
     */
    enpiIds: Array<(number)>;
    description?: string | null;
    /**
     * Display data quality indicator in report module
     */
    showDataQualityIndicator?: boolean;
} | {
    moduleType: "cost-overview";
    year: number;
    locationId?: number | null;
    description?: string | null;
};
};

export type GetGapsResponseDto = {
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Building ID
     */
    buildingId: number;
    /**
     * Device ID
     */
    deviceId: string;
    /**
     * Device name
     */
    deviceName: string;
    /**
     * Gap start
     */
    startDate: string;
    /**
     * Gap end
     */
    endDate: string;
    /**
     * Total intervals missing
     */
    missingIntervals: number;
    /**
     * Total minutes
     */
    missingMinutes: number;
    /**
     * Measurement unit
     */
    unit: string;
    /**
     * API provider
     */
    source: string;
    /**
     * Energy type
     */
    energyType: string;
    /**
     * Is main source
     */
    isMain: boolean;
    /**
     * Is virtual
     */
    isVirtual: boolean;
};

export type SeriesResponseDto = {
    /**
     * Series UUID
     */
    id: string;
    /**
     * Series title
     */
    title?: string | null;
    /**
     * Is default series
     */
    isDefault: boolean;
    /**
     * API Provider ID
     */
    apiProviderId?: number | null;
    /**
     * Energy Type ID
     */
    energyTypeId?: number | null;
    /**
     * Device Type ID
     */
    deviceTypeId: number;
    /**
     * Data granularity
     */
    granularity: string;
    /**
     * Granularity unit
     */
    granularityUnit: 'MINUTES' | 'MONTHS';
    /**
     * Measurement Unit ID
     */
    measurementUnitId?: number | null;
    /**
     * Scale factor
     */
    factor: number;
    /**
     * Value Type ID
     */
    valueTypeId?: number | null;
    /**
     * First data date
     */
    firstDataDate?: string | null;
    /**
     * Last data date
     */
    lastDataDate?: string | null;
    /**
     * Provider-specific configuration
     */
    apiProviderConfig?: {
        [key: string]: unknown;
    } | null;
    /**
     * Created timestamp
     */
    createdAt: string;
    /**
     * Updated timestamp
     */
    updatedAt: string;
};

export type CreateOrLinkSeriesDto = {
    /**
     * Meter ID to link the series to
     */
    meterId: number;
    /**
     * Series title
     */
    title?: string;
    /**
     * Is this the default series
     */
    isDefault?: boolean;
    /**
     * API Provider ID
     */
    apiProviderId: number;
    /**
     * Energy Type ID
     */
    energyTypeId?: number;
    /**
     * Device Type ID
     */
    deviceTypeId: number;
    /**
     * Virtual meter configuration
     */
    virtual?: {
        [key: string]: unknown;
    };
    /**
     * Data granularity (e.g., "15" for 15 minutes)
     */
    granularity: string;
    /**
     * Granularity unit
     */
    granularityUnit?: 'MINUTES' | 'MONTHS';
    /**
     * Measurement Unit ID
     */
    measurementUnitId?: number;
    /**
     * Scale factor
     */
    factor?: number;
    /**
     * Value Type ID
     */
    valueTypeId?: number;
    /**
     * Provider-specific configuration (groupId for MQTT, deviceId+obisCode for Mako, etc.)
     */
    apiProviderConfig?: {
        [key: string]: unknown;
    };
};

export type CreateOrLinkSeriesResponseDto = {
    series: {
        id?: string;
        title?: string | null;
        isDefault?: boolean;
        apiProviderId?: number | null;
        energyTypeId?: number | null;
        deviceTypeId?: number;
        granularity?: string;
        granularityUnit?: string;
        measurementUnitId?: number | null;
        factor?: number;
        valueTypeId?: number | null;
        firstDataDate?: string | null;
        lastDataDate?: string | null;
        apiProviderConfig?: {
            [key: string]: unknown;
        } | null;
        createdAt?: string;
        updatedAt?: string;
    };
    /**
     * Whether the series was newly created (true) or already existed (false)
     */
    created: boolean;
};

export type UpdateSeriesDto = {
    /**
     * Series title
     */
    title?: string;
    /**
     * Is this the default series
     */
    isDefault?: boolean;
    /**
     * API Provider ID
     */
    apiProviderId?: number;
    /**
     * Energy Type ID
     */
    energyTypeId?: number;
    /**
     * Device Type ID
     */
    deviceTypeId?: number;
    /**
     * Virtual meter configuration
     */
    virtual?: {
        [key: string]: unknown;
    };
    /**
     * Data granularity
     */
    granularity?: string;
    /**
     * Granularity unit
     */
    granularityUnit?: 'MINUTES' | 'MONTHS';
    /**
     * Measurement Unit ID
     */
    measurementUnitId?: number;
    /**
     * Scale factor
     */
    factor?: number;
    /**
     * Value Type ID
     */
    valueTypeId?: number;
    /**
     * Provider-specific configuration
     */
    apiProviderConfig?: {
        [key: string]: unknown;
    };
};

export type MeterSeriesLinkDto = {
    /**
     * Meter ID
     */
    meterId: number;
    /**
     * Series UUID
     */
    seriesId: string;
    /**
     * Override title for this meter-series link
     */
    title?: string;
};

export type LinkMetersToSeriesDto = {
    /**
     * Array of meter-series links
     */
    links: Array<MeterSeriesLinkDto>;
};

export type MeterSeriesTitleUpdateItem = {
    /**
     * Meter ID
     */
    meterId: number;
    /**
     * Series UUID
     */
    seriesId: string;
    /**
     * Display title (null to clear and use series.title)
     */
    title?: string | null;
};

export type BatchUpdateMeterSeriesTitleDto = {
    /**
     * Array of meter-series title updates
     */
    updates: Array<MeterSeriesTitleUpdateItem>;
};

export type MeterInfoDto = {
    /**
     * Meter ID
     */
    id: number;
    /**
     * Meter title
     */
    title: string | null;
    /**
     * Device ID
     */
    deviceId: string;
    /**
     * Building ID
     */
    buildingId: number;
    /**
     * Building name
     */
    buildingName: string | null;
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Location name
     */
    locationName: string;
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Company name
     */
    companyName: string;
};

export type SankeyNodeDto = {
    key?: number;
    id: string;
    consumption: number;
    isIndividualDevice?: boolean;
    color?: string;
    name: string;
    deviceId?: string;
};

export type SankeyLinkDto = {
    source: string;
    target: string;
    value: number;
    color?: string;
    fromProducerToTotalFlow?: boolean;
};

export type SankeyGetResponseDto = {
    nodes: Array<SankeyNodeDto>;
    links: Array<SankeyLinkDto>;
};

export type SankeyDeviceIdentifierDto = {
    /**
     * The display name of the device/meter
     */
    name: string;
    /**
     * The unique device ID
     */
    deviceId: string;
};

export type SankeyCyclicErrorDto = {
    /**
     * Error type identifier for cyclic tree detection in sankey data generation
     */
    error: string;
    /**
     * Possible culprit devices that are causing the cyclic reference
     */
    possibleCulprit: Array<SankeyDeviceIdentifierDto>;
};

export type SankeyCsvExportRequestDto = {
    /**
     * IDs of the nodes that should be visible in the exported CSV
     */
    visibleNodeIds?: Array<(string)>;
};

export type MeterViewListItemDto = {
    id: number;
    name: string;
    description?: string;
    companyId: number;
    createdAt: string;
    updatedAt: string;
};

export type MeterViewListResponseDto = {
    views: Array<MeterViewListItemDto>;
    total: number;
};

export type MeterNodeInfoDto = {
    id: number;
    deviceId: string;
    name?: string;
    energyType?: string;
    measurementUnit?: string;
    virtual?: {
        [key: string]: unknown;
    };
    locationId?: number;
    locationTitle?: string;
    buildingTitle?: string;
};

export type FolderNodeInfoDto = {
    id: number;
    name: string;
};

export type ViewNodeDto = {
    id: number;
    viewId: number;
    parentNodeId?: number | null;
    displayOrder: number;
    type: 'FOLDER' | 'METER';
    /**
     * Whether the meter behind this node is readable by the caller. `DELETED` and `LOCKED` nodes still list their children; `LOCKED` nodes carry no `meterNodeInfo` and reject every write.
     */
    accessState: 'AVAILABLE' | 'DELETED' | 'LOCKED';
    /**
     * Absent on `LOCKED` nodes — the caller may not see the meter.
     */
    meterNodeInfo?: MeterNodeInfoDto;
    folderNodeInfo?: FolderNodeInfoDto;
    /**
     * Child nodes
     */
    children: Array<ViewNodeDto>;
    createdAt: string;
    updatedAt: string;
    consumption: number;
};

export enum type7 {
    FOLDER = 'FOLDER',
    METER = 'METER'
}

/**
 * Whether the meter behind this node is readable by the caller. `DELETED` and `LOCKED` nodes still list their children; `LOCKED` nodes carry no `meterNodeInfo` and reject every write.
 */
export enum accessState {
    AVAILABLE = 'AVAILABLE',
    DELETED = 'DELETED',
    LOCKED = 'LOCKED'
}

export type MeterViewDto = {
    id: number;
    name: string;
    description?: string;
    companyId: number;
    nodes: Array<ViewNodeDto>;
    createdAt: string;
    updatedAt: string;
};

export type CreateMeterViewDto = {
    /**
     * View name
     */
    name: string;
    /**
     * View description
     */
    description?: string;
    /**
     * Company ID
     */
    companyId: number;
};

export type UpdateMeterViewDto = {
    /**
     * View name
     */
    name?: string;
    /**
     * View description
     */
    description?: string;
};

export type CreateMeterNodeInfoDto = {
    /**
     * Device ID for the meter
     */
    deviceId: string;
};

export type CreateFolderNodeInfoDto = {
    /**
     * Folder name
     */
    name: string;
};

export type CreateViewNodeDto = {
    /**
     * Type of node
     */
    type: 'FOLDER' | 'METER';
    /**
     * Parent node ID
     */
    parentNodeId?: number;
    /**
     * Display order
     */
    displayOrder?: number;
    /**
     * Meter info (required when type is METER)
     */
    meterNodeInfo?: CreateMeterNodeInfoDto;
    /**
     * Folder info (required when type is FOLDER)
     */
    folderNodeInfo?: CreateFolderNodeInfoDto;
};

export type UpdateNodeParentDto = {
    /**
     * New parent node ID (null to move to root)
     */
    parentNodeId?: number | null;
};

export type InvoiceUploadedEvent = {
    eventName: 'invoiceUploaded';
    /**
     * The invoice ID of the uploaded invoice
     */
    invoiceId: number;
};

export enum eventName7 {
    INVOICE_UPLOADED = 'invoiceUploaded'
}

export type InvoiceAiAnalysisCompleted = {
    eventName: 'invoiceAiAnalysisCompleted';
    /**
     * The invoice ID of the uploaded invoice
     */
    invoiceId: number;
};

export enum eventName8 {
    INVOICE_AI_ANALYSIS_COMPLETED = 'invoiceAiAnalysisCompleted'
}

export type InvoiceUploadedErrorEvent = {
    eventName: 'invoiceUploadError';
    /**
     * The invoice ID of the uploaded invoice
     */
    invoiceId: number;
    /**
     * Error message
     */
    errorMessage: string;
};

export enum eventName9 {
    INVOICE_UPLOAD_ERROR = 'invoiceUploadError'
}

export type InvoiceAiAnalysisErrorEvent = {
    eventName: 'invoiceAiAnalysisError';
    /**
     * The invoice ID of the uploaded invoice
     */
    invoiceId: number;
    /**
     * Error message
     */
    errorMessage: string;
    /**
     * Number of consecutive failed analyses on this invoice slot after this failure. 1 => first failure (prompt re-upload); >1 => repeated failure (ecoplanet team notified).
     */
    failureCount: number;
};

export enum eventName10 {
    INVOICE_AI_ANALYSIS_ERROR = 'invoiceAiAnalysisError'
}

export type InvoiceEcoplanetReview = {
    eventName: 'invoiceInEcoplanetReview';
    /**
     * The invoice ID of the uploaded invoice
     */
    invoiceId: number;
};

export enum eventName11 {
    INVOICE_IN_ECOPLANET_REVIEW = 'invoiceInEcoplanetReview'
}

export type InvoiceEcoplanetUpdateEvent = {
    eventName: 'invoiceEcoplanetUpdate';
    /**
     * The invoice ID of the updated invoice
     */
    invoiceId: number;
    /**
     * The company firebase ID of the updated invoice
     */
    companyId: string;
    /**
     * The location ID of the updated invoice
     */
    locationId: number;
    /**
     * The building ID of the updated invoice
     */
    buildingId: number;
};

export enum eventName12 {
    INVOICE_ECOPLANET_UPDATE = 'invoiceEcoplanetUpdate'
}

export type RecreateBulkInvoicesDto = {
    /**
     * Year to regenerate invoices for
     */
    year: number;
    /**
     * Array of Company IDs to regenerate invoices for.
     */
    companyIds?: Array<(number)>;
    /**
     * Array of Location IDs to regenerate invoices for.
     */
    locationIds?: Array<(number)>;
    /**
     * Optional month to regenerate invoices for. If not provided, all months will be processed.
     */
    month?: number;
    /**
     * Whether to recalculate hedge summaries. Defaults to false (uses cached values). Set to true to force recalculation.
     */
    calculateSummary?: boolean;
    /**
     * Must be set to true to recalculate invoices for ALL companies when neither companyIds nor locationIds are provided. This is a safety flag to prevent accidental mass recalculation.
     */
    dangerouslyRecalculateForAllCompanies?: boolean;
};

export enum InvoiceStatusEnum {
    CHECKED = 'checked',
    PROCESSING = 'processing',
    DISCREPANCY = 'discrepancy',
    REVIEW = 'review',
    WAITING_DATA = 'waitingData'
}

export type AmountDto = {
    /**
     * The unit of measurement
     */
    unit: string;
    /**
     * The numerical value
     */
    value: number;
};

export type UnitCostDto = {
    /**
     * The unit of measurement for the cost
     */
    unit: string;
    /**
     * The numerical value of the unit cost
     */
    value: number;
};

export type CostsDto = {
    /**
     * The amount of energy or cost-related quantity
     */
    amount: (AmountDto) | null;
    /**
     * The unit cost for the specified amount
     */
    unitCost: UnitCostDto;
    /**
     * The total cost for the specific category
     */
    totalCost: number;
};

export type ManualInvoicePositionDto = {
    /**
     * Unique identifier for the manual invoice position
     */
    id: number;
    /**
     * Display name for the manual invoice position
     */
    name: string;
    /**
     * Optional description or notes for the item
     */
    description?: string;
    /**
     * The amount of energy or cost-related quantity
     */
    amount: AmountDto;
    /**
     * The unit cost for the specified amount
     */
    unitCost: UnitCostDto;
    /**
     * The total cost for the specified manual invoice position
     */
    totalCost: number;
};

export type SupplierFeeAllocationDto = {
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Allocated amount
     */
    amount: number;
    /**
     * Percentage share
     */
    share?: number;
    /**
     * Consumption in kWh for this location
     */
    consumptionKwh?: number;
    /**
     * Reason for fallback if allocation was not possible
     */
    fallbackReason?: string;
};

export type SupplierFeeBreakdownDto = {
    /**
     * The scope type for distribution
     */
    appliedScope: string;
    /**
     * The location logic for distribution
     */
    appliedPerLocationLogic: string | null;
    /**
     * The period logic for distribution
     */
    appliedPeriodLogic: string;
    /**
     * Individual location allocations
     */
    allocations: Array<SupplierFeeAllocationDto>;
};

export type CostDetailsDto = {
    /**
     * Cost breakdown for KWK (Combined Heat and Power)
     */
    kwk: CostsDto;
    /**
     * Cost breakdown for ABLA (Anti-Blackout Assistance)
     */
    abla: CostsDto;
    /**
     * Cost breakdown for offshore energy costs
     */
    offshore: CostsDto;
    /**
     * Cost breakdown for StromNEV (Electricity Grid Usage)
     */
    stromNEV: CostsDto;
    /**
     * Cost breakdown for energy taxes
     */
    energyTax: CostsDto;
    /**
     * Cost breakdown for grid usage
     */
    gridUsage: CostsDto;
    /**
     * Cost breakdown for meter costs
     */
    meterCost: CostsDto;
    /**
     * Cost breakdown for other costs
     */
    otherCost: CostsDto;
    /**
     * Total energy cost
     */
    totalCost: number;
    /**
     * Cost breakdown for service fees
     */
    serviceFee: CostsDto;
    /**
     * Cost breakdown for base supplier fee
     */
    baseSupplierFee: CostsDto;
    /**
     * Total taxes applied to the energy consumption
     */
    totalTaxes: number;
    /**
     * Cost breakdown for commodity spot prices
     */
    commoditySpot: CostsDto;
    /**
     * Metering costs associated with energy usage
     */
    meteringCosts: number;
    /**
     * Cost breakdown for peak load prices
     */
    peakloadPrice: CostsDto;
    /**
     * Total grid usage costs
     */
    totalGridCost: number;
    /**
     * Cost breakdown for fixed commodity costs
     */
    commodityFixed: CostsDto;
    /**
     * Total remaining costs after calculations
     */
    totalRemaining: number;
    /**
     * Cost breakdown for Konzessionsabgabe (concession fees)
     */
    konzessionsabgabe: CostsDto;
    /**
     * Total peak load cost
     */
    totalPeakloadCost: number;
    /**
     * Total commodity costs
     */
    totalCommodityCost: number;
    /**
     * Whether the invoice uses hedging CSV data
     */
    isHedged: boolean;
    /**
     * VAT rate in percent
     */
    vat?: number | null;
    /**
     * Total cost including VAT
     */
    totalCostWithVat?: number | null;
    /**
     * Arbitrary manual line items to be included in the Others section
     */
    manualInvoicePositions?: Array<ManualInvoicePositionDto>;
    /**
     * Breakdown of the supplier base fee distribution
     */
    supplierFeeBreakdown?: SupplierFeeBreakdownDto;
};

export type OcrExtractedCostDetailsDto = {
    /**
     * Invoice month in YYYY-MM format
     */
    month: string;
    totalConsumption: number | null;
    totalNetCost: number | null;
    energyPricePerKwh: number | null;
    totalEnergyCost: number | null;
    arbeitspreisNetzPerKwh: number | null;
    totalArbeitspreisNetzCost: number | null;
    peakloadPrice: number | null;
    totalPeakloadCost: number | null;
    peakloadKw: number | null;
    kwkgPerKwh: number | null;
    totalKwkgCost: number | null;
    stromNEVPerKwh: number | null;
    totalStromNEVCost: number | null;
    offshorePerKwh: number | null;
    totalOffshoreCost: number | null;
    konzessionsabgabePerKwh: number | null;
    totalKonzessionsabgabeCost: number | null;
    stromsteuerPerKwh: number | null;
    totalStromsteuerCost: number | null;
    totalMesskosten: number | null;
};

export enum InvoicePositionStatusEnum {
    CHECKED = 'checked',
    PROCESSING = 'processing',
    DISCREPANCY = 'discrepancy',
    MISSING = 'missing'
}

export type CostDetailVerificationResultDto = {
    status: InvoicePositionStatusEnum;
    discrepancy?: number;
    isDiscrepancyLessThanOnePercent: boolean;
};

export type CostDetailsVerificationDto = {
    totalNetCost: CostDetailVerificationResultDto;
    energyPricePerKwh: CostDetailVerificationResultDto;
    totalEnergyCost: CostDetailVerificationResultDto;
    arbeitspreisNetzPerKwh: CostDetailVerificationResultDto;
    totalArbeitspreisNetzCost: CostDetailVerificationResultDto;
    peakloadPrice: CostDetailVerificationResultDto;
    totalPeakloadCost: CostDetailVerificationResultDto;
    peakloadKw: CostDetailVerificationResultDto;
    kwkgPerKwh: CostDetailVerificationResultDto;
    totalKwkgCost: CostDetailVerificationResultDto;
    stromNEVPerKwh: CostDetailVerificationResultDto;
    totalStromNEVCost: CostDetailVerificationResultDto;
    offshorePerKwh: CostDetailVerificationResultDto;
    totalOffshoreCost: CostDetailVerificationResultDto;
    konzessionsabgabePerKwh: CostDetailVerificationResultDto;
    totalKonzessionsabgabeCost: CostDetailVerificationResultDto;
    stromsteuerPerKwh: CostDetailVerificationResultDto;
    totalStromsteuerCost: CostDetailVerificationResultDto;
    totalMesskosten: CostDetailVerificationResultDto;
};

export type CostVerificationStatusesDto = {
    totalNetCost?: InvoicePositionStatusEnum;
    energyPricePerKwh?: InvoicePositionStatusEnum;
    totalEnergyCost?: InvoicePositionStatusEnum;
    arbeitspreisNetzPerKwh?: InvoicePositionStatusEnum;
    totalArbeitspreisNetzCost?: InvoicePositionStatusEnum;
    peakloadPrice?: InvoicePositionStatusEnum;
    totalPeakloadCost?: InvoicePositionStatusEnum;
    peakloadKw?: InvoicePositionStatusEnum;
    kwkgPerKwh?: InvoicePositionStatusEnum;
    totalKwkgCost?: InvoicePositionStatusEnum;
    stromNEVPerKwh?: InvoicePositionStatusEnum;
    totalStromNEVCost?: InvoicePositionStatusEnum;
    offshorePerKwh?: InvoicePositionStatusEnum;
    totalOffshoreCost?: InvoicePositionStatusEnum;
    konzessionsabgabePerKwh?: InvoicePositionStatusEnum;
    totalKonzessionsabgabeCost?: InvoicePositionStatusEnum;
    stromsteuerPerKwh?: InvoicePositionStatusEnum;
    totalStromsteuerCost?: InvoicePositionStatusEnum;
    totalMesskosten?: InvoicePositionStatusEnum;
};

export type InvoiceResponseDto = {
    id: number;
    invoiceDate: string;
    locationId: number;
    buildingId: number;
    invoiceAmount: number;
    externalInvoice?: ObjectStorageV2MetadataDto;
    invoiceStatus: InvoiceStatusEnum;
    costDetails?: CostDetailsDto;
    calculationVersion: number;
    ocrCostDetails?: OcrExtractedCostDetailsDto;
    costDetailsVerification?: CostDetailsVerificationDto;
    /**
     * Sparse map of per-line statuses the user has manually overridden. Lines listed here have their status reflected in costDetailsVerification; absent lines are purely computed. A line is dropped from this map when a later recomputation verifies it as checked.
     */
    costDetailsVerificationOverride?: CostVerificationStatusesDto;
    notes?: string;
    /**
     * Historic consumption amount derived from energy tax amount field
     */
    historicConsumptionAmount?: number | null;
    /**
     * Audit trail of changes made to this invoice
     */
    changeHistory: Array<ObjectChangeHistoryDto>;
    /**
     * When the current OCR/AI analysis started; null when no analysis is in flight
     */
    analysisStartedAt: string | null;
    /**
     * Whether an OCR/AI analysis is currently in flight for this invoice (respects the staleness threshold)
     */
    isBeingAnalyzed: boolean;
    /**
     * Count of consecutive failed OCR/AI analyses on this invoice slot; 0 when the last analysis succeeded. Persists across file deletes. The table failure state ("Rechnungsanalyse-Fehler") is shown when a file is present, this is > 0, and no analysis is in flight; > 1 indicates a repeated failure (ecoplanet team notified).
     */
    analysisFailureCount: number;
};

export type InvoicePageableResponseListDto = {
    invoices: Array<InvoiceResponseDto>;
    /**
     * Pagination Metadata
     */
    metadata: PageableMetadataDto;
};

export type PatchInvoiceStatusDto = {
    invoiceStatus: InvoiceStatusEnum;
};

export type UpdateCostVerificationOverrideDto = {
    statuses?: CostVerificationStatusesDto;
    clearedFields?: 'totalNetCost' | 'energyPricePerKwh' | 'totalEnergyCost' | 'arbeitspreisNetzPerKwh' | 'totalArbeitspreisNetzCost' | 'peakloadPrice' | 'totalPeakloadCost' | 'peakloadKw' | 'kwkgPerKwh' | 'totalKwkgCost' | 'stromNEVPerKwh' | 'totalStromNEVCost' | 'offshorePerKwh' | 'totalOffshoreCost' | 'konzessionsabgabePerKwh' | 'totalKonzessionsabgabeCost' | 'stromsteuerPerKwh' | 'totalStromsteuerCost' | 'totalMesskosten';
};

export enum clearedFields {
    TOTAL_NET_COST = 'totalNetCost',
    ENERGY_PRICE_PER_KWH = 'energyPricePerKwh',
    TOTAL_ENERGY_COST = 'totalEnergyCost',
    ARBEITSPREIS_NETZ_PER_KWH = 'arbeitspreisNetzPerKwh',
    TOTAL_ARBEITSPREIS_NETZ_COST = 'totalArbeitspreisNetzCost',
    PEAKLOAD_PRICE = 'peakloadPrice',
    TOTAL_PEAKLOAD_COST = 'totalPeakloadCost',
    PEAKLOAD_KW = 'peakloadKw',
    KWKG_PER_KWH = 'kwkgPerKwh',
    TOTAL_KWKG_COST = 'totalKwkgCost',
    STROM_NEVPER_KWH = 'stromNEVPerKwh',
    TOTAL_STROM_NEVCOST = 'totalStromNEVCost',
    OFFSHORE_PER_KWH = 'offshorePerKwh',
    TOTAL_OFFSHORE_COST = 'totalOffshoreCost',
    KONZESSIONSABGABE_PER_KWH = 'konzessionsabgabePerKwh',
    TOTAL_KONZESSIONSABGABE_COST = 'totalKonzessionsabgabeCost',
    STROMSTEUER_PER_KWH = 'stromsteuerPerKwh',
    TOTAL_STROMSTEUER_COST = 'totalStromsteuerCost',
    TOTAL_MESSKOSTEN = 'totalMesskosten'
}

export type PatchInvoiceNotesDto = {
    notes: string;
};

export type CreateManualInvoicePositionRequestDto = {
    /**
     * Display name for the manual invoice position
     */
    name: string;
    /**
     * Optional description or notes for the item
     */
    description?: string;
    /**
     * The unit of measurement for amount
     */
    amountUnit: string;
    /**
     * The numerical amount value
     */
    amountValue: number;
    /**
     * The unit of measurement for unit cost
     */
    unitCostUnit: string;
    /**
     * The unit cost value
     */
    unitCostValue: number;
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Year
     */
    year: number;
    /**
     * Month
     */
    month: number;
};

export type UpdateManualInvoicePositionRequestDto = {
    /**
     * Display name for the manual invoice position
     */
    name: string;
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Optional description or notes for the item
     */
    description?: string;
    /**
     * The unit of measurement for amount
     */
    amountUnit: string;
    /**
     * The numerical amount value
     */
    amountValue: number;
    /**
     * The unit of measurement for unit cost
     */
    unitCostUnit: string;
    /**
     * The unit cost value
     */
    unitCostValue: number;
};

export type GraphMarkerDto = {
    datepickerFrom: string;
    datepickerTo: string;
    from: string;
    to: string;
};

export type InsightsResponseDto = {
    id: string;
    approved: boolean;
    category: string;
    createdAt: string;
    graphMarker: Array<GraphMarkerDto>;
    impact: string;
    irrelevantCount: number;
    isCustom: boolean;
    kpi: string;
    seenAt: string;
    subtype: string;
    tabIndex: number;
    text: string;
    type: string;
    visible: boolean;
    buildingName: string;
    buildingIndex: number;
    locationName: string;
    locationIndex: number;
    deviceId: string;
    locationId: number;
};

export type FetchConsumptionDto = {
    companyId: number;
    locationId: number;
    buildingId: number;
    isUserInitiated?: boolean;
};

export type TimeSeriesDto = {
    id: string;
    locationId?: number;
    type?: string;
};

export type CreateMultivariateLinearRegressionDto = {
    title: string;
    from: string;
    to: string;
    independentSeries: Array<TimeSeriesDto>;
    dependentSeries: TimeSeriesDto;
    granularity: '15min' | 'day' | 'week' | 'month';
    /**
     * Standard error factor for regression calculations
     */
    stdErrorFactor?: number;
    locationId?: number;
    companyId?: number;
};

export enum granularity3 {
    _15MIN = '15min',
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month'
}

export type TimeSeriesResponseDto = {
    id: string;
    locationId?: number;
    type?: string;
    /**
     * Unit of the series, if available. Missing for regressions calculated before units were stored
     */
    unit?: string;
};

export type ConfidenceIntervalDto = {
    lower: number;
    upper: number;
    confidenceLevel: number;
};

export type RegressionCoefficientStatisticDto = {
    stdError: number;
    tValue: number;
    pValue: number;
    /**
     * Missing for regressions calculated before confidence intervals were introduced
     */
    confidenceInterval?: ConfidenceIntervalDto;
    significance: 'not_significant' | 'significant' | 'very_significant' | 'highly_significant';
};

export enum significance {
    NOT_SIGNIFICANT = 'not_significant',
    SIGNIFICANT = 'significant',
    VERY_SIGNIFICANT = 'very_significant',
    HIGHLY_SIGNIFICANT = 'highly_significant'
}

export type RegressionCoefficientDto = {
    variable: string;
    coefficient: number;
    statistics: RegressionCoefficientStatisticDto;
};

export type ResidualStatisticsDto = {
    mean: number;
    max: number;
    min: number;
    stdError: number;
};

export type PlotPointDto = {
    x: number;
    y: number;
};

export type CorrelationOfIndependentVariablesDto = {
    variableNames: Array<(string)>;
    correlationMatrix: Array<Array<(number)>>;
};

export type ModelDiagnosticsDto = {
    isNormalityCheckPassed: boolean;
    normalityPlot: Array<PlotPointDto>;
    isHomoscedasticityCheckPassed: boolean;
    homoscedasticityPlot: Array<PlotPointDto>;
    isMulticollinearityCheckPassed: boolean;
    vifValues: {
        [key: string]: unknown;
    };
    correlationOfIndependentVariables: CorrelationOfIndependentVariablesDto;
};

export type RegressionStatisticsDto = {
    r2: number;
    adjustedR2: number;
    overallFit: 'excellent_fit' | 'fair_fit' | 'good_fit' | 'poor_fit';
    fStatistic: number;
    fStatisticPValue: number;
    overallSignificance: 'not_significant' | 'significant' | 'very_significant' | 'highly_significant';
    residualStatistics: ResidualStatisticsDto;
    modelDiagnostics: ModelDiagnosticsDto;
};

export enum overallFit {
    EXCELLENT_FIT = 'excellent_fit',
    FAIR_FIT = 'fair_fit',
    GOOD_FIT = 'good_fit',
    POOR_FIT = 'poor_fit'
}

export enum overallSignificance {
    NOT_SIGNIFICANT = 'not_significant',
    SIGNIFICANT = 'significant',
    VERY_SIGNIFICANT = 'very_significant',
    HIGHLY_SIGNIFICANT = 'highly_significant'
}

export type ResidualPointDto = {
    timestamp: string;
    value: number;
    unit: string;
    numStdErrors: number;
    isOutlier: boolean;
};

export type MultivariateLinearRegressionResponse = {
    id: number;
    title?: string | null;
    from: string;
    to: string;
    independentSeries: Array<TimeSeriesResponseDto>;
    dependentSeries: TimeSeriesResponseDto;
    granularity: '15min' | 'day' | 'week' | 'month';
    coefficients: Array<RegressionCoefficientDto>;
    statistics: RegressionStatisticsDto;
    totalDataPoints: number;
    stdErrorFactor?: number;
    residualTimeseries: Array<ResidualPointDto>;
    excludedTimestamps: Array<(string)>;
    createdBy?: string;
    updatedBy?: string;
    createdAt: string;
    updatedAt: string;
};

export type UpdateMultivariateLinearRegressionDto = {
    title?: string;
    from?: string;
    to?: string;
    independentSeries?: Array<TimeSeriesDto>;
    dependentSeries?: TimeSeriesDto;
    granularity?: '15min' | 'day' | 'week' | 'month';
    /**
     * List of timestamps to be excluded from regression calculations
     */
    excludedTimestamps?: Array<(string)>;
    /**
     * Standard error factor used for outlier detection
     */
    stdErrorFactor?: number;
};

export type TimeseriesPointDto = {
    /**
     * Normalized timestamp in the format of the regression granularity
     */
    timestamp: string;
    value: number;
};

export type ActualVsModelSeriesResponse = {
    regressionId: number;
    /**
     * Always the granularity the regression was fitted on
     */
    granularity: '15min' | 'day' | 'week' | 'month';
    /**
     * Unit of the dependent series, which is also the unit of the model output
     */
    unit?: string;
    /**
     * Measured values of the dependent series; only timestamps with a value, see actualMissingValues for the rest
     */
    actualSeries: Array<TimeseriesPointDto>;
    /**
     * Output of the regression model; only timestamps where every independent series has a value, see modelMissingValues for the rest
     */
    modelSeries: Array<TimeseriesPointDto>;
    /**
     * Normalized timestamps in the range without a measured value of the dependent series
     */
    actualMissingValues: Array<(string)>;
    /**
     * Normalized timestamps in the range where an independent series has no value, so the model cannot be evaluated
     */
    modelMissingValues: Array<(string)>;
};

export type MultivariateLinearRegressionPageableResponseList = {
    regressions: Array<MultivariateLinearRegressionResponse>;
    /**
     * Pagination Metadata
     */
    metadata: PageableMetadataDto;
};

export type LegacyBaselinePayload = {
    title: string;
    companyId: {
        locationPgId?: number;
        firebaseId?: string;
        companyPgId?: number;
    };
    series: {
        [key: string]: unknown;
    };
    relativeSeries: {
        [key: string]: unknown;
    } | null;
    baselineTimeframe: {
        from?: string;
        to?: string;
    };
    reportingTimeframe: {
        from?: string;
        to?: string;
    };
    granularity: 'day' | 'week' | 'month';
    normalization: Array<{
        [key: string]: unknown;
    }> | null;
    kpiType: 'absolute' | 'relative';
    reportingTimeframeType?: 'fixed' | 'rolling';
    user: {
        id?: string;
        name?: string;
    };
};

export enum granularity4 {
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month'
}

export enum kpiType {
    ABSOLUTE = 'absolute',
    RELATIVE = 'relative'
}

export enum reportingTimeframeType {
    FIXED = 'fixed',
    ROLLING = 'rolling'
}

export type FeatureNewsDTO = {
    /**
     * The unique identifier of the feature news
     */
    id: string;
    /**
     * The headline of the feature news article
     */
    headline: string;
    /**
     * The body content of the feature news (optional)
     */
    body?: string;
    /**
     * The image URL associated with the feature news (optional)
     */
    imageUrl?: string;
    /**
     * Title of the image
     */
    imageTitle?: string;
    /**
     * The timestamp when the feature news was created
     */
    createdAt: string;
    /**
     * The timestamp when the feature news was last updated
     */
    updatedAt: string;
    /**
     * Category of the article
     */
    category: string;
    /**
     * Link of the article
     */
    link?: string;
};

export type BudgetSummaryDto = {
    /**
     * Total Cost YTD
     */
    totalYtdCost: number;
    /**
     * Total Budget YTD
     */
    totalYtdBudget: number;
    /**
     * Total Budget
     */
    totalBudget: number;
    /**
     * forecast
     */
    forecast: number;
    /**
     * Selected Year
     */
    year: number;
    /**
     * Last two open invoices
     */
    invoices: Array<InvoiceResponseDto>;
};

export type UploadConsumptionFilesDto = {
    /**
     * Device ID
     */
    deviceId: string;
    files: Array<((Blob | File))>;
    /**
     * Use ingester upload endpoint for zip files
     */
    useIngesterUploadEndpoint?: boolean;
    /**
     * Location ID
     */
    locationFirebaseId?: string;
    /**
     * Building ID
     */
    buildingId?: number;
    /**
     * Energy type
     */
    energyType?: string;
    /**
     * Source
     */
    source?: string;
    /**
     * Preformatted flag
     */
    preformatted?: boolean;
};

export type DemoDataDeviceResultDto = {
    deviceId: string;
    totalPoints: number;
    status: 'success' | 'failed';
    errors: Array<(string)>;
};

export enum status {
    SUCCESS = 'success',
    FAILED = 'failed'
}

export type DemoDataSummaryDto = {
    totalDevices: number;
    totalDataPoints: number;
    successfulPoints: number;
    failedPoints: number;
    devices: Array<DemoDataDeviceResultDto>;
};

export type UploadDemoDevicesResponseDto = {
    success: boolean;
    message: string;
    summary: DemoDataSummaryDto;
};

export type UploadSlpManualConsumptionDto = {
    /**
     * Excel file to upload
     */
    files: (Blob | File);
};

export type ValidateOptions = {
    /**
     * Validate duplicates
     */
    duplicates?: boolean;
    /**
     * Validate data series
     */
    dataSeries?: boolean;
    /**
     * Validate configuration
     */
    configuration?: boolean;
};

export type DevicesHealthCheckBodyDTO = {
    /**
     * List of device IDs
     */
    deviceIds?: Array<(string)>;
    /**
     * Type of energy
     */
    energyType?: 'fuels' | 'fluidGas' | 'water' | 'heating' | 'electricity' | 'gas' | 'pressurizedAir';
    /**
     * Start date for data retrieval
     */
    from?: string | null;
    /**
     * End date for data retrieval
     */
    to?: string | null;
    /**
     * Data granularity
     */
    granularity?: string;
    /**
     * Type of value to retrieve
     */
    valueType?: 'periodAverages' | 'meterReadings';
    /**
     * API provider source
     */
    source?: 'wattline' | 'enometrik' | 'sma' | 'mako' | 'ampect' | '-' | 'linemetrics' | 'mqtt' | 'virtual' | 'demo' | 'api' | 'SLP' | 'manual15mins';
    /**
     * Company ID
     */
    companyId?: number;
    /**
     * Location ID
     */
    locationId?: number;
    /**
     * Building ID
     */
    buildingId?: number;
    /**
     * Validation configuration
     */
    validate?: ValidateOptions;
    /**
     * Whether to return virtual meters
     */
    isVirtual?: boolean;
    /**
     * Exclude SLP meters
     */
    excludeSLPMeters?: boolean;
    /**
     * Whether to return duplicated devices
     */
    returnDuplicatedDevices?: boolean;
    /**
     * Only return unhealthy devices in the result
     */
    returnUnhealthyDevicesOnly?: boolean;
};

/**
 * Type of value to retrieve
 */
export enum valueType {
    PERIOD_AVERAGES = 'periodAverages',
    METER_READINGS = 'meterReadings'
}

/**
 * API provider source
 */
export enum source {
    WATTLINE = 'wattline',
    ENOMETRIK = 'enometrik',
    SMA = 'sma',
    MAKO = 'mako',
    AMPECT = 'ampect',
    _ = '-',
    LINEMETRICS = 'linemetrics',
    MQTT = 'mqtt',
    VIRTUAL = 'virtual',
    DEMO = 'demo',
    API = 'api',
    SLP = 'SLP',
    MANUAL15MINS = 'manual15mins'
}

export type DeviceHealthCheckErrorDto = {
    dataSeries: Array<(string)>;
    configuration: Array<(string)>;
    duplicates: {
        [key: string]: unknown;
    };
};

export type SeriesStatsDto = {
    avgSampledIntervalMinutes: number | null;
    minSampledIntervalMinutes: number | null;
    maxSampledIntervalMinutes: number | null;
    firstTimestamp: string | null;
    lastTimestamp: string | null;
    totalPoints: number | null;
    nullCount: number | null;
    negativeCount: number | null;
    minValue: number | null;
    maxValue: number | null;
    avgValue: number | null;
    stddevValue: number | null;
};

export type DeviceHealthCheckResultDto = {
    status: 'healthy' | 'unhealthy';
    deviceId: string;
    meterInfo: MeterInfoDto;
    errors: DeviceHealthCheckErrorDto;
    seriesStats?: SeriesStatsDto;
};

export enum status2 {
    HEALTHY = 'healthy',
    UNHEALTHY = 'unhealthy'
}

export type NormalizeBodyDTO = {
    /**
     * List of device IDs
     */
    deviceIds?: Array<(string)>;
    /**
     * Type of energy
     */
    energyType?: 'fuels' | 'fluidGas' | 'water' | 'heating' | 'electricity' | 'gas' | 'pressurizedAir';
    /**
     * Start date for data retrieval
     */
    from?: string | null;
    /**
     * End date for data retrieval
     */
    to?: string | null;
    /**
     * Data granularity
     */
    granularity?: string;
    /**
     * Type of value to retrieve
     */
    valueType?: 'periodAverages' | 'meterReadings';
    /**
     * API provider source
     */
    source?: 'wattline' | 'enometrik' | 'sma' | 'mako' | 'ampect' | '-' | 'linemetrics' | 'mqtt' | 'virtual' | 'demo' | 'api' | 'SLP' | 'manual15mins';
    /**
     * Company ID
     */
    companyId?: number;
    /**
     * Location ID
     */
    locationId?: number;
    /**
     * Building ID
     */
    buildingId?: number;
    /**
     * Validate options
     */
    validate?: ValidateOptions;
    /**
     * Whether to return virtual meters
     */
    isVirtual?: boolean;
    /**
     * Exclude SLP meters
     */
    excludeSLPMeters?: boolean;
    /**
     * Whether to return duplicated devices
     */
    returnDuplicatedDevices?: boolean;
    /**
     * Persist the normalized data in the database
     */
    saveToDatabase?: boolean;
    /**
     * Return only unhealthy devices
     */
    returnUnhealthyDevicesOnly?: boolean;
    /**
     * Compute virtual series
     */
    skipVirtualSeriesUpdate?: boolean;
    /**
     * Whether normalization was triggered by a user
     */
    isUserInitiated?: boolean;
};

export type UpdateVirtualsAfterNormalizationDTO = {
    /**
     * List of device IDs (referenced devices, not virtuals). We will update the virtual series for all virtuals that have in their definition at least one of these device ids.
     */
    normalizedDeviceIds: Array<(string)>;
    /**
     * Start date for virtual series update (ISO 8601 format). Can only narrow the range, not widen it.
     */
    from?: string;
    /**
     * End date for virtual series update (ISO 8601 format). Can only narrow the range, not widen it.
     */
    to?: string;
};

export type VirtualSetupBodyDTO = {
    /**
     * Calculate and persist all virtual series
     */
    calculateAndPersistVirtuals?: boolean;
    /**
     * Aggregate all consumption to daily and monthly tables
     */
    aggregateToTables?: boolean;
    /**
     * Copy SLP data to monthly normalized table
     */
    copySlpToMonthly?: boolean;
    /**
     * Update SLPs first date
     */
    updateSlpsFirstDate?: boolean;
    /**
     * Delete all data from virtuals
     */
    deleteAllDataFromVirtuals?: boolean;
    /**
     * Update series metadata for virtual meters
     */
    updateSeriesMetadata?: boolean;
};

export type HandleManualNormalizedDataDto = {
    /**
     * Meter info
     */
    meterInfo: {
        [key: string]: unknown;
    };
    /**
     * Normalized values
     */
    normalizedValues: {
        [key: string]: unknown;
    };
};

export type MeterOverviewResponseDto = {
    scope: {
        type?: 'company' | 'region' | 'location' | 'building';
        companyId?: number;
        regionId?: number | null;
        locationId?: number | null;
        buildingId?: number | null;
        locationIds?: Array<(number)>;
    };
    period: {
        from?: string;
        to?: string;
    };
    comparisonPeriod: {
        from?: string;
        to?: string;
    };
    energyTypes: Array<{
        energyTypeId: number;
        energyType: string;
        measurementUnitId: number;
        unit: string;
        total: number | null;
        previousTotal: number | null;
        yoyChange: number | null;
        unavailableReason: 'missing_main_meter' | 'conflicting_components' | 'missing_data' | null;
        onsiteGeneration: number | null;
        previousOnsiteGeneration: number | null;
        gridExport: number | null;
        previousGridExport: number | null;
        selfConsumption: number | null;
        meterCount: number;
        dataQualityTimeSeriesIds: Array<(string)>;
        sections: Array<{
            type: 'supply' | 'grid_export' | 'consumption';
            total: number | null;
            rows: Array<{
                id: string;
                category: 'grid_import' | 'onsite_generation' | 'grid_export' | 'consumer' | 'onsite_self_consumption' | 'residual' | 'group';
                title: string;
                entityType: 'meter' | 'series' | null;
                storageId: string | null;
                contextMeterId: number | null;
                currentValue: number | null;
                previousValue: number | null;
                yoyChange: number | null;
                percentage: number | null;
                unit: string;
                locationId: number | null;
                locationTitle: string | null;
                buildingId: number | null;
                buildingTitle: string | null;
                source: string | null;
                isMain: boolean;
                isVirtual: boolean;
                isSignificantEnergyConsumer: boolean;
                meterNumber: string | null;
                maLoId: string | null;
                meLoId: string | null;
                groupId: number | null;
                dataQualityTimeSeriesIds: Array<(string)>;
                type: 'series' | 'calculated' | 'group';
                children: Array<{
                    id: string;
                    category: 'grid_import' | 'onsite_generation' | 'grid_export' | 'consumer' | 'onsite_self_consumption' | 'residual' | 'group';
                    title: string;
                    entityType: 'meter' | 'series' | null;
                    storageId: string | null;
                    contextMeterId: number | null;
                    currentValue: number | null;
                    previousValue: number | null;
                    yoyChange: number | null;
                    percentage: number | null;
                    unit: string;
                    locationId: number | null;
                    locationTitle: string | null;
                    buildingId: number | null;
                    buildingTitle: string | null;
                    source: string | null;
                    isMain: boolean;
                    isVirtual: boolean;
                    isSignificantEnergyConsumer: boolean;
                    meterNumber: string | null;
                    maLoId: string | null;
                    meLoId: string | null;
                    groupId: number | null;
                    dataQualityTimeSeriesIds: Array<(string)>;
                    type: 'series' | 'calculated' | 'group';
                    children: unknown[];
                }>;
            }>;
        }>;
    }>;
};

export enum type8 {
    COMPANY = 'company',
    REGION = 'region',
    LOCATION = 'location',
    BUILDING = 'building'
}

export type MeterOverviewElectricityBalanceResponseDto = {
    components: Array<{
        entityType: 'meter' | 'series';
        storageId: string;
        contextMeterIds: Array<(number)>;
        title: string | null;
        category: 'grid_import' | 'onsite_generation' | 'grid_export' | 'consumer';
        sign: 1 | -1 | 0;
        isVirtual: boolean;
        parentStorageId: string | null;
        virtualInputStorageIds: Array<(string)>;
        granularity: string;
        granularityUnit: string;
        sources: Array<(string)>;
        firstDataDate: string | null;
        lastDataDate: string | null;
    }>;
    consumers: Array<{
        entityType: 'meter' | 'series';
        storageId: string;
        contextMeterIds: Array<(number)>;
        title: string | null;
        category: 'grid_import' | 'onsite_generation' | 'grid_export' | 'consumer';
        sign: 1 | -1 | 0;
        isVirtual: boolean;
        parentStorageId: string | null;
        virtualInputStorageIds: Array<(string)>;
        granularity: string;
        granularityUnit: string;
        sources: Array<(string)>;
        firstDataDate: string | null;
        lastDataDate: string | null;
    }>;
    conflicts: Array<{
        storageId: string;
        entityTypes: Array<('meter' | 'series')>;
        contextMeterIds: Array<(number)>;
        categories: Array<('grid_import' | 'onsite_generation' | 'grid_export' | 'consumer')>;
        reasons: Array<('category' | 'entity_type' | 'parent' | 'virtual_inputs')>;
    }>;
    /**
     * Every available energy type, describes what kind of energy we are dealing with.Relevant if the data type of a timeseries is "energy" or "power", irrelevant for other data types.
     */
    energyType: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
    /**
     * The physical unit of the energy being measured or consumedsuch as kilowatt-hours for electricity (kWh) or cubic meters for gas (m3).
     */
    unit: 'kWh' | 'm3';
    reference: {
        id?: string;
        type?: "location_total";
    };
    locationId: number;
    /**
     * Available options for the intervals between two values in a timeseries.
     */
    granularity: '15min' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
    entries: Array<{
        timestamp: string;
        value: number | null;
        gridImport: number | null;
        onsiteGeneration: number | null;
        gridExport: number | null;
        selfConsumption: number | null;
        selfConsumptionRate: number | null;
        residual: number | null;
    }>;
    residualConsumers: Array<{
        entityType: 'meter' | 'series';
        storageId: string;
        contextMeterIds: Array<(number)>;
        title: string | null;
        category: 'grid_import' | 'onsite_generation' | 'grid_export' | 'consumer';
        sign: 1 | -1 | 0;
        isVirtual: boolean;
        parentStorageId: string | null;
        virtualInputStorageIds: Array<(string)>;
        granularity: string;
        granularityUnit: string;
        sources: Array<(string)>;
        firstDataDate: string | null;
        lastDataDate: string | null;
    }>;
    dataQualityTimeSeriesIds: Array<(string)>;
    dataQuality: {
        status?: 'complete' | 'partial' | 'missing' | 'conflict';
        coverage?: number;
    };
    formulaVersion: string;
};

export enum status3 {
    COMPLETE = 'complete',
    PARTIAL = 'partial',
    MISSING = 'missing',
    CONFLICT = 'conflict'
}

export type CreateMeterOverviewGroupDto = {
    companyId: number;
    locationId: number;
    energyTypeId: number;
    measurementUnitId: number;
    name: string;
};

export type MeterOverviewGroupDto = {
    id: number;
    name: string;
};

export type RenameMeterOverviewGroupDto = {
    companyId: number;
    locationId: number;
    energyTypeId: number;
    measurementUnitId: number;
    name: string;
};

export type SetMeterOverviewGroupMembershipDto = {
    companyId: number;
    locationId: number;
    energyTypeId: number;
    measurementUnitId: number;
    entityType: 'meter' | 'series';
    storageId: string;
    contextMeterId: number;
    groupId: number | null;
};

export enum entityType {
    METER = 'meter',
    SERIES = 'series'
}

export type VirtualMeterCreatedEvent = {
    eventName: 'meterCreated';
    /**
     * The device ID of the created virtual meter
     */
    deviceId: string;
    /**
     * The meter ID of the created virtual meter
     */
    meterId: number;
};

export enum eventName13 {
    METER_CREATED = 'meterCreated'
}

export type VirtualMeterUpdatedEvent = {
    eventName: 'meterUpdated';
    /**
     * The device ID of the updated virtual meter
     */
    deviceId: string;
    /**
     * The meter ID of the updated virtual meter
     */
    meterId: number;
};

export enum eventName14 {
    METER_UPDATED = 'meterUpdated'
}

export type VirtualMeterCreateErrorEvent = {
    eventName: 'meterCreateError';
    /**
     * The device ID that failed to be created
     */
    deviceId: string;
    /**
     * Error message
     */
    errorMessage: string;
};

export enum eventName15 {
    METER_CREATE_ERROR = 'meterCreateError'
}

export type VirtualMeterUpdateErrorEvent = {
    eventName: 'meterUpdateError';
    /**
     * The device ID that failed to be updated
     */
    deviceId: string;
    /**
     * Error message
     */
    errorMessage: string;
};

export enum eventName16 {
    METER_UPDATE_ERROR = 'meterUpdateError'
}

export type CreateVirtualDeviceDto = {
    /**
     * Building ID
     */
    buildingId: number;
    /**
     * Virtual meter definition
     */
    definition: VirtualMeterDefinitionDto;
    /**
     * Granularity of the meter
     */
    granularity: number;
    /**
     * Device ID
     */
    id: string;
    /**
     * Name of the virtual device
     */
    name: string;
    /**
     * Type of the virtual device
     */
    type: string;
};

export type VirtualDeviceResponseDto = {
    /**
     * Success status
     */
    success: boolean;
    /**
     * Created virtual meter data
     */
    data?: {
        [key: string]: unknown;
    };
    /**
     * Error message if operation failed
     */
    error?: string;
};

export type UpdateVirtualDeviceDto = {
    /**
     * Name of the virtual device
     */
    name: string;
    /**
     * Type of the virtual device
     */
    type: string;
    /**
     * Virtual meter definition
     */
    definition: VirtualMeterDefinitionDto;
};

export type UpdateVirtualDeviceResponseDto = {
    /**
     * Success status
     */
    success: boolean;
    data: {
        originalMeter?: {
            [key: string]: unknown;
        };
        updatedMeter?: {
            [key: string]: unknown;
        };
    };
    /**
     * Error message if operation failed
     */
    error?: string;
};

export type DeleteVirtualDeviceDto = {
    /**
     * Device ID of the virtual meter to delete
     */
    id: string;
};

export type UpsertDeviceDto = {
    /**
     * Unique identifier of the meter
     */
    id?: number | null;
    /**
     * Meter title
     */
    title: string;
    /**
     * Indicates if this is the default meter
     */
    isDefault: boolean;
    /**
     * Series identifier for the meter
     */
    seriesId: string | null;
    /**
     * Measurement factor applied to the meter readings
     */
    factor: number;
    /**
     * Identifier of the building the meter belongs to
     */
    buildingId: number;
    /**
     * Device ID associated with the meter
     */
    deviceId: string;
    /**
     * Granularity of data collection
     */
    granularity: string;
    /**
     * Unit of granularity
     */
    granularityUnit: 'MINUTES' | 'MONTHS';
    /**
     * Identifier for the type of energy measured
     */
    energyTypeId: number;
    /**
     * Virtual meter settings
     */
    virtual: {
        [key: string]: unknown;
    };
    /**
     * Date of the first recorded data
     */
    firstDataDate: string | null;
    /**
     * Date of the last recorded data
     */
    lastDataDate: string | null;
    /**
     * LineMetrics input identifier
     */
    linemetricsInputId: string;
    /**
     * Identifier for the device type
     */
    deviceTypeId: number;
    /**
     * Identifier for the measurement unit
     */
    measurementUnitId: number | null;
    /**
     * Energy type title
     */
    energyTypeTitle: string;
    /**
     * API provider ID
     */
    apiProviderId: number;
    /**
     * API provider title
     */
    apiProviderTitle: string;
    /**
     * OBIS code identifier
     */
    obisCodeId: number | null;
    /**
     * Value type identifier
     */
    valueTypeId: number;
    /**
     * Producer grid feed-in ID
     */
    producerGreedFeedInId: string;
    /**
     * JQ program name
     */
    jqProgram: string;
    /**
     * Location Firebase identifier
     */
    locationFirebaseId: string;
    /**
     * Source of the meter data
     */
    source: string;
    /**
     * Data source of the SLP
     */
    slpDataSource?: 'MONTHLY_CONSUMPTION' | 'METER_READING';
    /**
     * Provider-specific metadata
     */
    metadata?: {
        [key: string]: unknown;
    } | null;
};

export type Building = unknown;

export type EnergyType = unknown;

export type DeviceType = unknown;

export type MeasurementUnit = unknown;

export type ObisCode = unknown;

export type ValueType = unknown;

export type MeterApiProvider = unknown;

export type DeviceResponseDto = {
    /**
     * Unique identifier of the meter
     */
    id: number;
    /**
     * Meter title
     */
    title: string | null;
    /**
     * Indicates if this is the default meter
     */
    isDefault: boolean;
    /**
     * Series identifier for the meter
     */
    seriesId: string | null;
    /**
     * Measurement factor applied to the meter readings
     */
    factor: number;
    /**
     * Identifier of the building the meter belongs to
     */
    buildingId: number;
    /**
     * Device ID associated with the meter
     */
    deviceId: string | null;
    /**
     * Granularity of data collection
     */
    granularity: string;
    /**
     * Unit of granularity
     */
    granularityUnit: 'MINUTES' | 'MONTHS';
    /**
     * Identifier for the type of energy measured
     */
    energyTypeId: number | null;
    /**
     * Virtual meter settings
     */
    virtual: {
        [key: string]: unknown;
    };
    /**
     * Date of the first recorded data
     */
    firstDataDate: string | null;
    /**
     * Date of the last recorded data
     */
    lastDataDate: string | null;
    /**
     * LineMetrics input identifier
     */
    linemetricsInputId: string | null;
    /**
     * Identifier for the device type
     */
    deviceTypeId: number;
    /**
     * Identifier for the measurement unit
     */
    measurementUnitId: number | null;
    /**
     * Identifier for the value type
     */
    valueTypeId: number;
    /**
     * Identifier for the OBIS code
     */
    obisCodeId: number;
    /**
     * Building entity
     */
    building?: Building;
    /**
     * Energy type entity
     */
    energyType?: EnergyType;
    /**
     * Device type entity
     */
    deviceType?: (DeviceType) | null;
    /**
     * Measurement unit entity
     */
    measurementUnit?: (MeasurementUnit) | null;
    /**
     * OBIS code entity
     */
    obisCode?: ObisCode;
    /**
     * Value type entity
     */
    valueType?: ValueType;
    /**
     * Meter API providers
     */
    meterApiProviders?: Array<MeterApiProvider>;
    /**
     * Data source of the SLP metadata
     */
    slpDataSource?: 'MONTHLY_CONSUMPTION' | 'METER_READING' | null;
};

export type DeviceListResponseDto = {
    success: boolean;
    /**
     * Created/updated device (meter)
     */
    upsertedDevice: DeviceResponseDto;
    data: Array<DeviceResponseDto>;
};

export type AdjustmentResponseDto = {
    id: number;
    title: string;
    adjustmentValueKwh: number;
    activeMonths: Array<('JANUARY' | 'FEBRUARY' | 'MARCH' | 'APRIL' | 'MAY' | 'JUNE' | 'JULY' | 'AUGUST' | 'SEPTEMBER' | 'OCTOBER' | 'NOVEMBER' | 'DECEMBER')>;
    activeWeekdays: Array<('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')>;
    activeFrom: string;
    activeTo: string;
    createdBy: string;
    updatedBy: string;
    createdAt: string;
    updatedAt: string;
    isActive: boolean;
};

export type ForecastResponseDto = {
    id: number;
    locationId: number;
    year: number;
    state: 'OPEN' | 'FIXED';
    type: 'HISTORIC' | 'MODEL_GENERATED';
    adjustments: Array<AdjustmentResponseDto>;
    createdAt: string;
    updatedAt: string;
};

export enum state {
    OPEN = 'OPEN',
    FIXED = 'FIXED'
}

export enum type9 {
    HISTORIC = 'HISTORIC',
    MODEL_GENERATED = 'MODEL_GENERATED'
}

export type ForecastDataPointDto = {
    /**
     * Consumption value in kWh
     */
    value: number;
    /**
     * Timestamp in format YYYY-MM-DD HH:mm:ss
     */
    timestamp: string;
};

export type ForecastDataResponseDto = {
    /**
     * Array of forecast data points
     */
    data: Array<ForecastDataPointDto>;
    metadata: {
        totalDataPoints?: number;
        forecastStartDate?: string;
        forecastEndDate?: string;
        sourceYear?: number;
        granularity?: string;
    };
};

export type CreateForecastDto = {
    /**
     * Location ID for the forecast
     */
    locationId: number;
    /**
     * Year for the forecast
     */
    year: number;
    /**
     * Type of forecast (currently only HISTORIC is supported)
     */
    type: 'HISTORIC' | 'MODEL_GENERATED';
};

export type PatchForecastStateDto = {
    /**
     * New state for the forecast
     */
    state: 'OPEN' | 'FIXED';
};

export type CreateAdjustmentDto = {
    /**
     * Title of the adjustment
     */
    title: string;
    /**
     * Adjustment value in kWh (can be positive or negative)
     */
    adjustmentValueKwh: number;
    /**
     * Array of active months
     */
    activeMonths: Array<('JANUARY' | 'FEBRUARY' | 'MARCH' | 'APRIL' | 'MAY' | 'JUNE' | 'JULY' | 'AUGUST' | 'SEPTEMBER' | 'OCTOBER' | 'NOVEMBER' | 'DECEMBER')>;
    /**
     * Array of active weekdays
     */
    activeWeekdays: Array<('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')>;
    /**
     * Start time (HH:MM format)
     */
    activeFrom: string;
    /**
     * End time (HH:MM format)
     */
    activeTo: string;
    /**
     * Whether the adjustment is active
     */
    isActive?: boolean;
};

export type UpdateAdjustmentDto = {
    /**
     * Title of the adjustment
     */
    title: string;
    /**
     * Adjustment value in kWh (can be positive or negative)
     */
    adjustmentValueKwh: number;
    /**
     * Array of active months
     */
    activeMonths: Array<('JANUARY' | 'FEBRUARY' | 'MARCH' | 'APRIL' | 'MAY' | 'JUNE' | 'JULY' | 'AUGUST' | 'SEPTEMBER' | 'OCTOBER' | 'NOVEMBER' | 'DECEMBER')>;
    /**
     * Array of active weekdays
     */
    activeWeekdays: Array<('MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY')>;
    /**
     * Start time (HH:MM format)
     */
    activeFrom: string;
    /**
     * End time (HH:MM format)
     */
    activeTo: string;
    /**
     * Whether the adjustment is active
     */
    isActive?: boolean;
};

export type PatchAdjustmentActiveDto = {
    /**
     * Active state for the adjustment
     */
    isActive: boolean;
};

export type ShortTermForecastDataPointDto = {
    /**
     * Timestamp (ISO format)
     */
    timestamp: string;
    /**
     * Forecasted value
     */
    forecastValue: number;
    /**
     * Upper bound value
     */
    upperBoundValue: number;
    /**
     * Lower bound value
     */
    lowerBoundValue: number;
};

export type ForecastMetadataDto = {
    /**
     * Company ID (if aggregationLevel=company)
     */
    companyId?: number;
    /**
     * Location ID (if aggregationLevel=location)
     */
    locationId?: number;
    /**
     * Building ID (if aggregationLevel=building)
     */
    buildingId?: number;
    /**
     * Device ID (if aggregationLevel=device)
     */
    deviceId?: string;
    /**
     * Aggregation level
     */
    aggregationLevel: 'company' | 'location' | 'building' | 'device';
    /**
     * Start datetime
     */
    from: string;
    /**
     * End datetime
     */
    to: string;
    /**
     * Granularity in minutes
     */
    granularity: number;
    /**
     * Data type returned
     */
    dataType: 'energy' | 'power';
    /**
     * Base measurement unit
     */
    baseUnit: 'kWh' | 'm3';
    /**
     * Actual unit returned (derived from dataType and baseUnit)
     */
    unit: 'kWh' | 'kW' | 'm3' | 'm3/h';
    /**
     * Timestamp when forecast was generated
     */
    generatedAt: string;
};

/**
 * Aggregation level
 */
export enum aggregationLevel2 {
    COMPANY = 'company',
    LOCATION = 'location',
    BUILDING = 'building',
    DEVICE = 'device'
}

/**
 * Data type returned
 */
export enum dataType2 {
    ENERGY = 'energy',
    POWER = 'power'
}

/**
 * Base measurement unit
 */
export enum baseUnit {
    K_WH = 'kWh',
    M3 = 'm3'
}

/**
 * Actual unit returned (derived from dataType and baseUnit)
 */
export enum unit3 {
    K_WH = 'kWh',
    K_W = 'kW',
    M3 = 'm3',
    M3_H = 'm3/h'
}

export type ShortTermForecastResponseDto = {
    /**
     * Forecast data points
     */
    forecast: Array<ShortTermForecastDataPointDto>;
    /**
     * Forecast metadata
     */
    metadata: ForecastMetadataDto;
};

export enum AdjustmentEnergyTypeDto {
    ELECTRICITY = 'ELECTRICITY',
    GAS = 'GAS'
}

export enum LoadAdjustmentGranularityDto {
    MONTHLY = 'MONTHLY',
    WEEKLY = 'WEEKLY'
}

export enum LoadAdjustmentTypeDto {
    COMPANY_HOLIDAYS = 'COMPANY_HOLIDAYS',
    QUANTITY_ADJUSTMENT = 'QUANTITY_ADJUSTMENT'
}

/**
 * Days of the week this adjustment applies to
 */
export enum WeekdayDto {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY'
}

export enum LoadAdjustmentChangeUnitDto {
    PERCENTAGE = 'PERCENTAGE',
    ABSOLUTE = 'ABSOLUTE'
}

export type LoadAdjustmentResponseDto = {
    /**
     * Unique identifier
     */
    id: number;
    /**
     * Name of the load adjustment
     */
    name: string;
    granularity?: LoadAdjustmentGranularityDto;
    adjustmentType: LoadAdjustmentTypeDto;
    /**
     * Location ID this adjustment applies to
     */
    locationId: number;
    /**
     * Year this adjustment applies to
     */
    year: number;
    energyType: AdjustmentEnergyTypeDto;
    /**
     * Start date for the adjustment period
     */
    dateFrom: string;
    /**
     * End date for the adjustment period
     */
    dateTo: string;
    applicableWeekdays?: Array<WeekdayDto>;
    /**
     * Start time in HH:MM format
     */
    timeFrom?: string;
    /**
     * End time in HH:MM format
     */
    timeTo?: string;
    /**
     * Whether this adjustment is active
     */
    isActive: boolean;
    adjustmentChangeUnit: LoadAdjustmentChangeUnitDto;
    /**
     * Adjustment value (percentage or absolute)
     */
    adjustmentValue: number;
    /**
     * Optional comment about this adjustment
     */
    comment?: string;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Last update timestamp
     */
    updatedAt: string;
};

export type LoadAdjustmentListResponseDto = {
    adjustments: Array<LoadAdjustmentResponseDto>;
    /**
     * Total number of adjustments
     */
    total: number;
};

export type CreateLoadAdjustmentDto = {
    /**
     * Name of the load adjustment
     */
    name: string;
    granularity?: LoadAdjustmentGranularityDto;
    adjustmentType: LoadAdjustmentTypeDto;
    /**
     * Location ID this adjustment applies to
     */
    locationId: number;
    /**
     * Year this adjustment applies to
     */
    year: number;
    energyType: AdjustmentEnergyTypeDto;
    /**
     * Start date for the adjustment period
     */
    dateFrom: string;
    /**
     * End date for the adjustment period
     */
    dateTo: string;
    applicableWeekdays?: Array<WeekdayDto>;
    /**
     * Start time in HH:MM format
     */
    timeFrom?: string;
    /**
     * End time in HH:MM format
     */
    timeTo?: string;
    /**
     * Whether this adjustment is active
     */
    isActive?: boolean;
    adjustmentChangeUnit: LoadAdjustmentChangeUnitDto;
    /**
     * Adjustment value (percentage or absolute)
     */
    adjustmentValue: number;
    /**
     * Optional comment about this adjustment
     */
    comment?: string;
};

export type UpdateLoadAdjustmentDto = {
    /**
     * Name of the load adjustment
     */
    name: string;
    granularity?: LoadAdjustmentGranularityDto;
    adjustmentType: LoadAdjustmentTypeDto;
    /**
     * Location ID this adjustment applies to
     */
    locationId: number;
    /**
     * Year this adjustment applies to
     */
    year: number;
    energyType: AdjustmentEnergyTypeDto;
    /**
     * Start date for the adjustment period
     */
    dateFrom: string;
    /**
     * End date for the adjustment period
     */
    dateTo: string;
    applicableWeekdays?: Array<WeekdayDto>;
    /**
     * Start time in HH:MM format
     */
    timeFrom?: string;
    /**
     * End time in HH:MM format
     */
    timeTo?: string;
    /**
     * Whether this adjustment is active
     */
    isActive?: boolean;
    adjustmentChangeUnit: LoadAdjustmentChangeUnitDto;
    /**
     * Adjustment value (percentage or absolute)
     */
    adjustmentValue: number;
    /**
     * Optional comment about this adjustment
     */
    comment?: string;
};

export enum ForecastGranularityDto {
    MONTHLY = 'monthly',
    YEARLY = 'yearly'
}

export type LoadForecastDataPointDto = {
    /**
     * Timestamp of the measurement (ISO‑8601 format)
     */
    timestamp: string;
    /**
     * Aggregated monthly consumption kwh
     */
    monthlyValueKwh: number;
    /**
     * Aggregated adjusted monthly consumption kwh
     */
    monthlyAdjustedValueKwh: number;
};

export type LoadForecastKpiDto = {
    /**
     * Summed forecasted load
     */
    aggregatedConsumption: number;
    /**
     * Summed forecasted adjusted load
     */
    aggregatedAdjustedConsumption: number;
    /**
     * Summed forecasted adjusted load
     */
    relativeChangeToLastYear: number;
};

export type LoadForecastDataDto = {
    /**
     * Generated Forecast with Adjustment
     */
    monthlyData: Array<LoadForecastDataPointDto>;
    /**
     * KPIs of Forecast
     */
    kpi: LoadForecastKpiDto;
};

export type NaceCode = {
    id: number;
    code: string;
    name: string;
    wzCode: string | null;
    parentId: number | null;
    parent?: (NaceCode) | null;
    children: Array<NaceCode>;
};

export type MachineCategoryDto = {
    id: number;
    name: string;
};

export type MeterDocumentResponseDto = {
    /**
     * Meter document ID
     */
    id: number;
    /**
     * Meter ID
     */
    meterId: number;
    /**
     * Object Storage ID
     */
    objectId: number;
    /**
     * Filename
     */
    filename: string;
};

export type CreateMeterDocumentDto = {
    /**
     * Meter ID
     */
    meterId: number;
    /**
     * Object Storage ID
     */
    objectStorageId: number;
};

export type UiPreferenceResponseDto = {
    key: 'messstellen-table';
    /**
     * Stored value, or null when the user has not saved this preference yet
     */
    value: {
        [key: string]: unknown;
    } | null;
};

export enum key {
    MESSSTELLEN_TABLE = 'messstellen-table'
}

export type UpdateUiPreferenceRequestBody = {
    /**
     * Preference value; its shape is owned by the client feature
     */
    value: {
        [key: string]: unknown;
    };
};

export enum InsightInboxCategoryEnum {
    STANDBY_DETECTION = 'standby_detection',
    PEAKLOAD = 'peakload',
    BASELOAD_BENCHMARK = 'baseload_benchmark',
    BASELOAD_TREND = 'baseload_trend',
    CONNECTION_LOSS = 'connection_loss'
}

export enum InsightEnergyTypeEnum {
    ELECTRICITY = 'electricity',
    GAS = 'gas'
}

export enum InsightInboxPriorityEnum {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH'
}

export enum InsightInboxStatusEnum {
    NEW = 'NEW',
    DISMISSED = 'DISMISSED',
    INVESTIGATION = 'INVESTIGATION',
    CONVERTED_TO_MEASURE = 'CONVERTED_TO_MEASURE',
    RESOLVED = 'RESOLVED'
}

export enum InsightDismissalReasonEnum {
    MEASUREMENT_DATA_FAULTY = 'measurement_data_faulty',
    WRONG_METERING_POINT = 'wrong_metering_point',
    OTHER = 'other',
    STANDBY_WAS_PRODUCTION = 'standby_was_production',
    STANDBY_SETUP_OR_MAINTENANCE = 'standby_setup_or_maintenance',
    STANDBY_RAMP_DOWN = 'standby_ramp_down',
    STANDBY_NOT_SWITCHABLE = 'standby_not_switchable',
    STANDBY_AUXILIARY_INTENTIONAL = 'standby_auxiliary_intentional',
    STANDBY_ACCEPTED = 'standby_accepted',
    STANDBY_LOW_POTENTIAL = 'standby_low_potential',
    STANDBY_MISDETECTED = 'standby_misdetected',
    PEAKLOAD_KNOWN_PROCESS_STEP = 'peakload_known_process_step',
    PEAKLOAD_ONE_TIME_EVENT = 'peakload_one_time_event',
    PEAKLOAD_NO_DEMAND_CHARGE = 'peakload_no_demand_charge',
    PEAKLOAD_BELOW_ANNUAL_PEAK = 'peakload_below_annual_peak',
    PEAKLOAD_MISDETECTED = 'peakload_misdetected',
    BASELOAD_ACCEPTED = 'baseload_accepted',
    BASELOAD_CONTINUOUS_PRODUCTION = 'baseload_continuous_production',
    BASELOAD_CHANGE_EXPECTED = 'baseload_change_expected',
    BASELOAD_NON_PRODUCTION_MISDETECTED = 'baseload_non_production_misdetected',
    BASELOAD_BENCHMARK_GROUP_MISMATCH = 'baseload_benchmark_group_mismatch',
    CONNECTION_LOSS_METER_REMOVED = 'connection_loss_meter_removed',
    CONNECTION_LOSS_PLANNED_OUT_OF_SERVICE = 'connection_loss_planned_out_of_service',
    CONNECTION_LOSS_METER_REPLACED = 'connection_loss_meter_replaced'
}

export type DismissalDetailsDto = {
    /**
     * Only for CONNECTION_LOSS_PLANNED_OUT_OF_SERVICE: date the meter is expected back in service.
     */
    plannedOutOfServiceUntil?: string;
};

export type FetchOneInsightInboxDto = {
    id: number;
    category: InsightInboxCategoryEnum;
    energyType: InsightEnergyTypeEnum;
    buildingId?: number;
    createdAt: string;
    priority: InsightInboxPriorityEnum;
    status: InsightInboxStatusEnum;
    title: string;
    shortDescription: string;
    description: string;
    suggestedRootCauses?: Array<(string)>;
    savingsKwhYearly: number;
    savingsEurYearly: number;
    estimatedPricePerKwh?: number;
    savingsKwhAnalysisWindow?: number;
    savingsEurAnalysisWindow?: number;
    analysisWindowFrom?: string;
    analysisWindowTo?: string;
    deviceIds: Array<(string)>;
    linkedMeasureIds?: Array<(number)>;
    locationIds: Array<(number)>;
    resolveNote?: string;
    /**
     * Email of the user who resolved the insight
     */
    resolvedByEmail?: string;
    dismissalReason?: InsightDismissalReasonEnum;
    dismissalNote?: string;
    dismissalDetails?: DismissalDetailsDto;
    /**
     * Email of the user who dismissed the insight (derived from change history)
     */
    dismissedByEmail?: string;
    /**
     * True while the insight has not been released to the customer yet
     */
    isHidden: boolean;
    assigneeId?: number;
    assignmentComment?: string;
    updatedAt: string;
    viewedByCurrentUser: boolean;
    categoryData?: {
        [key: string]: unknown;
    };
    isOutdated: boolean;
};

export type InsightInboxFetchResponseListDto = {
    insights: Array<FetchOneInsightInboxDto>;
    /**
     * Total number of insights matching the filter
     */
    total: number;
    /**
     * Current page number
     */
    page: number;
    /**
     * Page size
     */
    pageSize: number;
};

export enum InsightInboxGroupByEnum {
    NONE = 'none',
    METER = 'meter',
    CATEGORY = 'category',
    LOCATION = 'location'
}

export type InsightInboxGroupDto = {
    /**
     * Group key: the deviceId (meter), category enum value or location id
     */
    groupKey: string;
    /**
     * Human-usable label. For meter grouping this is the meter title resolved server-side (falls back to the deviceId when no meter matches). For category grouping this is the category enum value. For location grouping this is the location title.
     */
    groupLabel: string;
    /**
     * Total insights in this group across all pages, honoring the active filters. For meter and location grouping an insight is counted once per group it belongs to, so the sum of group counts can exceed `total`.
     */
    count: number;
    /**
     * The current-page slice of insights belonging to this group
     */
    insights: Array<FetchOneInsightInboxDto>;
};

export type InsightInboxGroupedResponseListDto = {
    groupBy: InsightInboxGroupByEnum;
    /**
     * Complete set of groups with full counts (ordered by count desc, then label). Insight arrays hold the current-page slice.
     */
    groups: Array<InsightInboxGroupDto>;
    /**
     * Total number of distinct insights matching the filter (same semantics as the flat response)
     */
    total: number;
    /**
     * Current page number
     */
    page: number;
    /**
     * Page size
     */
    pageSize: number;
};

export type CreateInsightInboxDto = {
    /**
     * Source insight id from the upstream AI Energy Intel event
     */
    sourceInsightId: string;
    /**
     * Category of the insight
     */
    category: string;
    energyType: InsightEnergyTypeEnum;
    /**
     * Building ID
     */
    buildingId?: number;
    priority: InsightInboxPriorityEnum;
    /**
     * Title of the insight
     */
    title: string;
    /**
     * Short description of the insight
     */
    shortDescription: string;
    /**
     * Markdown description of the insight
     */
    description: string;
    /**
     * Suggested root causes
     */
    suggestedRootCauses?: Array<(string)>;
    /**
     * Savings in kWh (yearly)
     */
    savingsKwhYearly: number;
    /**
     * Savings in EUR (yearly)
     */
    savingsEurYearly: number;
    /**
     * Estimated price per kWh
     */
    estimatedPricePerKwh?: number;
    /**
     * Savings in kWh (analysis window)
     */
    savingsKwhAnalysisWindow?: number;
    /**
     * Savings in EUR (analysis window)
     */
    savingsEurAnalysisWindow?: number;
    /**
     * Analysis window start
     */
    analysisWindowFrom?: string;
    /**
     * Analysis window end
     */
    analysisWindowTo?: string;
    /**
     * Array of device IDs
     */
    deviceIds: Array<(string)>;
    /**
     * Linked measure IDs
     */
    linkedMeasureIds?: Array<(number)>;
    /**
     * Location IDs (at least 1 required)
     */
    locationIds: Array<(number)>;
    /**
     * Assignee user ID
     */
    assigneeId?: number;
    /**
     * Category-specific payload
     */
    categoryData?: {
        [key: string]: unknown;
    };
    /**
     * Defines if the insight is outdated since a newer one of the same category was published for the device
     */
    isOutdated?: boolean;
};

export type DismissalReasonOptionDto = {
    reason: InsightDismissalReasonEnum;
    /**
     * A note is mandatory before this reason can be submitted
     */
    requiresNote: boolean;
    /**
     * A plannedOutOfServiceUntil date is mandatory for this reason
     */
    requiresPlannedDate: boolean;
    /**
     * Whether the "disable setting" toggle is pre-selected for this reason
     */
    disablesSettingByDefault: boolean;
};

export type DismissalReasonCategoryConfigDto = {
    category: InsightInboxCategoryEnum;
    /**
     * Whether a dismissal can switch off the insight setting for this category
     */
    canDisableSetting: boolean;
    /**
     * Reasons offered for this category, in display order
     */
    reasons: Array<DismissalReasonOptionDto>;
};

export type DismissalReasonConfigDto = {
    categories: Array<DismissalReasonCategoryConfigDto>;
};

export type UpdateInsightInboxDto = {
    /**
     * Category of the insight
     */
    category?: string;
    energyType?: InsightEnergyTypeEnum;
    /**
     * Building ID
     */
    buildingId?: number;
    priority?: InsightInboxPriorityEnum;
    /**
     * Title of the insight
     */
    title?: string;
    /**
     * Short description of the insight
     */
    shortDescription?: string;
    /**
     * Markdown description of the insight
     */
    description?: string;
    /**
     * Suggested root causes
     */
    suggestedRootCauses?: Array<(string)>;
    /**
     * Savings in kWh (yearly)
     */
    savingsKwhYearly?: number;
    /**
     * Savings in EUR (yearly)
     */
    savingsEurYearly?: number;
    /**
     * Estimated price per kWh
     */
    estimatedPricePerKwh?: number;
    /**
     * Savings in kWh (analysis window)
     */
    savingsKwhAnalysisWindow?: number;
    /**
     * Savings in EUR (analysis window)
     */
    savingsEurAnalysisWindow?: number;
    /**
     * Analysis window start
     */
    analysisWindowFrom?: string;
    /**
     * Analysis window end
     */
    analysisWindowTo?: string;
    /**
     * Array of device IDs
     */
    deviceIds?: Array<(string)>;
    /**
     * Linked measure IDs
     */
    linkedMeasureIds?: Array<(number)>;
    /**
     * Location IDs (at least 1 required)
     */
    locationIds?: Array<(number)>;
    /**
     * Assignee user ID
     */
    assigneeId?: number;
    /**
     * Category-specific payload
     */
    categoryData?: {
        [key: string]: unknown;
    };
    /**
     * Defines if the insight is outdated since a newer one of the same category was published for the device
     */
    isOutdated?: boolean;
};

export type BulkResolveInsightDto = {
    /**
     * IDs of the insights to act on (at least 1)
     */
    ids: Array<(number)>;
    /**
     * Resolution note applied to every selected insight
     */
    resolveNote?: string;
};

export type BulkInsightFailureDto = {
    /**
     * ID of the insight that could not be processed
     */
    id: number;
    /**
     * Reason the action failed for this insight
     */
    reason: string;
};

export type BulkInsightActionResultDto = {
    /**
     * IDs of the insights the action was applied to
     */
    succeededIds: Array<(number)>;
    /**
     * Insights that could not be processed, with the reason
     */
    failed: Array<BulkInsightFailureDto>;
};

export type BulkDismissInsightDto = {
    /**
     * IDs of the insights to act on (at least 1)
     */
    ids: Array<(number)>;
    dismissalReason: InsightDismissalReasonEnum;
    /**
     * Additional notes applied to every selected insight
     */
    dismissalNote?: string;
    dismissalDetails?: DismissalDetailsDto;
    /**
     * Also switch off the insight setting of the affected meters, so no further insights of this type are generated.
     */
    disableInsightSetting?: boolean;
};

export type DismissInsightGroupDto = {
    /**
     * IDs of the insights to act on (at least 1)
     */
    ids: Array<(number)>;
    dismissalReason: InsightDismissalReasonEnum;
    /**
     * Additional notes. Required when the reason is OTHER.
     */
    dismissalNote?: string;
    dismissalDetails?: DismissalDetailsDto;
    /**
     * Also switch off the insight setting of the affected meters, so no further insights of this type are generated.
     */
    disableInsightSetting?: boolean;
};

export type BulkDismissGroupedDto = {
    /**
     * Per-category dismissal groups (at least 1)
     */
    groups: Array<DismissInsightGroupDto>;
};

export type BulkAssignInsightDto = {
    /**
     * IDs of the insights to act on (at least 1)
     */
    ids: Array<(number)>;
    /**
     * User ID to assign (null to unassign) to every selected insight
     */
    assigneeId: number | null;
    /**
     * Optional comment to the assignee
     */
    assignmentComment?: string;
};

export type BulkUpdateInsightVisibilityDto = {
    /**
     * IDs of the insights to act on (at least 1)
     */
    ids: Array<(number)>;
    /**
     * True hides every selected insight from the customer, false releases them
     */
    isHidden: boolean;
};

export type UpdateInsightVisibilityDto = {
    /**
     * True hides the insight from the customer, false releases it
     */
    isHidden: boolean;
};

export type ResolveInsightDto = {
    /**
     * Resolution note
     */
    resolveNote?: string;
};

export type DismissInsightDto = {
    dismissalReason: InsightDismissalReasonEnum;
    /**
     * Additional notes. Required when the reason is OTHER.
     */
    dismissalNote?: string;
    /**
     * Structured extra data for reasons that need it.
     */
    dismissalDetails?: DismissalDetailsDto;
    /**
     * Also switch off the insight setting of the affected meters, so no further insights of this type are generated.
     */
    disableInsightSetting?: boolean;
};

export type AssignInsightDto = {
    /**
     * User ID to assign (null to unassign)
     */
    assigneeId: number | null;
    /**
     * Optional comment to the assignee
     */
    assignmentComment?: string;
};

/**
 * Which kind of non-production period this insight was derived from
 */
export enum OffTimeCategoryEnum {
    NIGHT = 'night',
    WEEKEND = 'weekend',
    HOLIDAY = 'holiday',
    OTHER = 'other'
}

export type NonProductionEpisodeDto = {
    /**
     * Start of the non-production episode (ISO 8601 with offset)
     */
    from: string;
    /**
     * End of the non-production episode (ISO 8601 with offset)
     */
    to: string;
};

export type BenchmarkEpisodeDto = {
    /**
     * Start of the non-production episode (ISO 8601 with offset)
     */
    from: string;
    /**
     * End of the non-production episode (ISO 8601 with offset)
     */
    to: string;
    /**
     * Baseload measured across this episode, in kW
     */
    baseloadKw: number;
};

export type BaseloadBenchmarkCategoryDataDto = {
    scope: OffTimeCategoryEnum;
    /**
     * Identified non-production episodes, shaded as bands on the load curve
     */
    nonProductionEpisodes: Array<NonProductionEpisodeDto>;
    /**
     * The subset of non-production episodes the benchmark was computed from, each with the baseload measured across it. Always a subset of nonProductionEpisodes
     */
    benchmarkEpisodes: Array<BenchmarkEpisodeDto>;
    /**
     * Achievable-minimum baseload the site is benchmarked against, in kW (the dashed "Erreichbares Minimum" line)
     */
    benchmarkKw: number;
    /**
     * Mean non-production baseload across the benchmark window, in kW (the second dashed "Ø Grundlast Analysezeitraum" line)
     */
    averageKw: number;
    /**
     * Start of the window the benchmark was computed over (ISO 8601)
     */
    benchmarkWindowFrom: string;
    /**
     * End of the window the benchmark was computed over (ISO 8601)
     */
    benchmarkWindowTo: string;
    /**
     * How far the average sits above the benchmark, in kW (averageKw − benchmarkKw)
     */
    excessKw: number;
    /**
     * The excess expressed as a percentage of the benchmark
     */
    excessPercentage: number;
};

export type CreateBaseloadBenchmarkInsightDto = {
    energyType: InsightEnergyTypeEnum;
    /**
     * Optional long-form explanation (markdown), authored manually. Title/shortDescription remain frontend-built
     */
    description?: string;
    /**
     * Building ID
     */
    buildingId?: number;
    priority: InsightInboxPriorityEnum;
    /**
     * Savings in kWh (yearly)
     */
    savingsKwhYearly?: number;
    /**
     * Savings in EUR (yearly)
     */
    savingsEurYearly?: number;
    /**
     * Savings in kWh (analysis window)
     */
    savingsKwhAnalysisWindow?: number;
    /**
     * Savings in EUR (analysis window)
     */
    savingsEurAnalysisWindow?: number;
    /**
     * Effective electricity price in EUR per kWh used to compute the savings
     */
    effectivePricePerKwh?: number;
    /**
     * Start of the analysed non-production period the insight was derived from (ISO 8601)
     */
    analysisWindowFrom: string;
    /**
     * End of the analysed non-production period (ISO 8601)
     */
    analysisWindowTo: string;
    /**
     * Device IDs whose load profile the insight is read from (at least 1 required)
     */
    deviceIds: Array<(string)>;
    /**
     * Location IDs (at least 1 required)
     */
    locationIds: Array<(number)>;
    /**
     * Baseload-benchmark-specific payload stored on categoryData
     */
    categoryData: BaseloadBenchmarkCategoryDataDto;
};

export type BaseloadTrendCategoryDataDto = {
    scope: OffTimeCategoryEnum;
    /**
     * Identified non-production episodes, shaded as bands on the load curve
     */
    nonProductionEpisodes: Array<NonProductionEpisodeDto>;
    /**
     * Baseload level at the start of the analysed period, in kW (start point of the trend line)
     */
    trendStartKw: number;
    /**
     * Baseload level at the end of the analysed period, in kW (end point of the trend line)
     */
    trendEndKw: number;
};

export type CreateBaseloadTrendInsightDto = {
    energyType: InsightEnergyTypeEnum;
    /**
     * Optional long-form explanation (markdown), authored manually. Title/shortDescription remain frontend-built
     */
    description?: string;
    /**
     * Building ID
     */
    buildingId?: number;
    priority: InsightInboxPriorityEnum;
    /**
     * Savings in kWh (yearly)
     */
    savingsKwhYearly?: number;
    /**
     * Savings in EUR (yearly)
     */
    savingsEurYearly?: number;
    /**
     * Savings in kWh (analysis window)
     */
    savingsKwhAnalysisWindow?: number;
    /**
     * Savings in EUR (analysis window)
     */
    savingsEurAnalysisWindow?: number;
    /**
     * Effective electricity price in EUR per kWh used to compute the savings
     */
    effectivePricePerKwh?: number;
    /**
     * Start of the analysed non-production period the insight was derived from (ISO 8601)
     */
    analysisWindowFrom: string;
    /**
     * End of the analysed non-production period (ISO 8601)
     */
    analysisWindowTo: string;
    /**
     * Device IDs whose load profile the insight is read from (at least 1 required)
     */
    deviceIds: Array<(string)>;
    /**
     * Location IDs (at least 1 required)
     */
    locationIds: Array<(number)>;
    /**
     * Baseload-trend-specific payload stored on categoryData
     */
    categoryData: BaseloadTrendCategoryDataDto;
};

/**
 * The window over which the peakload is calculated
 */
export enum PeakloadCalculationWindowEnum {
    MONTHLY = 'MONTHLY',
    YEARLY = 'YEARLY'
}

export type PeakloadInsightConfigDto = {
    calculationWindow: PeakloadCalculationWindowEnum;
};

export enum InsightCadenceEnum {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY',
    YEARLY = 'YEARLY'
}

export type StandbyDetectionInsightConfigDto = {
    cadence?: InsightCadenceEnum;
    /**
     * Load in kW at or below which the meter counts as switched off rather than idle. Omit to fall back to the default.
     */
    offThresholdKw?: number;
};

export type BaseloadBenchmarkInsightConfigDto = {
    cadence?: InsightCadenceEnum;
};

export type BaseloadTrendInsightConfigDto = {
    cadence?: InsightCadenceEnum;
};

export type ConnectionLossInsightConfigResponseDto = {
    /**
     * Allowed downtime in minutes before a connection loss is declared. Meters report at different rhythms, so this is set per meter. Omit to fall back to the global default.
     */
    healthyDowntimeMinutes?: number;
    /**
     * Set when a connection-loss insight was dismissed as planned out of service. No loss is detected until this day has passed.
     */
    plannedOutOfServiceUntil?: string;
};

export type StandbyDetectionInsightDefaultsDto = {
    cadence: InsightCadenceEnum;
    offThresholdKw: number;
};

export type CadenceInsightDefaultsDto = {
    cadence: InsightCadenceEnum;
};

export type ConnectionLossInsightDefaultsDto = {
    healthyDowntimeMinutes: number;
};

export type InsightSettingsDefaultsDto = {
    standbyDetection: StandbyDetectionInsightDefaultsDto;
    baseloadBenchmark: CadenceInsightDefaultsDto;
    baseloadTrend: CadenceInsightDefaultsDto;
    connectionLoss: ConnectionLossInsightDefaultsDto;
};

export type InsightInboxSettingsResponseDto = {
    meterId: number;
    peakload?: (PeakloadInsightConfigDto) | null;
    standbyDetection?: (StandbyDetectionInsightConfigDto) | null;
    baseloadBenchmark?: (BaseloadBenchmarkInsightConfigDto) | null;
    baseloadTrend?: (BaseloadTrendInsightConfigDto) | null;
    connectionLoss?: (ConnectionLossInsightConfigResponseDto) | null;
    defaults: InsightSettingsDefaultsDto;
};

export type InsightInboxSettingsListDto = {
    settings: Array<InsightInboxSettingsResponseDto>;
};

export type ConnectionLossInsightConfigDto = {
    /**
     * Allowed downtime in minutes before a connection loss is declared. Meters report at different rhythms, so this is set per meter. Omit to fall back to the global default.
     */
    healthyDowntimeMinutes?: number;
};

export type UpsertMeterInsightInboxSettingsDto = {
    /**
     * Config object to enable peakload; omit or null to disable
     */
    peakload?: (PeakloadInsightConfigDto) | null;
    /**
     * Config object to enable; omit or null to disable
     */
    standbyDetection?: (StandbyDetectionInsightConfigDto) | null;
    /**
     * Config object to enable; omit or null to disable
     */
    baseloadBenchmark?: (BaseloadBenchmarkInsightConfigDto) | null;
    /**
     * Config object to enable; omit or null to disable
     */
    baseloadTrend?: (BaseloadTrendInsightConfigDto) | null;
    /**
     * Config object to enable connection-loss detection; omit or null to disable
     */
    connectionLoss?: (ConnectionLossInsightConfigDto) | null;
    /**
     * The meter the settings belong to
     */
    meterId: number;
};

export type BulkUpsertInsightInboxSettingsDto = {
    settings: Array<UpsertMeterInsightInboxSettingsDto>;
};

export type ApplyInsightRecommendationsDto = {
    /**
     * The meters whose settings are replaced with the recommendation
     */
    meterIds: Array<(number)>;
};

export type UpsertInsightInboxSettingsDto = {
    /**
     * Config object to enable peakload; omit or null to disable
     */
    peakload?: (PeakloadInsightConfigDto) | null;
    /**
     * Config object to enable; omit or null to disable
     */
    standbyDetection?: (StandbyDetectionInsightConfigDto) | null;
    /**
     * Config object to enable; omit or null to disable
     */
    baseloadBenchmark?: (BaseloadBenchmarkInsightConfigDto) | null;
    /**
     * Config object to enable; omit or null to disable
     */
    baseloadTrend?: (BaseloadTrendInsightConfigDto) | null;
    /**
     * Config object to enable connection-loss detection; omit or null to disable
     */
    connectionLoss?: (ConnectionLossInsightConfigDto) | null;
};

export type PatchInsightInboxSettingsDto = {
    /**
     * Config object to enable peakload; omit or null to disable
     */
    peakload?: (PeakloadInsightConfigDto) | null;
    /**
     * Config object to enable; omit or null to disable
     */
    standbyDetection?: (StandbyDetectionInsightConfigDto) | null;
    /**
     * Config object to enable; omit or null to disable
     */
    baseloadBenchmark?: (BaseloadBenchmarkInsightConfigDto) | null;
    /**
     * Config object to enable; omit or null to disable
     */
    baseloadTrend?: (BaseloadTrendInsightConfigDto) | null;
    /**
     * Config object to enable connection-loss detection; omit or null to disable
     */
    connectionLoss?: (ConnectionLossInsightConfigDto) | null;
};

/**
 * Shifts running on Sunday. null when not specified.
 */
export enum ProductionDayModeEnum {
    NONE = 'NONE',
    ONE_SHIFT = 'ONE_SHIFT',
    TWO_SHIFTS = 'TWO_SHIFTS',
    THREE_SHIFTS = 'THREE_SHIFTS'
}

export type LocationProductionScheduleDto = {
    monday?: ProductionDayModeEnum | null;
    tuesday?: ProductionDayModeEnum | null;
    wednesday?: ProductionDayModeEnum | null;
    thursday?: ProductionDayModeEnum | null;
    friday?: ProductionDayModeEnum | null;
    saturday?: ProductionDayModeEnum | null;
    sunday?: ProductionDayModeEnum | null;
    /**
     * The location the schedule belongs to
     */
    locationId: number;
};

export type LocationProductionSchedulesResponseDto = {
    /**
     * Saved schedules. Locations the caller can see but has never saved are omitted.
     */
    schedules: Array<LocationProductionScheduleDto>;
};

export type ProductionScheduleDto = {
    monday?: ProductionDayModeEnum | null;
    tuesday?: ProductionDayModeEnum | null;
    wednesday?: ProductionDayModeEnum | null;
    thursday?: ProductionDayModeEnum | null;
    friday?: ProductionDayModeEnum | null;
    saturday?: ProductionDayModeEnum | null;
    sunday?: ProductionDayModeEnum | null;
};

export type UpsertLocationProductionScheduleItemDto = {
    monday?: ProductionDayModeEnum | null;
    tuesday?: ProductionDayModeEnum | null;
    wednesday?: ProductionDayModeEnum | null;
    thursday?: ProductionDayModeEnum | null;
    friday?: ProductionDayModeEnum | null;
    saturday?: ProductionDayModeEnum | null;
    sunday?: ProductionDayModeEnum | null;
    /**
     * The location the schedule belongs to
     */
    locationId: number;
};

export type BulkUpsertLocationProductionSchedulesDto = {
    /**
     * One full-week schedule per location. Every referenced location is access-checked.
     */
    schedules: Array<UpsertLocationProductionScheduleItemDto>;
};

export type InsightsOnboardingStateDto = {
    /**
     * null when the company never started the onboarding.
     */
    status: 'IN_PROGRESS' | 'COMPLETED' | null;
    /**
     * Whether the onboarding replaces the insights inbox for this company.
     */
    isActive: boolean;
    startedAt?: string | null;
    completedAt?: string | null;
};

/**
 * null when the company never started the onboarding.
 */
export enum status4 {
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED'
}

export type ValidateInvitationResponseDto = {
    /**
     * Email of the invited user
     */
    email: string;
    /**
     * First name of the invited user
     */
    firstName: string | null;
    /**
     * Company name
     */
    companyName: string;
    /**
     * Invitation expiry date
     */
    expiresAt: string;
};

export type AcceptInvitationDto = {
    /**
     * Raw invitation token from the email link
     */
    token: string;
    /**
     * Password the user wants to set
     */
    password: string;
};

export type UserManagementRegisteredUserDto = {
    /**
     * The unique pg ID of the user.
     */
    pgId: number;
    /**
     * Permissions related to locations.
     */
    locationsPermissions: UserFrontendDto_LocationsPermissions;
    /**
     * Last name of the user.
     */
    lastName: string;
    /**
     * Position of the user within the company.
     */
    companyRole: string;
    /**
     * Whether the app reload is required for the user.
     */
    appReloadRequired: boolean;
    /**
     * Roles assigned to the user.
     */
    roles: Array<('admin' | 'user' | 'consultant')>;
    /**
     * Title of the user.
     */
    title: string;
    /**
     * First name of the user.
     */
    firstName: string;
    /**
     * Firebase id of the main location of the user.
     */
    companyId: string;
    /**
     * Phone number of the user.
     */
    phoneNumber: string;
    /**
     * Whether the user is marked as deleted.
     */
    isDeleted: boolean;
    /**
     * Statistical data related to the user's activity.
     */
    stats: UserFrontendDto_Stats;
    /**
     * Notifications enabled for the user.
     */
    enabledNotifications: UserFrontendDto_EnabledNotifications;
    /**
     * Email address of the user.
     */
    email: string;
    /**
     * Region permissions IDs.
     */
    regionsPermissions: Array<(string)>;
    /**
     * Firebase id of the user.
     */
    id: string;
    /**
     * Indicates whether the user is part of the energy team
     */
    isEnergyTeam?: boolean;
    /**
     * Whether the user may release insights to customers.
     */
    isInsightsAdmin: boolean;
    /**
     * Custom dashboard layout for the user.
     */
    customDashboardLayout: {
        [key: string]: unknown;
    } | null;
    company: UserFrontendDto_Company;
    companies: Array<UserFrontendDto_Company>;
    /**
     * Whether the user has only read-only access.
     */
    readonly: boolean;
    /**
     * The consultancy ID of the user.
     */
    consultancyId?: number | null;
    isInvited: number;
};

export type UserManagementAllowedLocationDto = {
    id: string;
};

export type UserManagementLocationsPermissionsDto = {
    canSeeAllLocations: boolean;
    allowedLocations: Array<UserManagementAllowedLocationDto>;
};

export type UserManagementInvitationDto = {
    id: number;
    email: string;
    firstName: string | null;
    lastName: string | null;
    companyRole: string | null;
    roles: Array<(string)>;
    message: string | null;
    expiresAt: string;
    isEnergyTeam: boolean;
    isInvited: number;
    readonly: boolean;
    locationsPermissions: UserManagementLocationsPermissionsDto;
};

export type UserManagementListResponseDto = {
    /**
     * Registered users and pending invitations for this page
     */
    items: Array<(UserManagementRegisteredUserDto | UserManagementInvitationDto)>;
    metadata: PageableMetadataDto;
};

export type InvitationResponseDto = {
    /**
     * Invitation ID
     */
    id: number;
    /**
     * Email of the invited user
     */
    email: string;
    /**
     * First name of the invited user
     */
    firstName: string | null;
    /**
     * Last name of the invited user
     */
    lastName: string | null;
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Company role
     */
    companyRole: string | null;
    /**
     * Roles
     */
    roles: Array<(string)>;
    /**
     * Allowed location Firebase IDs
     */
    allowedLocationFirebaseIds: Array<(string)>;
    /**
     * Whether user is on the energy team
     */
    isEnergyTeam: boolean;
    /**
     * Whether user is readonly
     */
    readonly: boolean;
    /**
     * Whether user can see all locations (legacy flag)
     */
    canSeeAllLocations: boolean;
    /**
     * Personal message
     */
    message: string | null;
    /**
     * Invitation status
     */
    status: 'pending' | 'accepted' | 'revoked' | 'expired';
    /**
     * Expiry date
     */
    expiresAt: string;
    /**
     * Created date
     */
    createdAt: string;
};

/**
 * Invitation status
 */
export enum status5 {
    PENDING = 'pending',
    ACCEPTED = 'accepted',
    REVOKED = 'revoked',
    EXPIRED = 'expired'
}

export type CreateInvitationDto = {
    /**
     * Company ID to invite user to
     */
    companyId: number;
    /**
     * Email of the invited user
     */
    email: string;
    /**
     * First name of the invited user
     */
    firstName?: string;
    /**
     * Last name of the invited user
     */
    lastName?: string;
    /**
     * Roles to assign to the user
     */
    roles: Array<(string)>;
    /**
     * Location Firebase IDs the user should have access to
     */
    allowedLocationFirebaseIds: Array<(string)>;
    /**
     * Company role for the user
     */
    companyRole?: string;
    /**
     * Whether the user is on the energy team
     */
    isEnergyTeam?: boolean;
    /**
     * Whether the user is readonly
     */
    readonly?: boolean;
    /**
     * Personal message for the invitation email
     */
    message?: string;
};

export type UpdateInvitationDto = {
    /**
     * Roles to assign to the user
     */
    roles?: Array<(string)>;
    /**
     * Location Firebase IDs the user should have access to
     */
    allowedLocationFirebaseIds?: Array<(string)>;
    /**
     * Company role for the user
     */
    companyRole?: string;
    /**
     * Whether the user is on the energy team
     */
    isEnergyTeam?: boolean;
    /**
     * Whether the user is readonly
     */
    readonly?: boolean;
    /**
     * Personal message for the invitation email
     */
    message?: string;
};

export type PublicHolidaySubdivisionDto = {
    /**
     * ISO 3166-2 subdivision code
     */
    code: string;
    /**
     * Short name of the subdivision
     */
    shortName?: string;
};

export type PublicHolidayDto = {
    /**
     * Stable holiday identifier from OpenHolidaysAPI
     */
    id: string;
    /**
     * Holiday start date (YYYY-MM-DD)
     */
    startDate: string;
    /**
     * Holiday end date (YYYY-MM-DD), inclusive
     */
    endDate: string;
    /**
     * Holiday type
     */
    type: string;
    /**
     * Localized name in the requested (or fallback) language
     */
    name: string;
    /**
     * True if the holiday applies to the entire country
     */
    nationwide: boolean;
    /**
     * Subdivisions the holiday applies to (when not nationwide)
     */
    subdivisions?: Array<PublicHolidaySubdivisionDto>;
};

export type PublicHolidaysResponseDto = {
    /**
     * ISO 3166-1 alpha-2 country code the holidays were resolved for
     */
    countryIsoCode: string;
    /**
     * ISO 3166-2 subdivision code the holidays were filtered by, if any
     */
    subdivisionCode?: string;
    holidays: Array<PublicHolidayDto>;
};

export type SubmeterAttributionResponseDto = {
    meterId: number;
    locationId: number;
    energyType: string | null;
    unit: string | null;
    mainMeter: {
        meterId?: number;
        deviceId?: string;
        title?: string | null;
        /**
         * Mean load in kW over the meter's own readings inside the windows (intervals without a reading are skipped, so an intermittent submeter's average is its load while running); null when the meter has no power reading there.
         */
        averageKw?: number | null;
        /**
         * Sum of the energy values over the 15min intervals inside the windows. For submeters, only intervals in which the main meter has a reading count.
         */
        total?: number | null;
        /**
         * The 15min intervals inside the windows; only present when includeSeries is true.
         */
        series?: Array<{
            timestamp: string;
            value: number | null;
            /**
             * Average load in kW over the interval; null when the meter has no power reading.
             */
            valueKw: number | null;
        }>;
    };
    /**
     * The measured leaves of the infrastructure hierarchy below the main meter that share its energy type, sorted by total descending.
     */
    submeters: Array<{
        meterId: number;
        deviceId: string;
        title: string | null;
        /**
         * Mean load in kW over the meter's own readings inside the windows (intervals without a reading are skipped, so an intermittent submeter's average is its load while running); null when the meter has no power reading there.
         */
        averageKw: number | null;
        /**
         * Sum of the energy values over the 15min intervals inside the windows. For submeters, only intervals in which the main meter has a reading count.
         */
        total: number | null;
        /**
         * The 15min intervals inside the windows; only present when includeSeries is true.
         */
        series?: Array<{
            timestamp: string;
            value: number | null;
            /**
             * Average load in kW over the interval; null when the meter has no power reading.
             */
            valueKw: number | null;
        }>;
        aggregationLevel: string | null;
        /**
         * The submeter's total divided by the main meter's total, i.e. its part of the main meter's energy in the windows (missing readings count as nothing). Multiplied by the main averageKw it gives the submeter's part of the main meter's mean load. Null when either total is unknown or the main total is zero.
         */
        contributionShare: number | null;
    }>;
};

export type AppControllerGetServiceStatusResponse = unknown;

export type AuthControllerLoginData = {
    /**
     * Login credentials
     */
    requestBody: LoginDto;
};

export type AuthControllerLoginResponse = AuthDto;

export type AuthControllerSsoLoginData = {
    /**
     * Login credentials
     */
    requestBody: SsoLoginRequestDto;
};

export type AuthControllerSsoLoginResponse = AuthDto | unknown;

export type AuthControllerSsoSignupData = {
    /**
     * Signup credentials
     */
    requestBody: LoginDto;
};

export type AuthControllerSsoSignupResponse = AuthDto | unknown;

export type AuthControllerSendPasswordResetEmailData = {
    requestBody: SendResetPasswordEmailDto;
};

export type AuthControllerSendPasswordResetEmailResponse = unknown;

export type AuthControllerUpdatePasswordData = {
    requestBody: ResetPasswordRequestDto;
};

export type AuthControllerUpdatePasswordResponse = unknown;

export type AuthControllerSelfUpdatePasswordData = {
    requestBody: SelfResetPasswordRequestDto;
};

export type AuthControllerSelfUpdatePasswordResponse = unknown;

export type AuthControllerUpdateEmailData = {
    /**
     * The new email address
     */
    requestBody: UpdateEmailDto;
    userId: number;
};

export type AuthControllerUpdateEmailResponse = unknown;

export type UserControllerGetUsersData = {
    /**
     * Filter users by company ID
     */
    companyId?: number;
    /**
     * Filter users by consultancy ID
     */
    consultancyId?: number;
    /**
     * Filter users by email
     */
    email?: string;
    /**
     * Filter users by firebase ID
     */
    firebaseId?: string;
    /**
     * Filter users by location Firebase ID
     */
    locationFirebaseId?: string;
    /**
     * Filter users by location ID
     */
    locationId?: number;
    /**
     * Filter users by region ID
     */
    regionId?: number;
};

export type UserControllerGetUsersResponse = Array<UserDto>;

export type UserControllerCreateData = {
    /**
     * Create User
     */
    requestBody: CreateUserDto;
};

export type UserControllerCreateResponse = UpsertUserResponseDto;

export type UserControllerDeleteUserData = {
    /**
     * Delete user
     */
    requestBody: DeleteUserRequestDto;
};

export type UserControllerDeleteUserResponse = DeleteUserRequestDto;

export type UserControllerGetFrontendUsersData = {
    /**
     * Filter users by company ID
     */
    companyId?: number;
    /**
     * Filter users by consultancy ID
     */
    consultancyId?: number;
    /**
     * Filter users by email
     */
    email?: string;
    /**
     * Filter users by firebase ID
     */
    firebaseId?: string;
    /**
     * Filter users by location Firebase ID
     */
    locationFirebaseId?: string;
    /**
     * Filter users by location ID
     */
    locationId?: number;
    /**
     * Filter users by region ID
     */
    regionId?: number;
};

export type UserControllerGetFrontendUsersResponse = Array<UserFrontendDto>;

export type UserControllerGetUserByIdData = {
    id: number;
};

export type UserControllerGetUserByIdResponse = UserDto;

export type UserControllerGetFrontendUserByIdData = {
    id: number;
};

export type UserControllerGetFrontendUserByIdResponse = UserFrontendDto;

export type UserControllerUpdateData = {
    /**
     * Patch User
     */
    requestBody: UpdateUserDto;
    /**
     * Firebase user ID
     */
    userId: string;
};

export type UserControllerUpdateResponse = UpsertUserResponseDto;

export type UserControllerUpdateAssignedLocationsData = {
    /**
     * Patch user locations
     */
    requestBody: UpsertUserLocationsDto;
    userId: number;
};

export type UserControllerUpdateAssignedLocationsResponse = UpsertUserDto;

export type UserControllerSelectCompanyData = {
    /**
     * ID of the company to select
     */
    companyId: number;
    /**
     * ID of the user
     */
    userId: number;
};

export type UserControllerSelectCompanyResponse = unknown;

export type UserControllerAddUserCompanyData = {
    requestBody: UserCompanyItemDto;
    /**
     * User ID
     */
    userId: number;
};

export type UserControllerAddUserCompanyResponse = unknown | Array<UserCompanyResponseDto>;

export type UserControllerSyncUserCompaniesData = {
    requestBody: SyncUserCompaniesDto;
    /**
     * User ID
     */
    userId: number;
};

export type UserControllerSyncUserCompaniesResponse = Array<UserCompanyResponseDto>;

export type UserControllerRemoveUserCompanyData = {
    /**
     * Company ID
     */
    companyId: number;
    /**
     * User ID
     */
    userId: number;
};

export type UserControllerRemoveUserCompanyResponse = unknown;

export type UserControllerPatchUserData = {
    /**
     * Patch User
     */
    requestBody: UpdateUserDto;
    /**
     * User Firebase ID
     */
    userId: string;
};

export type UserControllerPatchUserResponse = UserFrontendDto;

export type UserControllerUpdateAppReloadRequiredForAllUsersData = {
    /**
     * Update app reload required flag for all users
     */
    requestBody: UpdateAppReloadRequiredRequestBodyDto;
};

export type UserControllerUpdateAppReloadRequiredForAllUsersResponse = unknown;

export type UserControllerGetUserProfilePictureResponse = (Blob | File);

export type UserControllerUploadUserProfilePictureData = {
    formData: UploadProfilePictureDto;
};

export type UserControllerUploadUserProfilePictureResponse = unknown;

export type UserControllerDeleteUserProfilePictureResponse = unknown;

export type UserControllerGetUserProfilePictureByIdData = {
    /**
     * ID of the user
     */
    id: number;
};

export type UserControllerGetUserProfilePictureByIdResponse = (Blob | File);

export type UserControllerHydrateUsersToKafkaResponse = unknown;

export type TracingControllerTraceErrorData = {
    /**
     * Trace Error
     */
    requestBody: TraceErrorDto;
};

export type TracingControllerTraceErrorResponse = unknown;

export type SsoControllerGetCompanyStrategiesData = {
    slug: string;
};

export type SsoControllerGetCompanyStrategiesResponse = Array<StrategyResponseDto>;

export type ConsultancyControllerGetAllResponse = Array<ConsultancyDto>;

export type ConsultancyControllerCreateData = {
    requestBody: CreateConsultancyDto;
};

export type ConsultancyControllerCreateResponse = ConsultancyDto;

export type ConsultancyControllerGetByIdData = {
    id: number;
};

export type ConsultancyControllerGetByIdResponse = ConsultancyDto;

export type ConsultancyControllerUpdateData = {
    id: number;
    requestBody: UpdateConsultancyDto;
};

export type ConsultancyControllerUpdateResponse = ConsultancyDto;

export type ConsultancyControllerDeleteData = {
    id: number;
};

export type ConsultancyControllerDeleteResponse = unknown;

export type ConsultancyControllerGetAvailableCompaniesData = {
    id: number;
};

export type ConsultancyControllerGetAvailableCompaniesResponse = unknown;

export type ConsultancyControllerAddCompaniesData = {
    id: number;
    requestBody: AddCompaniesDto;
};

export type ConsultancyControllerAddCompaniesResponse = unknown;

export type ConsultancyControllerGetConsultancyUsersData = {
    id: number;
};

export type ConsultancyControllerGetConsultancyUsersResponse = Array<User> | unknown;

export type ConsultancyControllerAddUserToConsultancyData = {
    id: number;
    userId: number;
};

export type ConsultancyControllerAddUserToConsultancyResponse = unknown;

export type ConsultancyControllerRemoveUserFromConsultancyData = {
    id: number;
    userId: number;
};

export type ConsultancyControllerRemoveUserFromConsultancyResponse = unknown;

export type ConsultancyControllerAttachCompaniesToUserData = {
    id: number;
    requestBody: AddCompaniesDto;
    userId: number;
};

export type ConsultancyControllerAttachCompaniesToUserResponse = unknown;

export type ConsultancyControllerGetLogoData = {
    id: number;
};

export type ConsultancyControllerGetLogoResponse = unknown;

export type ConsultancyControllerRequestMeterCreationData = {
    requestBody: RequestMeterCreationDto;
};

export type ConsultancyControllerRequestMeterCreationResponse = unknown;

export type RegionControllerUpsertCompanyRegionData = {
    requestBody: UpsertRegionDto;
};

export type RegionControllerUpsertCompanyRegionResponse = unknown;

export type CompanyControllerGetCompanyRegionsData = {
    companyId: number;
};

export type CompanyControllerGetCompanyRegionsResponse = unknown[];

export type RegionControllerDeleteCompanyRegionData = {
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Region ID
     */
    regionId: number;
};

export type RegionControllerDeleteCompanyRegionResponse = unknown;

export type RolesControllerFindAllResponse = Array<Role>;

export type ObjectStorageControllerUploadData = {
    /**
     * Upload files to object storage
     */
    formData: ObjectStorageDto;
};

export type ObjectStorageControllerUploadResponse = Array<ObjectStoragePostResponseDto> | unknown;

export type ObjectStorageControllerDownloadData = {
    fileId: number;
};

export type ObjectStorageControllerDownloadResponse = unknown;

export type ObjectStorageControllerDeleteData = {
    fileId: number;
};

export type ObjectStorageControllerDeleteResponse = unknown;

export type ObjectStorageControllerGetFileMetadataData = {
    fileId: number;
};

export type ObjectStorageControllerGetFileMetadataResponse = ObjectStorageDto;

export type ObjectStorageControllerDownloadConsultantsLoadProfileTemplateData = {
    /**
     * Company ID
     */
    companyId: number;
};

export type ObjectStorageControllerDownloadConsultantsLoadProfileTemplateResponse = unknown;

export type ObjectStorageV2ControllerUploadData = {
    /**
     * Upload files to object storage
     */
    formData: ObjectStorageDto;
};

export type ObjectStorageV2ControllerUploadResponse = Array<ObjectStorageV2PostResponseDto>;

export type ObjectStorageV2ControllerDownloadByUidData = {
    uid: string;
};

export type ObjectStorageV2ControllerDownloadByUidResponse = unknown;

export type ObjectStorageV2ControllerDeleteByUidData = {
    uid: string;
};

export type ObjectStorageV2ControllerDeleteByUidResponse = unknown;

export type ObjectStorageV2ControllerUploadAdminData = {
    /**
     * Company ID for cross-tenant upload
     */
    companyId?: number;
    /**
     * Upload files to object storage
     */
    formData: ObjectStorageDto;
};

export type ObjectStorageV2ControllerUploadAdminResponse = Array<ObjectStorageV2PostResponseDto>;

export type ObjectStorageV2ControllerDownloadByUidAdminData = {
    companyId: number;
    uid: string;
};

export type ObjectStorageV2ControllerDownloadByUidAdminResponse = unknown;

export type ObjectStorageV2ControllerDeleteByUidAdminData = {
    uid: string;
};

export type ObjectStorageV2ControllerDeleteByUidAdminResponse = unknown;

export type ObjectStorageV2ControllerGetFileMetadataByUidData = {
    uid: string;
};

export type ObjectStorageV2ControllerGetFileMetadataByUidResponse = ObjectStorageV2MetadataDto;

export type ObjectStorageV2ControllerGetFileMetadataByUidAdminData = {
    /**
     * Company ID for cross-tenant lookup
     */
    companyId?: number;
    /**
     * File UID
     */
    uid: string;
};

export type ObjectStorageV2ControllerGetFileMetadataByUidAdminResponse = ObjectStorageV2MetadataDto;

export type ObjectStorageV2ControllerDownloadConsultantsLoadProfileTemplateData = {
    /**
     * Company ID
     */
    companyId: number;
};

export type ObjectStorageV2ControllerDownloadConsultantsLoadProfileTemplateResponse = unknown;

export type EmissionsControllerGetEmissionsComparisonData = {
    buildingId: number;
    locationId: number;
    years: Array<(number)>;
};

export type EmissionsControllerGetEmissionsComparisonResponse = EmissionsComparisonDto;

export type MeterControllerGetAvailableYearsByLocationData = {
    locationId: number;
};

export type MeterControllerGetAvailableYearsByLocationResponse = AvailableMeterYearsDto;

export type MeterControllerGetAvailableYearsByCompanyData = {
    companyId: string;
};

export type MeterControllerGetAvailableYearsByCompanyResponse = AvailableMeterYearsDto;

export type MeterControllerGetBulkInfrastructureSettingsData = {
    /**
     * Locations whose meters are returned.
     */
    locationIds: Array<(number)>;
};

export type MeterControllerGetBulkInfrastructureSettingsResponse = MeterInfrastructureSettingsListDto;

export type MeterControllerPutBulkInfrastructureSettingsData = {
    requestBody: BulkUpdateMeterClassificationDto;
};

export type MeterControllerPutBulkInfrastructureSettingsResponse = MeterInfrastructureSettingsListDto;

export type MeterControllerGetInfrastructureSettingsData = {
    buildingId: number;
    deviceId: string;
};

export type MeterControllerGetInfrastructureSettingsResponse = InfrastructureSettingsSelectOneResponseDto;

export type MeterControllerPutInfrastructureSettingsData = {
    buildingId: number;
    deviceId: string;
    requestBody: InfrastructureSettingsUpdateOneRequestBody;
};

export type MeterControllerPutInfrastructureSettingsResponse = InfrastructureSettingsUpdateOneResponseDto;

export type MeterControllerGetPossibleParentMetersData = {
    buildingId: number;
    deviceId: string;
};

export type MeterControllerGetPossibleParentMetersResponse = PossibleParentMetersResponseDto;

export type MeterControllerCreateSlpMeterData = {
    requestBody: CreateSlpMeterRequestDto;
};

export type MeterControllerCreateSlpMeterResponse = SlpMeterDto;

export type MeterControllerUpdateSlpMeterData = {
    deviceId: string;
    requestBody: CreateSlpMeterRequestDto;
};

export type MeterControllerUpdateSlpMeterResponse = SlpMeterDto;

export type MeterControllerDeleteSlpMeterData = {
    buildingId: number;
    deviceId: string;
};

export type MeterControllerDeleteSlpMeterResponse = unknown;

export type MeterControllerGetSlpMeterData = {
    buildingId: number;
    deviceId: string;
};

export type MeterControllerGetSlpMeterResponse = SlpMeterDto;

export type MeterControllerGetMetersData = {
    /**
     * Building ID
     */
    buildingId?: number;
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Devices
     */
    deviceIds?: Array<(string)>;
    /**
     * Start date for data filtering (YYYY-MM-DD)
     */
    from?: string | null;
    /**
     * Granularity to display the consumptiondata series
     */
    granularity?: '15min' | 'hourly' | 'daily' | 'monthly';
    /**
     * Include data series with kW and kWh values (requires from and to)
     */
    includeFullSeries?: boolean;
    /**
     * Include peakload and baseload in timeframe
     */
    includeTimeframePeakloadAndBaseload?: boolean;
    /**
     * Include YTD consumption data (peakloadYtd, totalConsumptionYtd)
     */
    includeTimeframeTotalConsumption?: boolean;
    /**
     * Include YTD peakload and baseload
     */
    includeYtdPeakloadAndBaseload?: boolean;
    /**
     * Include YTD consumption (totalConsumptionYtd) unitl the end of the current day
     */
    includeYtdTotalConsumption?: boolean;
    /**
     * Include YTD consumption (totalConsumptionYtd) until the end of the current month
     */
    includeYtdTotalConsumptionUntilEndOfMonth?: boolean;
    /**
     * Location ID
     */
    locationId?: number;
    /**
     * Region ID
     */
    regionId?: number;
    /**
     * End date for data filtering (YYYY-MM-DD)
     */
    to?: string | null;
};

export type MeterControllerGetMetersResponse = Array<MeterResponseDto>;

export type MeterControllerGetSlpMetersData = {
    /**
     * Building ID
     */
    buildingId?: number;
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Devices
     */
    deviceIds?: Array<(string)>;
    /**
     * Location ID
     */
    locationId?: number;
    /**
     * Region ID
     */
    regionId?: number;
    /**
     * Data source of the SLP meter
     */
    slpDataSource?: 'MONTHLY_CONSUMPTION' | 'METER_READING';
};

export type MeterControllerGetSlpMetersResponse = Array<SlpMeterResponseDto>;

export type MeterControllerGetMetersInfoByAllowedLocationsData = {
    /**
     * Building ID
     */
    buildingId?: number;
    /**
     * Company ID
     */
    companyId?: number;
    /**
     * Device IDs to filter
     */
    deviceIds?: Array<(string)>;
    /**
     * Energy types to filter
     */
    energyTypes?: Array<(string)>;
    /**
     * Time granularity
     */
    granularity?: string;
    /**
     * Filter main meters only
     */
    isMain?: boolean;
    /**
     * Filter virtual meters only
     */
    isVirtual?: boolean;
    /**
     * Location ID
     */
    locationId?: number;
    /**
     * Region ID
     */
    regionId?: number;
    /**
     * API provider source
     */
    source?: string;
    /**
     * Value type
     */
    valueType?: string;
};

export type MeterControllerGetMetersInfoByAllowedLocationsResponse = Array<MeterInfoResponseDto>;

export type MeterControllerGetMeterEvaluationsData = {
    /**
     * Filter by building ID
     */
    buildingId?: number;
    /**
     * Filter by company ID
     */
    companyId?: number;
    /**
     * Filter by location ID
     */
    locationId?: number;
};

export type MeterControllerGetMeterEvaluationsResponse = Array<MeterEvaluationResponseDto>;

export type MeterControllerCreateMeterEvaluationData = {
    requestBody: MeterEvaluationCreateRequestDto;
};

export type MeterControllerCreateMeterEvaluationResponse = unknown;

export type MeterControllerDeleteMeterEvaluationData = {
    meterId: number;
};

export type MeterControllerDeleteMeterEvaluationResponse = unknown;

export type MeterControllerGetEnergyEvaluationData = {
    /**
     * Building ID
     */
    buildingId?: number;
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Start date for data filtering (YYYY-MM-DD)
     */
    from?: string | null;
    /**
     * Location ID
     */
    locationId?: number;
    /**
     * Region ID
     */
    regionId?: number;
    /**
     * End date for data filtering (YYYY-MM-DD)
     */
    to?: string | null;
};

export type MeterControllerGetEnergyEvaluationResponse = Array<MeterEvaluationDto>;

export type DocumentTemplateControllerCreateData = {
    requestBody: CreateDocumentTemplateDto;
};

export type DocumentTemplateControllerCreateResponse = DocumentTemplateDto;

export type DocumentTemplateControllerFindAllData = {
    isStatic?: boolean;
    isSuggested?: boolean;
};

export type DocumentTemplateControllerFindAllResponse = DocumentTemplateDtoList;

export type DocumentTemplateControllerFindOneData = {
    id: number;
};

export type DocumentTemplateControllerFindOneResponse = DocumentTemplateDto;

export type DocumentTemplateControllerUpdateData = {
    id: number;
    requestBody: UpdateDocumentTemplateDto;
};

export type DocumentTemplateControllerUpdateResponse = DocumentTemplateDto;

export type DocumentTemplateControllerRemoveData = {
    id: number;
};

export type DocumentTemplateControllerRemoveResponse = void;

export type DocumentTemplateControllerUpdateContentData = {
    id: number;
};

export type DocumentTemplateControllerUpdateContentResponse = unknown | void;

export type UsageAnalyticsControllerTrackEventData = {
    requestBody: TrackEventDto;
};

export type UsageAnalyticsControllerTrackEventResponse = unknown;

export type HedgingControllerUploadFileData = {
    /**
     * Upload hedging CSV for a given location
     */
    formData: HedgingCsvDto;
    locationId: number;
};

export type HedgingControllerUploadFileResponse = unknown;

export type VisualizationControllerGetVisualizationsData = {
    /**
     * Company ID to filter visualizations. Required if locationId is not provided.
     */
    companyId?: number;
    /**
     * The number of results per page. Must be greater than or equal to 1.
     */
    limit?: number;
    /**
     * Location ID to filter visualizations. Required if companyId is not provided.
     */
    locationId?: number;
    /**
     * The page number for pagination. Must be greater than or equal to 1.
     */
    page?: number;
    /**
     * Field to sort the results by.
     */
    sortBy?: 'createdAt' | 'fullName' | 'defaultView';
    /**
     * Sort order for the results.
     */
    sortOrder?: 'asc' | 'desc';
};

export type VisualizationControllerGetVisualizationsResponse = Array<Visualization>;

export type VisualizationControllerDeleteVisualizationData = {
    /**
     * ID of the visualization to delete
     */
    id: number;
};

export type VisualizationControllerDeleteVisualizationResponse = unknown;

export type GridFeesControllerGetGridUsageFeesData = {
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Location ID
     */
    locationId: number;
};

export type GridFeesControllerGetGridUsageFeesResponse = ApiGridUsagePriceResponseDto;

export type GridFeesControllerUpsertGridUsageFeeData = {
    requestBody: UpsertGridUsagePriceDto;
};

export type GridFeesControllerUpsertGridUsageFeeResponse = GenericResponseDto;

export type GridFeesControllerDeleteGridUsageFeeData = {
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Month (1-12)
     */
    month: number;
    /**
     * Year
     */
    year: number;
};

export type GridFeesControllerDeleteGridUsageFeeResponse = GenericResponseDto;

export type GridFeesControllerGetPeakLoadPricesData = {
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Location ID
     */
    locationId: number;
};

export type GridFeesControllerGetPeakLoadPricesResponse = ApiPeakLoadPriceResponseDto;

export type GridFeesControllerUpsertPeakLoadPriceData = {
    requestBody: UpsertPeakLoadPriceDto;
};

export type GridFeesControllerUpsertPeakLoadPriceResponse = GenericResponseDto;

export type GridFeesControllerDeletePeakLoadPriceData = {
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Month (1-12)
     */
    month: number;
    /**
     * Year
     */
    year: number;
};

export type GridFeesControllerDeletePeakLoadPriceResponse = GenericResponseDto;

export type IsoChaptersControllerFindAllResponse = IsoChapterListResponseDto;

export type IsoChaptersControllerCreateData = {
    requestBody: CreateIsoChapterDto;
};

export type IsoChaptersControllerCreateResponse = IsoChapterResponseDto;

export type IsoChaptersControllerUpdateData = {
    id: number;
    requestBody: UpdateIsoChapterDto;
};

export type IsoChaptersControllerUpdateResponse = IsoChapterResponseDto;

export type IsoChaptersControllerRemoveData = {
    id: number;
};

export type IsoChaptersControllerRemoveResponse = unknown | IsoChapterResponseDto;

export type IsoDocumentsControllerFindAllData = {
    /**
     * Filter by chapter ID
     */
    chapterId?: number;
    /**
     * Filter by company ID
     */
    companyId?: number;
    /**
     * Filter by location ID
     */
    locationId?: number;
    /**
     * Filter by ISO Measure ID
     */
    measureId?: number;
};

export type IsoDocumentsControllerFindAllResponse = IsoDocumentResponseListDto;

export type IsoDocumentsControllerCreateData = {
    /**
     * Create Document
     */
    requestBody: CreateIsoDocumentDto;
};

export type IsoDocumentsControllerCreateResponse = IsoDocumentResponseDto;

export type IsoDocumentsControllerFindOneByIdData = {
    id: number;
};

export type IsoDocumentsControllerFindOneByIdResponse = IsoDocumentFetchOneResponseDto;

export type IsoDocumentsControllerDeleteData = {
    id: number;
};

export type IsoDocumentsControllerDeleteResponse = unknown | void;

export type IsoDocumentsControllerUpdateContentData = {
    id: number;
    /**
     * Update Document content
     */
    requestBody: IsoDocumentUpdateContentDto;
};

export type IsoDocumentsControllerUpdateContentResponse = unknown | void;

export type IsoDocumentsControllerUpdateMetaDataData = {
    id: number;
    /**
     * Update Document meta data
     */
    requestBody: UpdateIsoDocumentMetaDataDto;
};

export type IsoDocumentsControllerUpdateMetaDataResponse = unknown | void;

export type IsoDocumentsControllerUploadFileData = {
    id: number;
};

export type IsoDocumentsControllerUploadFileResponse = unknown | void;

export type IsoDocumentsControllerDeleteUploadDocumentData = {
    id: number;
};

export type IsoDocumentsControllerDeleteUploadDocumentResponse = unknown | void;

export type IsoRiskControllerFindAllData = {
    companyId: number;
};

export type IsoRiskControllerFindAllResponse = IsoRiskFetchResponseListDto;

export type IsoRiskControllerCreateData = {
    /**
     * Create Risk
     */
    requestBody: CreateIsoRiskDto;
};

export type IsoRiskControllerCreateResponse = IsoRiskFetchOneResponseDto;

export type IsoRiskControllerFindOneByIdData = {
    id: number;
};

export type IsoRiskControllerFindOneByIdResponse = IsoRiskFetchOneResponseDto;

export type IsoRiskControllerUpdateData = {
    id: number;
    /**
     * Update Risk
     */
    requestBody: CreateIsoRiskDto;
};

export type IsoRiskControllerUpdateResponse = IsoRiskFetchOneResponseDto;

export type IsoRiskControllerDeleteData = {
    id: number;
};

export type IsoRiskControllerDeleteResponse = void;

export type IsoGoalsControllerFindAllData = {
    companyId: number;
};

export type IsoGoalsControllerFindAllResponse = IsoGoalFetchResponseListDto;

export type IsoGoalsControllerCreateData = {
    /**
     * Create Goal
     */
    requestBody: CreateIsoGoalDto;
};

export type IsoGoalsControllerCreateResponse = IsoGoalFetchResponseDto;

export type IsoGoalsControllerFindOneByIdData = {
    id: number;
};

export type IsoGoalsControllerFindOneByIdResponse = IsoGoalFetchResponseDto;

export type IsoGoalsControllerUpdateData = {
    id: number;
    /**
     * Update Goal
     */
    requestBody: CreateIsoGoalDto;
};

export type IsoGoalsControllerUpdateResponse = IsoGoalFetchResponseDto;

export type IsoGoalsControllerDeleteData = {
    id: number;
};

export type IsoGoalsControllerDeleteResponse = void;

export type IsoEnpiControllerFindSeuOptionsData = {
    locationId: number;
};

export type IsoEnpiControllerFindSeuOptionsResponse = FetchEnpiSeuOptionsDto;

export type IsoEnpiControllerFindSeuOptionsForLocationsData = {
    requestBody: FetchEnpiSeuOptionsForLocationsDto;
};

export type IsoEnpiControllerFindSeuOptionsForLocationsResponse = FetchEnpiSeuOptionsDto;

export type IsoEnpiControllerFindAllData = {
    companyId: number;
};

export type IsoEnpiControllerFindAllResponse = FetchEnpiListDto;

export type IsoEnpiControllerCreateData = {
    /**
     * Create ENPI
     */
    requestBody: CreateEnpiDto;
};

export type IsoEnpiControllerCreateResponse = FetchOneEnpiDto;

export type IsoEnpiControllerFindOneByIdData = {
    id: number;
};

export type IsoEnpiControllerFindOneByIdResponse = FetchOneEnpiDto;

export type IsoEnpiControllerUpdateData = {
    id: number;
    /**
     * Update ENPI
     */
    requestBody: UpdateEnpiDto;
};

export type IsoEnpiControllerUpdateResponse = FetchOneEnpiDto;

export type IsoEnpiControllerDeleteData = {
    id: number;
};

export type IsoEnpiControllerDeleteResponse = void;

export type IsoEnpiControllerAddCommentData = {
    id: number;
    /**
     * Add comment
     */
    requestBody: CreateCommentDto;
};

export type IsoEnpiControllerAddCommentResponse = void;

export type IsoEnpiControllerBatchUpdateData = {
    interval: 'yearly' | 'monthly' | 'weekly' | 'daily';
};

export type IsoEnpiControllerBatchUpdateResponse = unknown;

export type IsoEnpiControllerTriggerDailyUpdateResponse = unknown;

export type IsoEnpiControllerRecalculateData = {
    id: number;
};

export type IsoEnpiControllerRecalculateResponse = void;

export type IsoMeasuresControllerFindAllData = {
    /**
     * Filter by company ID
     */
    companyId?: number;
    /**
     * Filter by location ID
     */
    locationId?: number;
    statuses?: Array<('BACKLOG' | 'PLANNED' | 'ACTIVE' | 'REVIEW' | 'DONE')>;
};

export type IsoMeasuresControllerFindAllResponse = IsoMeasureFetchResponseListDto;

export type IsoMeasuresControllerCreateData = {
    /**
     * Create Measure
     */
    requestBody: CreateIsoMeasureDto;
};

export type IsoMeasuresControllerCreateResponse = FetchOneIsoMeasureDto;

export type IsoMeasuresControllerFindOneByIdData = {
    id: number;
};

export type IsoMeasuresControllerFindOneByIdResponse = FetchOneDetailIsoMeasureDto;

export type IsoMeasuresControllerUpdateData = {
    id: number;
    /**
     * Update Measure
     */
    requestBody: UpdateIsoMeasureDto;
};

export type IsoMeasuresControllerUpdateResponse = FetchOneIsoMeasureDto;

export type IsoMeasuresControllerDeleteData = {
    id: number;
};

export type IsoMeasuresControllerDeleteResponse = void;

export type IsoMeasuresControllerCreateMeasureDocumentsResponse = unknown;

export type IsoMeasuresControllerLinkSuccessMeasurementAnalyticsBaselineData = {
    id: number;
    requestBody: LinkSuccessMeasurementAnalyticsBaselineDto;
};

export type IsoMeasuresControllerLinkSuccessMeasurementAnalyticsBaselineResponse = FetchOneDetailIsoMeasureDto;

export type IsoMeasuresControllerPatchStatusData = {
    id: number;
    /**
     * Update Measure status
     */
    requestBody: PatchMeasureStatusDto;
};

export type IsoMeasuresControllerPatchStatusResponse = FetchOneIsoMeasureDto;

export type IsoMeasuresControllerValidateStatusData = {
    id: number;
    /**
     * Validate Measure status update
     */
    requestBody: PatchMeasureStatusDto;
};

export type IsoMeasuresControllerValidateStatusResponse = IsoMeasureStatusValidationResultDto;

export type IsoMeasuresControllerAddCommentData = {
    id: number;
    /**
     * Add comment
     */
    requestBody: CreateCommentDto;
};

export type IsoMeasuresControllerAddCommentResponse = void;

export type IsoMeasuresControllerCreateMilestoneData = {
    id: number;
    /**
     * Create Measure Milestone
     */
    requestBody: CreateIsoMilestoneDto;
};

export type IsoMeasuresControllerCreateMilestoneResponse = IsoMilestoneFetchOneDto;

export type IsoMeasuresControllerUpdateMilestoneData = {
    id: number;
    milestoneId: number;
    /**
     * Update Measure Milestone
     */
    requestBody: UpdateIsoMilestoneDto;
};

export type IsoMeasuresControllerUpdateMilestoneResponse = IsoMilestoneFetchOneDto;

export type IsoMeasuresControllerDeleteMilestoneData = {
    id: number;
    milestoneId: number;
};

export type IsoMeasuresControllerDeleteMilestoneResponse = IsoMilestoneFetchOneDto;

export type IsoMeasuresControllerPatchMilestoneStatusData = {
    id: number;
    milestoneId: number;
    /**
     * Patch Milestone status
     */
    requestBody: PatchMilestoneStatusDto;
};

export type IsoMeasuresControllerPatchMilestoneStatusResponse = IsoMilestoneFetchOneDto;

export type IsoMeasuresControllerUpdateMilestonesOrderData = {
    id: number;
    /**
     * Update Milestone order
     */
    requestBody: UpdateMilestoneOrderDto;
};

export type IsoMeasuresControllerUpdateMilestonesOrderResponse = unknown;

export type IsoMeasuresControllerDeleteMeasureSavingsData = {
    id: number;
};

export type IsoMeasuresControllerDeleteMeasureSavingsResponse = IsoMilestoneFetchOneDto;

export type IsoMeasuresControllerActivateAutoTrackingData = {
    id: number;
};

export type IsoMeasuresControllerActivateAutoTrackingResponse = FetchOneDetailIsoMeasureDto;

export type IsoControllerGetIsoOverviewData = {
    companyId: number;
    /**
     * user id (email) of the respective user
     */
    userId: string;
};

export type IsoControllerGetIsoOverviewResponse = IsoOverviewModelDto;

export type IsoChecklistConfigurationControllerFindAllResponse = IsoChecklistConfigurationFetchListDto;

export type IsoChecklistConfigurationControllerCreateChecklistResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerFindOneByIdData = {
    id: number;
};

export type IsoChecklistConfigurationControllerFindOneByIdResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerDeleteChecklistConfigurationData = {
    id: number;
};

export type IsoChecklistConfigurationControllerDeleteChecklistConfigurationResponse = void;

export type IsoChecklistConfigurationControllerCopyChecklistData = {
    id: number;
};

export type IsoChecklistConfigurationControllerCopyChecklistResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerPatchStatusData = {
    id: number;
};

export type IsoChecklistConfigurationControllerPatchStatusResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerUnFinalizeData = {
    id: number;
};

export type IsoChecklistConfigurationControllerUnFinalizeResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerPatchLatestData = {
    id: number;
};

export type IsoChecklistConfigurationControllerPatchLatestResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerAddChecklistChapterData = {
    id: number;
    /**
     * Chapter Create
     */
    requestBody: IsoChecklistChaptersConfigurationCreateDto;
};

export type IsoChecklistConfigurationControllerAddChecklistChapterResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerUpdateChecklistChapterData = {
    chapterId: number;
    id: number;
    /**
     * Chapter Update
     */
    requestBody: IsoChecklistChaptersConfigurationUpdateDto;
};

export type IsoChecklistConfigurationControllerUpdateChecklistChapterResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerDeleteChecklistChapterData = {
    chapterId: number;
    id: number;
};

export type IsoChecklistConfigurationControllerDeleteChecklistChapterResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerAddChecklistSubChapterData = {
    chapterId: number;
    id: number;
    /**
     * Sub Chapter Create
     */
    requestBody: IsoChecklistSubChaptersConfigurationCreateDto;
};

export type IsoChecklistConfigurationControllerAddChecklistSubChapterResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerUpdateChecklistSubChapterData = {
    chapterId: number;
    id: number;
    /**
     * Chapter Update
     */
    requestBody: IsoChecklistSubChaptersConfigurationUpdateDto;
    subChapterId: number;
};

export type IsoChecklistConfigurationControllerUpdateChecklistSubChapterResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerDeleteChecklistSubChapterData = {
    chapterId: number;
    id: number;
    subChapterId: number;
};

export type IsoChecklistConfigurationControllerDeleteChecklistSubChapterResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerAddTaskData = {
    chapterId: number;
    id: number;
    /**
     * Task Create
     */
    requestBody: IsoChecklistSubChaptersConfigurationCreateDto;
    subChapterId: number;
};

export type IsoChecklistConfigurationControllerAddTaskResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerUpdateTasksData = {
    chapterId: number;
    id: number;
    /**
     * Tasks Update
     */
    requestBody: IsoChecklistSubChaptersConfigurationUpdateDto;
    subChapterId: number;
    taskId: number;
};

export type IsoChecklistConfigurationControllerUpdateTasksResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistConfigurationControllerDeleteTaskData = {
    chapterId: number;
    id: number;
    subChapterId: number;
    taskId: number;
};

export type IsoChecklistConfigurationControllerDeleteTaskResponse = IsoChecklistConfigurationFetchDto;

export type IsoChecklistControllerFindByCompanyIdData = {
    companyId: number;
};

export type IsoChecklistControllerFindByCompanyIdResponse = IsoChecklistFetchDto;

export type IsoChecklistControllerCreateChecklistByCompanyData = {
    companyId: number;
};

export type IsoChecklistControllerCreateChecklistByCompanyResponse = IsoChecklistFetchDto;

export type IsoChecklistControllerMarkTaskCompletedData = {
    id: number;
    taskId: number;
};

export type IsoChecklistControllerMarkTaskCompletedResponse = IsoChecklistFetchDto;

export type IsoChecklistControllerMarkTaskOpenData = {
    id: number;
    taskId: number;
};

export type IsoChecklistControllerMarkTaskOpenResponse = IsoChecklistFetchDto;

export type IsoChecklistControllerMarkTaskInProgressData = {
    id: number;
    taskId: number;
};

export type IsoChecklistControllerMarkTaskInProgressResponse = IsoChecklistFetchDto;

export type IsoChecklistControllerLinkDocumentData = {
    id: number;
    /**
     * Document to link
     */
    requestBody: IsoChecklistDocumentLinkCreateDto;
    taskId: number;
};

export type IsoChecklistControllerLinkDocumentResponse = IsoChecklistFetchDto;

export type IsoChecklistControllerRemoveLinkDocumentData = {
    documentId: number;
    id: number;
    taskId: number;
};

export type IsoChecklistControllerRemoveLinkDocumentResponse = IsoChecklistFetchDto;

export type ValeriControllerCreateValeriData = {
    /**
     * Create Valeri
     */
    requestBody: CreateValeriDto;
};

export type ValeriControllerCreateValeriResponse = FetchOneValeriDto;

export type ValeriControllerUpdateValeriData = {
    id: number;
    /**
     * Update Valeri
     */
    requestBody: UpdateValeriDto;
};

export type ValeriControllerUpdateValeriResponse = FetchOneValeriDto;

export type ValeriControllerDeleteValeriData = {
    id: number;
};

export type ValeriControllerDeleteValeriResponse = void;

export type ValeriControllerFindOneByIdData = {
    id: number;
};

export type ValeriControllerFindOneByIdResponse = FetchOneValeriDto;

export type ValeriControllerGetValeriPositionsData = {
    id: number;
};

export type ValeriControllerGetValeriPositionsResponse = ValeriPositionsListDto;

export type ValeriControllerCreateValeriPositionData = {
    id: number;
    /**
     * Create Valeri Position
     */
    requestBody: CreateValeriPositionDto;
};

export type ValeriControllerCreateValeriPositionResponse = FetchOneValeriDto;

export type ValeriControllerCalculateValeriData = {
    id: number;
};

export type ValeriControllerCalculateValeriResponse = ValeriCalculationResultSummaryDto;

export type ValeriControllerExportValeriCalculationResultData = {
    id: number;
};

export type ValeriControllerExportValeriCalculationResultResponse = (Blob | File);

export type ValeriControllerUpdateValeriPositionData = {
    id: number;
    positionId: number;
    /**
     * Update Valeri Position
     */
    requestBody: UpdateValeriPositionDto;
};

export type ValeriControllerUpdateValeriPositionResponse = FetchOneValeriDto;

export type ValeriControllerDeleteValeriPositionData = {
    id: number;
    positionId: number;
};

export type ValeriControllerDeleteValeriPositionResponse = void;

export type ValeriControllerUploadValeriPositionDocumentData = {
    id: number;
    positionId: number;
};

export type ValeriControllerUploadValeriPositionDocumentResponse = ValeriPositionDto | void;

export type ValeriControllerDeleteValeriPositionDocumentData = {
    id: number;
    positionId: number;
};

export type ValeriControllerDeleteValeriPositionDocumentResponse = void;

export type ValeriControllerGetValeriCalculationResultsData = {
    companyId?: number;
    locationId?: number;
    measureId?: number;
};

export type ValeriControllerGetValeriCalculationResultsResponse = GetValeriCalculationResultsDto;

export type ValeriControllerGetValeriByMeasureIdData = {
    measureId: number;
};

export type ValeriControllerGetValeriByMeasureIdResponse = FetchOneValeriDto;

export type ValeriControllerLinkValeriToMeasureData = {
    id: number;
    requestBody: LinkValeriToMeasureDto;
};

export type ValeriControllerLinkValeriToMeasureResponse = FetchOneValeriDto;

export type ValeriControllerGetCompanyDefaultsData = {
    companyId: number;
};

export type ValeriControllerGetCompanyDefaultsResponse = ResponseCompanyValeriDefaultsDto;

export type ValeriControllerUpsertCompanyDefaultsData = {
    companyId: number;
    /**
     * Create or update company Valeri defaults
     */
    requestBody: UpsertCompanyValeriDefaultsDto;
};

export type ValeriControllerUpsertCompanyDefaultsResponse = ResponseCompanyValeriDefaultsDto;

export type CompanyEnergyBaselineConfigControllerGetData = {
    companyId: number;
};

export type CompanyEnergyBaselineConfigControllerGetResponse = ResponseCompanyEnergyBaselineConfigDto;

export type CompanyEnergyBaselineConfigControllerUpsertData = {
    companyId: number;
    /**
     * Create or update company energy baseline configuration
     */
    requestBody: UpsertCompanyEnergyBaselineConfigDto;
};

export type CompanyEnergyBaselineConfigControllerUpsertResponse = ResponseCompanyEnergyBaselineConfigDto;

export type BuildingControllerGetBuildingsByLocationData = {
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Location ID
     */
    locationId: number;
};

export type BuildingControllerGetBuildingsByLocationResponse = unknown;

export type BuildingControllerUpsertBuildingData = {
    requestBody: UpsertBuildingDto;
};

export type BuildingControllerUpsertBuildingResponse = unknown;

export type BuildingControllerHydrateBuildingsToKafkaResponse = unknown;

export type BuildingControllerDeleteBuildingData = {
    /**
     * Building ID
     */
    buildingId: number;
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Location ID
     */
    locationId: number;
};

export type BuildingControllerDeleteBuildingResponse = unknown;

export type ConsumptionControllerGetConsumptionData = {
    aggregationTimeframe: number;
    deviceId: string;
    from: string;
    locationId: number;
    source: string;
    to: string;
};

export type ConsumptionControllerGetConsumptionResponse = ConsumptionResponseDto;

export type ConsumptionControllerGetConsumptionLocationWithGranularityData = {
    /**
     * Comma-separated list of building ids. When provided, only consumption from meters in these buildings is returned.
     */
    buildingIds?: string | null;
    /**
     * Energy type to filter by
     */
    energyType?: string;
    /**
     * Start date for data
     */
    from: string;
    /**
     * When true, each series item is annotated with the locationId of the meter it belongs to
     */
    includeLocationId?: boolean;
    locationId: number;
    /**
     * Comma-seperate list of location ids
     */
    locationIds?: string | null;
    /**
     * Filter meters by their measurement type. "rlm" (default) returns registered/measured meters (everything except SLP); "slp" returns only standard-load-profile meters.
     */
    meterType?: 'slp' | 'rlm';
    /**
     * End date for data
     */
    to: string;
};

export type ConsumptionControllerGetConsumptionLocationWithGranularityResponse = unknown[];

export type ConsumptionControllerGetConsumptionWithGranularityData = {
    /**
     * Comma-separated list of building ids. When provided, only consumption from meters in these buildings is returned.
     */
    buildingIds?: string | null;
    companyId: number;
    /**
     * Energy type to filter by
     */
    energyType?: string;
    /**
     * Start date for data
     */
    from: string;
    /**
     * When true, each series item is annotated with the locationId of the meter it belongs to
     */
    includeLocationId?: boolean;
    /**
     * Comma-seperate list of location ids
     */
    locationIds?: string | null;
    /**
     * Filter meters by their measurement type. "rlm" (default) returns registered/measured meters (everything except SLP); "slp" returns only standard-load-profile meters.
     */
    meterType?: 'slp' | 'rlm';
    /**
     * End date for data
     */
    to: string;
};

export type ConsumptionControllerGetConsumptionWithGranularityResponse = unknown[];

export type ConsumptionControllerGetLoadProfileData = {
    /**
     * Comma-separated list of building ids. When provided, only consumption from meters in these buildings is returned.
     */
    buildingIds?: string | null;
    companyId: number;
    /**
     * Energy type to filter by
     */
    energyType?: string;
    /**
     * Start date for data
     */
    from: string;
    /**
     * When true, each series item is annotated with the locationId of the meter it belongs to
     */
    includeLocationId?: boolean;
    /**
     * Comma-seperate list of location ids
     */
    locationIds?: string | null;
    /**
     * Filter meters by their measurement type. "rlm" (default) returns registered/measured meters (everything except SLP); "slp" returns only standard-load-profile meters.
     */
    meterType?: 'slp' | 'rlm';
    /**
     * End date for data
     */
    to: string;
};

export type ConsumptionControllerGetLoadProfileResponse = unknown[];

export type ConsumptionControllerGetAggregatedConsumptionWithGranularityData = {
    deviceIds: Array<(string)>;
    from: string;
    to: string;
};

export type ConsumptionControllerGetAggregatedConsumptionWithGranularityResponse = LoadProfileResponseDto;

export type ConsumptionControllerGetAggregatedConsumptionData = {
    /**
     * Building ID
     */
    buildingId?: number;
    /**
     * Fill missing data gaps with zeros instead of null
     */
    coerceNullToZero?: boolean;
    /**
     * Company ID
     */
    companyId?: number;
    /**
     * Start date
     */
    from: string;
    /**
     * Location ID
     */
    locationId?: number;
    /**
     * Region ID
     */
    regionId?: number;
    /**
     * End date
     */
    to: string;
};

export type ConsumptionControllerGetAggregatedConsumptionResponse = LoadProfileResponseDto;

export type ConsumptionControllerGetConsumptionSeriesData = {
    requestBody: ConsumptionSeriesRequestDto;
};

export type ConsumptionControllerGetConsumptionSeriesResponse = Array<ConsumptionSeriesDto>;

export type LocationTotalSeriesControllerGetLocationTotalSeriesData = {
    requestBody: LocationTotalSeriesRequestDto;
};

export type LocationTotalSeriesControllerGetLocationTotalSeriesResponse = unknown;

export type CompanyControllerGetCompaniesResponse = {
    [key: string]: unknown;
};

export type CompanyControllerUpsertCompanyData = {
    requestBody: UpsertCompanyDto;
};

export type CompanyControllerUpsertCompanyResponse = unknown;

export type CompanyControllerPushAllToKafkaResponse = {
    [key: string]: unknown;
};

export type CompanyControllerDeleteCompanyData = {
    /**
     * Company ID
     */
    companyId: number;
};

export type CompanyControllerDeleteCompanyResponse = unknown;

export type CompanyControllerGetCompanyData = {
    companyId: number;
};

export type CompanyControllerGetCompanyResponse = CompanyDto;

export type CompanyControllerGetPremiumFeaturesData = {
    companyId: number;
};

export type CompanyControllerGetPremiumFeaturesResponse = CompanyPremiumFeaturesResponseDto;

export type CompanyControllerUpdatePremiumFeaturesData = {
    companyId: number;
    requestBody: UpdateCompanyPremiumFeaturesDto;
};

export type CompanyControllerUpdatePremiumFeaturesResponse = CompanyPremiumFeaturesResponseDto;

export type CompanyControllerGetCompanyLogoData = {
    companyId: number;
};

export type CompanyControllerGetCompanyLogoResponse = unknown;

export type CompanyControllerGetCompanyWhiteLabelLogoData = {
    companyId: number;
};

export type CompanyControllerGetCompanyWhiteLabelLogoResponse = unknown;

export type CompanyControllerIsCostEnabledData = {
    /**
     * Company ID
     */
    companyId: number;
};

export type CompanyControllerIsCostEnabledResponse = unknown;

export type LocationControllerGetLocationsByCompanyData = {
    /**
     * Company ID
     */
    companyId: number;
};

export type LocationControllerGetLocationsByCompanyResponse = unknown;

export type LocationControllerUpsertLocationData = {
    requestBody: UpsertLocationDto;
};

export type LocationControllerUpsertLocationResponse = unknown;

export type LocationControllerGetLocationsWithBuildingsAndDevicesByCompanyData = {
    /**
     * Company ID
     */
    companyId: number;
};

export type LocationControllerGetLocationsWithBuildingsAndDevicesByCompanyResponse = Array<LocationTreeDto>;

export type LocationControllerDeleteLocationData = {
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Location ID
     */
    locationId: number;
};

export type LocationControllerDeleteLocationResponse = unknown;

export type LocationControllerGetRegionsByLocationData = {
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Location ID
     */
    locationId: number;
};

export type LocationControllerGetRegionsByLocationResponse = unknown;

export type LocationControllerToggleLocationAssignmentToRegionData = {
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Region ID
     */
    regionId: number;
};

export type LocationControllerToggleLocationAssignmentToRegionResponse = unknown;

export type LocationControllerPushAllToKafkaResponse = {
    [key: string]: unknown;
};

export type TemperatureControllerFindAllData = {
    companyId: number;
};

export type TemperatureControllerFindAllResponse = Array<TemperatureResponseDto>;

export type TemperatureControllerGetWeatherDataByCityIdData = {
    cityId: number;
    /**
     * Start date for weather data in YYYY-MM-DD format
     */
    from: string;
    /**
     * Granularity to aggregate weather data by
     */
    granularity?: '15min' | 'default' | 'day' | 'month' | 'week';
    /**
     * End date for weather data in YYYY-MM-DD format
     */
    to: string;
};

export type TemperatureControllerGetWeatherDataByCityIdResponse = WeatherDataResponseDto;

export type TemperatureControllerGetWeatherDataData = {
    /**
     * Start date for weather data in YYYY-MM-DD format
     */
    from: string;
    /**
     * Granularity to aggregate weather data by
     */
    granularity?: '15min' | 'default' | 'day' | 'month' | 'week';
    id: number;
    /**
     * End date for weather data in YYYY-MM-DD format
     */
    to: string;
};

export type TemperatureControllerGetWeatherDataResponse = WeatherDataResponseDto;

export type TemperatureControllerFindOneData = {
    id: number;
};

export type TemperatureControllerFindOneResponse = TemperatureResponseDto;

export type TemperatureControllerUpdateData = {
    id: number;
    requestBody: UpdateTemperatureDto;
};

export type TemperatureControllerUpdateResponse = TemperatureResponseDto;

export type TemperatureControllerDeleteData = {
    id: number;
};

export type TemperatureControllerDeleteResponse = void;

export type TemperatureControllerCreateData = {
    requestBody: CreateTemperatureDto;
};

export type TemperatureControllerCreateResponse = TemperatureResponseDto;

export type TemperatureControllerTriggerSyncResponse = unknown;

export type CityControllerGetAllCitiesData = {
    /**
     * Page number (1-based). Omit or set to 0 to fetch all cities.
     */
    page?: number;
};

export type CityControllerGetAllCitiesResponse = Array<CityDto>;

export type CityControllerPreviewGeocodedCityData = {
    requestBody: CreateCityGeocodeDto;
};

export type CityControllerPreviewGeocodedCityResponse = CityGeocodePreviewDto;

export type CityControllerCommitGeocodedCityData = {
    requestBody: CreateCityGeocodeDto;
};

export type CityControllerCommitGeocodedCityResponse = CityDto;

export type CityControllerFindAndUpsertCityData = {
    name: string;
};

export type CityControllerFindAndUpsertCityResponse = {
    [key: string]: unknown;
};

export type CustomTimeseriesControllerFindPageData = {
    /**
     * Company ID to filter custom time series
     */
    companyId?: number;
    /**
     * Location ID to filter custom time series
     */
    locationPgId?: number;
    /**
     * Region ID to filter a company-scoped custom time-series list
     */
    regionId?: number;
    /**
     * Search by name, location, granularity, or unit. Name matches are ranked before location matches.
     */
    search?: string;
    sortBy?: 'name' | 'locationName' | 'granularity' | 'type' | 'startDate' | 'endDate';
    sortOrder?: 'asc' | 'desc';
};

export type CustomTimeseriesControllerFindPageResponse = CustomTimeseriesListResponseDto;

export type LoadControllerGetAggregatedMonthlyPeakloadsData = {
    /**
     * The ID of the building (optional)
     */
    buildingId?: number;
    /**
     * The ID of the building (optional)
     */
    buildingId?: number;
    /**
     * The ID of the company (optional)
     */
    companyId?: number;
    /**
     * The ID of the company (optional)
     */
    companyId?: number;
    /**
     * The ID of the location (optional)
     */
    locationId?: number;
    /**
     * The ID of the location (optional)
     */
    locationId?: number;
    /**
     * The ID of the region (optional)
     */
    regionId?: number;
    /**
     * The ID of the region (optional)
     */
    regionId?: number;
    /**
     * Array of years for comparison
     */
    years: Array<(number)>;
    /**
     * Array of years for comparison
     */
    years: Array<(number)>;
};

export type LoadControllerGetAggregatedMonthlyPeakloadsResponse = AggregatedMonthlyPeakloadsResponseDto;

export type LoadControllerGetAggregatedMonthlyBaseloadsData = {
    /**
     * The ID of the building (optional)
     */
    buildingId?: number;
    /**
     * The ID of the building (optional)
     */
    buildingId?: number;
    /**
     * The ID of the company (optional)
     */
    companyId?: number;
    /**
     * The ID of the company (optional)
     */
    companyId?: number;
    /**
     * The ID of the location (optional)
     */
    locationId?: number;
    /**
     * The ID of the location (optional)
     */
    locationId?: number;
    /**
     * The ID of the region (optional)
     */
    regionId?: number;
    /**
     * The ID of the region (optional)
     */
    regionId?: number;
    /**
     * Array of years for comparison
     */
    years: Array<(number)>;
    /**
     * Array of years for comparison
     */
    years: Array<(number)>;
};

export type LoadControllerGetAggregatedMonthlyBaseloadsResponse = AggregatedMonthlyBaseloadsResponseDto;

export type LoadSimulationControllerPopulatePfcResponse = unknown;

export type LoadSimulationControllerRecalculateSimulationOfTypeData = {
    simulationType: string;
};

export type LoadSimulationControllerRecalculateSimulationOfTypeResponse = unknown;

export type LoadSimulationControllerGetAvailableMainMetersData = {
    /**
     * Filter to only return simulations that are allowed for load planning inclusion
     */
    canBeIncludedInLoadPlanning?: boolean;
    /**
     * The id of the company the load simulations should be retrieved for
     */
    companyId: number;
};

export type LoadSimulationControllerGetAvailableMainMetersResponse = Array<AvailableMainMeterDto>;

export type LoadSimulationControllerGetAvailableGenerationLoadProfilesResponse = Array<GenerationLoadProfileDto>;

export type LoadSimulationControllerFindAllForCompanyIdData = {
    /**
     * Filter to only return simulations that are allowed for load planning inclusion
     */
    canBeIncludedInLoadPlanning?: boolean;
    /**
     * The id of the company the load simulations should be retrieved for
     */
    companyId: number;
};

export type LoadSimulationControllerFindAllForCompanyIdResponse = Array<(EfficiencyImprovementSimulationDto | OnsiteGenerationSimulationDto | FlexibilitySimulationDto)>;

export type LoadSimulationControllerCreateSimulationData = {
    /**
     * Payload containing one simulation definition
     */
    requestBody: CreateSimulationRequestDto;
};

export type LoadSimulationControllerCreateSimulationResponse = unknown;

export type LoadSimulationControllerUpdateSimulationByIdData = {
    id: number;
    requestBody: CreateSimulationRequestDto;
};

export type LoadSimulationControllerUpdateSimulationByIdResponse = EfficiencyImprovementSimulationDto | OnsiteGenerationSimulationDto | FlexibilitySimulationDto;

export type LoadSimulationControllerFindSimulationByIdData = {
    /**
     * The start of the timeframe the simulation should be retrieved for. If none provided, the current week will be used as bound
     */
    from?: string;
    id: number;
    /**
     * The end of the timeframe the simulation should be retrieved for. If none provided, the current week will be used as bound
     */
    to?: string;
};

export type LoadSimulationControllerFindSimulationByIdResponse = EfficiencyImprovementSimulationDto | OnsiteGenerationSimulationDto | FlexibilitySimulationDto;

export type LoadSimulationControllerDeleteSimulationByIdData = {
    id: number;
};

export type LoadSimulationControllerDeleteSimulationByIdResponse = void;

export type LoadSimulationControllerRecalculateSimulationByIdData = {
    id: number;
};

export type LoadSimulationControllerRecalculateSimulationByIdResponse = EfficiencyImprovementSimulationDto | OnsiteGenerationSimulationDto | FlexibilitySimulationDto;

export type LoadSimulationControllerGetSimulationCsvData = {
    /**
     * The start of the timeframe the simulation should be retrieved for. If none provided, the current week will be used as bound
     */
    from?: string;
    id: number;
    /**
     * The end of the timeframe the simulation should be retrieved for. If none provided, the current week will be used as bound
     */
    to?: string;
};

export type LoadSimulationControllerGetSimulationCsvResponse = unknown;

export type GenerationLoadProfileControllerGetLoadProfileData = {
    id: number;
};

export type GenerationLoadProfileControllerGetLoadProfileResponse = GenerationLoadProfileDto;

export type GenerationLoadProfileControllerUpdateGenerationLoadProfileData = {
    id: number;
    requestBody: GenerationLoadProfileWriteDto;
};

export type GenerationLoadProfileControllerUpdateGenerationLoadProfileResponse = GenerationLoadProfileDto;

export type GenerationLoadProfileControllerDeleteGenerationLoadProfileData = {
    id: number;
};

export type GenerationLoadProfileControllerDeleteGenerationLoadProfileResponse = unknown;

export type GenerationLoadProfileControllerCreateGenerationLoadProfileData = {
    requestBody: GenerationLoadProfileWriteDto;
};

export type GenerationLoadProfileControllerCreateGenerationLoadProfileResponse = GenerationLoadProfileDto;

export type GenerationLoadProfileControllerUpdateLoadDataData = {
    id: number;
};

export type GenerationLoadProfileControllerUpdateLoadDataResponse = unknown;

export type SlpConsumptionControllerGetReferencesForDeviceIdData = {
    deviceId: string;
};

export type SlpConsumptionControllerGetReferencesForDeviceIdResponse = DeviceReferencesResponseDto;

export type SlpConsumptionControllerGetSlpConsumptionData = {
    deviceId: string;
    from: string;
    to: string;
};

export type SlpConsumptionControllerGetSlpConsumptionResponse = SlpConsumptionResponseDto;

export type SlpConsumptionControllerUpdateSlpConsumptionData = {
    deviceId: string;
    requestBody: SlpConsumptionPutRequestDto;
};

export type SlpConsumptionControllerUpdateSlpConsumptionResponse = unknown;

export type SlpConsumptionControllerDeleteSlpConsumptionData = {
    deviceId: string;
};

export type SlpConsumptionControllerDeleteSlpConsumptionResponse = unknown;

export type SlpMeterReadingControllerGetReadingsData = {
    deviceId: string;
};

export type SlpMeterReadingControllerGetReadingsResponse = Array<SlpMeterReadingResponseDto>;

export type SlpMeterReadingControllerReplaceReadingsData = {
    deviceId: string;
    /**
     * Array of SLP meter readings to save
     */
    requestBody: Array<CreateSlpMeterReadingDto>;
};

export type SlpMeterReadingControllerReplaceReadingsResponse = Array<SlpMeterReadingResponseDto>;

export type SlpMeterReadingControllerCreateReadingData = {
    deviceId: string;
    requestBody: CreateSlpMeterReadingDto;
};

export type SlpMeterReadingControllerCreateReadingResponse = SlpMeterReadingResponseDto;

export type SlpMeterReadingControllerUploadFileData = {
    deviceId: string;
    formData: UploadSlpImageDto;
};

export type SlpMeterReadingControllerUploadFileResponse = UploadSlpImageResponseDto;

export type SlpMeterReadingControllerDownloadReadingImageData = {
    deviceId: string;
    id: number;
};

export type SlpMeterReadingControllerDownloadReadingImageResponse = unknown;

export type GasCostInformationControllerUpdateGasCostInformationData = {
    locationId: number;
    /**
     * Full gas cost information object keyed by year (replaces the stored value entirely)
     */
    requestBody: {
        [key: string]: {
            spotIndex: 'EGSI' | 'EOD';
        };
    };
};

export type GasCostInformationControllerUpdateGasCostInformationResponse = GasCostInformationResponseDto;

export type BudgetTrackingControllerGetCostsData = {
    /**
     * Building ID to filter locations data.
     */
    buildingId?: number;
    /**
     * Company ID to filter locations data.
     */
    companyId?: number;
    /**
     * Location ID to filter locations data.
     */
    locationId?: number;
    /**
     * Region ID to filter locations data.
     */
    regionId?: number;
    /**
     * Year
     */
    year: number;
};

export type BudgetTrackingControllerGetCostsResponse = BudgetTrackingResponseDto;

export type ConsumptionTrendsControllerGetConsumptionTrendsByEnergyTypeData = {
    /**
     * Building ID to filter locations data.
     */
    buildingId?: number;
    /**
     * Company ID to filter locations data.
     */
    companyId?: number;
    endDate: string;
    /**
     * Energy types to filter the consumption data.
     */
    energyTypes?: Array<(string)>;
    /**
     * Location ID to filter locations data.
     */
    locationId?: number;
    /**
     * Region ID to filter locations data.
     */
    regionId?: number;
    startDate: string;
};

export type ConsumptionTrendsControllerGetConsumptionTrendsByEnergyTypeResponse = ConsumptionTrendsResponseDto;

export type ConsumptionTrendsControllerGetConsumptionHistoryData = {
    /**
     * Building ID
     */
    buildingId: number;
    /**
     * Company Firebase ID
     */
    companyId: number;
    energyTypes: Array<(string)>;
    /**
     * Location Firebase ID
     */
    locationId: number;
    /**
     * Region ID
     */
    regionId: number;
    /**
     * Comma-seperate list of years
     */
    years: string;
};

export type ConsumptionTrendsControllerGetConsumptionHistoryResponse = ConsumptionHistoryResponseDto;

export type InvoiceCostsControllerGetInvoiceCostsData = {
    deviceId: string;
    from: string;
    locationId: number;
    to: string;
};

export type InvoiceCostsControllerGetInvoiceCostsResponse = unknown;

export type CalculationsControllerRecalculateYearData = {
    deviceId: string;
    year: string;
};

export type CalculationsControllerRecalculateYearResponse = unknown;

export type CalculationsControllerRecalculateMonthData = {
    deviceId: string;
    month: string;
};

export type CalculationsControllerRecalculateMonthResponse = unknown;

export type CalculationsControllerRecalculateDayData = {
    date: string;
    deviceId: string;
    locationId: number;
};

export type CalculationsControllerRecalculateDayResponse = unknown;

export type CalculationsControllerCalculateEnetCostsData = {
    requestBody: CalculateEnetCostsBodyDto;
};

export type CalculationsControllerCalculateEnetCostsResponse = unknown;

export type CalculationsControllerCalculatePeakloadData = {
    requestBody: CalculateDailyPeakloadForDateRangeBodyDto;
};

export type CalculationsControllerCalculatePeakloadResponse = unknown;

export type CalculationsControllerCalculateBaseloadData = {
    requestBody: CalculateDailyBaseloadForDateRangeBodyDto;
};

export type CalculationsControllerCalculateBaseloadResponse = unknown;

export type CalculationsControllerGetLocationsOverviewData = {
    /**
     * Building ID to filter locations data.
     */
    buildingId?: number;
    /**
     * Company ID to filter locations data.
     */
    companyId: number;
    /**
     * Energy type to filter locations data.
     */
    energyType?: 'electricity' | 'gas';
    /**
     * The number of results per page. Must be greater than or equal to 1.
     */
    limit?: number;
    /**
     * Location ID to filter locations data.
     */
    locationId?: number;
    /**
     * The page number for pagination. Must be greater than or equal to 1.
     */
    page?: number;
    /**
     * Region ID to filter locations data.
     */
    regionId?: number;
    /**
     * Field to sort the results by.
     */
    sortBy?: string;
    /**
     * Sort order for the results.
     */
    sortOrder?: 'asc' | 'desc';
    /**
     * Year to filter locations data.
     */
    year: number;
};

export type CalculationsControllerGetLocationsOverviewResponse = {
    [key: string]: unknown;
};

export type CalculationsControllerGetLocationsMetricsData = {
    /**
     * Building ID to filter locations data.
     */
    buildingId?: number;
    /**
     * Building ID to filter locations data.
     */
    buildingId?: number;
    /**
     * Company ID to filter locations data.
     */
    companyId: number;
    /**
     * Company ID to filter locations data.
     */
    companyId: number;
    /**
     * Energy type to filter locations data.
     */
    energyType?: 'electricity' | 'gas';
    /**
     * Energy type to filter locations data.
     */
    energyType?: 'electricity' | 'gas';
    /**
     * The number of results per page. Must be greater than or equal to 1.
     */
    limit?: number;
    /**
     * The number of results per page. Must be greater than or equal to 1.
     */
    limit?: number;
    /**
     * Location ID to filter locations data.
     */
    locationId?: number;
    /**
     * Location ID to filter locations data.
     */
    locationId?: number;
    /**
     * The page number for pagination. Must be greater than or equal to 1.
     */
    page?: number;
    /**
     * The page number for pagination. Must be greater than or equal to 1.
     */
    page?: number;
    /**
     * Region ID to filter locations data.
     */
    regionId?: number;
    /**
     * Region ID to filter locations data.
     */
    regionId?: number;
    /**
     * Field to sort the results by.
     */
    sortBy?: string;
    /**
     * Field to sort the results by.
     */
    sortBy?: string;
    /**
     * Sort order for the results.
     */
    sortOrder?: 'asc' | 'desc';
    /**
     * Sort order for the results.
     */
    sortOrder?: 'asc' | 'desc';
    /**
     * Year to filter locations data.
     */
    year: number;
    /**
     * Year to filter locations data.
     */
    year: number;
};

export type CalculationsControllerGetLocationsMetricsResponse = LocationEnergyPerformanceMetricsResponseDto;

export type CalculationsControllerGetLocationsMetricsCsvData = {
    /**
     * Building ID to filter locations data.
     */
    buildingId?: number;
    /**
     * Building ID to filter locations data.
     */
    buildingId?: number;
    /**
     * Company ID to filter locations data.
     */
    companyId: number;
    /**
     * Company ID to filter locations data.
     */
    companyId: number;
    /**
     * Energy type to filter locations data.
     */
    energyType?: 'electricity' | 'gas';
    /**
     * Energy type to filter locations data.
     */
    energyType?: 'electricity' | 'gas';
    /**
     * The number of results per page. Must be greater than or equal to 1.
     */
    limit?: number;
    /**
     * The number of results per page. Must be greater than or equal to 1.
     */
    limit?: number;
    /**
     * Location ID to filter locations data.
     */
    locationId?: number;
    /**
     * Location ID to filter locations data.
     */
    locationId?: number;
    /**
     * The page number for pagination. Must be greater than or equal to 1.
     */
    page?: number;
    /**
     * The page number for pagination. Must be greater than or equal to 1.
     */
    page?: number;
    /**
     * Region ID to filter locations data.
     */
    regionId?: number;
    /**
     * Region ID to filter locations data.
     */
    regionId?: number;
    /**
     * Field to sort the results by.
     */
    sortBy?: string;
    /**
     * Field to sort the results by.
     */
    sortBy?: string;
    /**
     * Sort order for the results.
     */
    sortOrder?: 'asc' | 'desc';
    /**
     * Sort order for the results.
     */
    sortOrder?: 'asc' | 'desc';
    /**
     * Year to filter locations data.
     */
    year: number;
    /**
     * Year to filter locations data.
     */
    year: number;
};

export type CalculationsControllerGetLocationsMetricsCsvResponse = unknown;

export type CalculationsControllerStoreHedgeCostMonthlySummaryData = {
    requestBody: StoreHedgeCostMonthlySummaryBodyDto;
};

export type CalculationsControllerStoreHedgeCostMonthlySummaryResponse = Array<{
    [key: string]: unknown;
}>;

export type CalculationsControllerRunCostCalculationsResponse = void;

export type CalculationsControllerRecalculateDeviceMetricsData = {
    requestBody: RecalculateDeviceMetricsDto;
};

export type CalculationsControllerRecalculateDeviceMetricsResponse = void;

export type CostsSummaryControllerGetCostsSummaryData = {
    /**
     * Filter by company ID
     */
    companyId?: number;
    /**
     * Filter by location ID
     */
    locationId?: number;
    year: number;
};

export type CostsSummaryControllerGetCostsSummaryResponse = CostsSummaryResponseDto;

export type LocationControllerGetEnabledModulesForUserData = {
    /**
     * Company ID to get enabled modules for
     */
    companyId: number;
    /**
     * User ID to get enabled modules for
     */
    userId: number;
};

export type LocationControllerGetEnabledModulesForUserResponse = LocationModulesResponseDto;

export type LocationControllerUpdateEnabledModulesData = {
    id: number;
    requestBody: UpdateEnabledModulesRequestDto;
};

export type LocationControllerUpdateEnabledModulesResponse = unknown | void;

export type LocationControllerGetLocationEnabledModulesData = {
    id: number;
};

export type LocationControllerGetLocationEnabledModulesResponse = unknown;

export type LocationControllerGetLocationData = {
    id: number;
};

export type LocationControllerGetLocationResponse = {
    [key: string]: unknown;
} | LocationDto;

export type LocationControllerGetEnergyManagerSettingsData = {
    locationId: string;
};

export type LocationControllerGetEnergyManagerSettingsResponse = unknown;

export type LocationControllerSetEnergyManagerSettingsData = {
    requestBody: PatchEnergyManagerRequestDto;
};

export type LocationControllerSetEnergyManagerSettingsResponse = unknown;

export type LocationControllerSetReportsSettingsData = {
    locationId: number;
    requestBody: ReportsSettingsDto;
};

export type LocationControllerSetReportsSettingsResponse = unknown;

export type PricesControllerGetPricesResponse = PricesResponseDto;

export type PricesControllerGetCurrentPriceResponse = CurrentPriceResponseDto;

export type PricesControllerGetAverageYtdPriceResponse = AveragePriceResponseDto;

export type PricesControllerGetElectricityPricesData = {
    requestBody: ElectricityPricesBodyDto;
};

export type PricesControllerGetElectricityPricesResponse = unknown;

export type SpotMarketControllerGetPricesData = {
    /**
     * End date (ISO 8601 string)
     */
    endDate: string;
    /**
     * Which spot market to read. Defaults to electricity.
     */
    energyType?: 'electricity' | 'gas';
    /**
     * Gas price series to read (only applies when energyType=gas). Defaults to EGSI.
     */
    source?: 'THE' | 'EGSI';
    /**
     * Start date (ISO 8601 string)
     */
    startDate: string;
};

export type SpotMarketControllerGetPricesResponse = Array<SpotMarketPriceResponseDto>;

export type SpotMarketControllerGetCompanyPricesData = {
    companyId: number;
    /**
     * End date (ISO 8601 string)
     */
    endDate: string;
    /**
     * Which spot market to read. Defaults to electricity.
     */
    energyType?: 'electricity' | 'gas';
    /**
     * Start date (ISO 8601 string)
     */
    startDate: string;
};

export type SpotMarketControllerGetCompanyPricesResponse = Array<SpotMarketPriceResponseDto>;

export type EmberControllerAskChecklistAssistantData = {
    requestBody: EmberChecklistAgentRequestBody;
};

export type EmberControllerAskChecklistAssistantResponse = EmberChecklistAgentResponse;

export type EmberControllerAskDocumentAssistantData = {
    requestBody: EmberDocumentAgentRequestBody;
};

export type EmberControllerAskDocumentAssistantResponse = EmberDocumentAgentResponse;

export type EmberControllerGetEmbeddedFilesResponse = GetEmbeddedFilesDTO;

export type EmberControllerCreateEmbeddingsResponse = EmbeddingResultDTO;

export type EmberControllerDeleteEmbeddingsByFileIdData = {
    /**
     * ID of the embedding file to delete
     */
    id: number;
};

export type EmberControllerDeleteEmbeddingsByFileIdResponse = unknown | void;

export type EmberControllerAskChatAssistantData = {
    requestBody: EmberChatAgentRequestBody;
};

export type EmberControllerAskChatAssistantResponse = EmberChatAgentResponse;

export type EmberControllerCancelMessageProcessingData = {
    requestBody: EmberCancelProcessingRequestBody;
};

export type EmberControllerCancelMessageProcessingResponse = unknown | void;

export type EmberControllerCleanupExpiredThreadsResponse = EmberThreadCleanupResultDto | unknown;

export type EmberControllerDeleteAllThreadsResponse = EmberThreadDeleteResultDto;

export type EmberControllerGetThreadStatsResponse = EmberThreadStatsDto;

export type EmberControllerGetProposedQuestionsData = {
    requestBody: ProposedQuestionsRequestDto;
};

export type EmberControllerGetProposedQuestionsResponse = ProposedQuestionsResponseDto;

export type EmberControllerGenerateReportModuleConfigData = {
    requestBody: EmberReportAgentRequestBody;
};

export type EmberControllerGenerateReportModuleConfigResponse = ResponseReportModuleDto;

export type EmberControllerVisualizeAgentGraphData = {
    /**
     * Name of the agent to be visualized
     */
    agent: 'chat' | 'checklist' | 'document' | 'report';
};

export type EmberControllerVisualizeAgentGraphResponse = unknown;

export type EmberControllerGetCallTranscriptsForCompanyData = {
    companyId: number;
    firefliesId: string;
};

export type EmberControllerGetCallTranscriptsForCompanyResponse = GetEmbeddedCallTranscriptsDTO;

export type EmberControllerEmbedSingleCallTranscriptData = {
    requestBody: CreateEmbeddedCallTranscriptDTO;
};

export type EmberControllerEmbedSingleCallTranscriptResponse = unknown | EmbeddingResultDTO;

export type EmberControllerDeleteSingleCallTranscriptEmbeddingData = {
    requestBody: DeleteEmbeddedCallTranscriptDTO;
};

export type EmberControllerDeleteSingleCallTranscriptEmbeddingResponse = unknown;

export type EmberControllerSyncCallTranscriptsData = {
    requestBody: SynchronizeCallTranscriptsDTO;
};

export type EmberControllerSyncCallTranscriptsResponse = unknown;

export type CustomReportControllerGetCustomReportData = {
    id: number;
};

export type CustomReportControllerGetCustomReportResponse = ResponseCustomReportDto;

export type CustomReportControllerUpdateCustomReportData = {
    id: number;
    requestBody: UpdateCustomReportDto;
};

export type CustomReportControllerUpdateCustomReportResponse = ResponseCustomReportDto;

export type CustomReportControllerDeleteCustomReportData = {
    id: number;
};

export type CustomReportControllerDeleteCustomReportResponse = void;

export type CustomReportControllerGetAllCustomReportsData = {
    companyId: number;
};

export type CustomReportControllerGetAllCustomReportsResponse = Array<ResponseCustomReportDto>;

export type CustomReportControllerCreateCustomReportData = {
    requestBody: CreateCustomReportDto;
};

export type CustomReportControllerCreateCustomReportResponse = ResponseCustomReportDto;

export type CustomReportControllerRequestReportingUpgradeResponse = unknown;

export type CustomReportControllerGetCustomReportLogoData = {
    id: number;
};

export type CustomReportControllerGetCustomReportLogoResponse = unknown;

export type CustomReportControllerGenerateReportManuallyData = {
    id: number;
    requestBody: GenerateReportDto;
};

export type CustomReportControllerGenerateReportManuallyResponse = unknown;

export type CustomReportControllerGeneratePdfData = {
    id: number;
};

export type CustomReportControllerGeneratePdfResponse = unknown;

export type CustomReportControllerValidatePdfTokenData = {
    token: string;
};

export type CustomReportControllerValidatePdfTokenResponse = unknown;

export type CustomReportControllerGetModulesForPdfData = {
    reportId: number;
    token: string;
};

export type CustomReportControllerGetModulesForPdfResponse = ResponseReportWithModulesForPdfDto;

export type CustomReportControllerGetDataCompletenessForPdfData = {
    /**
     * Building IDs. Used when deviceIds are omitted; takes precedence over locationIds and companyId.
     */
    buildingIds?: Array<(number)>;
    /**
     * Company ID. Used when explicit ids or narrower hierarchy filters are omitted.
     */
    companyId?: number;
    /**
     * Custom time series IDs. Pass explicitly to include custom time series; hierarchy filters do not automatically include them.
     */
    customTimeseriesIds?: Array<(string)>;
    /**
     * Meter device IDs. Explicit ids are additive with customTimeseriesIds and take precedence over hierarchy filters.
     */
    deviceIds?: Array<(string)>;
    /**
     * Range end for completeness calculation. Must be on or after startDate.
     */
    endDate: string;
    /**
     * Energy type filter (e.g. electricity, gas). Omit to return all types.
     */
    energyType?: string;
    /**
     * Limit a timeSeries-level request to one storage namespace. Omit to include legacy meters and linked sidecar series; with deviceIds, one meter device ID can therefore return both the meter and its sidecars.
     */
    entityType?: 'meter' | 'series';
    /**
     * When true, include electricity spot market prices in the scoped calculation.
     */
    includeElectricitySpotPrices?: boolean;
    /**
     * Include per-interval details in each item. Defaults to true for backward compatibility.
     */
    includeIntervals?: boolean;
    /**
     * When set to timeSeries, hierarchy scopes return one item per legacy meter stream or linked sidecar series. Omit to preserve scope-level grouping.
     */
    itemLevel?: 'timeSeries';
    /**
     * Location IDs. Used when explicit ids or buildingIds are omitted; takes precedence over companyId.
     */
    locationIds?: Array<(number)>;
    /**
     * When true, return data only for legacy meters marked as main. Linked sidecar series are excluded. Omit or false for all meters and series matching the scope filter.
     */
    onlyMainMeters?: boolean;
    reportId: number;
    /**
     * Range start for completeness calculation.
     */
    startDate: string;
    token: string;
};

export type CustomReportControllerGetDataCompletenessForPdfResponse = GetDataCompletenessResponseDto;

export type CustomReportControllerGetModuleImageForPdfData = {
    moduleId: number;
    reportId: number;
    token: string;
};

export type CustomReportControllerGetModuleImageForPdfResponse = unknown;

export type CustomReportControllerTriggerRecoverySweepResponse = unknown;

export type CustomReportControllerGetSentReportsData = {
    reportId: number;
};

export type CustomReportControllerGetSentReportsResponse = Array<ResponseSentReportDto>;

export type CustomReportControllerGetSentReportData = {
    reportId: number;
    sentReportId: number;
};

export type CustomReportControllerGetSentReportResponse = ResponseSentReportDto;

export type CustomReportControllerGetSentReportLogoData = {
    reportId: number;
    sentReportId: number;
};

export type CustomReportControllerGetSentReportLogoResponse = unknown;

export type CustomReportControllerGetSentReportModulesData = {
    reportId: number;
    sentReportId: number;
};

export type CustomReportControllerGetSentReportModulesResponse = Array<ResponseSentReportModuleDto>;

export type CustomReportControllerGetSentReportModulesWithDataData = {
    reportId: number;
    sentReportId: number;
};

export type CustomReportControllerGetSentReportModulesWithDataResponse = Array<ResponseSentReportModuleWithDataDto>;

export type CustomReportControllerGetSentReportModuleWithDataData = {
    moduleId: number;
    reportId: number;
    sentReportId: number;
};

export type CustomReportControllerGetSentReportModuleWithDataResponse = ResponseSentReportModuleWithDataDto;

export type CustomReportControllerGetSentReportModuleImageData = {
    moduleId: number;
    reportId: number;
    sentReportId: number;
};

export type CustomReportControllerGetSentReportModuleImageResponse = unknown;

export type CustomReportControllerGetReportModulesData = {
    reportId: number;
};

export type CustomReportControllerGetReportModulesResponse = Array<ResponseReportModuleDto>;

export type CustomReportControllerCreateReportModuleData = {
    reportId: number;
    requestBody: CreateReportModuleDto;
};

export type CustomReportControllerCreateReportModuleResponse = ResponseReportModuleDto;

export type CustomReportControllerGetModuleData = {
    /**
     * Maximum number of data series to include
     */
    limit?: number;
    moduleId: number;
    reportId: number;
};

export type CustomReportControllerGetModuleResponse = ResponseReportModuleWithDataDto;

export type CustomReportControllerUpdateReportModuleData = {
    moduleId: number;
    reportId: number;
    requestBody: UpdateReportModuleDto;
};

export type CustomReportControllerUpdateReportModuleResponse = ResponseReportModuleDto;

export type CustomReportControllerDeleteReportModuleData = {
    moduleId: number;
    reportId: number;
};

export type CustomReportControllerDeleteReportModuleResponse = void;

export type CustomReportControllerApplyTemplateData = {
    reportId: number;
    requestBody: ApplyTemplateDto;
};

export type CustomReportControllerApplyTemplateResponse = Array<ResponseReportModuleDto>;

export type CustomReportControllerReorderReportModulesData = {
    reportId: number;
    requestBody: ReorderModulesDto;
};

export type CustomReportControllerReorderReportModulesResponse = Array<ResponseReportModuleDto>;

export type CustomReportControllerGetModuleImageData = {
    moduleId: number;
    reportId: number;
};

export type CustomReportControllerGetModuleImageResponse = unknown;

export type DataCompletenessControllerGetDataCompletenessData = {
    /**
     * Building IDs. Used when deviceIds are omitted; takes precedence over locationIds and companyId.
     */
    buildingIds?: Array<(number)>;
    /**
     * Company ID. Used when explicit ids or narrower hierarchy filters are omitted.
     */
    companyId?: number;
    /**
     * Custom time series IDs. Pass explicitly to include custom time series; hierarchy filters do not automatically include them.
     */
    customTimeseriesIds?: Array<(string)>;
    /**
     * Meter device IDs. Explicit ids are additive with customTimeseriesIds and take precedence over hierarchy filters.
     */
    deviceIds?: Array<(string)>;
    /**
     * Range end for completeness calculation. Must be on or after startDate.
     */
    endDate: string;
    /**
     * Energy type filter (e.g. electricity, gas). Omit to return all types.
     */
    energyType?: string;
    /**
     * Limit a timeSeries-level request to one storage namespace. Omit to include legacy meters and linked sidecar series; with deviceIds, one meter device ID can therefore return both the meter and its sidecars.
     */
    entityType?: 'meter' | 'series';
    /**
     * When true, include electricity spot market prices in the scoped calculation.
     */
    includeElectricitySpotPrices?: boolean;
    /**
     * Include per-interval details in each item. Defaults to true for backward compatibility.
     */
    includeIntervals?: boolean;
    /**
     * When set to timeSeries, hierarchy scopes return one item per legacy meter stream or linked sidecar series. Omit to preserve scope-level grouping.
     */
    itemLevel?: 'timeSeries';
    /**
     * Location IDs. Used when explicit ids or buildingIds are omitted; takes precedence over companyId.
     */
    locationIds?: Array<(number)>;
    /**
     * When true, return data only for legacy meters marked as main. Linked sidecar series are excluded. Omit or false for all meters and series matching the scope filter.
     */
    onlyMainMeters?: boolean;
    /**
     * Range start for completeness calculation.
     */
    startDate: string;
};

export type DataCompletenessControllerGetDataCompletenessResponse = GetDataCompletenessResponseDto;

export type GapsControllerGetGapsData = {
    /**
     * Building IDs. Used when deviceIds are omitted; takes precedence over locationIds and companyId.
     */
    buildingIds?: Array<(number)>;
    /**
     * Company ID. Used when explicit ids or narrower hierarchy filters are omitted.
     */
    companyId?: number;
    /**
     * Custom time series IDs. Pass explicitly to include custom time series; hierarchy filters do not automatically include them.
     */
    customTimeseriesIds?: Array<(string)>;
    /**
     * Meter device IDs. Explicit ids are additive with customTimeseriesIds and take precedence over hierarchy filters.
     */
    deviceIds?: Array<(string)>;
    /**
     * Include gaps that overlap this range end (optional). Must be on or after startDate when both are set.
     */
    endDate?: string;
    /**
     * Energy type filter (e.g. electricity, gas). Omit to return all types.
     */
    energyType?: string;
    /**
     * Limit energy gaps to legacy meters or sidecar series. Omit to preserve the combined result.
     */
    entityType?: 'meter' | 'series';
    /**
     * When true, include electricity spot market prices in the scoped calculation.
     */
    includeElectricitySpotPrices?: boolean;
    /**
     * Include linked sidecar-series gaps in addition to legacy meter gaps.
     */
    includeSeries?: boolean;
    /**
     * Location IDs. Used when explicit ids or buildingIds are omitted; takes precedence over companyId.
     */
    locationIds?: Array<(number)>;
    /**
     * When true, return data only for legacy meters marked as main. Linked sidecar series are excluded. Omit or false for all meters and series matching the scope filter.
     */
    onlyMainMeters?: boolean;
    /**
     * Include gaps that overlap this range start (optional).
     */
    startDate?: string;
};

export type GapsControllerGetGapsResponse = Array<GetGapsResponseDto>;

export type SeriesControllerListSeriesData = {
    /**
     * Filter by building ID
     */
    buildingId?: number;
    /**
     * Filter by company ID
     */
    companyId?: number;
    /**
     * Filter by device IDs (comma-separated)
     */
    deviceIds?: string;
    /**
     * Filter by location ID
     */
    locationId?: number;
};

export type SeriesControllerListSeriesResponse = Array<SeriesResponseDto>;

export type SeriesControllerCreateOrLinkSeriesData = {
    requestBody: CreateOrLinkSeriesDto;
};

export type SeriesControllerCreateOrLinkSeriesResponse = CreateOrLinkSeriesResponseDto;

export type SeriesControllerGetSeriesByIdData = {
    /**
     * Series UUID
     */
    id: string;
};

export type SeriesControllerGetSeriesByIdResponse = SeriesResponseDto;

export type SeriesControllerUpdateSeriesData = {
    /**
     * Series UUID
     */
    id: string;
    requestBody: UpdateSeriesDto;
};

export type SeriesControllerUpdateSeriesResponse = SeriesResponseDto;

export type SeriesControllerDeleteSeriesData = {
    /**
     * Series UUID
     */
    id: string;
};

export type SeriesControllerDeleteSeriesResponse = void;

export type MeterSeriesControllerLinkMetersToSeriesData = {
    requestBody: LinkMetersToSeriesDto;
};

export type MeterSeriesControllerLinkMetersToSeriesResponse = unknown;

export type MeterSeriesControllerUnlinkMetersFromSeriesData = {
    requestBody: LinkMetersToSeriesDto;
};

export type MeterSeriesControllerUnlinkMetersFromSeriesResponse = void;

export type MeterSeriesControllerBatchUpdateMeterSeriesTitlesData = {
    requestBody: BatchUpdateMeterSeriesTitleDto;
};

export type MeterSeriesControllerBatchUpdateMeterSeriesTitlesResponse = void;

export type MeterSeriesControllerGetSeriesForMeterData = {
    /**
     * Meter ID
     */
    meterId: number;
};

export type MeterSeriesControllerGetSeriesForMeterResponse = Array<SeriesResponseDto>;

export type MeterSeriesControllerGetMetersForSeriesData = {
    /**
     * Series UUID
     */
    seriesId: string;
};

export type MeterSeriesControllerGetMetersForSeriesResponse = Array<MeterInfoDto>;

export type MeterSeriesControllerGetAllSeriesForDeviceWithLinkStatusData = {
    /**
     * Device ID
     */
    deviceId: string;
    /**
     * Meter ID to check link status against
     */
    meterId: number;
};

export type MeterSeriesControllerGetAllSeriesForDeviceWithLinkStatusResponse = unknown;

export type MeterSeriesControllerGetAllMetersForDeviceWithLinkStatusData = {
    /**
     * Device ID
     */
    deviceId: string;
    /**
     * Series UUID to check link status against
     */
    seriesId: string;
};

export type MeterSeriesControllerGetAllMetersForDeviceWithLinkStatusResponse = unknown;

export type SankeyControllerGetSankeyData = {
    /**
     * Building ID (optional – one of locationId/buildingId required)
     */
    buildingId?: number;
    /**
     * Building ID (optional – one of locationId/buildingId required)
     */
    buildingId?: number;
    /**
     * Opt in to the canonical location energy-balance classification and formula.
     */
    calculationMode?: 'locationEnergyBalance';
    /**
     * Opt in to the canonical location energy-balance classification and formula.
     */
    calculationMode?: 'locationEnergyBalance';
    /**
     * Start time
     */
    from: string;
    /**
     * Start time
     */
    from: string;
    /**
     * Language for localized Sankey labels. Defaults to German.
     */
    lang?: 'de' | 'en';
    /**
     * Language for localized Sankey labels. Defaults to German.
     */
    lang?: 'de' | 'en';
    /**
     * Location ID (optional – one of locationId/buildingId required)
     */
    locationId?: number;
    /**
     * Location ID (optional – one of locationId/buildingId required)
     */
    locationId?: number;
    /**
     * End time
     */
    to: string;
    /**
     * End time
     */
    to: string;
};

export type SankeyControllerGetSankeyResponse = SankeyGetResponseDto;

export type SankeyControllerGetSankeyCsvData = {
    /**
     * Building ID (optional – one of locationId/buildingId required)
     */
    buildingId?: number;
    /**
     * Building ID (optional – one of locationId/buildingId required)
     */
    buildingId?: number;
    /**
     * Opt in to the canonical location energy-balance classification and formula.
     */
    calculationMode?: 'locationEnergyBalance';
    /**
     * Opt in to the canonical location energy-balance classification and formula.
     */
    calculationMode?: 'locationEnergyBalance';
    /**
     * Start time
     */
    from: string;
    /**
     * Start time
     */
    from: string;
    /**
     * Language for localized Sankey labels. Defaults to German.
     */
    lang?: 'de' | 'en';
    /**
     * Language for localized Sankey labels. Defaults to German.
     */
    lang?: 'de' | 'en';
    /**
     * Location ID (optional – one of locationId/buildingId required)
     */
    locationId?: number;
    /**
     * Location ID (optional – one of locationId/buildingId required)
     */
    locationId?: number;
    requestBody: SankeyCsvExportRequestDto;
    /**
     * End time
     */
    to: string;
    /**
     * End time
     */
    to: string;
};

export type SankeyControllerGetSankeyCsvResponse = unknown;

export type SankeyControllerGetMeterViewSankeyData = {
    /**
     * Start date for consumption data (ISO string)
     */
    from: string;
    /**
     * Start date for consumption data (ISO string)
     */
    from: string;
    /**
     * Meter view ID
     */
    id: number;
    /**
     * Language for localized Sankey labels. Defaults to German.
     */
    lang?: 'de' | 'en';
    /**
     * Language for localized Sankey labels. Defaults to German.
     */
    lang?: 'de' | 'en';
    /**
     * End date for consumption data (ISO string)
     */
    to: string;
    /**
     * End date for consumption data (ISO string)
     */
    to: string;
};

export type SankeyControllerGetMeterViewSankeyResponse = SankeyGetResponseDto;

export type SankeyControllerGetMeterViewSankeyCsvData = {
    /**
     * Start date for consumption data (ISO string)
     */
    from: string;
    /**
     * Start date for consumption data (ISO string)
     */
    from: string;
    /**
     * Meter view ID
     */
    id: number;
    /**
     * Language for localized Sankey labels. Defaults to German.
     */
    lang?: 'de' | 'en';
    /**
     * Language for localized Sankey labels. Defaults to German.
     */
    lang?: 'de' | 'en';
    requestBody: SankeyCsvExportRequestDto;
    /**
     * End date for consumption data (ISO string)
     */
    to: string;
    /**
     * End date for consumption data (ISO string)
     */
    to: string;
};

export type SankeyControllerGetMeterViewSankeyCsvResponse = unknown;

export type MeterViewControllerFindAllData = {
    /**
     * Filter by company ID
     */
    companyId: number;
    /**
     * Filter by company ID
     */
    companyId: number;
};

export type MeterViewControllerFindAllResponse = MeterViewListResponseDto;

export type MeterViewControllerCreateData = {
    /**
     * Meter view creation data
     */
    requestBody: CreateMeterViewDto;
};

export type MeterViewControllerCreateResponse = MeterViewDto;

export type MeterViewControllerFindByIdData = {
    /**
     * Start date for consumption data (ISO string)
     */
    from: string;
    /**
     * Start date for consumption data (ISO string)
     */
    from: string;
    /**
     * Meter view ID
     */
    id: number;
    /**
     * End date for consumption data (ISO string)
     */
    to: string;
    /**
     * End date for consumption data (ISO string)
     */
    to: string;
};

export type MeterViewControllerFindByIdResponse = MeterViewDto;

export type MeterViewControllerUpdateData = {
    /**
     * Meter view ID
     */
    id: number;
    /**
     * Meter view update data
     */
    requestBody: UpdateMeterViewDto;
};

export type MeterViewControllerUpdateResponse = MeterViewDto;

export type MeterViewControllerDeleteData = {
    /**
     * Meter view ID
     */
    id: number;
};

export type MeterViewControllerDeleteResponse = void;

export type MeterViewControllerCreateNodeData = {
    /**
     * Meter view ID
     */
    id: number;
    /**
     * Node creation data
     */
    requestBody: CreateViewNodeDto;
};

export type MeterViewControllerCreateNodeResponse = ViewNodeDto;

export type MeterViewControllerDeleteNodeData = {
    /**
     * Meter view ID
     */
    id: number;
    /**
     * Node ID
     */
    nodeId: number;
};

export type MeterViewControllerDeleteNodeResponse = void;

export type MeterViewControllerUpdateFolderNameData = {
    /**
     * Meter view ID
     */
    id: number;
    /**
     * Folder node ID
     */
    nodeId: number;
    /**
     * Folder name update
     */
    requestBody: {
        /**
         * New folder name
         */
        name: string;
    };
};

export type MeterViewControllerUpdateFolderNameResponse = unknown | void;

export type MeterViewControllerUpdateNodeParentData = {
    /**
     * Meter view ID
     */
    id: number;
    /**
     * Node ID
     */
    nodeId: number;
    /**
     * Parent node update
     */
    requestBody: UpdateNodeParentDto;
};

export type MeterViewControllerUpdateNodeParentResponse = void;

export type InvoicesControllerBatchCreatePastInvoicesResponse = unknown;

export type InvoicesControllerBatchCreateScheduledInvoicesResponse = unknown;

export type InvoicesControllerRecreateYearInvoicesForCompanyData = {
    requestBody: RecreateBulkInvoicesDto;
};

export type InvoicesControllerRecreateYearInvoicesForCompanyResponse = unknown;

export type InvoicesControllerGetInvoicesData = {
    /**
     * Filter by building ID
     */
    buildingId: number;
    /**
     * Filter by company ID
     */
    companyId: number;
    /**
     * Filter by location ID
     */
    locationId: number;
    /**
     * Page number (1-based)
     */
    page: number;
    /**
     * Items per page
     */
    pageSize: number;
};

export type InvoicesControllerGetInvoicesResponse = InvoicePageableResponseListDto;

export type InvoicesControllerGetProcurementInvoicesData = {
    /**
     * Filter by building ID
     */
    buildingId: number;
    /**
     * Filter by company ID
     */
    companyId: number;
    /**
     * Filter by location ID
     */
    locationId: number;
    /**
     * Page number (1-based)
     */
    page: number;
    /**
     * Items per page
     */
    pageSize: number;
};

export type InvoicesControllerGetProcurementInvoicesResponse = InvoicePageableResponseListDto;

export type InvoicesControllerUpdateStatusData = {
    invoiceId: number;
    requestBody: PatchInvoiceStatusDto;
};

export type InvoicesControllerUpdateStatusResponse = InvoiceResponseDto;

export type InvoicesControllerUpdateCostDetailsData = {
    invoiceId: number;
    requestBody: CostDetailsDto;
};

export type InvoicesControllerUpdateCostDetailsResponse = InvoiceResponseDto;

export type InvoicesControllerUpdateOcrCostDetailsData = {
    invoiceId: number;
    requestBody: OcrExtractedCostDetailsDto;
};

export type InvoicesControllerUpdateOcrCostDetailsResponse = InvoiceResponseDto;

export type InvoicesControllerUpdateOcrCostVerificationData = {
    invoiceId: number;
    requestBody: UpdateCostVerificationOverrideDto;
};

export type InvoicesControllerUpdateOcrCostVerificationResponse = InvoiceResponseDto;

export type InvoicesControllerUpdateNotesData = {
    invoiceId: number;
    requestBody: PatchInvoiceNotesDto;
};

export type InvoicesControllerUpdateNotesResponse = InvoiceResponseDto;

export type InvoicesControllerUploadExternalInvoiceData = {
    id: number;
    invoiceId: number;
};

export type InvoicesControllerUploadExternalInvoiceResponse = InvoiceResponseDto | void;

export type InvoicesControllerDeleteInvoiceFileData = {
    invoiceId: number;
};

export type InvoicesControllerDeleteInvoiceFileResponse = void;

export type InvoicesControllerUploadInvoiceToMeterData = {
    deviceId: string;
};

export type InvoicesControllerUploadInvoiceToMeterResponse = InvoiceResponseDto | void;

export type InvoicesControllerUploadExternalInvoiceLegacyData = {
    id: number;
    invoiceId: number;
};

export type InvoicesControllerUploadExternalInvoiceLegacyResponse = InvoiceResponseDto | void;

export type InvoicesControllerDeleteInvoiceData = {
    invoiceId: number;
};

export type InvoicesControllerDeleteInvoiceResponse = void;

export type InvoicesControllerGetInvoiceByIdData = {
    invoiceId: number;
};

export type InvoicesControllerGetInvoiceByIdResponse = InvoiceResponseDto;

export type InvoicesControllerGetProcurementInvoiceByIdData = {
    invoiceId: number;
};

export type InvoicesControllerGetProcurementInvoiceByIdResponse = InvoiceResponseDto;

export type ManualInvoicePositionsControllerFindByLocationAndPeriodData = {
    /**
     * Location ID
     */
    locationId: number;
    /**
     * Month
     */
    month: number;
    /**
     * Year
     */
    year: number;
};

export type ManualInvoicePositionsControllerFindByLocationAndPeriodResponse = Array<ManualInvoicePositionDto>;

export type ManualInvoicePositionsControllerCreateData = {
    requestBody: CreateManualInvoicePositionRequestDto;
};

export type ManualInvoicePositionsControllerCreateResponse = ManualInvoicePositionDto;

export type ManualInvoicePositionsControllerUpdateData = {
    /**
     * Manual invoice position ID
     */
    id: number;
    requestBody: UpdateManualInvoicePositionRequestDto;
};

export type ManualInvoicePositionsControllerUpdateResponse = ManualInvoicePositionDto;

export type ManualInvoicePositionsControllerDeleteData = {
    /**
     * Manual invoice position ID
     */
    id: number;
};

export type ManualInvoicePositionsControllerDeleteResponse = void;

export type InsightsControllerGetInsightsData = {
    /**
     * Device id
     */
    deviceId: string;
    /**
     * End date (ISO 8601 string)
     */
    endDate?: string;
    /**
     * Start date (ISO 8601 string)
     */
    startDate?: string;
};

export type InsightsControllerGetInsightsResponse = Array<InsightsResponseDto>;

export type DataIngesterControllerSendDataFetchCommandData = {
    requestBody: FetchConsumptionDto;
};

export type DataIngesterControllerSendDataFetchCommandResponse = unknown;

export type SmaControllerUpdateTokenData = {
    code: string;
    companyId: string;
};

export type SmaControllerUpdateTokenResponse = unknown;

export type EnetControllerGetNetworkCostsData = {
    energyType: 'electricity' | 'gas' | 'water' | 'pressurizedAir' | 'heating' | 'fuels' | 'fluidGas';
    /**
     * Supply period start (YYYY-MM-DD)
     */
    from: string;
    /**
     * Location to fetch network costs for
     */
    locationId: number;
    /**
     * Supply period end (YYYY-MM-DD)
     */
    to: string;
    /**
     * Grid voltage level. Required for electricity (ENET mandates it); ignored for gas.
     */
    voltageLevel?: 'HSP' | 'HSP_MSP_UMSP' | 'MSP' | 'MSP_NSP_UMSP' | 'NSP';
};

export type EnetControllerGetNetworkCostsResponse = {
    [key: string]: unknown;
};

export type EnetControllerGetConcessionFeeData = {
    /**
     * Energy type. Electricity returns two customer groups; gas returns three.
     */
    energyType: 'electricity' | 'gas';
    /**
     * Supply period start (YYYY-MM-DD)
     */
    from: string;
    /**
     * Location to fetch the concession fee for
     */
    locationId: number;
    /**
     * Supply period end (YYYY-MM-DD)
     */
    to: string;
};

export type EnetControllerGetConcessionFeeResponse = {
    [key: string]: unknown;
};

export type EnetControllerGetSpecialGridUsageData = {
    /**
     * Supply period start (YYYY-MM-DD)
     */
    from: string;
    /**
     * Location to fetch the special grid usage surcharge for
     */
    locationId: number;
    /**
     * Supply period end (YYYY-MM-DD)
     */
    to: string;
};

export type EnetControllerGetSpecialGridUsageResponse = {
    [key: string]: unknown;
};

export type EnetControllerGetEnergyTaxData = {
    /**
     * Energy type. Electricity returns Stromsteuer; gas returns Energiesteuer.
     */
    energyType: 'electricity' | 'gas';
    /**
     * Supply period start (YYYY-MM-DD)
     */
    from: string;
    /**
     * Supply period end (YYYY-MM-DD)
     */
    to: string;
};

export type EnetControllerGetEnergyTaxResponse = {
    [key: string]: unknown;
};

export type EnetControllerGetGasRlmMeteringData = {
    /**
     * Supply period start (YYYY-MM-DD)
     */
    from: string;
    /**
     * Location to fetch gas RLM metering fees for
     */
    locationId: number;
    /**
     * Meter kind (zaehler.geraetetyp). Required together with pressureLevel and meterSize.
     */
    meterKind?: 'BALGENGASZAEHLER' | 'DREHKOLBENGASZAEHLER' | 'TURBINENRADGASZAEHLER';
    /**
     * Meter size (zaehler.geraetemerkmal). Required together with pressureLevel and meterKind.
     */
    meterSize?: string;
    /**
     * Gas pressure level (messebene). Required together with meterSize and meterKind.
     */
    pressureLevel?: 'ND' | 'MD' | 'HD';
    /**
     * Supply period end (YYYY-MM-DD)
     */
    to: string;
};

export type EnetControllerGetGasRlmMeteringResponse = {
    [key: string]: unknown;
};

export type EnetControllerGetElectricityLeviesData = {
    /**
     * Supply period start (YYYY-MM-DD)
     */
    from: string;
    /**
     * Supply period end (YYYY-MM-DD)
     */
    to: string;
};

export type EnetControllerGetElectricityLeviesResponse = {
    [key: string]: unknown;
};

export type EnetControllerGetGasLeviesData = {
    /**
     * Supply period start (YYYY-MM-DD)
     */
    from: string;
    /**
     * Supply period end (YYYY-MM-DD)
     */
    to: string;
};

export type EnetControllerGetGasLeviesResponse = {
    [key: string]: unknown;
};

export type EnetControllerGetGasRlmEnergyZonesData = {
    /**
     * Supply period start (YYYY-MM-DD)
     */
    from: string;
    /**
     * Location to fetch gas RLM energy zones for
     */
    locationId: number;
    /**
     * Gas pressure level (netzebene) that selects the network price sheet.
     */
    pressureLevel: 'ND' | 'MD' | 'HD';
    /**
     * Supply period end (YYYY-MM-DD)
     */
    to: string;
};

export type EnetControllerGetGasRlmEnergyZonesResponse = Array<{
    [key: string]: unknown;
}>;

export type EnetControllerGetGasRlmPeakZonesData = {
    /**
     * Supply period start (YYYY-MM-DD)
     */
    from: string;
    /**
     * Location to fetch gas RLM peak zones for
     */
    locationId: number;
    /**
     * Gas pressure level (netzebene) that selects the network price sheet.
     */
    pressureLevel: 'ND' | 'MD' | 'HD';
    /**
     * Supply period end (YYYY-MM-DD)
     */
    to: string;
};

export type EnetControllerGetGasRlmPeakZonesResponse = Array<{
    [key: string]: unknown;
}>;

export type LogsControllerFindGapLogsByTimestampResponse = {
    [key: string]: unknown;
};

export type LogsControllerFindIngestionLogsData = {
    apiProviderTitle: string;
    date: string;
};

export type LogsControllerFindIngestionLogsResponse = unknown;

export type ReportsControllerGetReportRecipientsData = {
    companyId: number;
    locationId: number;
    reportType: string;
};

export type ReportsControllerGetReportRecipientsResponse = unknown[];

export type MultivariateLinearRegressionControllerCreateRegressionData = {
    requestBody: CreateMultivariateLinearRegressionDto;
};

export type MultivariateLinearRegressionControllerCreateRegressionResponse = MultivariateLinearRegressionResponse;

export type MultivariateLinearRegressionControllerGetAllRegressionsData = {
    /**
     * Company ID to filter regressions. Required if locationId is not provided.
     */
    companyId?: number;
    dateRange?: unknown[];
    /**
     * Location ID to filter regressions. Required if companyId is not provided.
     */
    locationId?: number;
    /**
     * Page number (1-based)
     */
    page: number;
    /**
     * Items per page
     */
    pageSize: number;
    /**
     * Field to sort regressions by. Default is "createdAt".
     */
    sortBy?: 'createdAt' | 'title';
    /**
     * Sort order for regressions. Default is "DESC". Case-insensitive.
     */
    sortOrder?: 'ASC' | 'DESC';
};

export type MultivariateLinearRegressionControllerGetAllRegressionsResponse = MultivariateLinearRegressionPageableResponseList;

export type MultivariateLinearRegressionControllerUpdateRegressionData = {
    id: number;
    requestBody: UpdateMultivariateLinearRegressionDto;
};

export type MultivariateLinearRegressionControllerUpdateRegressionResponse = MultivariateLinearRegressionResponse;

export type MultivariateLinearRegressionControllerGetRegressionByIdData = {
    id: string;
};

export type MultivariateLinearRegressionControllerGetRegressionByIdResponse = MultivariateLinearRegressionResponse;

export type MultivariateLinearRegressionControllerDeleteRegressionData = {
    id: number;
};

export type MultivariateLinearRegressionControllerDeleteRegressionResponse = unknown | void;

export type MultivariateLinearRegressionControllerGetActualVsModelSeriesData = {
    /**
     * Start of the range (ISO date string)
     */
    from: string;
    id: number;
    /**
     * End of the range (ISO date string)
     */
    to: string;
};

export type MultivariateLinearRegressionControllerGetActualVsModelSeriesResponse = ActualVsModelSeriesResponse;

export type BaselineControllerFindAllData = {
    /**
     * At least one of companyId or locationId is required
     */
    companyId?: string;
    filtersDateRange0?: unknown;
    filtersDateRange1?: unknown;
    limit?: string;
    /**
     * At least one of companyId or locationId is required
     */
    locationId?: string;
    page?: string;
    sortBy?: 'createdAt' | 'fullName' | 'energySavings' | 'currentEnPI.value' | 'name';
    sortOrder?: 'ASC' | 'DESC';
};

export type BaselineControllerFindAllResponse = {
    [key: string]: unknown;
};

export type BaselineControllerCreateData = {
    requestBody: LegacyBaselinePayload;
};

export type BaselineControllerCreateResponse = unknown;

export type BaselineControllerGetAnalysisData = {
    id: number;
};

export type BaselineControllerGetAnalysisResponse = unknown;

export type BaselineControllerUpdateData = {
    id: number;
    requestBody: LegacyBaselinePayload;
};

export type BaselineControllerUpdateResponse = unknown;

export type BaselineControllerDeleteData = {
    id: number;
};

export type BaselineControllerDeleteResponse = void;

export type FeatureNewsControllerGetFeatureNewsData = {
    /**
     * Page number (1-based)
     */
    page: number;
    /**
     * Items per page
     */
    pageSize: number;
};

export type FeatureNewsControllerGetFeatureNewsResponse = Array<FeatureNewsDTO>;

export type BudgetControllerGetInvoicesData = {
    /**
     * Filter by building ID
     */
    buildingId?: number;
    /**
     * Filter by company ID
     */
    companyId?: number;
    /**
     * Filter by location ID
     */
    locationId?: number;
};

export type BudgetControllerGetInvoicesResponse = BudgetSummaryDto;

export type BudgetControllerGetInvoicesWithProcurementCostsData = {
    /**
     * Filter by building ID
     */
    buildingId?: number;
    /**
     * Filter by company ID
     */
    companyId?: number;
    /**
     * Filter by location ID
     */
    locationId?: number;
};

export type BudgetControllerGetInvoicesWithProcurementCostsResponse = BudgetSummaryDto;

export type UploadControllerUploadConsumptionFilesData = {
    formData: UploadConsumptionFilesDto;
};

export type UploadControllerUploadConsumptionFilesResponse = UploadConsumptionFilesDto | {
    [key: string]: unknown;
};

export type UploadControllerUploadDemoDevicesResponse = UploadDemoDevicesResponseDto;

export type UploadControllerUploadSlpManualConsumptionData = {
    companyId: number;
    formData: UploadSlpManualConsumptionDto;
};

export type UploadControllerUploadSlpManualConsumptionResponse = unknown;

export type ManualMeterUploadControllerTemplateData = {
    companyId: number;
    month: string;
};

export type ManualMeterUploadControllerTemplateResponse = unknown;

export type ManualMeterUploadControllerPreviewData = {
    companyId: number;
};

export type ManualMeterUploadControllerPreviewResponse = {
    [key: string]: unknown;
};

export type ManualMeterUploadControllerApplyData = {
    companyId: number;
};

export type ManualMeterUploadControllerApplyResponse = {
    [key: string]: unknown;
};

export type ManualMeterUploadControllerHistoryData = {
    companyId: number;
    page: string;
    search: string;
    sortBy: string;
    sortOrder: string;
};

export type ManualMeterUploadControllerHistoryResponse = unknown;

export type ManualMeterUploadControllerDetailData = {
    companyId: number;
    id: string;
};

export type ManualMeterUploadControllerDetailResponse = {
    [key: string]: unknown;
};

export type ManualMeterUploadControllerOriginalFileData = {
    companyId: number;
    id: string;
};

export type ManualMeterUploadControllerOriginalFileResponse = unknown;

export type ManualMeterUploadControllerRetryData = {
    companyId: number;
    id: string;
};

export type ManualMeterUploadControllerRetryResponse = {
    [key: string]: unknown;
};

export type NormalizerControllerCheckDevicesHealthData = {
    /**
     * Parameters for device healthcheck
     */
    requestBody: DevicesHealthCheckBodyDTO;
};

export type NormalizerControllerCheckDevicesHealthResponse = Array<DeviceHealthCheckResultDto> | unknown;

export type NormalizerControllerNormalizeData = {
    /**
     * Normalization parameters including devices and time periods
     */
    requestBody: NormalizeBodyDTO;
};

export type NormalizerControllerNormalizeResponse = unknown;

export type NormalizerControllerUpdateVirtualsAfterDataNormalizationData = {
    /**
     * Parameters for virtual series update
     */
    requestBody: UpdateVirtualsAfterNormalizationDTO;
};

export type NormalizerControllerUpdateVirtualsAfterDataNormalizationResponse = unknown;

export type NormalizerControllerSetupVirtualMetersData = {
    /**
     * Setup configuration with flags to control which operations to perform
     */
    requestBody: VirtualSetupBodyDTO;
};

export type NormalizerControllerSetupVirtualMetersResponse = unknown;

export type NormalizerControllerHandleManualNormalizedDataData = {
    requestBody: HandleManualNormalizedDataDto;
};

export type NormalizerControllerHandleManualNormalizedDataResponse = unknown;

export type MeterOverviewControllerGetOverviewData = {
    buildingId?: number;
    companyId: number;
    from: string;
    locationId?: number;
    regionId?: number;
    to: string;
};

export type MeterOverviewControllerGetOverviewResponse = MeterOverviewResponseDto;

export type MeterOverviewControllerGetElectricityBalanceData = {
    buildingId?: number;
    from: string;
    locationId: number;
    to: string;
};

export type MeterOverviewControllerGetElectricityBalanceResponse = MeterOverviewElectricityBalanceResponseDto;

export type MeterOverviewControllerCreateGroupData = {
    requestBody: CreateMeterOverviewGroupDto;
};

export type MeterOverviewControllerCreateGroupResponse = MeterOverviewGroupDto;

export type MeterOverviewControllerRenameGroupData = {
    groupId: number;
    requestBody: RenameMeterOverviewGroupDto;
};

export type MeterOverviewControllerRenameGroupResponse = void;

export type MeterOverviewControllerDeleteGroupData = {
    companyId: number;
    energyTypeId: number;
    groupId: number;
    locationId: number;
    measurementUnitId: number;
};

export type MeterOverviewControllerDeleteGroupResponse = void;

export type MeterOverviewControllerSetGroupMembershipData = {
    requestBody: SetMeterOverviewGroupMembershipDto;
};

export type MeterOverviewControllerSetGroupMembershipResponse = void;

export type VirtualMeterControllerCreateVirtualDeviceData = {
    requestBody: CreateVirtualDeviceDto;
};

export type VirtualMeterControllerCreateVirtualDeviceResponse = VirtualDeviceResponseDto;

export type VirtualMeterControllerDeleteVirtualDeviceData = {
    requestBody: DeleteVirtualDeviceDto;
};

export type VirtualMeterControllerDeleteVirtualDeviceResponse = void;

export type VirtualMeterControllerUpdateVirtualDeviceData = {
    /**
     * Device ID of the virtual meter to update
     */
    deviceId: string;
    requestBody: UpdateVirtualDeviceDto;
};

export type VirtualMeterControllerUpdateVirtualDeviceResponse = UpdateVirtualDeviceResponseDto;

export type LocationsInfoControllerGetLocationsInfoData = {
    /**
     * Company firebase id.
     */
    companyId: string;
    /**
     * Accepted for backward compatibility with the legacy endpoint and deliberately ignored — the user is derived from the auth context. Trusting a client-supplied user id here would allow reading another user’s locations.
     */
    userId?: string;
};

export type LocationsInfoControllerGetLocationsInfoResponse = unknown;

export type DeviceControllerGetDevicesByBuildingData = {
    /**
     * Building ID
     */
    buildingId: number;
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Location ID
     */
    locationId: number;
};

export type DeviceControllerGetDevicesByBuildingResponse = unknown;

export type DeviceControllerUpsertDeviceData = {
    requestBody: UpsertDeviceDto;
};

export type DeviceControllerUpsertDeviceResponse = DeviceListResponseDto;

export type DeviceControllerDeleteDeviceData = {
    /**
     * Building ID
     */
    buildingId: number;
    /**
     * Company ID
     */
    companyId: number;
    /**
     * Device ID
     */
    deviceId: number;
    /**
     * Location ID
     */
    locationId: number;
};

export type DeviceControllerDeleteDeviceResponse = unknown;

export type ForecastControllerFindAllData = {
    /**
     * Filter by company ID
     */
    companyId?: number;
    /**
     * Filter by location ID
     */
    locationId?: number;
};

export type ForecastControllerFindAllResponse = Array<ForecastResponseDto>;

export type ForecastControllerCreateData = {
    /**
     * Create forecast data
     */
    requestBody: CreateForecastDto;
};

export type ForecastControllerCreateResponse = ForecastResponseDto;

export type ForecastControllerFindOneByIdData = {
    /**
     * Forecast ID
     */
    forecastId: number;
};

export type ForecastControllerFindOneByIdResponse = ForecastResponseDto;

export type ForecastControllerGetForecastDataData = {
    /**
     * Forecast ID
     */
    forecastId: number;
};

export type ForecastControllerGetForecastDataResponse = ForecastDataResponseDto;

export type ForecastControllerPatchStateData = {
    /**
     * Forecast ID
     */
    forecastId: number;
    /**
     * Update forecast state
     */
    requestBody: PatchForecastStateDto;
};

export type ForecastControllerPatchStateResponse = ForecastResponseDto;

export type ForecastControllerCreateAdjustmentData = {
    /**
     * Forecast ID
     */
    forecastId: number;
    /**
     * Create adjustment data
     */
    requestBody: CreateAdjustmentDto;
};

export type ForecastControllerCreateAdjustmentResponse = AdjustmentResponseDto;

export type ForecastControllerUpdateAdjustmentData = {
    /**
     * Adjustment ID
     */
    adjustmentId: number;
    /**
     * Forecast ID
     */
    forecastId: number;
    /**
     * Update adjustment data
     */
    requestBody: UpdateAdjustmentDto;
};

export type ForecastControllerUpdateAdjustmentResponse = AdjustmentResponseDto;

export type ForecastControllerDeleteAdjustmentData = {
    /**
     * Adjustment ID
     */
    adjustmentId: number;
    /**
     * Forecast ID
     */
    forecastId: number;
};

export type ForecastControllerDeleteAdjustmentResponse = void;

export type ForecastControllerPatchAdjustmentActiveData = {
    /**
     * Adjustment ID
     */
    adjustmentId: number;
    /**
     * Forecast ID
     */
    forecastId: number;
    /**
     * Update adjustment active state
     */
    requestBody: PatchAdjustmentActiveDto;
};

export type ForecastControllerPatchAdjustmentActiveResponse = AdjustmentResponseDto;

export type ShortTermForecastControllerGetShortTermForecastData = {
    /**
     * Building ID
     */
    buildingId?: number;
    /**
     * Company ID
     */
    companyId?: number;
    /**
     * Type of data to return (energy or power)
     */
    dataType?: 'energy' | 'power';
    /**
     * Device ID
     */
    deviceId?: string;
    /**
     * Start datetime (minute precision)
     */
    from: string;
    /**
     * Forecast granularity in minutes (15 = quarter-hourly, 60 = hourly, 1440 = daily)
     */
    granularity?: 15 | 60 | 1440;
    /**
     * Location ID
     */
    locationId?: number;
    /**
     * End datetime (minute precision)
     */
    to: string;
};

export type ShortTermForecastControllerGetShortTermForecastResponse = ShortTermForecastResponseDto;

export type LoadAdjustmentControllerFindAllData = {
    /**
     * Filter by company ID
     */
    companyId?: number;
    energyType: AdjustmentEnergyTypeDto;
    /**
     * Filter by location ID
     */
    locationId?: number;
    /**
     * Filter by year
     */
    year: number;
};

export type LoadAdjustmentControllerFindAllResponse = LoadAdjustmentListResponseDto;

export type LoadAdjustmentControllerCreateData = {
    /**
     * Load adjustment data
     */
    requestBody: CreateLoadAdjustmentDto;
};

export type LoadAdjustmentControllerCreateResponse = LoadAdjustmentResponseDto;

export type LoadAdjustmentControllerFindOneData = {
    /**
     * Load adjustment ID
     */
    id: number;
};

export type LoadAdjustmentControllerFindOneResponse = LoadAdjustmentResponseDto;

export type LoadAdjustmentControllerUpdateData = {
    /**
     * Load adjustment ID
     */
    id: number;
    /**
     * Updated load adjustment data
     */
    requestBody: UpdateLoadAdjustmentDto;
};

export type LoadAdjustmentControllerUpdateResponse = LoadAdjustmentResponseDto;

export type LoadAdjustmentControllerDeleteData = {
    id: number;
};

export type LoadAdjustmentControllerDeleteResponse = void;

export type LoadAdjustmentControllerActivateData = {
    /**
     * Load adjustment ID
     */
    id: number;
};

export type LoadAdjustmentControllerActivateResponse = LoadAdjustmentResponseDto;

export type LoadAdjustmentControllerDeactivateData = {
    /**
     * Load adjustment ID
     */
    id: number;
};

export type LoadAdjustmentControllerDeactivateResponse = LoadAdjustmentResponseDto;

export type LoadPlanningForecastControllerGetForecastData = {
    /**
     * Filter by company ID
     */
    companyId?: number;
    energyType: AdjustmentEnergyTypeDto;
    granularity?: ForecastGranularityDto;
    /**
     * Filter by location ID
     */
    locationId?: number;
    /**
     * Filter by year
     */
    year: number;
};

export type LoadPlanningForecastControllerGetForecastResponse = LoadForecastDataDto;

export type NaceCodeControllerGetAllCodesResponse = Array<NaceCode>;

export type MachineCategoryControllerGetAllCategoriesResponse = Array<MachineCategoryDto>;

export type MeterDocumentControllerGetMeterDocumentsData = {
    /**
     * The meter ID to filter documents
     */
    meterId: number;
};

export type MeterDocumentControllerGetMeterDocumentsResponse = Array<MeterDocumentResponseDto>;

export type MeterDocumentControllerCreateMeterDocumentData = {
    requestBody: CreateMeterDocumentDto;
};

export type MeterDocumentControllerCreateMeterDocumentResponse = MeterDocumentResponseDto;

export type MeterDocumentControllerDeleteMeterDocumentData = {
    /**
     * Meter document ID
     */
    id: number;
};

export type MeterDocumentControllerDeleteMeterDocumentResponse = void;

export type MeterDocumentControllerDownloadData = {
    /**
     * Meter document ID
     */
    id: number;
};

export type MeterDocumentControllerDownloadResponse = (Blob | File);

export type UiPreferenceControllerGetPreferenceData = {
    key: 'messstellen-table';
};

export type UiPreferenceControllerGetPreferenceResponse = UiPreferenceResponseDto;

export type UiPreferenceControllerUpdatePreferenceData = {
    key: 'messstellen-table';
    requestBody: UpdateUiPreferenceRequestBody;
};

export type UiPreferenceControllerUpdatePreferenceResponse = UiPreferenceResponseDto;

export type InsightInboxControllerCreateData = {
    /**
     * Create insight
     */
    requestBody: CreateInsightInboxDto;
};

export type InsightInboxControllerCreateResponse = FetchOneInsightInboxDto;

export type InsightInboxControllerFindAllData = {
    /**
     * Filter by assignee user ID (across all statuses)
     */
    assigneeId?: number;
    /**
     * Filter by building ID
     */
    buildingId?: number;
    /**
     * Filter by category (can be multiple, OR-ed together)
     */
    categories?: Array<InsightInboxCategoryEnum>;
    /**
     * Filter by company ID
     */
    companyId?: number;
    /**
     * Filter by end date (ISO 8601 string)
     */
    endDate?: string;
    /**
     * Filter by energy type (can be multiple, OR-ed together)
     */
    energyTypes?: Array<InsightEnergyTypeEnum>;
    /**
     * Grouping dimension. "none" (default) returns the flat paginated list. "meter" groups by deviceId (an insight appears in every one of its deviceId groups). "category" groups by category. "location" groups by location (an insight appears in every one of its location groups). When set, the response is InsightInboxGroupedResponseListDto.
     */
    groupBy?: InsightInboxGroupByEnum;
    /**
     * Customer visibility filter. Omitted returns released insights only. `true` returns the not-yet-released review set and is restricted to the insights admin.
     */
    isHidden?: boolean;
    /**
     * Filter by location ID
     */
    locationId?: number;
    /**
     * Page number for pagination
     */
    page?: number;
    /**
     * Number of items per page
     */
    pageSize?: number;
    /**
     * Filter by priority (can be multiple)
     */
    priorities?: Array<('LOW' | 'MEDIUM' | 'HIGH')>;
    /**
     * Sort by field
     */
    sortBy?: 'priority' | 'createdAt';
    /**
     * Sort order
     */
    sortOrder?: 'ASC' | 'DESC';
    /**
     * Filter by start date (ISO 8601 string)
     */
    startDate?: string;
    /**
     * Filter by status (can be multiple)
     */
    statuses?: Array<('NEW' | 'DISMISSED' | 'INVESTIGATION' | 'CONVERTED_TO_MEASURE' | 'RESOLVED')>;
};

export type InsightInboxControllerFindAllResponse = InsightInboxFetchResponseListDto | InsightInboxGroupedResponseListDto;

export type InsightInboxControllerGetDismissalReasonConfigResponse = DismissalReasonConfigDto;

export type InsightInboxControllerFindOneData = {
    id: number;
};

export type InsightInboxControllerFindOneResponse = FetchOneInsightInboxDto;

export type InsightInboxControllerUpdateData = {
    id: number;
    /**
     * Update insight
     */
    requestBody: UpdateInsightInboxDto;
};

export type InsightInboxControllerUpdateResponse = FetchOneInsightInboxDto;

export type InsightInboxControllerDeleteData = {
    id: number;
};

export type InsightInboxControllerDeleteResponse = void;

export type InsightInboxControllerGetChangeHistoryData = {
    id: number;
};

export type InsightInboxControllerGetChangeHistoryResponse = Array<ObjectChangeHistoryDto>;

export type InsightInboxControllerBulkResolveData = {
    /**
     * Resolve multiple insights
     */
    requestBody: BulkResolveInsightDto;
};

export type InsightInboxControllerBulkResolveResponse = BulkInsightActionResultDto;

export type InsightInboxControllerBulkDismissData = {
    /**
     * Dismiss multiple insights
     */
    requestBody: BulkDismissInsightDto;
};

export type InsightInboxControllerBulkDismissResponse = BulkInsightActionResultDto;

export type InsightInboxControllerBulkDismissGroupedData = {
    /**
     * Dismiss a mixed selection, grouped by category with a per-group reason
     */
    requestBody: BulkDismissGroupedDto;
};

export type InsightInboxControllerBulkDismissGroupedResponse = BulkInsightActionResultDto;

export type InsightInboxControllerBulkAssignData = {
    /**
     * Assign multiple insights
     */
    requestBody: BulkAssignInsightDto;
};

export type InsightInboxControllerBulkAssignResponse = BulkInsightActionResultDto;

export type InsightInboxControllerBulkSetVisibilityData = {
    /**
     * Release or hide multiple insights
     */
    requestBody: BulkUpdateInsightVisibilityDto;
};

export type InsightInboxControllerBulkSetVisibilityResponse = BulkInsightActionResultDto;

export type InsightInboxControllerSetVisibilityData = {
    id: number;
    /**
     * Release or hide the insight
     */
    requestBody: UpdateInsightVisibilityDto;
};

export type InsightInboxControllerSetVisibilityResponse = FetchOneInsightInboxDto;

export type InsightInboxControllerInvestigateData = {
    id: number;
};

export type InsightInboxControllerInvestigateResponse = FetchOneInsightInboxDto;

export type InsightInboxControllerConvertData = {
    id: number;
};

export type InsightInboxControllerConvertResponse = FetchOneInsightInboxDto;

export type InsightInboxControllerResolveData = {
    id: number;
    /**
     * Resolve insight
     */
    requestBody: ResolveInsightDto;
};

export type InsightInboxControllerResolveResponse = FetchOneInsightInboxDto;

export type InsightInboxControllerDismissData = {
    id: number;
    /**
     * Dismiss insight
     */
    requestBody: DismissInsightDto;
};

export type InsightInboxControllerDismissResponse = FetchOneInsightInboxDto;

export type InsightInboxControllerAssignData = {
    id: number;
    /**
     * Assign user to insight
     */
    requestBody: AssignInsightDto;
};

export type InsightInboxControllerAssignResponse = FetchOneInsightInboxDto;

export type InsightInboxControllerMarkViewedData = {
    id: number;
};

export type InsightInboxControllerMarkViewedResponse = void;

export type InsightInboxManualControllerCreateBaseloadBenchmarkData = {
    /**
     * Manually create a Baseload Benchmark insight
     */
    requestBody: CreateBaseloadBenchmarkInsightDto;
};

export type InsightInboxManualControllerCreateBaseloadBenchmarkResponse = FetchOneInsightInboxDto;

export type InsightInboxManualControllerCreateBaseloadTrendData = {
    /**
     * Manually create a Baseload Trend insight
     */
    requestBody: CreateBaseloadTrendInsightDto;
};

export type InsightInboxManualControllerCreateBaseloadTrendResponse = FetchOneInsightInboxDto;

export type InsightSettingsControllerGetForLocationsData = {
    /**
     * Locations whose meters are returned
     */
    locationIds: Array<(number)>;
};

export type InsightSettingsControllerGetForLocationsResponse = InsightInboxSettingsListDto;

export type InsightSettingsControllerGetRecommendationsForLocationsData = {
    /**
     * Locations whose meters are returned
     */
    locationIds: Array<(number)>;
};

export type InsightSettingsControllerGetRecommendationsForLocationsResponse = InsightInboxSettingsListDto;

export type InsightSettingsControllerUpsertManyData = {
    requestBody: BulkUpsertInsightInboxSettingsDto;
};

export type InsightSettingsControllerUpsertManyResponse = InsightInboxSettingsListDto;

export type InsightSettingsControllerApplyRecommendationsData = {
    requestBody: ApplyInsightRecommendationsDto;
};

export type InsightSettingsControllerApplyRecommendationsResponse = InsightInboxSettingsListDto;

export type InsightSettingsControllerGetForMeterData = {
    /**
     * The meter whose insight settings to fetch
     */
    meterId: number;
};

export type InsightSettingsControllerGetForMeterResponse = InsightInboxSettingsResponseDto;

export type InsightSettingsControllerUpsertForMeterData = {
    /**
     * The meter the settings belong to
     */
    meterId: number;
    requestBody: UpsertInsightInboxSettingsDto;
};

export type InsightSettingsControllerUpsertForMeterResponse = InsightInboxSettingsResponseDto;

export type InsightSettingsControllerPatchForMeterData = {
    /**
     * The meter the settings belong to
     */
    meterId: number;
    requestBody: PatchInsightInboxSettingsDto;
};

export type InsightSettingsControllerPatchForMeterResponse = InsightInboxSettingsResponseDto;

export type InsightSettingsControllerGetRecommendationForMeterData = {
    /**
     * The meter whose recommended insight settings to compute
     */
    meterId: number;
};

export type InsightSettingsControllerGetRecommendationForMeterResponse = InsightInboxSettingsResponseDto;

export type InsightSettingsControllerApplyRecommendationForMeterData = {
    /**
     * The meter the settings belong to
     */
    meterId: number;
};

export type InsightSettingsControllerApplyRecommendationForMeterResponse = InsightInboxSettingsResponseDto;

export type LocationProductionScheduleControllerGetForCallerResponse = LocationProductionSchedulesResponseDto;

export type LocationProductionScheduleControllerUpsertForLocationData = {
    /**
     * The location the schedule belongs to
     */
    locationId: number;
    requestBody: ProductionScheduleDto;
};

export type LocationProductionScheduleControllerUpsertForLocationResponse = LocationProductionScheduleDto;

export type LocationProductionScheduleControllerBulkUpsertData = {
    requestBody: BulkUpsertLocationProductionSchedulesDto;
};

export type LocationProductionScheduleControllerBulkUpsertResponse = LocationProductionSchedulesResponseDto;

export type InsightsOnboardingControllerGetStateResponse = InsightsOnboardingStateDto;

export type InsightsOnboardingControllerStartResponse = InsightsOnboardingStateDto;

export type InsightsOnboardingControllerCompleteResponse = InsightsOnboardingStateDto;

export type InvitationControllerValidateData = {
    /**
     * Raw invitation token from the email link
     */
    token: string;
};

export type InvitationControllerValidateResponse = ValidateInvitationResponseDto;

export type InvitationControllerAcceptData = {
    requestBody: AcceptInvitationDto;
};

export type InvitationControllerAcceptResponse = unknown;

export type InvitationControllerFindUserManagementPageData = {
    /**
     * Company ID whose users and invitations should be listed
     */
    companyId: number;
    /**
     * Page number (1-based)
     */
    page: number;
    /**
     * Items per page
     */
    pageSize?: number;
    /**
     * Search visible user name, email, company role, permission, location access, or invitation status
     */
    search?: string;
    sortBy?: 'user' | 'companyRole' | 'roleType';
    sortDirection?: 'asc' | 'desc';
};

export type InvitationControllerFindUserManagementPageResponse = UserManagementListResponseDto;

export type InvitationControllerFindAllData = {
    /**
     * Company ID to list invitations for
     */
    companyId: number;
};

export type InvitationControllerFindAllResponse = Array<InvitationResponseDto>;

export type InvitationControllerCreateData = {
    requestBody: CreateInvitationDto;
};

export type InvitationControllerCreateResponse = InvitationResponseDto;

export type InvitationControllerUpdateData = {
    /**
     * Invitation ID
     */
    id: number;
    requestBody: UpdateInvitationDto;
};

export type InvitationControllerUpdateResponse = InvitationResponseDto;

export type InvitationControllerRevokeData = {
    /**
     * Invitation ID
     */
    id: number;
};

export type InvitationControllerRevokeResponse = void;

export type SavingsFlowControllerCreateMeasureFromInsightData = {
    id: number;
    /**
     * Create a measure from this insight
     */
    requestBody: CreateIsoMeasureDto;
};

export type SavingsFlowControllerCreateMeasureFromInsightResponse = FetchOneInsightInboxDto;

export type PublicHolidaysControllerFindForLocationData = {
    /**
     * ISO 3166-1 alpha-2 country code override. If omitted, inferred from the location postal code (fallback DE).
     */
    countryIsoCode?: string;
    /**
     * ISO 639-1 language code for holiday names (e.g. DE, EN). Defaults to DE.
     */
    languageIsoCode?: string;
    locationId: number;
    /**
     * ISO 3166-2 subdivision code override (e.g. DE-BY). If omitted, inferred from the location postal code.
     */
    subdivisionCode?: string;
    /**
     * Start of the range (YYYY-MM-DD)
     */
    validFrom: string;
    /**
     * End of the range (YYYY-MM-DD). Range must not exceed 3 years.
     */
    validTo: string;
};

export type PublicHolidaysControllerFindForLocationResponse = PublicHolidaysResponseDto;

export type PublicHolidaysControllerFindByParamsData = {
    /**
     * ISO 3166-1 alpha-2 country code
     */
    countryIsoCode: string;
    /**
     * ISO 639-1 language code for holiday names. Defaults to DE.
     */
    languageIsoCode?: string;
    /**
     * Postal code used to infer the subdivision when subdivisionCode is not provided. DE 5-digit and AT 4-digit supported.
     */
    postalCode?: string;
    /**
     * ISO 3166-2 subdivision code (e.g. DE-BY). Takes precedence over postal code inference.
     */
    subdivisionCode?: string;
    /**
     * Start of the range (YYYY-MM-DD)
     */
    validFrom: string;
    /**
     * End of the range (YYYY-MM-DD). Range must not exceed 3 years.
     */
    validTo: string;
};

export type PublicHolidaysControllerFindByParamsResponse = PublicHolidaysResponseDto;

export type SubmeterAttributionControllerGetAttributionData = {
    /**
     * When true, return every meter below the main meter in the infrastructure hierarchy, including intermediate ones whose consumption overlaps their children. By default only the leaves of the hierarchy below the main meter are returned. Either way, only measured (not virtual, SLP or generation) meters of the main meter's energy type are included.
     */
    includeAllSubmeters?: boolean;
    /**
     * When true, each meter also carries its 15min series (only the intervals inside the windows), e.g. to plot the load's time course.
     */
    includeSeries?: boolean;
    /**
     * Main meter ID
     */
    meterId: number;
    /**
     * The windows to aggregate over, repeated once per window, each as an ISO 8601 interval "start/end" (at most 100). A 15min interval belongs to a window when its end timestamp lies in (start, end]; overlapping windows count each interval once.
     */
    window: Array<(string)>;
};

export type SubmeterAttributionControllerGetAttributionResponse = SubmeterAttributionResponseDto;

export type $OpenApiTs = {
    '/': {
        get: {
            res: {
                200: unknown;
            };
        };
    };
    '/auth/login': {
        post: {
            req: AuthControllerLoginData;
            res: {
                /**
                 * Returns token and user information upon valid credentials
                 */
                200: AuthDto;
            };
        };
    };
    '/auth/login/sso': {
        post: {
            req: AuthControllerSsoLoginData;
            res: {
                /**
                 * Processes SSO login and returns token and user information
                 */
                200: AuthDto;
                201: unknown;
            };
        };
    };
    '/auth/signup/sso': {
        post: {
            req: AuthControllerSsoSignupData;
            res: {
                /**
                 * Processes SSO signup and returns token and user information
                 */
                200: AuthDto;
                201: unknown;
            };
        };
    };
    '/auth/reset-password/email': {
        post: {
            req: AuthControllerSendPasswordResetEmailData;
            res: {
                /**
                 * Sends a reset password email to the user
                 */
                200: unknown;
            };
        };
    };
    '/auth/reset-password': {
        patch: {
            req: AuthControllerUpdatePasswordData;
            res: {
                /**
                 * Updates user password using a reset token
                 */
                200: unknown;
            };
        };
    };
    '/auth/reset-password/me': {
        patch: {
            req: AuthControllerSelfUpdatePasswordData;
            res: {
                /**
                 * Updates the authenticated user's own password
                 */
                200: unknown;
            };
        };
    };
    '/auth/update-email/{userId}': {
        patch: {
            req: AuthControllerUpdateEmailData;
            res: {
                /**
                 * Overrides the given user's email address, after verifying it is not already assigned to another user.
                 */
                200: unknown;
            };
        };
    };
    '/users': {
        get: {
            req: UserControllerGetUsersData;
            res: {
                /**
                 * List of users in the format the admin view expects. This will become the only interface of returning users in the future.
                 */
                200: Array<UserDto>;
                /**
                 * Invalid query parameters
                 */
                400: unknown;
            };
        };
        post: {
            req: UserControllerCreateData;
            res: {
                /**
                 * User created
                 */
                201: UpsertUserResponseDto;
            };
        };
        delete: {
            req: UserControllerDeleteUserData;
            res: {
                /**
                 * User deleted
                 */
                200: DeleteUserRequestDto;
            };
        };
    };
    '/users/frontend': {
        get: {
            req: UserControllerGetFrontendUsersData;
            res: {
                /**
                 * List of users in the format the frontend expects.
                 */
                200: Array<UserFrontendDto>;
                /**
                 * Invalid query parameters
                 */
                400: unknown;
            };
        };
    };
    '/users/{id}': {
        get: {
            req: UserControllerGetUserByIdData;
            res: {
                /**
                 * User associated with the specified user ID
                 */
                200: UserDto;
                /**
                 * Invalid query parameters
                 */
                400: unknown;
            };
        };
    };
    '/users/frontend/{id}': {
        get: {
            req: UserControllerGetFrontendUserByIdData;
            res: {
                /**
                 * User associated with the specified user ID formatted for the frontend.
                 */
                200: UserFrontendDto;
                /**
                 * Invalid query parameters
                 */
                400: unknown;
            };
        };
    };
    '/users/{userId}': {
        patch: {
            req: UserControllerUpdateData;
            res: {
                /**
                 * User updated
                 */
                200: UpsertUserResponseDto;
            };
        };
    };
    '/users/{userId}/locations': {
        patch: {
            req: UserControllerUpdateAssignedLocationsData;
            res: {
                /**
                 * User updated
                 */
                200: UpsertUserDto;
            };
        };
    };
    '/users/{userId}/companies/{companyId}/select': {
        post: {
            req: UserControllerSelectCompanyData;
            res: {
                /**
                 * Company selected successfully
                 */
                200: unknown;
                /**
                 * Forbidden: cannot select company for another user
                 */
                403: unknown;
                /**
                 * User or user-company relation not found
                 */
                404: unknown;
            };
        };
    };
    '/users/{userId}/companies': {
        post: {
            req: UserControllerAddUserCompanyData;
            res: {
                /**
                 * Company added successfully
                 */
                200: unknown;
                201: Array<UserCompanyResponseDto>;
                /**
                 * Bad Request: user is already assigned to this company or other validation error
                 */
                400: unknown;
                /**
                 * User not found
                 */
                404: unknown;
            };
        };
        put: {
            req: UserControllerSyncUserCompaniesData;
            res: {
                /**
                 * User company assignments synced successfully
                 */
                200: Array<UserCompanyResponseDto>;
                /**
                 * Bad Request: the company list is empty or fails validation
                 */
                400: unknown;
                /**
                 * User not found
                 */
                404: unknown;
            };
        };
    };
    '/users/{userId}/companies/{companyId}': {
        delete: {
            req: UserControllerRemoveUserCompanyData;
            res: {
                /**
                 * Company removed successfully
                 */
                200: unknown;
                /**
                 * Bad Request: user must remain assigned to at least one company
                 */
                400: unknown;
                /**
                 * Forbidden: only admins/consultants may remove another user from a company
                 */
                403: unknown;
                /**
                 * User or user-company relation not found
                 */
                404: unknown;
            };
        };
    };
    '/users/frontend/{userId}': {
        patch: {
            req: UserControllerPatchUserData;
            res: {
                /**
                 * User updated
                 */
                200: UserFrontendDto;
            };
        };
    };
    '/users/app-reload-required': {
        put: {
            req: UserControllerUpdateAppReloadRequiredForAllUsersData;
            res: {
                /**
                 * App reload required flag updated for all users
                 */
                200: unknown;
            };
        };
    };
    '/users/self/profile-picture': {
        get: {
            res: {
                /**
                 * Profile picture image
                 */
                200: (Blob | File);
                /**
                 * Profile picture not found
                 */
                404: unknown;
            };
        };
        post: {
            req: UserControllerUploadUserProfilePictureData;
            res: {
                /**
                 * Profile picture uploaded successfully
                 */
                201: unknown;
                /**
                 * Invalid or missing file
                 */
                400: unknown;
            };
        };
        delete: {
            res: {
                /**
                 * Profile picture deleted successfully
                 */
                200: unknown;
                /**
                 * Profile picture not found
                 */
                404: unknown;
            };
        };
    };
    '/users/{id}/profile-picture': {
        get: {
            req: UserControllerGetUserProfilePictureByIdData;
            res: {
                /**
                 * Profile picture image
                 */
                200: (Blob | File);
                /**
                 * User or profile picture not found
                 */
                404: unknown;
            };
        };
    };
    '/users/hydrate-queue': {
        put: {
            res: {
                /**
                 * Successfully hydrated user data to Kafka
                 */
                200: unknown;
            };
        };
    };
    '/tracing/trace-error': {
        post: {
            req: TracingControllerTraceErrorData;
            res: {
                201: unknown;
            };
        };
    };
    '/auth/sso/strategies/{slug}': {
        get: {
            req: SsoControllerGetCompanyStrategiesData;
            res: {
                200: Array<StrategyResponseDto>;
            };
        };
    };
    '/consultancies': {
        get: {
            res: {
                200: Array<ConsultancyDto>;
            };
        };
        post: {
            req: ConsultancyControllerCreateData;
            res: {
                201: ConsultancyDto;
            };
        };
    };
    '/consultancies/{id}': {
        get: {
            req: ConsultancyControllerGetByIdData;
            res: {
                200: ConsultancyDto;
            };
        };
        put: {
            req: ConsultancyControllerUpdateData;
            res: {
                200: ConsultancyDto;
            };
        };
        delete: {
            req: ConsultancyControllerDeleteData;
            res: {
                200: unknown;
            };
        };
    };
    '/consultancies/{id}/companies': {
        get: {
            req: ConsultancyControllerGetAvailableCompaniesData;
            res: {
                200: unknown;
            };
        };
        post: {
            req: ConsultancyControllerAddCompaniesData;
            res: {
                201: unknown;
            };
        };
    };
    '/consultancies/{id}/users': {
        get: {
            req: ConsultancyControllerGetConsultancyUsersData;
            res: {
                200: Array<User>;
                201: unknown;
            };
        };
    };
    '/consultancies/{id}/users/{userId}': {
        post: {
            req: ConsultancyControllerAddUserToConsultancyData;
            res: {
                201: unknown;
            };
        };
        delete: {
            req: ConsultancyControllerRemoveUserFromConsultancyData;
            res: {
                200: unknown;
            };
        };
    };
    '/consultancies/{id}/users/{userId}/companies': {
        post: {
            req: ConsultancyControllerAttachCompaniesToUserData;
            res: {
                200: unknown;
            };
        };
    };
    '/consultancies/{id}/logo': {
        get: {
            req: ConsultancyControllerGetLogoData;
            res: {
                200: unknown;
            };
        };
    };
    '/consultancies/request-meter-creation': {
        post: {
            req: ConsultancyControllerRequestMeterCreationData;
            res: {
                201: unknown;
            };
        };
    };
    '/companies/{companyId}/regions': {
        post: {
            req: RegionControllerUpsertCompanyRegionData;
            res: {
                /**
                 * Upsert company region
                 */
                200: unknown;
            };
        };
        get: {
            req: CompanyControllerGetCompanyRegionsData;
            res: {
                /**
                 * Get company regions
                 */
                200: unknown[];
            };
        };
    };
    '/companies/{companyId}/regions/{regionId}': {
        delete: {
            req: RegionControllerDeleteCompanyRegionData;
            res: {
                /**
                 * Delete company region
                 */
                200: unknown;
            };
        };
    };
    '/roles': {
        get: {
            res: {
                200: Array<Role>;
            };
        };
    };
    '/object-storage': {
        post: {
            req: ObjectStorageControllerUploadData;
            res: {
                /**
                 * Files uploaded successfully
                 */
                200: Array<ObjectStoragePostResponseDto>;
                201: unknown;
            };
        };
        get: {
            req: ObjectStorageControllerDownloadData;
            res: {
                200: unknown;
            };
        };
        delete: {
            req: ObjectStorageControllerDeleteData;
            res: {
                200: unknown;
            };
        };
    };
    '/object-storage/metadata': {
        get: {
            req: ObjectStorageControllerGetFileMetadataData;
            res: {
                /**
                 * Successful response
                 */
                200: ObjectStorageDto;
            };
        };
    };
    '/object-storage/consultants/load-profile-template': {
        get: {
            req: ObjectStorageControllerDownloadConsultantsLoadProfileTemplateData;
            res: {
                200: unknown;
            };
        };
    };
    '/v2/object-storage': {
        post: {
            req: ObjectStorageV2ControllerUploadData;
            res: {
                /**
                 * Files uploaded successfully
                 */
                200: Array<ObjectStorageV2PostResponseDto>;
            };
        };
        get: {
            req: ObjectStorageV2ControllerDownloadByUidData;
            res: {
                200: unknown;
            };
        };
        delete: {
            req: ObjectStorageV2ControllerDeleteByUidData;
            res: {
                200: unknown;
            };
        };
    };
    '/v2/object-storage/admin': {
        post: {
            req: ObjectStorageV2ControllerUploadAdminData;
            res: {
                /**
                 * Files uploaded successfully
                 */
                200: Array<ObjectStorageV2PostResponseDto>;
            };
        };
        get: {
            req: ObjectStorageV2ControllerDownloadByUidAdminData;
            res: {
                200: unknown;
            };
        };
        delete: {
            req: ObjectStorageV2ControllerDeleteByUidAdminData;
            res: {
                200: unknown;
            };
        };
    };
    '/v2/object-storage/metadata': {
        get: {
            req: ObjectStorageV2ControllerGetFileMetadataByUidData;
            res: {
                /**
                 * Successful response
                 */
                200: ObjectStorageV2MetadataDto;
            };
        };
    };
    '/v2/object-storage/metadata/admin': {
        get: {
            req: ObjectStorageV2ControllerGetFileMetadataByUidAdminData;
            res: {
                /**
                 * Successful response
                 */
                200: ObjectStorageV2MetadataDto;
            };
        };
    };
    '/v2/object-storage/consultants/load-profile-template': {
        get: {
            req: ObjectStorageV2ControllerDownloadConsultantsLoadProfileTemplateData;
            res: {
                200: unknown;
            };
        };
    };
    '/emissions/{locationId}/yearly-comparison': {
        get: {
            req: EmissionsControllerGetEmissionsComparisonData;
            res: {
                /**
                 * Yearly comparison of emission
                 */
                200: EmissionsComparisonDto;
            };
        };
    };
    '/meters/locations/{locationId}/available-years': {
        get: {
            req: MeterControllerGetAvailableYearsByLocationData;
            res: {
                /**
                 * List of available years for the meters in a location
                 */
                200: AvailableMeterYearsDto;
            };
        };
    };
    '/meters/companies/{companyId}/available-years': {
        get: {
            req: MeterControllerGetAvailableYearsByCompanyData;
            res: {
                /**
                 * List of available years for the meters in a company
                 */
                200: AvailableMeterYearsDto;
            };
        };
    };
    '/meters/infrastructure-settings': {
        get: {
            req: MeterControllerGetBulkInfrastructureSettingsData;
            res: {
                /**
                 * Infrastructure settings of every meter of the given locations.
                 */
                200: MeterInfrastructureSettingsListDto;
            };
        };
    };
    '/meters/infrastructure-settings/bulk': {
        put: {
            req: MeterControllerPutBulkInfrastructureSettingsData;
            res: {
                /**
                 * Updates aggregation level, asset purpose and asset type for many meters at once.
                 */
                200: MeterInfrastructureSettingsListDto;
            };
        };
    };
    '/meters/infrastructure-settings/{deviceId}': {
        get: {
            req: MeterControllerGetInfrastructureSettingsData;
            res: {
                /**
                 * Get infrastructure settings for given device.
                 */
                200: InfrastructureSettingsSelectOneResponseDto;
            };
        };
        put: {
            req: MeterControllerPutInfrastructureSettingsData;
            res: {
                /**
                 * Create or updates infrastructure settings for given device.
                 */
                200: InfrastructureSettingsUpdateOneResponseDto;
                /**
                 * Cyclic reference detected in meter hierarchy or other validation errors.
                 */
                400: MeterCyclicErrorDto;
            };
        };
    };
    '/meters/{deviceId}/possible-parent-meters': {
        get: {
            req: MeterControllerGetPossibleParentMetersData;
            res: {
                /**
                 * Return possible parent meters for given device.
                 */
                200: PossibleParentMetersResponseDto;
            };
        };
    };
    '/meters/slp': {
        post: {
            req: MeterControllerCreateSlpMeterData;
            res: {
                /**
                 * Create a new meter
                 */
                201: SlpMeterDto;
            };
        };
    };
    '/meters/slp/{deviceId}': {
        patch: {
            req: MeterControllerUpdateSlpMeterData;
            res: {
                /**
                 * Update meter based on deviceId
                 */
                200: SlpMeterDto;
            };
        };
        delete: {
            req: MeterControllerDeleteSlpMeterData;
            res: {
                /**
                 * Delete a meter based on deviceId and buildingId
                 */
                200: unknown;
            };
        };
        get: {
            req: MeterControllerGetSlpMeterData;
            res: {
                /**
                 * Return SLP meter details based on deviceId and buildingId
                 */
                200: SlpMeterDto;
                /**
                 * User does not have access to the location
                 */
                401: unknown;
                /**
                 * Meter not found
                 */
                404: unknown;
            };
        };
    };
    '/meters': {
        get: {
            req: MeterControllerGetMetersData;
            res: {
                /**
                 * List of meters
                 */
                200: Array<MeterResponseDto>;
            };
        };
    };
    '/meters/slps': {
        get: {
            req: MeterControllerGetSlpMetersData;
            res: {
                /**
                 * List of SLP meters
                 */
                200: Array<SlpMeterResponseDto>;
            };
        };
    };
    '/meters/info': {
        get: {
            req: MeterControllerGetMetersInfoByAllowedLocationsData;
            res: {
                /**
                 * List of meters information without consumption data
                 */
                200: Array<MeterInfoResponseDto>;
            };
        };
    };
    '/meters/evaluations': {
        get: {
            req: MeterControllerGetMeterEvaluationsData;
            res: {
                /**
                 * List of meter evaluation records from database. Use /meters/energy-evaluation for calculated scores.
                 */
                200: Array<MeterEvaluationResponseDto>;
            };
        };
        post: {
            req: MeterControllerCreateMeterEvaluationData;
            res: {
                /**
                 * Meter evaluation created successfully
                 */
                201: unknown;
                /**
                 * Meter not found
                 */
                404: unknown;
                /**
                 * Evaluation already exists for this meter
                 */
                409: unknown;
            };
        };
    };
    '/meters/evaluations/{meterId}': {
        delete: {
            req: MeterControllerDeleteMeterEvaluationData;
            res: {
                /**
                 * Meter evaluation deleted successfully
                 */
                200: unknown;
                /**
                 * Cannot delete evaluation for meters marked as Significant Energy Consumer (SEU)
                 */
                400: unknown;
                /**
                 * Evaluation not found for this meter
                 */
                404: unknown;
            };
        };
    };
    '/meters/energy-evaluation': {
        get: {
            req: MeterControllerGetEnergyEvaluationData;
            res: {
                /**
                 * List of meters with energy evaluation scores. Automatically includes all meters marked as Significant Energy Consumers (isSignificantEnergyConsumer = true). Newly marked SEU meters are automatically added on the next call. Use POST /meters/evaluations to manually add more meters or DELETE /meters/evaluations/:meterId to remove meters from evaluation.
                 */
                200: Array<MeterEvaluationDto>;
            };
        };
    };
    '/document-templates': {
        post: {
            req: DocumentTemplateControllerCreateData;
            res: {
                /**
                 * The document template has been successfully created.
                 */
                201: DocumentTemplateDto;
                /**
                 * Bad request.
                 */
                400: unknown;
            };
        };
        get: {
            req: DocumentTemplateControllerFindAllData;
            res: {
                /**
                 * List of all document templates.
                 */
                200: DocumentTemplateDtoList;
            };
        };
    };
    '/document-templates/{id}': {
        get: {
            req: DocumentTemplateControllerFindOneData;
            res: {
                /**
                 * The document template with the specified ID.
                 */
                200: DocumentTemplateDto;
                /**
                 * Document template not found.
                 */
                404: unknown;
            };
        };
        put: {
            req: DocumentTemplateControllerUpdateData;
            res: {
                /**
                 * The document template has been successfully updated.
                 */
                200: DocumentTemplateDto;
                /**
                 * Document template not found.
                 */
                404: unknown;
            };
        };
        delete: {
            req: DocumentTemplateControllerRemoveData;
            res: {
                /**
                 * The document template has been successfully deleted.
                 */
                204: void;
                /**
                 * Document template not found.
                 */
                404: unknown;
            };
        };
    };
    '/document-templates/{id}/content': {
        patch: {
            req: DocumentTemplateControllerUpdateContentData;
            res: {
                /**
                 * The document template has been successfully updated.
                 */
                200: unknown;
                204: void;
                /**
                 * Document template not found.
                 */
                404: unknown;
            };
        };
    };
    '/v2/usage-analytics/event': {
        post: {
            req: UsageAnalyticsControllerTrackEventData;
            res: {
                /**
                 * Registers usage analytics events
                 */
                200: unknown;
            };
        };
    };
    '/cost/hedging': {
        post: {
            req: HedgingControllerUploadFileData;
            res: {
                /**
                 * Upload hedging CSV for a given location
                 */
                200: unknown;
            };
        };
    };
    '/v2/analytics/visualization': {
        get: {
            req: VisualizationControllerGetVisualizationsData;
            res: {
                200: Array<Visualization>;
            };
        };
    };
    '/v2/analytics/visualization/{id}': {
        delete: {
            req: VisualizationControllerDeleteVisualizationData;
            res: {
                /**
                 * Visualization deleted successfully
                 */
                200: unknown;
                /**
                 * Visualization not found
                 */
                404: unknown;
            };
        };
    };
    '/grid-fees/locations/{locationId}/grid-usage': {
        get: {
            req: GridFeesControllerGetGridUsageFeesData;
            res: {
                /**
                 * List of grid usage fees for location
                 */
                200: ApiGridUsagePriceResponseDto;
            };
        };
    };
    '/grid-fees/grid-usage': {
        post: {
            req: GridFeesControllerUpsertGridUsageFeeData;
            res: {
                /**
                 * Grid usage fee created/updated successfully
                 */
                201: GenericResponseDto;
            };
        };
    };
    '/grid-fees/grid-usage/{locationId}/{year}/{month}': {
        delete: {
            req: GridFeesControllerDeleteGridUsageFeeData;
            res: {
                /**
                 * Grid usage fee deleted successfully
                 */
                200: GenericResponseDto;
            };
        };
    };
    '/grid-fees/locations/{locationId}/peak-load': {
        get: {
            req: GridFeesControllerGetPeakLoadPricesData;
            res: {
                /**
                 * List of peak load prices for location
                 */
                200: ApiPeakLoadPriceResponseDto;
            };
        };
    };
    '/grid-fees/peak-load': {
        post: {
            req: GridFeesControllerUpsertPeakLoadPriceData;
            res: {
                /**
                 * Peak load price created/updated successfully
                 */
                201: GenericResponseDto;
            };
        };
    };
    '/grid-fees/peak-load/{locationId}/{year}/{month}': {
        delete: {
            req: GridFeesControllerDeletePeakLoadPriceData;
            res: {
                /**
                 * Peak load price deleted successfully
                 */
                200: GenericResponseDto;
            };
        };
    };
    '/iso/chapters': {
        get: {
            res: {
                /**
                 * Fetch all ISO chapters
                 */
                200: IsoChapterListResponseDto;
            };
        };
        post: {
            req: IsoChaptersControllerCreateData;
            res: {
                /**
                 * Create a new ISO chapter
                 */
                201: IsoChapterResponseDto;
            };
        };
    };
    '/iso/chapters/{id}': {
        put: {
            req: IsoChaptersControllerUpdateData;
            res: {
                /**
                 * Update an ISO chapter by ID
                 */
                200: IsoChapterResponseDto;
            };
        };
        delete: {
            req: IsoChaptersControllerRemoveData;
            res: {
                200: unknown;
                /**
                 * Delete an ISO chapter by ID
                 */
                204: IsoChapterResponseDto;
            };
        };
    };
    '/iso/documents': {
        get: {
            req: IsoDocumentsControllerFindAllData;
            res: {
                /**
                 * Requested Document
                 */
                200: IsoDocumentResponseListDto;
            };
        };
        post: {
            req: IsoDocumentsControllerCreateData;
            res: {
                /**
                 * Document created
                 */
                201: IsoDocumentResponseDto;
            };
        };
    };
    '/iso/documents/{id}': {
        get: {
            req: IsoDocumentsControllerFindOneByIdData;
            res: {
                /**
                 * Requested Document
                 */
                200: IsoDocumentFetchOneResponseDto;
            };
        };
        delete: {
            req: IsoDocumentsControllerDeleteData;
            res: {
                200: unknown;
                /**
                 * Document deleted
                 */
                204: void;
            };
        };
    };
    '/iso/documents/{id}/content': {
        patch: {
            req: IsoDocumentsControllerUpdateContentData;
            res: {
                200: unknown;
                /**
                 * Document content updated
                 */
                204: void;
            };
        };
    };
    '/iso/documents/{id}/meta-data': {
        patch: {
            req: IsoDocumentsControllerUpdateMetaDataData;
            res: {
                200: unknown;
                /**
                 * Document meta data updated
                 */
                204: void;
            };
        };
    };
    '/iso/documents/{id}/upload-document': {
        post: {
            req: IsoDocumentsControllerUploadFileData;
            res: {
                201: unknown;
                /**
                 * Document file uploaded
                 */
                204: void;
            };
        };
        delete: {
            req: IsoDocumentsControllerDeleteUploadDocumentData;
            res: {
                200: unknown;
                /**
                 * Uploaded Document deleted
                 */
                204: void;
            };
        };
    };
    '/iso/risks': {
        get: {
            req: IsoRiskControllerFindAllData;
            res: {
                /**
                 * Requested Risks
                 */
                200: IsoRiskFetchResponseListDto;
            };
        };
        post: {
            req: IsoRiskControllerCreateData;
            res: {
                /**
                 * Risk created
                 */
                201: IsoRiskFetchOneResponseDto;
            };
        };
    };
    '/iso/risks/{id}': {
        get: {
            req: IsoRiskControllerFindOneByIdData;
            res: {
                /**
                 * Requested Risk
                 */
                200: IsoRiskFetchOneResponseDto;
            };
        };
        put: {
            req: IsoRiskControllerUpdateData;
            res: {
                /**
                 * Risk created
                 */
                200: IsoRiskFetchOneResponseDto;
            };
        };
        delete: {
            req: IsoRiskControllerDeleteData;
            res: {
                /**
                 * Risk deleted
                 */
                204: void;
            };
        };
    };
    '/iso/goals': {
        get: {
            req: IsoGoalsControllerFindAllData;
            res: {
                /**
                 * Requested Goals
                 */
                200: IsoGoalFetchResponseListDto;
            };
        };
        post: {
            req: IsoGoalsControllerCreateData;
            res: {
                /**
                 * Goal created
                 */
                201: IsoGoalFetchResponseDto;
            };
        };
    };
    '/iso/goals/{id}': {
        get: {
            req: IsoGoalsControllerFindOneByIdData;
            res: {
                /**
                 * Requested Goal
                 */
                200: IsoGoalFetchResponseDto;
            };
        };
        put: {
            req: IsoGoalsControllerUpdateData;
            res: {
                /**
                 * Goal updated
                 */
                200: IsoGoalFetchResponseDto;
            };
        };
        delete: {
            req: IsoGoalsControllerDeleteData;
            res: {
                /**
                 * Goal deleted
                 */
                204: void;
            };
        };
    };
    '/iso/enpis/seu-options': {
        get: {
            req: IsoEnpiControllerFindSeuOptionsData;
            res: {
                /**
                 * Available EnPI SEU options for a location
                 */
                200: FetchEnpiSeuOptionsDto;
            };
        };
    };
    '/iso/enpis/seu-options/batch': {
        post: {
            req: IsoEnpiControllerFindSeuOptionsForLocationsData;
            res: {
                /**
                 * Available EnPI SEU options for locations
                 */
                200: FetchEnpiSeuOptionsDto;
            };
        };
    };
    '/iso/enpis': {
        get: {
            req: IsoEnpiControllerFindAllData;
            res: {
                /**
                 * Requested ENPIs
                 */
                200: FetchEnpiListDto;
            };
        };
        post: {
            req: IsoEnpiControllerCreateData;
            res: {
                /**
                 * ENPI created
                 */
                201: FetchOneEnpiDto;
            };
        };
    };
    '/iso/enpis/{id}': {
        get: {
            req: IsoEnpiControllerFindOneByIdData;
            res: {
                /**
                 * Requested ENPI
                 */
                200: FetchOneEnpiDto;
            };
        };
        put: {
            req: IsoEnpiControllerUpdateData;
            res: {
                /**
                 * ENPI updated
                 */
                200: FetchOneEnpiDto;
            };
        };
        delete: {
            req: IsoEnpiControllerDeleteData;
            res: {
                /**
                 * ENPI deleted
                 */
                204: void;
            };
        };
    };
    '/iso/enpis/{id}/comments': {
        put: {
            req: IsoEnpiControllerAddCommentData;
            res: {
                /**
                 * Comment added
                 */
                204: void;
            };
        };
    };
    '/iso/enpis/batch-update': {
        post: {
            req: IsoEnpiControllerBatchUpdateData;
            res: {
                /**
                 * Batch ENPI update triggered
                 */
                200: unknown;
            };
        };
    };
    '/iso/enpis/daily-update': {
        post: {
            res: {
                /**
                 * Daily EnPI update started; it runs in the background
                 */
                202: unknown;
            };
        };
    };
    '/iso/enpis/{id}/recalculate': {
        post: {
            req: IsoEnpiControllerRecalculateData;
            res: {
                /**
                 * EnPI recalculated
                 */
                204: void;
            };
        };
    };
    '/iso/measures': {
        get: {
            req: IsoMeasuresControllerFindAllData;
            res: {
                /**
                 * Requested Measures
                 */
                200: IsoMeasureFetchResponseListDto;
            };
        };
        post: {
            req: IsoMeasuresControllerCreateData;
            res: {
                /**
                 * Measure created
                 */
                201: FetchOneIsoMeasureDto;
            };
        };
    };
    '/iso/measures/{id}': {
        get: {
            req: IsoMeasuresControllerFindOneByIdData;
            res: {
                /**
                 * Requested Measure
                 */
                200: FetchOneDetailIsoMeasureDto;
            };
        };
        put: {
            req: IsoMeasuresControllerUpdateData;
            res: {
                /**
                 * Measure updated
                 */
                200: FetchOneIsoMeasureDto;
            };
        };
        delete: {
            req: IsoMeasuresControllerDeleteData;
            res: {
                /**
                 * Measure deleted
                 */
                204: void;
            };
        };
    };
    '/iso/measures/create-documents': {
        post: {
            res: {
                201: unknown;
            };
        };
    };
    '/iso/measures/{id}/success-measurement/analytics-baseline': {
        post: {
            req: IsoMeasuresControllerLinkSuccessMeasurementAnalyticsBaselineData;
            res: {
                /**
                 * Linked analytics baseline to the measure for Erfolgsmessung
                 */
                201: FetchOneDetailIsoMeasureDto;
            };
        };
    };
    '/iso/measures/{id}/status': {
        patch: {
            req: IsoMeasuresControllerPatchStatusData;
            res: {
                /**
                 * Measure status updated
                 */
                200: FetchOneIsoMeasureDto;
            };
        };
    };
    '/iso/measures/{id}/status/validate': {
        post: {
            req: IsoMeasuresControllerValidateStatusData;
            res: {
                /**
                 * Measure status update validation result
                 */
                200: IsoMeasureStatusValidationResultDto;
            };
        };
    };
    '/iso/measures/{id}/comments': {
        put: {
            req: IsoMeasuresControllerAddCommentData;
            res: {
                /**
                 * Comment added
                 */
                204: void;
            };
        };
    };
    '/iso/measures/{id}/milestones': {
        post: {
            req: IsoMeasuresControllerCreateMilestoneData;
            res: {
                /**
                 * Milestone created
                 */
                201: IsoMilestoneFetchOneDto;
            };
        };
    };
    '/iso/measures/{id}/milestones/{milestoneId}': {
        put: {
            req: IsoMeasuresControllerUpdateMilestoneData;
            res: {
                /**
                 * Milestone updated
                 */
                200: IsoMilestoneFetchOneDto;
            };
        };
        delete: {
            req: IsoMeasuresControllerDeleteMilestoneData;
            res: {
                /**
                 * Milestone deleted
                 */
                204: IsoMilestoneFetchOneDto;
            };
        };
    };
    '/iso/measures/{id}/milestones/{milestoneId}/status': {
        patch: {
            req: IsoMeasuresControllerPatchMilestoneStatusData;
            res: {
                /**
                 * Milestone status updated created
                 */
                200: IsoMilestoneFetchOneDto;
            };
        };
    };
    '/iso/measures/{id}/milestones-order': {
        put: {
            req: IsoMeasuresControllerUpdateMilestonesOrderData;
            res: {
                /**
                 * Milestone order updated
                 */
                200: unknown;
            };
        };
    };
    '/iso/measures/{id}/clear-savings': {
        patch: {
            req: IsoMeasuresControllerDeleteMeasureSavingsData;
            res: {
                /**
                 * Milestone deleted
                 */
                204: IsoMilestoneFetchOneDto;
            };
        };
    };
    '/iso/measures/{id}/activate-auto-tracking': {
        patch: {
            req: IsoMeasuresControllerActivateAutoTrackingData;
            res: {
                /**
                 * Measure auto-tracking activated
                 */
                200: FetchOneDetailIsoMeasureDto;
            };
        };
    };
    '/iso/overview': {
        get: {
            req: IsoControllerGetIsoOverviewData;
            res: {
                /**
                 * Get ISO Overview for specific user
                 */
                200: IsoOverviewModelDto;
            };
        };
    };
    '/iso/checklist-configurations': {
        get: {
            res: {
                /**
                 * Get all ISO checklist configurations
                 */
                200: IsoChecklistConfigurationFetchListDto;
            };
        };
        post: {
            res: {
                /**
                 * Created iso checklist configurations
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
    };
    '/iso/checklist-configurations/{id}': {
        get: {
            req: IsoChecklistConfigurationControllerFindOneByIdData;
            res: {
                /**
                 * Requested checklist configuration
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
        delete: {
            req: IsoChecklistConfigurationControllerDeleteChecklistConfigurationData;
            res: {
                /**
                 * Delete checklist
                 */
                204: void;
            };
        };
    };
    '/iso/checklist-configurations/{id}/copy': {
        post: {
            req: IsoChecklistConfigurationControllerCopyChecklistData;
            res: {
                /**
                 * Copies checklist by given id
                 */
                201: IsoChecklistConfigurationFetchDto;
            };
        };
    };
    '/iso/checklist-configurations/{id}/finalize': {
        patch: {
            req: IsoChecklistConfigurationControllerPatchStatusData;
            res: {
                /**
                 * Set finalize status of checklist configuration
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
    };
    '/iso/checklist-configurations/{id}/un-finalize': {
        patch: {
            req: IsoChecklistConfigurationControllerUnFinalizeData;
            res: {
                /**
                 * Set finalize status of checklist configuration
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
    };
    '/iso/checklist-configurations/{id}/set-latest': {
        patch: {
            req: IsoChecklistConfigurationControllerPatchLatestData;
            res: {
                /**
                 * Set checklist configuration to be latest
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
    };
    '/iso/checklist-configurations/{id}/chapters': {
        post: {
            req: IsoChecklistConfigurationControllerAddChecklistChapterData;
            res: {
                /**
                 * Adds chapter to checklist configuration
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
    };
    '/iso/checklist-configurations/{id}/chapters/{chapterId}': {
        put: {
            req: IsoChecklistConfigurationControllerUpdateChecklistChapterData;
            res: {
                /**
                 * Updates chapter to checklist configuration
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
        delete: {
            req: IsoChecklistConfigurationControllerDeleteChecklistChapterData;
            res: {
                /**
                 * Deletes chapter from the checklist configuration
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
    };
    '/iso/checklist-configurations/{id}/chapters/{chapterId}/sub-chapters': {
        post: {
            req: IsoChecklistConfigurationControllerAddChecklistSubChapterData;
            res: {
                /**
                 * Adds sub chapter to chapter configuration
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
    };
    '/iso/checklist-configurations/{id}/chapters/{chapterId}/sub-chapters/{subChapterId}': {
        put: {
            req: IsoChecklistConfigurationControllerUpdateChecklistSubChapterData;
            res: {
                /**
                 * Updates sub chapter to chapter configuration
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
        delete: {
            req: IsoChecklistConfigurationControllerDeleteChecklistSubChapterData;
            res: {
                /**
                 * Deletes chapter from the checklist configuration
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
    };
    '/iso/checklist-configurations/{id}/chapters/{chapterId}/sub-chapters/{subChapterId}/tasks': {
        post: {
            req: IsoChecklistConfigurationControllerAddTaskData;
            res: {
                /**
                 * Adds task to sub chapter configuration
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
    };
    '/iso/checklist-configurations/{id}/chapters/{chapterId}/sub-chapters/{subChapterId}/tasks/{taskId}': {
        put: {
            req: IsoChecklistConfigurationControllerUpdateTasksData;
            res: {
                /**
                 * Updates task to  sub chapter configuration
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
        delete: {
            req: IsoChecklistConfigurationControllerDeleteTaskData;
            res: {
                /**
                 * Deletes task from the checklist configuration
                 */
                200: IsoChecklistConfigurationFetchDto;
            };
        };
    };
    '/iso/checklists': {
        get: {
            req: IsoChecklistControllerFindByCompanyIdData;
            res: {
                /**
                 * Find currently valid iso checklist by company
                 */
                200: IsoChecklistFetchDto;
            };
        };
        post: {
            req: IsoChecklistControllerCreateChecklistByCompanyData;
            res: {
                /**
                 * Create checklist for a given company
                 */
                200: IsoChecklistFetchDto;
            };
        };
    };
    '/iso/checklists/{id}/tasks/{taskId}/completed': {
        patch: {
            req: IsoChecklistControllerMarkTaskCompletedData;
            res: {
                /**
                 * Set tasks completed
                 */
                200: IsoChecklistFetchDto;
            };
        };
    };
    '/iso/checklists/{id}/tasks/{taskId}/open': {
        patch: {
            req: IsoChecklistControllerMarkTaskOpenData;
            res: {
                /**
                 * Set task open
                 */
                200: IsoChecklistFetchDto;
            };
        };
    };
    '/iso/checklists/{id}/tasks/{taskId}/in-progress': {
        patch: {
            req: IsoChecklistControllerMarkTaskInProgressData;
            res: {
                /**
                 * Set task in progress
                 */
                200: IsoChecklistFetchDto;
            };
        };
    };
    '/iso/checklists/{id}/tasks/{taskId}/documents': {
        put: {
            req: IsoChecklistControllerLinkDocumentData;
            res: {
                /**
                 * Document linked
                 */
                200: IsoChecklistFetchDto;
            };
        };
    };
    '/iso/checklists/{id}/tasks/{taskId}/documents/{documentId}': {
        delete: {
            req: IsoChecklistControllerRemoveLinkDocumentData;
            res: {
                /**
                 * Document linked
                 */
                200: IsoChecklistFetchDto;
            };
        };
    };
    '/iso/valeri': {
        post: {
            req: ValeriControllerCreateValeriData;
            res: {
                /**
                 * Valeri created
                 */
                201: FetchOneValeriDto;
            };
        };
    };
    '/iso/valeri/{id}': {
        put: {
            req: ValeriControllerUpdateValeriData;
            res: {
                /**
                 * Valeri updated
                 */
                200: FetchOneValeriDto;
            };
        };
        delete: {
            req: ValeriControllerDeleteValeriData;
            res: {
                /**
                 * Valeri deleted
                 */
                204: void;
            };
        };
        get: {
            req: ValeriControllerFindOneByIdData;
            res: {
                /**
                 * Requested Valeri
                 */
                200: FetchOneValeriDto;
            };
        };
    };
    '/iso/valeri/{id}/positions': {
        get: {
            req: ValeriControllerGetValeriPositionsData;
            res: {
                /**
                 * Valeri Positions
                 */
                200: ValeriPositionsListDto;
            };
        };
        post: {
            req: ValeriControllerCreateValeriPositionData;
            res: {
                /**
                 * Valeri created
                 */
                200: FetchOneValeriDto;
            };
        };
    };
    '/iso/valeri/{id}/calculate-valeri': {
        post: {
            req: ValeriControllerCalculateValeriData;
            res: {
                /**
                 * Valeri Result calculated
                 */
                200: ValeriCalculationResultSummaryDto;
            };
        };
    };
    '/iso/valeri/{id}/calculation-result/export': {
        get: {
            req: ValeriControllerExportValeriCalculationResultData;
            res: {
                /**
                 * Returns valeri calculation result .xlsx file
                 */
                200: (Blob | File);
            };
        };
    };
    '/iso/valeri/{id}/positions/{positionId}': {
        put: {
            req: ValeriControllerUpdateValeriPositionData;
            res: {
                /**
                 * Valeri updated
                 */
                200: FetchOneValeriDto;
            };
        };
        delete: {
            req: ValeriControllerDeleteValeriPositionData;
            res: {
                /**
                 * Valeri Position deleted
                 */
                204: void;
            };
        };
    };
    '/iso/valeri/{id}/positions/{positionId}/document': {
        put: {
            req: ValeriControllerUploadValeriPositionDocumentData;
            res: {
                200: ValeriPositionDto;
                /**
                 * Invoice file uploaded
                 */
                204: void;
            };
        };
        delete: {
            req: ValeriControllerDeleteValeriPositionDocumentData;
            res: {
                /**
                 * Valeri Position deleted
                 */
                204: void;
            };
        };
    };
    '/iso/valeri/calculation-results': {
        get: {
            req: ValeriControllerGetValeriCalculationResultsData;
            res: {
                /**
                 * Get VALERI list for specific user
                 */
                200: GetValeriCalculationResultsDto;
            };
        };
    };
    '/iso/valeri/by-measure/{measureId}': {
        get: {
            req: ValeriControllerGetValeriByMeasureIdData;
            res: {
                /**
                 * Returns a Valeri for the given measureId, or null if not found
                 */
                200: FetchOneValeriDto;
            };
        };
    };
    '/iso/valeri/{id}/measures': {
        patch: {
            req: ValeriControllerLinkValeriToMeasureData;
            res: {
                /**
                 * Valeri with the latest attached measurement ID
                 */
                200: FetchOneValeriDto;
            };
        };
    };
    '/iso/valeri/company/{companyId}/defaults': {
        get: {
            req: ValeriControllerGetCompanyDefaultsData;
            res: {
                /**
                 * Company Valeri defaults (can be null if not set)
                 */
                200: ResponseCompanyValeriDefaultsDto;
            };
        };
        put: {
            req: ValeriControllerUpsertCompanyDefaultsData;
            res: {
                /**
                 * Upserted company Valeri defaults
                 */
                200: ResponseCompanyValeriDefaultsDto;
            };
        };
    };
    '/iso/company/{companyId}/energy-baseline-config': {
        get: {
            req: CompanyEnergyBaselineConfigControllerGetData;
            res: {
                /**
                 * Company energy baseline configuration (can be null if not set)
                 */
                200: ResponseCompanyEnergyBaselineConfigDto;
            };
        };
        put: {
            req: CompanyEnergyBaselineConfigControllerUpsertData;
            res: {
                /**
                 * Upserted company energy baseline configuration
                 */
                200: ResponseCompanyEnergyBaselineConfigDto;
            };
        };
    };
    '/companies/{companyId}/locations/{locationId}/buildings': {
        get: {
            req: BuildingControllerGetBuildingsByLocationData;
            res: {
                200: unknown;
            };
        };
        post: {
            req: BuildingControllerUpsertBuildingData;
            res: {
                201: unknown;
            };
        };
    };
    '/companies/buildings/hydrate-queue': {
        put: {
            res: {
                /**
                 * Successfully hydrated building data to Kafka
                 */
                200: unknown;
            };
        };
    };
    '/companies/{companyId}/locations/{locationId}/buildings/{buildingId}': {
        delete: {
            req: BuildingControllerDeleteBuildingData;
            res: {
                200: unknown;
            };
        };
    };
    '/consumption': {
        get: {
            req: ConsumptionControllerGetConsumptionData;
            res: {
                /**
                 * Get Energy Consumption in KWH for a given time period.
                 */
                200: ConsumptionResponseDto;
            };
        };
    };
    '/consumption/locations/{locationId}': {
        get: {
            req: ConsumptionControllerGetConsumptionLocationWithGranularityData;
            res: {
                /**
                 * Get energy consumption for a locations by granularity
                 */
                200: unknown[];
            };
        };
    };
    '/consumption/company/{companyId}': {
        get: {
            req: ConsumptionControllerGetConsumptionWithGranularityData;
            res: {
                /**
                 * Get energy consumption for multiple locations by granularity
                 */
                200: unknown[];
            };
        };
    };
    '/consumption/company/{companyId}/aggregated': {
        get: {
            req: ConsumptionControllerGetLoadProfileData;
            res: {
                /**
                 * Get aggregated energy consumption for multiple locations by granularity
                 */
                200: unknown[];
            };
        };
    };
    '/details/load-profile': {
        get: {
            req: ConsumptionControllerGetAggregatedConsumptionWithGranularityData;
            res: {
                /**
                 * Get load profile
                 */
                200: LoadProfileResponseDto;
            };
        };
    };
    '/energy-data/aggregated': {
        get: {
            req: ConsumptionControllerGetAggregatedConsumptionData;
            res: {
                /**
                 * Get load profile
                 */
                200: LoadProfileResponseDto;
            };
        };
    };
    '/consumption/series': {
        post: {
            req: ConsumptionControllerGetConsumptionSeriesData;
            res: {
                /**
                 * Get consumption series for device IDs or series UUIDs
                 */
                200: Array<ConsumptionSeriesDto>;
            };
        };
    };
    '/consumption/series/location-total': {
        post: {
            req: LocationTotalSeriesControllerGetLocationTotalSeriesData;
            res: {
                /**
                 * Resolve location-total metadata and, when requested, its calculated data.
                 */
                200: unknown;
            };
        };
    };
    '/companies': {
        get: {
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
        post: {
            req: CompanyControllerUpsertCompanyData;
            res: {
                201: unknown;
            };
        };
        put: {
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/companies/{companyId}': {
        delete: {
            req: CompanyControllerDeleteCompanyData;
            res: {
                200: unknown;
            };
        };
        get: {
            req: CompanyControllerGetCompanyData;
            res: {
                /**
                 * List of all document templates.
                 */
                200: CompanyDto;
            };
        };
    };
    '/companies/{companyId}/premium-features': {
        get: {
            req: CompanyControllerGetPremiumFeaturesData;
            res: {
                200: CompanyPremiumFeaturesResponseDto;
            };
        };
        put: {
            req: CompanyControllerUpdatePremiumFeaturesData;
            res: {
                200: CompanyPremiumFeaturesResponseDto;
            };
        };
    };
    '/companies/{companyId}/logo': {
        get: {
            req: CompanyControllerGetCompanyLogoData;
            res: {
                200: unknown;
            };
        };
    };
    '/companies/{companyId}/white-label-logo': {
        get: {
            req: CompanyControllerGetCompanyWhiteLabelLogoData;
            res: {
                200: unknown;
            };
        };
    };
    '/companies/{companyId}/cost/status': {
        get: {
            req: CompanyControllerIsCostEnabledData;
            res: {
                200: unknown;
            };
        };
    };
    '/companies/{companyId}/locations': {
        get: {
            req: LocationControllerGetLocationsByCompanyData;
            res: {
                200: unknown;
            };
        };
        post: {
            req: LocationControllerUpsertLocationData;
            res: {
                201: unknown;
            };
        };
    };
    '/companies/{companyId}/locations-with-buildings-and-devices': {
        get: {
            req: LocationControllerGetLocationsWithBuildingsAndDevicesByCompanyData;
            res: {
                200: Array<LocationTreeDto>;
            };
        };
    };
    '/companies/{companyId}/locations/{locationId}': {
        delete: {
            req: LocationControllerDeleteLocationData;
            res: {
                200: unknown;
            };
        };
    };
    '/companies/{companyId}/locations/{locationId}/regions': {
        get: {
            req: LocationControllerGetRegionsByLocationData;
            res: {
                200: unknown;
            };
        };
    };
    '/companies/{companyId}/locations/{locationId}/regions/{regionId}': {
        post: {
            req: LocationControllerToggleLocationAssignmentToRegionData;
            res: {
                201: unknown;
            };
        };
    };
    '/companies/locations': {
        put: {
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/weather/temperature/company/{companyId}': {
        get: {
            req: TemperatureControllerFindAllData;
            res: {
                /**
                 * Get all temperature locations
                 */
                200: Array<TemperatureResponseDto>;
            };
        };
    };
    '/weather/temperature/city/{cityId}': {
        get: {
            req: TemperatureControllerGetWeatherDataByCityIdData;
            res: {
                /**
                 * Get weather data for temperature location by city ID with date range
                 */
                200: WeatherDataResponseDto;
            };
        };
    };
    '/weather/temperature/{id}/data': {
        get: {
            req: TemperatureControllerGetWeatherDataData;
            res: {
                /**
                 * Get weather data for temperature location by ID with date range
                 */
                200: WeatherDataResponseDto;
            };
        };
    };
    '/weather/temperature/{id}': {
        get: {
            req: TemperatureControllerFindOneData;
            res: {
                /**
                 * Get temperature location by ID
                 */
                200: TemperatureResponseDto;
            };
        };
        put: {
            req: TemperatureControllerUpdateData;
            res: {
                /**
                 * Update temperature location
                 */
                200: TemperatureResponseDto;
            };
        };
        delete: {
            req: TemperatureControllerDeleteData;
            res: {
                /**
                 * Temperature location deleted
                 */
                204: void;
            };
        };
    };
    '/weather/temperature': {
        post: {
            req: TemperatureControllerCreateData;
            res: {
                /**
                 * Create a new temperature location
                 */
                201: TemperatureResponseDto;
            };
        };
    };
    '/weather/temperature/sync': {
        post: {
            res: {
                /**
                 * Trigger temperature sync (geocode missing cities + create missing entries)
                 */
                200: unknown;
            };
        };
    };
    '/cities': {
        get: {
            req: CityControllerGetAllCitiesData;
            res: {
                200: Array<CityDto>;
            };
        };
    };
    '/cities/geocode/preview': {
        post: {
            req: CityControllerPreviewGeocodedCityData;
            res: {
                /**
                 * Unique match resolved.
                 */
                200: CityGeocodePreviewDto;
                /**
                 * No city matched the search name and filters.
                 */
                404: unknown;
                /**
                 * Ambiguous: more than one candidate matched. Refine the filters.
                 */
                409: unknown;
            };
        };
    };
    '/cities/geocode/commit': {
        post: {
            req: CityControllerCommitGeocodedCityData;
            res: {
                /**
                 * City resolved and persisted.
                 */
                201: CityDto;
                /**
                 * No city matched the search name and filters.
                 */
                404: unknown;
                /**
                 * Ambiguous match, or resolved coordinates already belong to another city.
                 */
                409: unknown;
            };
        };
    };
    '/cities/{name}': {
        post: {
            req: CityControllerFindAndUpsertCityData;
            res: {
                201: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/v2/analytics/data-management/meta': {
        get: {
            req: CustomTimeseriesControllerFindPageData;
            res: {
                /**
                 * Paginated custom time-series metadata
                 */
                200: CustomTimeseriesListResponseDto;
            };
        };
    };
    '/load/peakload/monthly/aggregated': {
        get: {
            req: LoadControllerGetAggregatedMonthlyPeakloadsData;
            res: {
                /**
                 * Aggregated monthly of peakloads by year for a set of main meters given the passed hiearchy params (companyId, regionId, locationId, buildingId)
                 */
                200: AggregatedMonthlyPeakloadsResponseDto;
            };
        };
    };
    '/load/baseload/monthly/aggregated': {
        get: {
            req: LoadControllerGetAggregatedMonthlyBaseloadsData;
            res: {
                /**
                 * Aggregated monthly of baseloads by year for a set of main meters given the passed hiearchy params (companyId, regionId, locationId, buildingId)
                 */
                200: AggregatedMonthlyBaseloadsResponseDto;
            };
        };
    };
    '/load-simulation/admin/store-pfc-lookup': {
        post: {
            res: {
                201: unknown;
            };
        };
    };
    '/load-simulation/admin/recalculate-simulation-type': {
        post: {
            req: LoadSimulationControllerRecalculateSimulationOfTypeData;
            res: {
                201: unknown;
            };
        };
    };
    '/load-simulation/available-main-meters': {
        get: {
            req: LoadSimulationControllerGetAvailableMainMetersData;
            res: {
                200: Array<AvailableMainMeterDto>;
            };
        };
    };
    '/load-simulation/available-generation-load-profiles': {
        get: {
            res: {
                200: Array<GenerationLoadProfileDto>;
            };
        };
    };
    '/load-simulation': {
        get: {
            req: LoadSimulationControllerFindAllForCompanyIdData;
            res: {
                /**
                 * Array of simulations (mixed types).
                 */
                200: Array<(EfficiencyImprovementSimulationDto | OnsiteGenerationSimulationDto | FlexibilitySimulationDto)>;
            };
        };
        post: {
            req: LoadSimulationControllerCreateSimulationData;
            res: {
                /**
                 * Simulation successfully created
                 */
                201: unknown;
                /**
                 * Validation failed – see error details
                 */
                400: unknown;
            };
        };
    };
    '/load-simulation/{id}': {
        put: {
            req: LoadSimulationControllerUpdateSimulationByIdData;
            res: {
                /**
                 * Single simulation (mixed type).
                 */
                200: EfficiencyImprovementSimulationDto | OnsiteGenerationSimulationDto | FlexibilitySimulationDto;
                /**
                 * No simulation found for the provided ID.
                 */
                404: unknown;
            };
        };
        get: {
            req: LoadSimulationControllerFindSimulationByIdData;
            res: {
                /**
                 * Single simulation (mixed type).
                 */
                200: EfficiencyImprovementSimulationDto | OnsiteGenerationSimulationDto | FlexibilitySimulationDto;
                /**
                 * No simulation found for the provided ID.
                 */
                404: unknown;
            };
        };
        delete: {
            req: LoadSimulationControllerDeleteSimulationByIdData;
            res: {
                204: void;
                /**
                 * No simulation found for the provided ID.
                 */
                404: unknown;
            };
        };
    };
    '/load-simulation/{id}/recalculate': {
        post: {
            req: LoadSimulationControllerRecalculateSimulationByIdData;
            res: {
                /**
                 * Single simulation (mixed type).
                 */
                200: EfficiencyImprovementSimulationDto | OnsiteGenerationSimulationDto | FlexibilitySimulationDto;
                /**
                 * No simulation found for the provided ID.
                 */
                404: unknown;
            };
        };
    };
    '/load-simulation/{id}/csv': {
        get: {
            req: LoadSimulationControllerGetSimulationCsvData;
            res: {
                /**
                 * CSV export with columns timestamp, valueKw, simulatedkw, deltaKw
                 */
                200: unknown;
            };
        };
    };
    '/generation-load-profile/{id}': {
        get: {
            req: GenerationLoadProfileControllerGetLoadProfileData;
            res: {
                200: GenerationLoadProfileDto;
            };
        };
        put: {
            req: GenerationLoadProfileControllerUpdateGenerationLoadProfileData;
            res: {
                200: GenerationLoadProfileDto;
            };
        };
        delete: {
            req: GenerationLoadProfileControllerDeleteGenerationLoadProfileData;
            res: {
                200: unknown;
            };
        };
    };
    '/generation-load-profile': {
        post: {
            req: GenerationLoadProfileControllerCreateGenerationLoadProfileData;
            res: {
                201: GenerationLoadProfileDto;
            };
        };
    };
    '/generation-load-profile/{id}/load-data': {
        post: {
            req: GenerationLoadProfileControllerUpdateLoadDataData;
            res: {
                201: unknown;
            };
        };
    };
    '/consumption/slp/{deviceId}/references': {
        get: {
            req: SlpConsumptionControllerGetReferencesForDeviceIdData;
            res: {
                /**
                 * Get references for a deviceId from visualizations and ENPI.
                 */
                200: DeviceReferencesResponseDto;
            };
        };
    };
    '/consumption/slp/{deviceId}': {
        get: {
            req: SlpConsumptionControllerGetSlpConsumptionData;
            res: {
                /**
                 * This API endpoint returns the consumption of a slp meter. The response includes:
                 *
                 * consumption: A list of all consumption across months in the selected timeframe.
                 */
                200: SlpConsumptionResponseDto;
            };
        };
        put: {
            req: SlpConsumptionControllerUpdateSlpConsumptionData;
            res: {
                /**
                 * Update slp consumption for given device.
                 */
                200: unknown;
            };
        };
        delete: {
            req: SlpConsumptionControllerDeleteSlpConsumptionData;
            res: {
                /**
                 * Delete slp consumption for given device.
                 */
                200: unknown;
            };
        };
    };
    '/meters/slp/{deviceId}/readings': {
        get: {
            req: SlpMeterReadingControllerGetReadingsData;
            res: {
                /**
                 * Get all SLP meter readings for a device
                 */
                200: Array<SlpMeterReadingResponseDto>;
            };
        };
        put: {
            req: SlpMeterReadingControllerReplaceReadingsData;
            res: {
                /**
                 * Receives the list of readings of a SLP and saves it
                 */
                200: Array<SlpMeterReadingResponseDto>;
                /**
                 * When new reading does not pass validation
                 */
                400: SlpMeterReadingValidationErrorDto;
            };
        };
    };
    '/meters/slp/{deviceId}/reading': {
        put: {
            req: SlpMeterReadingControllerCreateReadingData;
            res: {
                /**
                 * Create or update SLP meter readings for a device id. Upsert is based on the deviceId and timestamp match.
                 */
                200: SlpMeterReadingResponseDto;
                /**
                 * When new reading does not pass validation
                 */
                400: SlpMeterReadingValidationErrorDto;
            };
        };
    };
    '/meters/slp/{deviceId}/reading/upload-image': {
        post: {
            req: SlpMeterReadingControllerUploadFileData;
            res: {
                /**
                 * Image uploaded and meter reading extracted successfully
                 */
                200: UploadSlpImageResponseDto;
            };
        };
    };
    '/meters/slp/{deviceId}/reading/{id}/image': {
        get: {
            req: SlpMeterReadingControllerDownloadReadingImageData;
            res: {
                /**
                 * Download the image of a meter reading
                 */
                200: unknown;
                /**
                 * Device, reading, or image not found
                 */
                404: unknown;
            };
        };
    };
    '/cost/gas-costs-information': {
        put: {
            req: GasCostInformationControllerUpdateGasCostInformationData;
            res: {
                /**
                 * Updated gas cost information for a location
                 */
                200: GasCostInformationResponseDto;
            };
        };
    };
    '/v3/budget/tracking': {
        get: {
            req: BudgetTrackingControllerGetCostsData;
            res: {
                /**
                 * Returns budget and costs
                 */
                200: BudgetTrackingResponseDto;
            };
        };
    };
    '/v3/trends/consumption': {
        get: {
            req: ConsumptionTrendsControllerGetConsumptionTrendsByEnergyTypeData;
            res: {
                /**
                 * This API endpoint returns the electricity consumption trends data by energy types. The response includes:
                 *
                 * totalConsumptionYtdKWh: Total consumption year-to-date in kWh.
                 * totalConsumptionPastMonthKWh: Total consumption for the past month in kWh.
                 * trend: Consumption trend indicator, which can be a number or null.
                 * monthlyData: Optional array of monthly consumption data, which can be null if no data is available.
                 *
                 * The endpoint provides a quick overview of the electricity consumption patterns and trends.
                 */
                200: ConsumptionTrendsResponseDto;
            };
        };
    };
    '/trends/consumption-history': {
        get: {
            req: ConsumptionTrendsControllerGetConsumptionHistoryData;
            res: {
                /**
                 * Get consumption history trends
                 */
                200: ConsumptionHistoryResponseDto;
            };
        };
    };
    '/cost/invoice': {
        get: {
            req: InvoiceCostsControllerGetInvoiceCostsData;
            res: {
                /**
                 * Total costs for a device in a location within a given time period
                 */
                200: unknown;
            };
        };
    };
    '/calculations/devices/{deviceId}/year/{year}': {
        get: {
            req: CalculationsControllerRecalculateYearData;
            res: {
                200: unknown;
            };
        };
    };
    '/calculations/locations/{locationId}/devices/{deviceId}/month/{month}': {
        put: {
            req: CalculationsControllerRecalculateMonthData;
            res: {
                200: unknown;
            };
        };
    };
    '/calculations/locations/{locationId}/devices/{deviceId}/date/{date}': {
        get: {
            req: CalculationsControllerRecalculateDayData;
            res: {
                200: unknown;
            };
        };
    };
    '/calculations/enet-costs': {
        post: {
            req: CalculationsControllerCalculateEnetCostsData;
            res: {
                202: unknown;
            };
        };
    };
    '/calculations/peakload-daily': {
        post: {
            req: CalculationsControllerCalculatePeakloadData;
            res: {
                201: unknown;
            };
        };
    };
    '/calculations/baseload-ytd': {
        post: {
            req: CalculationsControllerCalculateBaseloadData;
            res: {
                201: unknown;
            };
        };
    };
    '/calculations/locations': {
        get: {
            req: CalculationsControllerGetLocationsOverviewData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/calculations/metrics': {
        get: {
            req: CalculationsControllerGetLocationsMetricsData;
            res: {
                /**
                 * Get locations metrics
                 */
                200: LocationEnergyPerformanceMetricsResponseDto;
            };
        };
    };
    '/calculations/metrics/csv': {
        get: {
            req: CalculationsControllerGetLocationsMetricsCsvData;
            res: {
                /**
                 * Get locations metrics
                 */
                200: unknown;
            };
        };
    };
    '/calculations/hedge-costs-monthly-summary': {
        post: {
            req: CalculationsControllerStoreHedgeCostMonthlySummaryData;
            res: {
                201: Array<{
                    [key: string]: unknown;
                }>;
            };
        };
    };
    '/calculations/run-cost-calculation': {
        post: {
            res: {
                204: void;
            };
        };
    };
    '/calculations/recalculate-device-metrics': {
        post: {
            req: CalculationsControllerRecalculateDeviceMetricsData;
            res: {
                204: void;
            };
        };
    };
    '/calculations/costs-summary/{year}': {
        get: {
            req: CostsSummaryControllerGetCostsSummaryData;
            res: {
                /**
                 * Get Costs Summary for given year.
                 */
                200: CostsSummaryResponseDto;
            };
        };
    };
    '/locations/enabled-modules': {
        get: {
            req: LocationControllerGetEnabledModulesForUserData;
            res: {
                /**
                 * Returns the enabled modules for the location
                 */
                200: LocationModulesResponseDto;
            };
        };
    };
    '/locations/{id}/enabled-modules': {
        put: {
            req: LocationControllerUpdateEnabledModulesData;
            res: {
                200: unknown;
                /**
                 * Modules updated successfully
                 */
                204: void;
            };
        };
        get: {
            req: LocationControllerGetLocationEnabledModulesData;
            res: {
                /**
                 * Modules updated successfully
                 */
                200: unknown;
            };
        };
    };
    '/locations/{id}': {
        get: {
            req: LocationControllerGetLocationData;
            res: {
                200: {
                    [key: string]: unknown;
                };
                /**
                 * Get location
                 */
                204: LocationDto;
            };
        };
    };
    '/locations/energy-manager-settings': {
        get: {
            req: LocationControllerGetEnergyManagerSettingsData;
            res: {
                /**
                 * Get energy manager pro settings
                 */
                200: unknown;
            };
        };
        patch: {
            req: LocationControllerSetEnergyManagerSettingsData;
            res: {
                /**
                 * Set energy manager pro settings
                 */
                200: unknown;
            };
        };
    };
    '/locations/{locationId}/reports': {
        patch: {
            req: LocationControllerSetReportsSettingsData;
            res: {
                /**
                 * Set reports settings
                 */
                200: unknown;
            };
        };
    };
    '/procurement/prices': {
        get: {
            res: {
                /**
                 * Spot market prices for the given time period
                 */
                200: PricesResponseDto;
            };
        };
    };
    '/procurement/prices/current': {
        get: {
            res: {
                /**
                 * Current spot market price
                 */
                200: CurrentPriceResponseDto;
            };
        };
    };
    '/procurement/prices/average-year-to-date': {
        get: {
            res: {
                /**
                 * Average year to date spot market price
                 */
                200: AveragePriceResponseDto;
            };
        };
    };
    '/procurement/prices/electricity': {
        post: {
            req: PricesControllerGetElectricityPricesData;
            res: {
                /**
                 * Electricity prices
                 */
                200: unknown;
            };
        };
    };
    '/spot-market': {
        get: {
            req: SpotMarketControllerGetPricesData;
            res: {
                /**
                 * Spot market prices for the given time period
                 */
                200: Array<SpotMarketPriceResponseDto>;
            };
        };
    };
    '/spot-market/{companyId}': {
        get: {
            req: SpotMarketControllerGetCompanyPricesData;
            res: {
                /**
                 * Spot market prices resolved from the company gas price source configuration
                 */
                200: Array<SpotMarketPriceResponseDto>;
            };
        };
    };
    '/v2/ember/checklist': {
        post: {
            req: EmberControllerAskChecklistAssistantData;
            res: {
                /**
                 * Request accepted and is being processed
                 */
                202: EmberChecklistAgentResponse;
            };
        };
    };
    '/v2/ember/document': {
        post: {
            req: EmberControllerAskDocumentAssistantData;
            res: {
                /**
                 * Request accepted and is being processed
                 */
                202: EmberDocumentAgentResponse;
            };
        };
    };
    '/v2/ember/embeddings': {
        get: {
            res: {
                /**
                 * List of all embedded files
                 */
                200: GetEmbeddedFilesDTO;
            };
        };
        post: {
            res: {
                /**
                 * Results of the file embedding operations
                 */
                201: EmbeddingResultDTO;
            };
        };
    };
    '/v2/ember/embeddings/{id}': {
        delete: {
            req: EmberControllerDeleteEmbeddingsByFileIdData;
            res: {
                200: unknown;
                /**
                 * File and its corresponding embeddings deleted successfully
                 */
                204: void;
            };
        };
    };
    '/v2/ember/chat': {
        post: {
            req: EmberControllerAskChatAssistantData;
            res: {
                /**
                 * Request accepted and is being processed
                 */
                202: EmberChatAgentResponse;
            };
        };
    };
    '/v2/ember/cancel': {
        post: {
            req: EmberControllerCancelMessageProcessingData;
            res: {
                201: unknown;
                /**
                 * Message processing aborted
                 */
                204: void;
            };
        };
    };
    '/v2/ember/threads/cleanup': {
        post: {
            res: {
                /**
                 * Thread cleanup completed
                 */
                200: EmberThreadCleanupResultDto;
                201: unknown;
            };
        };
    };
    '/v2/ember/threads/all': {
        delete: {
            res: {
                /**
                 * All threads deleted successfully
                 */
                200: EmberThreadDeleteResultDto;
            };
        };
    };
    '/v2/ember/threads/stats': {
        get: {
            res: {
                /**
                 * Thread statistics
                 */
                200: EmberThreadStatsDto;
            };
        };
    };
    '/v2/ember/propose': {
        post: {
            req: EmberControllerGetProposedQuestionsData;
            res: {
                /**
                 * Proposed questions
                 */
                200: ProposedQuestionsResponseDto;
            };
        };
    };
    '/ember/reports/generate-module': {
        post: {
            req: EmberControllerGenerateReportModuleConfigData;
            res: {
                /**
                 * A report module DTO with AI-generated values
                 */
                202: ResponseReportModuleDto;
                /**
                 * Validation failed
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
            };
        };
    };
    '/v2/ember/agent-graph': {
        get: {
            req: EmberControllerVisualizeAgentGraphData;
            res: {
                /**
                 * Visualization of the agent graph as a PNG
                 */
                200: unknown;
            };
        };
    };
    '/v2/ember/call-transcripts': {
        get: {
            req: EmberControllerGetCallTranscriptsForCompanyData;
            res: {
                /**
                 * Returns a list of call transcripts
                 */
                200: GetEmbeddedCallTranscriptsDTO;
            };
        };
        post: {
            req: EmberControllerEmbedSingleCallTranscriptData;
            res: {
                200: unknown;
                201: EmbeddingResultDTO;
            };
        };
        delete: {
            req: EmberControllerDeleteSingleCallTranscriptEmbeddingData;
            res: {
                200: unknown;
            };
        };
    };
    '/v2/ember/call-transcripts/sync': {
        post: {
            req: EmberControllerSyncCallTranscriptsData;
            res: {
                201: unknown;
            };
        };
    };
    '/custom-reports/{id}': {
        get: {
            req: CustomReportControllerGetCustomReportData;
            res: {
                /**
                 * Custom report retrieved
                 */
                200: ResponseCustomReportDto;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden: user has no access to this report
                 */
                403: unknown;
                /**
                 * Custom report not found
                 */
                404: unknown;
            };
        };
        patch: {
            req: CustomReportControllerUpdateCustomReportData;
            res: {
                /**
                 * Custom report updated
                 */
                200: ResponseCustomReportDto;
                /**
                 * Validation failed
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden: user has no access to this report
                 */
                403: unknown;
                /**
                 * Custom report not found
                 */
                404: unknown;
            };
        };
        delete: {
            req: CustomReportControllerDeleteCustomReportData;
            res: {
                /**
                 * Custom report deleted
                 */
                204: void;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden: user has no access to this report
                 */
                403: unknown;
                /**
                 * Custom report not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports': {
        get: {
            req: CustomReportControllerGetAllCustomReportsData;
            res: {
                /**
                 * List of custom reports
                 */
                200: Array<ResponseCustomReportDto>;
                /**
                 * Unauthorized
                 */
                401: unknown;
            };
        };
        post: {
            req: CustomReportControllerCreateCustomReportData;
            res: {
                /**
                 * Custom report created
                 */
                201: ResponseCustomReportDto;
                /**
                 * Validation failed
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
            };
        };
    };
    '/custom-reports/request-reporting-upgrade': {
        post: {
            res: {
                /**
                 * Upgrade request sent
                 */
                200: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
            };
        };
    };
    '/custom-reports/{id}/logo': {
        get: {
            req: CustomReportControllerGetCustomReportLogoData;
            res: {
                /**
                 * Logo file returned
                 */
                200: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden: user has no access to this report
                 */
                403: unknown;
                /**
                 * Logo not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/{id}/generate': {
        post: {
            req: CustomReportControllerGenerateReportManuallyData;
            res: {
                /**
                 * Report generated successfully
                 */
                200: unknown;
                /**
                 * Report has no frequency configuration
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Report not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/{id}/generate-pdf': {
        post: {
            req: CustomReportControllerGeneratePdfData;
            res: {
                /**
                 * PDF generated successfully
                 */
                200: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
                /**
                 * Report not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/pdf-access/validate': {
        get: {
            req: CustomReportControllerValidatePdfTokenData;
            res: {
                /**
                 * Token is valid
                 */
                200: unknown;
                /**
                 * Invalid or expired token
                 */
                401: unknown;
            };
        };
    };
    '/custom-reports/pdf-access/report/{reportId}/modules': {
        get: {
            req: CustomReportControllerGetModulesForPdfData;
            res: {
                /**
                 * Report with modules data
                 */
                200: ResponseReportWithModulesForPdfDto;
                /**
                 * Invalid PDF token
                 */
                401: unknown;
                /**
                 * Report not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/pdf-access/report/{reportId}/data-completeness': {
        get: {
            req: CustomReportControllerGetDataCompletenessForPdfData;
            res: {
                /**
                 * Data completeness returned
                 */
                200: GetDataCompletenessResponseDto;
                /**
                 * Invalid PDF token
                 */
                401: unknown;
            };
        };
    };
    '/custom-reports/pdf-access/report/{reportId}/module/{moduleId}/images': {
        get: {
            req: CustomReportControllerGetModuleImageForPdfData;
            res: {
                /**
                 * Image file returned
                 */
                200: unknown;
                /**
                 * Invalid PDF token
                 */
                401: unknown;
                /**
                 * Image not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/scheduler/trigger-recovery': {
        post: {
            res: {
                /**
                 * Recovery sweep completed
                 */
                200: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden — platform admin access required
                 */
                403: unknown;
            };
        };
    };
    '/custom-reports/{reportId}/sent-reports': {
        get: {
            req: CustomReportControllerGetSentReportsData;
            res: {
                /**
                 * List of sent reports
                 */
                200: Array<ResponseSentReportDto>;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
                /**
                 * Report not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/{reportId}/sent-reports/{sentReportId}': {
        get: {
            req: CustomReportControllerGetSentReportData;
            res: {
                /**
                 * Sent report retrieved
                 */
                200: ResponseSentReportDto;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
                /**
                 * Sent report not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/{reportId}/sent-reports/{sentReportId}/logo': {
        get: {
            req: CustomReportControllerGetSentReportLogoData;
            res: {
                /**
                 * Logo file returned
                 */
                200: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden: user has no access to this report
                 */
                403: unknown;
                /**
                 * Logo not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/{reportId}/sent-reports/{sentReportId}/modules': {
        get: {
            req: CustomReportControllerGetSentReportModulesData;
            res: {
                /**
                 * List of sent report modules
                 */
                200: Array<ResponseSentReportModuleDto>;
                /**
                 * Validation failed or report mismatch
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
                /**
                 * Sent report not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/{reportId}/sent-reports/{sentReportId}/modules-with-data': {
        get: {
            req: CustomReportControllerGetSentReportModulesWithDataData;
            res: {
                /**
                 * List of sent report modules with data
                 */
                200: Array<ResponseSentReportModuleWithDataDto>;
                /**
                 * Validation failed or report mismatch
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
                /**
                 * Sent report not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/{reportId}/sent-reports/{sentReportId}/modules/{moduleId}': {
        get: {
            req: CustomReportControllerGetSentReportModuleWithDataData;
            res: {
                /**
                 * Sent report module with data
                 */
                200: ResponseSentReportModuleWithDataDto;
                /**
                 * Validation failed or report mismatch
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
                /**
                 * Module not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/{reportId}/sent-reports/{sentReportId}/modules/{moduleId}/image': {
        get: {
            req: CustomReportControllerGetSentReportModuleImageData;
            res: {
                /**
                 * Image file returned
                 */
                200: unknown;
                /**
                 * Validation failed or report mismatch
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden: user has no access to this report
                 */
                403: unknown;
                /**
                 * Image not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/{reportId}/modules': {
        get: {
            req: CustomReportControllerGetReportModulesData;
            res: {
                /**
                 * List of report modules
                 */
                200: Array<ResponseReportModuleDto>;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
                /**
                 * Report not found
                 */
                404: unknown;
            };
        };
        post: {
            req: CustomReportControllerCreateReportModuleData;
            res: {
                /**
                 * Report module created
                 */
                201: ResponseReportModuleDto;
                /**
                 * Validation failed
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
            };
        };
    };
    '/custom-reports/{reportId}/modules/{moduleId}': {
        get: {
            req: CustomReportControllerGetModuleData;
            res: {
                /**
                 * Report module with data
                 */
                200: ResponseReportModuleWithDataDto;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
                /**
                 * Module not found
                 */
                404: unknown;
            };
        };
        patch: {
            req: CustomReportControllerUpdateReportModuleData;
            res: {
                /**
                 * Report module updated
                 */
                200: ResponseReportModuleDto;
                /**
                 * Validation failed
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
                /**
                 * Module not found
                 */
                404: unknown;
            };
        };
        delete: {
            req: CustomReportControllerDeleteReportModuleData;
            res: {
                /**
                 * Report module deleted
                 */
                204: void;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
                /**
                 * Module not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/{reportId}/apply-template': {
        post: {
            req: CustomReportControllerApplyTemplateData;
            res: {
                /**
                 * Template modules created
                 */
                201: Array<ResponseReportModuleDto>;
                /**
                 * Validation failed
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
            };
        };
    };
    '/custom-reports/{reportId}/modules/reorder': {
        post: {
            req: CustomReportControllerReorderReportModulesData;
            res: {
                /**
                 * Modules reordered successfully
                 */
                200: Array<ResponseReportModuleDto>;
                /**
                 * Validation failed or invalid module IDs
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
                /**
                 * Report not found
                 */
                404: unknown;
            };
        };
    };
    '/custom-reports/{reportId}/modules/{moduleId}/image': {
        get: {
            req: CustomReportControllerGetModuleImageData;
            res: {
                /**
                 * Image file returned
                 */
                200: unknown;
                /**
                 * Module is not an image module
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden: user has no access to this report
                 */
                403: unknown;
                /**
                 * Image not found
                 */
                404: unknown;
            };
        };
    };
    '/data-completeness': {
        get: {
            req: DataCompletenessControllerGetDataCompletenessData;
            res: {
                /**
                 * Scope items with item-level and per-period completeness plus global completenessPercentage rollup
                 */
                200: GetDataCompletenessResponseDto;
            };
        };
    };
    '/gaps': {
        get: {
            req: GapsControllerGetGapsData;
            res: {
                /**
                 * Get device data gaps filtered by scope and optional date range
                 */
                200: Array<GetGapsResponseDto>;
            };
        };
    };
    '/v2/series': {
        get: {
            req: SeriesControllerListSeriesData;
            res: {
                /**
                 * Series list retrieved
                 */
                200: Array<SeriesResponseDto>;
                /**
                 * At least one filter parameter is required
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
            };
        };
        post: {
            req: SeriesControllerCreateOrLinkSeriesData;
            res: {
                /**
                 * Series created or linked successfully
                 */
                200: CreateOrLinkSeriesResponseDto;
                /**
                 * Invalid input
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
            };
        };
    };
    '/v2/series/{id}': {
        get: {
            req: SeriesControllerGetSeriesByIdData;
            res: {
                /**
                 * Series found
                 */
                200: SeriesResponseDto;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Series not found
                 */
                404: unknown;
            };
        };
        put: {
            req: SeriesControllerUpdateSeriesData;
            res: {
                /**
                 * Series updated successfully
                 */
                200: SeriesResponseDto;
                /**
                 * Invalid input
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Series not found
                 */
                404: unknown;
            };
        };
        delete: {
            req: SeriesControllerDeleteSeriesData;
            res: {
                /**
                 * Series deleted successfully
                 */
                204: void;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Series not found
                 */
                404: unknown;
            };
        };
    };
    '/v2/meter-series': {
        post: {
            req: MeterSeriesControllerLinkMetersToSeriesData;
            res: {
                /**
                 * Meters linked to series successfully
                 */
                201: unknown;
                /**
                 * DeviceId mismatch
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Meter or series not found
                 */
                404: unknown;
            };
        };
        delete: {
            req: MeterSeriesControllerUnlinkMetersFromSeriesData;
            res: {
                /**
                 * Meters unlinked from series successfully
                 */
                204: void;
                /**
                 * Unauthorized
                 */
                401: unknown;
            };
        };
    };
    '/v2/meter-series/titles': {
        post: {
            req: MeterSeriesControllerBatchUpdateMeterSeriesTitlesData;
            res: {
                /**
                 * Titles updated successfully
                 */
                204: void;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Meter-series link not found
                 */
                404: unknown;
            };
        };
    };
    '/v2/meter-series/meter/{meterId}': {
        get: {
            req: MeterSeriesControllerGetSeriesForMeterData;
            res: {
                /**
                 * Series list retrieved
                 */
                200: Array<SeriesResponseDto>;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Meter belongs to a location the caller is not assigned to
                 */
                403: unknown;
                /**
                 * Meter not found
                 */
                404: unknown;
            };
        };
    };
    '/v2/meter-series/series/{seriesId}': {
        get: {
            req: MeterSeriesControllerGetMetersForSeriesData;
            res: {
                /**
                 * Meters list retrieved
                 */
                200: Array<MeterInfoDto>;
                /**
                 * Unauthorized
                 */
                401: unknown;
            };
        };
    };
    '/v2/meter-series/device/{deviceId}/meter/{meterId}': {
        get: {
            req: MeterSeriesControllerGetAllSeriesForDeviceWithLinkStatusData;
            res: {
                /**
                 * Series list with link status retrieved
                 */
                200: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
            };
        };
    };
    '/v2/meter-series/device/{deviceId}/series/{seriesId}/meters': {
        get: {
            req: MeterSeriesControllerGetAllMetersForDeviceWithLinkStatusData;
            res: {
                /**
                 * Meters list with link status retrieved
                 */
                200: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
            };
        };
    };
    '/sankey': {
        get: {
            req: SankeyControllerGetSankeyData;
            res: {
                /**
                 * Sankey-Graph data of given building.
                 */
                200: SankeyGetResponseDto;
                /**
                 * Cyclic tree detected in sankey data generation.
                 */
                400: SankeyCyclicErrorDto;
            };
        };
    };
    '/sankey/csv': {
        post: {
            req: SankeyControllerGetSankeyCsvData;
            res: {
                /**
                 * CSV export of sankey nodes for either location or building
                 */
                200: unknown;
                /**
                 * CSV export not available or invalid parameters
                 */
                400: unknown;
            };
        };
    };
    '/sankey/meter-views/{id}': {
        get: {
            req: SankeyControllerGetMeterViewSankeyData;
            res: {
                /**
                 * Sankey diagram data with nodes and links
                 */
                200: SankeyGetResponseDto;
                /**
                 * Meter view not found
                 */
                404: unknown;
            };
        };
    };
    '/sankey/meter-views/{id}/csv': {
        post: {
            req: SankeyControllerGetMeterViewSankeyCsvData;
            res: {
                /**
                 * CSV export of sankey nodes with consumption data
                 */
                200: unknown;
                /**
                 * Meter view not found
                 */
                404: unknown;
            };
        };
    };
    '/meter-views': {
        get: {
            req: MeterViewControllerFindAllData;
            res: {
                /**
                 * List of meter views
                 */
                200: MeterViewListResponseDto;
            };
        };
        post: {
            req: MeterViewControllerCreateData;
            res: {
                /**
                 * Meter view created successfully
                 */
                201: MeterViewDto;
                /**
                 * Invalid input data
                 */
                400: unknown;
            };
        };
    };
    '/meter-views/{id}': {
        get: {
            req: MeterViewControllerFindByIdData;
            res: {
                /**
                 * Meter view with nodes
                 */
                200: MeterViewDto;
                /**
                 * Meter view not found
                 */
                404: unknown;
            };
        };
        put: {
            req: MeterViewControllerUpdateData;
            res: {
                /**
                 * Meter view updated successfully
                 */
                200: MeterViewDto;
                /**
                 * Meter view not found
                 */
                404: unknown;
            };
        };
        delete: {
            req: MeterViewControllerDeleteData;
            res: {
                /**
                 * Meter view deleted successfully
                 */
                204: void;
                /**
                 * Meter view not found
                 */
                404: unknown;
            };
        };
    };
    '/meter-views/{id}/nodes': {
        post: {
            req: MeterViewControllerCreateNodeData;
            res: {
                /**
                 * Node created successfully
                 */
                201: ViewNodeDto;
                /**
                 * Invalid input data
                 */
                400: unknown;
                /**
                 * Meter view not found
                 */
                404: unknown;
            };
        };
    };
    '/meter-views/{id}/nodes/{nodeId}': {
        delete: {
            req: MeterViewControllerDeleteNodeData;
            res: {
                /**
                 * Node deleted successfully
                 */
                204: void;
                /**
                 * Cannot delete node with children
                 */
                400: unknown;
                /**
                 * Node not found
                 */
                404: unknown;
            };
        };
    };
    '/meter-views/{id}/nodes/{nodeId}/folder-name': {
        patch: {
            req: MeterViewControllerUpdateFolderNameData;
            res: {
                200: unknown;
                /**
                 * Folder name updated successfully
                 */
                204: void;
                /**
                 * Invalid input data or node is not a folder
                 */
                400: unknown;
                /**
                 * Folder node not found
                 */
                404: unknown;
            };
        };
    };
    '/meter-views/{id}/nodes/{nodeId}/parent': {
        patch: {
            req: MeterViewControllerUpdateNodeParentData;
            res: {
                /**
                 * Node parent updated successfully
                 */
                204: void;
                /**
                 * Invalid input data or circular reference
                 */
                400: unknown;
                /**
                 * Node not found
                 */
                404: unknown;
            };
        };
    };
    '/procurement/create-past-invoices': {
        post: {
            res: {
                201: unknown;
            };
        };
    };
    '/procurement/create-scheduled-invoices': {
        post: {
            res: {
                201: unknown;
            };
        };
    };
    '/procurement/invoices/recreate': {
        post: {
            req: InvoicesControllerRecreateYearInvoicesForCompanyData;
            res: {
                /**
                 * Re-generates invoices for given year/month for locations or companies.
                 */
                200: unknown;
            };
        };
    };
    '/procurement/invoices': {
        get: {
            req: InvoicesControllerGetInvoicesData;
            res: {
                /**
                 * Get invoices for given company.
                 */
                200: InvoicePageableResponseListDto;
            };
        };
    };
    '/v2/procurement/invoices': {
        get: {
            req: InvoicesControllerGetProcurementInvoicesData;
            res: {
                /**
                 * Get invoices for given company, with cost details calculated by procurement.
                 */
                200: InvoicePageableResponseListDto;
            };
        };
    };
    '/procurement/invoices/{invoiceId}/status': {
        patch: {
            req: InvoicesControllerUpdateStatusData;
            res: {
                /**
                 * Updates status of an invoice
                 */
                200: InvoiceResponseDto;
            };
        };
    };
    '/procurement/invoices/{invoiceId}/cost-details': {
        patch: {
            req: InvoicesControllerUpdateCostDetailsData;
            res: {
                /**
                 * Updates cost details of an invoice
                 */
                200: InvoiceResponseDto;
            };
        };
    };
    '/procurement/invoices/{invoiceId}/ocr-cost-details': {
        patch: {
            req: InvoicesControllerUpdateOcrCostDetailsData;
            res: {
                /**
                 * Updates ocr cost details of an invoice. Accepts a body with the cost details or an empty body to execute OCR.
                 */
                200: InvoiceResponseDto;
            };
        };
    };
    '/procurement/invoices/{invoiceId}/cost-verification': {
        patch: {
            req: InvoicesControllerUpdateOcrCostVerificationData;
            res: {
                /**
                 * Updates ocr cost verifications of an invoice
                 */
                200: InvoiceResponseDto;
            };
        };
    };
    '/procurement/invoices/{invoiceId}/notes': {
        patch: {
            req: InvoicesControllerUpdateNotesData;
            res: {
                /**
                 * Updates notes of an invoice
                 */
                200: InvoiceResponseDto;
            };
        };
    };
    '/procurement/invoices/{invoiceId}/invoice': {
        post: {
            req: InvoicesControllerUploadExternalInvoiceData;
            res: {
                201: InvoiceResponseDto;
                /**
                 * Invoice file uploaded
                 */
                204: void;
            };
        };
        delete: {
            req: InvoicesControllerDeleteInvoiceFileData;
            res: {
                /**
                 * External Invoice deleted
                 */
                204: void;
            };
        };
    };
    '/procurement/invoices/meters/{deviceId}': {
        post: {
            req: InvoicesControllerUploadInvoiceToMeterData;
            res: {
                201: InvoiceResponseDto;
                /**
                 * Invoice file uploaded
                 */
                204: void;
            };
        };
    };
    '/procurement/invoices/{invoiceId}/invoice-legacy': {
        post: {
            req: InvoicesControllerUploadExternalInvoiceLegacyData;
            res: {
                201: InvoiceResponseDto;
                /**
                 * Invoice file uploaded without ocr checking. this endpoint exist as long as ocr invoice checking has not been enabled for all customers
                 */
                204: void;
            };
        };
    };
    '/procurement/invoices/{invoiceId}': {
        delete: {
            req: InvoicesControllerDeleteInvoiceData;
            res: {
                /**
                 * Invoice deleted
                 */
                204: void;
            };
        };
        get: {
            req: InvoicesControllerGetInvoiceByIdData;
            res: {
                /**
                 * Get invoice by ID
                 */
                200: InvoiceResponseDto;
            };
        };
    };
    '/v2/procurement/invoices/{invoiceId}': {
        get: {
            req: InvoicesControllerGetProcurementInvoiceByIdData;
            res: {
                /**
                 * Get invoice by ID, with cost details calculated by procurement.
                 */
                200: InvoiceResponseDto;
            };
        };
    };
    '/procurement/manual-invoice-positions': {
        get: {
            req: ManualInvoicePositionsControllerFindByLocationAndPeriodData;
            res: {
                /**
                 * List of manual invoice positions
                 */
                200: Array<ManualInvoicePositionDto>;
            };
        };
        post: {
            req: ManualInvoicePositionsControllerCreateData;
            res: {
                /**
                 * Manual invoice position created successfully
                 */
                201: ManualInvoicePositionDto;
                /**
                 * Bad Request
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
            };
        };
    };
    '/procurement/manual-invoice-positions/{id}': {
        put: {
            req: ManualInvoicePositionsControllerUpdateData;
            res: {
                /**
                 * Manual invoice position updated successfully
                 */
                200: ManualInvoicePositionDto;
                /**
                 * Bad Request
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
                /**
                 * Manual invoice position not found
                 */
                404: unknown;
            };
        };
        delete: {
            req: ManualInvoicePositionsControllerDeleteData;
            res: {
                /**
                 * Manual invoice position deleted successfully
                 */
                204: void;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden
                 */
                403: unknown;
                /**
                 * Manual invoice position not found
                 */
                404: unknown;
            };
        };
    };
    '/functions/insights': {
        get: {
            req: InsightsControllerGetInsightsData;
            res: {
                /**
                 * Insights for a given device
                 */
                200: Array<InsightsResponseDto>;
            };
        };
    };
    '/platform/data-ingester/consumption': {
        post: {
            req: DataIngesterControllerSendDataFetchCommandData;
            res: {
                201: unknown;
            };
        };
    };
    '/integrations/sma/token': {
        get: {
            req: SmaControllerUpdateTokenData;
            res: {
                200: unknown;
            };
        };
    };
    '/integrations/enet/network-costs': {
        get: {
            req: EnetControllerGetNetworkCostsData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/integrations/enet/concession-fee': {
        get: {
            req: EnetControllerGetConcessionFeeData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/integrations/enet/special-grid-usage': {
        get: {
            req: EnetControllerGetSpecialGridUsageData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/integrations/enet/energy-tax': {
        get: {
            req: EnetControllerGetEnergyTaxData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/integrations/enet/gas-rlm-metering': {
        get: {
            req: EnetControllerGetGasRlmMeteringData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/integrations/enet/electricity-levies': {
        get: {
            req: EnetControllerGetElectricityLeviesData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/integrations/enet/gas-levies': {
        get: {
            req: EnetControllerGetGasLeviesData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/integrations/enet/gas-rlm-energy-zones': {
        get: {
            req: EnetControllerGetGasRlmEnergyZonesData;
            res: {
                200: Array<{
                    [key: string]: unknown;
                }>;
            };
        };
    };
    '/integrations/enet/gas-rlm-peak-zones': {
        get: {
            req: EnetControllerGetGasRlmPeakZonesData;
            res: {
                200: Array<{
                    [key: string]: unknown;
                }>;
            };
        };
    };
    '/logs/data-gaps': {
        get: {
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/logs/ingestion': {
        post: {
            req: LogsControllerFindIngestionLogsData;
            res: {
                201: unknown;
            };
        };
    };
    '/reports/recipients': {
        get: {
            req: ReportsControllerGetReportRecipientsData;
            res: {
                /**
                 * Get list of recipients for a given report.
                 */
                200: unknown[];
            };
        };
    };
    '/v2/analytics/multivariate-linear-regression': {
        post: {
            req: MultivariateLinearRegressionControllerCreateRegressionData;
            res: {
                /**
                 * Successful creation of Regression
                 */
                201: MultivariateLinearRegressionResponse;
            };
        };
        get: {
            req: MultivariateLinearRegressionControllerGetAllRegressionsData;
            res: {
                /**
                 * Get all MultivariateLinearRegressions
                 */
                200: MultivariateLinearRegressionPageableResponseList;
                /**
                 * Unauthorized access
                 */
                401: unknown;
            };
        };
    };
    '/v2/analytics/multivariate-linear-regression/{id}': {
        patch: {
            req: MultivariateLinearRegressionControllerUpdateRegressionData;
            res: {
                /**
                 * Successfully updated Regression
                 */
                200: MultivariateLinearRegressionResponse;
            };
        };
        get: {
            req: MultivariateLinearRegressionControllerGetRegressionByIdData;
            res: {
                /**
                 * Successfully retrieved regression by ID
                 */
                200: MultivariateLinearRegressionResponse;
            };
        };
        delete: {
            req: MultivariateLinearRegressionControllerDeleteRegressionData;
            res: {
                /**
                 * Successfully deleted Regression
                 */
                200: unknown;
                204: void;
            };
        };
    };
    '/v2/analytics/multivariate-linear-regression/{id}/actual-vs-model-series': {
        get: {
            req: MultivariateLinearRegressionControllerGetActualVsModelSeriesData;
            res: {
                /**
                 * Measured dependent series and the output of the regression model within the given range
                 */
                200: ActualVsModelSeriesResponse;
            };
        };
    };
    '/analytics/baseline': {
        get: {
            req: BaselineControllerFindAllData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
        post: {
            req: BaselineControllerCreateData;
            res: {
                /**
                 * Baseline created
                 */
                201: unknown;
            };
        };
    };
    '/analytics/baseline/{id}': {
        get: {
            req: BaselineControllerGetAnalysisData;
            res: {
                /**
                 * Baseline analysis result
                 */
                200: unknown;
            };
        };
        put: {
            req: BaselineControllerUpdateData;
            res: {
                /**
                 * Baseline updated
                 */
                200: unknown;
            };
        };
        delete: {
            req: BaselineControllerDeleteData;
            res: {
                204: void;
            };
        };
    };
    '/feature-news': {
        get: {
            req: FeatureNewsControllerGetFeatureNewsData;
            res: {
                /**
                 * Successfully fetched feature news
                 */
                200: Array<FeatureNewsDTO>;
                /**
                 * Internal server error
                 */
                500: unknown;
            };
        };
    };
    '/v3/budget/budget': {
        get: {
            req: BudgetControllerGetInvoicesData;
            res: {
                /**
                 * Get Budget for company or location
                 */
                200: BudgetSummaryDto;
            };
        };
    };
    '/v4/budget/budget': {
        get: {
            req: BudgetControllerGetInvoicesWithProcurementCostsData;
            res: {
                /**
                 * Get Budget for company or location. Open invoices use procurement costs when that calculation succeeds.
                 */
                200: BudgetSummaryDto;
            };
        };
    };
    '/upload/consumption': {
        post: {
            req: UploadControllerUploadConsumptionFilesData;
            res: {
                /**
                 * Upload consumption files successfully
                 */
                200: UploadConsumptionFilesDto;
                201: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/upload/consumption/demo-devices': {
        post: {
            res: {
                /**
                 * Upload demo devices data successfully
                 */
                200: UploadDemoDevicesResponseDto;
            };
        };
    };
    '/upload/consumption/slp-manual/{companyId}': {
        post: {
            req: UploadControllerUploadSlpManualConsumptionData;
            res: {
                201: unknown;
            };
        };
    };
    '/upload/manual-meters/{companyId}/template': {
        get: {
            req: ManualMeterUploadControllerTemplateData;
            res: {
                200: unknown;
            };
        };
    };
    '/upload/manual-meters/{companyId}/preview': {
        post: {
            req: ManualMeterUploadControllerPreviewData;
            res: {
                201: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/upload/manual-meters/{companyId}': {
        post: {
            req: ManualMeterUploadControllerApplyData;
            res: {
                201: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/upload/manual-meters/{companyId}/history': {
        get: {
            req: ManualMeterUploadControllerHistoryData;
            res: {
                200: unknown;
            };
        };
    };
    '/upload/manual-meters/{companyId}/history/{id}': {
        get: {
            req: ManualMeterUploadControllerDetailData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/upload/manual-meters/{companyId}/history/{id}/file': {
        get: {
            req: ManualMeterUploadControllerOriginalFileData;
            res: {
                200: unknown;
            };
        };
    };
    '/upload/manual-meters/{companyId}/history/{id}/retry': {
        post: {
            req: ManualMeterUploadControllerRetryData;
            res: {
                201: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/normalizer/devices-health-check': {
        post: {
            req: NormalizerControllerCheckDevicesHealthData;
            res: {
                /**
                 * Successfully run health check on devices
                 */
                200: Array<DeviceHealthCheckResultDto>;
                201: unknown;
            };
        };
    };
    '/normalizer': {
        post: {
            req: NormalizerControllerNormalizeData;
            res: {
                /**
                 * Data successfully normalized and persisted
                 */
                201: unknown;
                /**
                 * Bad request - invalid input parameters or unsupported series
                 */
                400: unknown;
                /**
                 * Device not found
                 */
                404: unknown;
                /**
                 * Internal server error
                 */
                500: unknown;
            };
        };
    };
    '/normalizer/virtual-series': {
        post: {
            req: NormalizerControllerUpdateVirtualsAfterDataNormalizationData;
            res: {
                /**
                 * Virtual series successfully calculated and persisted
                 */
                201: unknown;
                /**
                 * Bad request - invalid input parameters
                 */
                400: unknown;
                /**
                 * Internal server error
                 */
                500: unknown;
            };
        };
    };
    '/normalizer/setup-virtuals': {
        post: {
            req: NormalizerControllerSetupVirtualMetersData;
            res: {
                /**
                 * Virtual meters setup completed successfully
                 */
                201: unknown;
                /**
                 * Bad request - invalid input parameters
                 */
                400: unknown;
                /**
                 * Internal server error
                 */
                500: unknown;
            };
        };
    };
    '/normalizer/manual-consumption': {
        post: {
            req: NormalizerControllerHandleManualNormalizedDataData;
            res: {
                201: unknown;
            };
        };
    };
    '/meter-overview': {
        get: {
            req: MeterOverviewControllerGetOverviewData;
            res: {
                200: MeterOverviewResponseDto;
            };
        };
    };
    '/meter-overview/electricity-balance': {
        get: {
            req: MeterOverviewControllerGetElectricityBalanceData;
            res: {
                200: MeterOverviewElectricityBalanceResponseDto;
            };
        };
    };
    '/meter-overview/groups': {
        post: {
            req: MeterOverviewControllerCreateGroupData;
            res: {
                201: MeterOverviewGroupDto;
            };
        };
    };
    '/meter-overview/groups/{groupId}': {
        patch: {
            req: MeterOverviewControllerRenameGroupData;
            res: {
                204: void;
            };
        };
        delete: {
            req: MeterOverviewControllerDeleteGroupData;
            res: {
                204: void;
            };
        };
    };
    '/meter-overview/group-membership': {
        put: {
            req: MeterOverviewControllerSetGroupMembershipData;
            res: {
                204: void;
            };
        };
    };
    '/virtual-meter': {
        post: {
            req: VirtualMeterControllerCreateVirtualDeviceData;
            res: {
                /**
                 * Virtual device created successfully
                 */
                201: VirtualDeviceResponseDto;
                /**
                 * Invalid input data
                 */
                400: unknown;
                /**
                 * Internal server error
                 */
                500: unknown;
            };
        };
        delete: {
            req: VirtualMeterControllerDeleteVirtualDeviceData;
            res: {
                /**
                 * Virtual device deleted successfully (no content returned)
                 */
                204: void;
                /**
                 * Invalid input data
                 */
                400: unknown;
                /**
                 * Virtual device not found
                 */
                404: unknown;
                /**
                 * Internal server error
                 */
                500: unknown;
            };
        };
    };
    '/virtual-meter/{deviceId}': {
        put: {
            req: VirtualMeterControllerUpdateVirtualDeviceData;
            res: {
                /**
                 * Virtual device updated successfully
                 */
                200: UpdateVirtualDeviceResponseDto;
                /**
                 * Invalid input data
                 */
                400: unknown;
                /**
                 * Virtual device not found
                 */
                404: unknown;
                /**
                 * Internal server error
                 */
                500: unknown;
            };
        };
    };
    '/firebase/locations-info': {
        get: {
            req: LocationsInfoControllerGetLocationsInfoData;
            res: {
                200: unknown;
            };
        };
    };
    '/companies/{companyId}/locations/{locationId}/buildings/{buildingId}/devices': {
        get: {
            req: DeviceControllerGetDevicesByBuildingData;
            res: {
                200: unknown;
            };
        };
        post: {
            req: DeviceControllerUpsertDeviceData;
            res: {
                200: DeviceListResponseDto;
            };
        };
    };
    '/companies/{companyId}/locations/{locationId}/buildings/{buildingId}/devices/{deviceId}': {
        delete: {
            req: DeviceControllerDeleteDeviceData;
            res: {
                200: unknown;
            };
        };
    };
    '/forecasts': {
        get: {
            req: ForecastControllerFindAllData;
            res: {
                /**
                 * List of forecasts
                 */
                200: Array<ForecastResponseDto>;
            };
        };
        post: {
            req: ForecastControllerCreateData;
            res: {
                /**
                 * Forecast created
                 */
                201: ForecastResponseDto;
            };
        };
    };
    '/forecasts/{forecastId}': {
        get: {
            req: ForecastControllerFindOneByIdData;
            res: {
                /**
                 * Forecast details
                 */
                200: ForecastResponseDto;
            };
        };
    };
    '/forecasts/{forecastId}/data': {
        get: {
            req: ForecastControllerGetForecastDataData;
            res: {
                /**
                 * Forecast data points with consumption values in 15-minute intervals
                 */
                200: ForecastDataResponseDto;
                /**
                 * Bad request - MODEL_GENERATED forecasts not supported
                 */
                400: unknown;
            };
        };
    };
    '/forecasts/{forecastId}/state': {
        patch: {
            req: ForecastControllerPatchStateData;
            res: {
                /**
                 * Forecast state updated
                 */
                200: ForecastResponseDto;
            };
        };
    };
    '/forecasts/{forecastId}/adjustments': {
        post: {
            req: ForecastControllerCreateAdjustmentData;
            res: {
                /**
                 * Adjustment created
                 */
                201: AdjustmentResponseDto;
            };
        };
    };
    '/forecasts/{forecastId}/adjustments/{adjustmentId}': {
        put: {
            req: ForecastControllerUpdateAdjustmentData;
            res: {
                /**
                 * Adjustment updated
                 */
                200: AdjustmentResponseDto;
            };
        };
        delete: {
            req: ForecastControllerDeleteAdjustmentData;
            res: {
                /**
                 * Adjustment deleted
                 */
                204: void;
            };
        };
    };
    '/forecasts/{forecastId}/adjustments/{adjustmentId}/active': {
        patch: {
            req: ForecastControllerPatchAdjustmentActiveData;
            res: {
                /**
                 * Adjustment active state updated
                 */
                200: AdjustmentResponseDto;
            };
        };
    };
    '/short-term-forecasts': {
        get: {
            req: ShortTermForecastControllerGetShortTermForecastData;
            res: {
                /**
                 * Forecast generated successfully
                 */
                200: ShortTermForecastResponseDto;
                /**
                 * Bad request - Invalid query parameters
                 */
                400: unknown;
                /**
                 * Unauthorized - Access denied
                 */
                401: unknown;
                /**
                 * Internal server error
                 */
                500: unknown;
            };
        };
    };
    '/load-planning/adjustments': {
        get: {
            req: LoadAdjustmentControllerFindAllData;
            res: {
                /**
                 * Load adjustments retrieved successfully
                 */
                200: LoadAdjustmentListResponseDto;
            };
        };
        post: {
            req: LoadAdjustmentControllerCreateData;
            res: {
                /**
                 * Load adjustment created successfully
                 */
                201: LoadAdjustmentResponseDto;
            };
        };
    };
    '/load-planning/adjustments/{id}': {
        get: {
            req: LoadAdjustmentControllerFindOneData;
            res: {
                /**
                 * Load adjustment retrieved successfully
                 */
                200: LoadAdjustmentResponseDto;
            };
        };
        put: {
            req: LoadAdjustmentControllerUpdateData;
            res: {
                /**
                 * Load adjustment updated successfully
                 */
                200: LoadAdjustmentResponseDto;
            };
        };
        delete: {
            req: LoadAdjustmentControllerDeleteData;
            res: {
                204: void;
            };
        };
    };
    '/load-planning/adjustments/{id}/activate': {
        patch: {
            req: LoadAdjustmentControllerActivateData;
            res: {
                /**
                 * Load adjustment activated successfully
                 */
                200: LoadAdjustmentResponseDto;
            };
        };
    };
    '/load-planning/adjustments/{id}/deactivate': {
        patch: {
            req: LoadAdjustmentControllerDeactivateData;
            res: {
                /**
                 * Load adjustment deactivated successfully
                 */
                200: LoadAdjustmentResponseDto;
            };
        };
    };
    '/load-planning/forecasts': {
        get: {
            req: LoadPlanningForecastControllerGetForecastData;
            res: {
                /**
                 * Adjusted Forecast Generated
                 */
                200: LoadForecastDataDto;
            };
        };
    };
    '/nace-codes': {
        get: {
            res: {
                /**
                 * List of NACE codes
                 */
                200: Array<NaceCode>;
            };
        };
    };
    '/machine-categories': {
        get: {
            res: {
                /**
                 * List of machine categories
                 */
                200: Array<MachineCategoryDto>;
            };
        };
    };
    '/meter-documents': {
        get: {
            req: MeterDocumentControllerGetMeterDocumentsData;
            res: {
                /**
                 * Get all meter documents for a specific meter
                 */
                200: Array<MeterDocumentResponseDto>;
            };
        };
        post: {
            req: MeterDocumentControllerCreateMeterDocumentData;
            res: {
                /**
                 * Create a new meter document
                 */
                201: MeterDocumentResponseDto;
                /**
                 * Invalid request payload
                 */
                400: unknown;
            };
        };
    };
    '/meter-documents/{id}': {
        delete: {
            req: MeterDocumentControllerDeleteMeterDocumentData;
            res: {
                /**
                 * Meter document successfully deleted
                 */
                204: void;
                /**
                 * Meter document not found
                 */
                404: unknown;
            };
        };
    };
    '/meter-documents/{id}/download': {
        get: {
            req: MeterDocumentControllerDownloadData;
            res: {
                /**
                 * File downloaded successfully
                 */
                200: (Blob | File);
            };
        };
    };
    '/ui-preferences/{key}': {
        get: {
            req: UiPreferenceControllerGetPreferenceData;
            res: {
                /**
                 * UI preference of the calling user
                 */
                200: UiPreferenceResponseDto;
                /**
                 * Unknown preference key
                 */
                400: unknown;
            };
        };
        put: {
            req: UiPreferenceControllerUpdatePreferenceData;
            res: {
                /**
                 * Saved UI preference of the calling user
                 */
                200: UiPreferenceResponseDto;
                /**
                 * Unknown preference key or invalid value
                 */
                400: unknown;
            };
        };
    };
    '/insight-inbox': {
        post: {
            req: InsightInboxControllerCreateData;
            res: {
                /**
                 * Insight created
                 */
                201: FetchOneInsightInboxDto;
            };
        };
        get: {
            req: InsightInboxControllerFindAllData;
            res: {
                /**
                 * List of insights. Flat list when groupBy is omitted/none, grouped otherwise.
                 */
                200: InsightInboxFetchResponseListDto | InsightInboxGroupedResponseListDto;
            };
        };
    };
    '/insight-inbox/dismissal-reasons': {
        get: {
            res: {
                /**
                 * Category → dismissal-reasons configuration
                 */
                200: DismissalReasonConfigDto;
            };
        };
    };
    '/insight-inbox/{id}': {
        get: {
            req: InsightInboxControllerFindOneData;
            res: {
                /**
                 * Insight details
                 */
                200: FetchOneInsightInboxDto;
            };
        };
        put: {
            req: InsightInboxControllerUpdateData;
            res: {
                /**
                 * Insight updated
                 */
                200: FetchOneInsightInboxDto;
            };
        };
        delete: {
            req: InsightInboxControllerDeleteData;
            res: {
                /**
                 * Insight deleted
                 */
                204: void;
            };
        };
    };
    '/insight-inbox/{id}/change-history': {
        get: {
            req: InsightInboxControllerGetChangeHistoryData;
            res: {
                /**
                 * Insight change history
                 */
                200: Array<ObjectChangeHistoryDto>;
            };
        };
    };
    '/insight-inbox/bulk/resolve': {
        patch: {
            req: InsightInboxControllerBulkResolveData;
            res: {
                /**
                 * Bulk resolve result
                 */
                200: BulkInsightActionResultDto;
            };
        };
    };
    '/insight-inbox/bulk/dismiss': {
        patch: {
            req: InsightInboxControllerBulkDismissData;
            res: {
                /**
                 * Bulk dismiss result
                 */
                200: BulkInsightActionResultDto;
            };
        };
    };
    '/insight-inbox/bulk/dismiss-grouped': {
        patch: {
            req: InsightInboxControllerBulkDismissGroupedData;
            res: {
                /**
                 * Bulk grouped dismiss result
                 */
                200: BulkInsightActionResultDto;
            };
        };
    };
    '/insight-inbox/bulk/assign': {
        patch: {
            req: InsightInboxControllerBulkAssignData;
            res: {
                /**
                 * Bulk assign result
                 */
                200: BulkInsightActionResultDto;
            };
        };
    };
    '/insight-inbox/bulk/visibility': {
        patch: {
            req: InsightInboxControllerBulkSetVisibilityData;
            res: {
                /**
                 * Bulk visibility result
                 */
                200: BulkInsightActionResultDto;
            };
        };
    };
    '/insight-inbox/{id}/visibility': {
        patch: {
            req: InsightInboxControllerSetVisibilityData;
            res: {
                /**
                 * Insight visibility updated
                 */
                200: FetchOneInsightInboxDto;
            };
        };
    };
    '/insight-inbox/{id}/investigate': {
        patch: {
            req: InsightInboxControllerInvestigateData;
            res: {
                /**
                 * Marked as under investigation
                 */
                200: FetchOneInsightInboxDto;
            };
        };
    };
    '/insight-inbox/{id}/convert': {
        patch: {
            req: InsightInboxControllerConvertData;
            res: {
                /**
                 * Converted to measure
                 */
                200: FetchOneInsightInboxDto;
            };
        };
    };
    '/insight-inbox/{id}/resolve': {
        patch: {
            req: InsightInboxControllerResolveData;
            res: {
                /**
                 * Marked as resolved
                 */
                200: FetchOneInsightInboxDto;
            };
        };
    };
    '/insight-inbox/{id}/dismiss': {
        patch: {
            req: InsightInboxControllerDismissData;
            res: {
                /**
                 * Insight dismissed
                 */
                200: FetchOneInsightInboxDto;
            };
        };
    };
    '/insight-inbox/{id}/assign': {
        patch: {
            req: InsightInboxControllerAssignData;
            res: {
                /**
                 * User assigned to insight
                 */
                200: FetchOneInsightInboxDto;
            };
        };
    };
    '/insight-inbox/{id}/viewed': {
        post: {
            req: InsightInboxControllerMarkViewedData;
            res: {
                /**
                 * Insight marked as viewed
                 */
                204: void;
            };
        };
    };
    '/insight-inbox/baseload-benchmark': {
        post: {
            req: InsightInboxManualControllerCreateBaseloadBenchmarkData;
            res: {
                /**
                 * Baseload Benchmark insight created
                 */
                201: FetchOneInsightInboxDto;
            };
        };
    };
    '/insight-inbox/baseload-trend': {
        post: {
            req: InsightInboxManualControllerCreateBaseloadTrendData;
            res: {
                /**
                 * Baseload Trend insight created
                 */
                201: FetchOneInsightInboxDto;
            };
        };
    };
    '/insight-settings': {
        get: {
            req: InsightSettingsControllerGetForLocationsData;
            res: {
                /**
                 * One entry per meter; insights of a meter without saved settings are null
                 */
                200: InsightInboxSettingsListDto;
            };
        };
    };
    '/insight-settings/recommendations': {
        get: {
            req: InsightSettingsControllerGetRecommendationsForLocationsData;
            res: {
                /**
                 * The recommended insight settings, one entry per meter
                 */
                200: InsightInboxSettingsListDto;
            };
        };
    };
    '/insight-settings/bulk': {
        put: {
            req: InsightSettingsControllerUpsertManyData;
            res: {
                /**
                 * The saved insight settings
                 */
                200: InsightInboxSettingsListDto;
            };
        };
    };
    '/insight-settings/apply-recommendation': {
        post: {
            req: InsightSettingsControllerApplyRecommendationsData;
            res: {
                /**
                 * The saved insight settings
                 */
                200: InsightInboxSettingsListDto;
            };
        };
    };
    '/insight-settings/meter/{meterId}': {
        get: {
            req: InsightSettingsControllerGetForMeterData;
            res: {
                /**
                 * The meter insight settings
                 */
                200: InsightInboxSettingsResponseDto;
            };
        };
        put: {
            req: InsightSettingsControllerUpsertForMeterData;
            res: {
                /**
                 * The saved meter insight settings
                 */
                200: InsightInboxSettingsResponseDto;
            };
        };
        patch: {
            req: InsightSettingsControllerPatchForMeterData;
            res: {
                /**
                 * The saved meter insight settings
                 */
                200: InsightInboxSettingsResponseDto;
            };
        };
    };
    '/insight-settings/meter/{meterId}/recommendation': {
        get: {
            req: InsightSettingsControllerGetRecommendationForMeterData;
            res: {
                /**
                 * The recommended meter insight settings
                 */
                200: InsightInboxSettingsResponseDto;
            };
        };
    };
    '/insight-settings/meter/{meterId}/apply-recommendation': {
        post: {
            req: InsightSettingsControllerApplyRecommendationForMeterData;
            res: {
                /**
                 * The saved meter insight settings
                 */
                200: InsightInboxSettingsResponseDto;
            };
        };
    };
    '/location-production-schedule': {
        get: {
            res: {
                /**
                 * The saved production schedules
                 */
                200: LocationProductionSchedulesResponseDto;
            };
        };
    };
    '/location-production-schedule/{locationId}': {
        put: {
            req: LocationProductionScheduleControllerUpsertForLocationData;
            res: {
                /**
                 * The saved production schedule
                 */
                200: LocationProductionScheduleDto;
            };
        };
    };
    '/location-production-schedule/bulk/upsert': {
        put: {
            req: LocationProductionScheduleControllerBulkUpsertData;
            res: {
                /**
                 * The saved production schedules
                 */
                200: LocationProductionSchedulesResponseDto;
            };
        };
    };
    '/insights-onboarding': {
        get: {
            res: {
                200: InsightsOnboardingStateDto;
            };
        };
    };
    '/insights-onboarding/start': {
        put: {
            res: {
                200: InsightsOnboardingStateDto;
            };
        };
    };
    '/insights-onboarding/complete': {
        put: {
            res: {
                200: InsightsOnboardingStateDto;
            };
        };
    };
    '/v2/invitations/validate': {
        get: {
            req: InvitationControllerValidateData;
            res: {
                /**
                 * Valid invitation
                 */
                200: ValidateInvitationResponseDto;
                /**
                 * Invalid or expired token
                 */
                404: unknown;
            };
        };
    };
    '/v2/invitations/accept': {
        post: {
            req: InvitationControllerAcceptData;
            res: {
                /**
                 * Invitation accepted
                 */
                200: unknown;
                /**
                 * Invalid, expired, or already used token
                 */
                404: unknown;
            };
        };
    };
    '/v2/invitations/user-management': {
        get: {
            req: InvitationControllerFindUserManagementPageData;
            res: {
                /**
                 * Paginated user-management list
                 */
                200: UserManagementListResponseDto;
            };
        };
    };
    '/v2/invitations': {
        get: {
            req: InvitationControllerFindAllData;
            res: {
                /**
                 * List of invitations
                 */
                200: Array<InvitationResponseDto>;
            };
        };
        post: {
            req: InvitationControllerCreateData;
            res: {
                /**
                 * Invitation created
                 */
                201: InvitationResponseDto;
                /**
                 * Validation error
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden — caller is not an admin of the company
                 */
                403: unknown;
            };
        };
    };
    '/v2/invitations/{id}': {
        patch: {
            req: InvitationControllerUpdateData;
            res: {
                /**
                 * Invitation updated
                 */
                200: InvitationResponseDto;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Forbidden — caller is not an admin of the company
                 */
                403: unknown;
                /**
                 * Invitation not found
                 */
                404: unknown;
            };
        };
        delete: {
            req: InvitationControllerRevokeData;
            res: {
                /**
                 * Invitation revoked
                 */
                204: void;
            };
        };
    };
    '/savings-flow/insights/{id}/measure': {
        post: {
            req: SavingsFlowControllerCreateMeasureFromInsightData;
            res: {
                /**
                 * Measure created and linked; insight marked as converted
                 */
                201: FetchOneInsightInboxDto;
            };
        };
    };
    '/public-holidays/location/{locationId}': {
        get: {
            req: PublicHolidaysControllerFindForLocationData;
            res: {
                /**
                 * Public holidays for the location and range
                 */
                200: PublicHolidaysResponseDto;
            };
        };
    };
    '/public-holidays': {
        get: {
            req: PublicHolidaysControllerFindByParamsData;
            res: {
                /**
                 * Public holidays for the country/subdivision and range
                 */
                200: PublicHolidaysResponseDto;
            };
        };
    };
    '/submeter-attribution/meter/{meterId}': {
        get: {
            req: SubmeterAttributionControllerGetAttributionData;
            res: {
                200: SubmeterAttributionResponseDto;
                /**
                 * Missing, malformed or more than 100 windows
                 */
                400: unknown;
                /**
                 * Unauthorized
                 */
                401: unknown;
                /**
                 * Meter belongs to a location the caller is not assigned to
                 */
                403: unknown;
                /**
                 * Meter not found
                 */
                404: unknown;
            };
        };
    };
};